

const dropdownOptions = {
    'pais': [
        "República Dominicana",
        "Afganistán",
        "Albania",
        "Alemania",
        "Andorra",
        "Angola",
        "Anguila",
        "Antigua y Barbuda",
        "Arabia Saudita",
        "Argelia",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaiyán",
        "Bahamas",
        "Bangladesh",
        "Barbados",
        "Baréin",
        "Belice",
        "Benín",
        "Bielorrusia",
        "Birmania",
        "Bolivia",
        "Bonaire, San Eustaquio y Saba",
        "Bosnia-Herzegovina",
        "Botswana - en la Lista de Definición AML del GAFI",
        "Brasil",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso - en la Lista de Definición AML del GAFI",
        "Burundi",
        "Bután",
        "Bélgica",
        "Cabo Verde",
        "Camboya",
        "Camerún",
        "Canadá",
        "Chad",
        "Chile",
        "China",
        "Chipre",
        "Cisjordania (Territorio Palestino, O",
        "Colombia",
        "Comoras",
        "Congo (Brazzaville)",
        "Congo, República Democrática",
        "Corea del Norte",
        "Corea del Sur",
        "Costa Rica",
        "Costa de Marfil",
        "Croacia",
        "Cuba",
        "Curazao",
        "Dinamarca",
        "Dominica",
        "Ecuador",
        "Egipto",
        "El Salvador",
        "Emiratos Árabes Unidos",
        "Eritrea",
        "Eslovaquia",
        "Eslovenia",
        "España",
        "Estado de la Ciudad del Vaticano (Santa Sede)",
        "Estados Unidos",
        "Estonia",
        "Etiopía",
        "Federación Rusa",
        "Fiji",
        "Filipinas",
        "Finlandia",
        "Francia",
        "Franja de Gaza",
        "Gabón",
        "Gambia",
        "Georgia",
        "Ghana",
        "Gibraltar",
        "Granada",
        "Grecia",
        "Groenlandia",
        "Guadalupe",
        "Guam",
        "Guatemala",
        "Guayana",
        "Guayana Francesa",
        "Guernesey",
        "Guinea",
        "Guinea Ecuatorial",
        "Guinea-Bisáu",
        "Haití",
        "Honduras",
        "Hong Kong",
        "Hungría",
        "India",
        "Indonesia",
        "Irak",
        "Irlanda",
        "Irán, República Islámica de",
        "Isla Norfolk",
        "Isla de Navidad",
        "Isla del Hombre",
        "Islandia",
        "Islas Aland",
        "Islas Bermudas",
        "Islas Caimán",
        "Islas Cocos (Keeling)",
        "Islas Cook",
        "Islas Faroe",
        "Islas Malvinas (Malvinas)",
        "Islas Marianas del Norte",
        "Islas Marshall",
        "Islas Salomón",
        "Islas Turcas y Caicos",
        "Islas Vírgenes Británicas",
        "Islas Vírgenes de los Estados Unidos",
        "Israel",
        "Italia",
        "Jamaica",
        "Japón",
        "Jersey",
        "Jordán",
        "Katar",
        "Kazajstán",
        "Kenia",
        "Kirguistán",
        "Kiribati",
        "Kosovo",
        "Kuwait",
        "Lesoto",
        "Letonia",
        "Liberia",
        "Libia",
        "Liechtenstein",
        "Lituania",
        "Luxemburgo",
        "Líbano",
        "Macao",
        "Macedonia",
        "Madagascar",
        "Malasia",
        "Malaui",
        "Maldivas",
        "Malta",
        "Malí",
        "Marruecos",
        "Martinica",
        "Mauricio - en la lista de definiciones ALD del GAFI",
        "Mauritania",
        "Mayotte",
        "Micronesia",
        "Moldavia",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Mozambique",
        "México",
        "Mónaco",
        "Namibia",
        "Nauru",
        "Nepal",
        "Nicaragua",
        "Nigeria",
        "Niue",
        "Noruega",
        "Nueva Caledonia",
        "Nueva Zelanda",
        "Níger",
        "Omán",
        "Pakistán",
        "Palaos",
        "Panamá",
        "Papúa Nueva Guinea",
        "Paraguay",
        "Países Bajos",
        "Perú",
        "Pitcairn",
        "Polinesia francesa",
        "Polonia",
        "Portugal",
        "Puerto Rico",
        "Reino Unido",
        "Rep Centroafricana",
        "Republica Checa",
        "República Democrática Popular Lao",
        "Reunión",
        "Ruanda",
        "Rumania",
        "Sahara Occidental",
        "Samoa",
        "Samoa Americana",
        "San Berthélemy",
        "San Cristóbal y Nieves",
        "San Marino",
        "San Martín",
        "San Martín (parte francesa)",
        "San Pedro y Miquelón",
        "San Vicente y Granadinas",
        "Santa Elena, Ascensión y Trista",
        "Santa Lucía",
        "Santo Tomé y Prin.",
        "Seicheles",
        "Senegal",
        "Serbia",
        "Sierra Leona",
        "Singapur",
        "Siria",
        "Somalia",
        "Sri Lanka",
        "Suazilandia (Esuatini)",
        "Sudáfrica",
        "Sudán",
        "Sudán del Sur",
        "Suecia",
        "Suiza",
        "Surinam",
        "Svalbard y Mayen",
        "Tailandia",
        "Taiwán",
        "Tanzania",
        "Tayikistán",
        "Territorio Británico del Océano Índico",
        "Timor Oriental",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad y Tobago",
        "Turkmenistán",
        "Turquía",
        "Tuvalu",
        "Túnez",
        "Ucrania",
        "Uganda",
        "Uruguay",
        "Uzbekistán",
        "Vanuatu",
        "Venezuela",
        "Vietnam",
        "Wallis y Futuna",
        "Yemen",
        "Yibuti",
        "Zambia",
        "Zimbabue"
    ],'pais_en': [
        "Dominican Republic",
        "Afghanistan",
        "Albania",
        "Germany",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua and Barbuda",
        "Saudi Arabia",
        "Algeria",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bangladesh",
        "Barbados",
        "Bahrain",
        "Belize",
        "Benin",
        "Belarus",
        "Myanmar",
        "Bolivia",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia-Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Bhutan",
        "Belgium",
        "Cape Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Chad",
        "Chile",
        "China",
        "Cyprus",
        "West Bank (Palestinian Territory, Occupied)",
        "Colombia",
        "Comoros",
        "Congo (Brazzaville)",
        "Congo, the Democratic Republic",
        "North Korea",
        "South Korea",
        "Costa Rica",
        "Cote D'Ivoire",
        "Croatia",
        "Cuba",
        "Curacao",
        "Denmark",
        "Dominica",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "United Arab Emirates",
        "Eritrea",
        "Slovakia",
        "Slovenia",
        "Spain",
        "Vatican City State (Holy See)",
        "United States",
        "Estonia",
        "Ethiopia",
        "Russian Federation",
        "Fiji",
        "Philippines",
        "Finland",
        "France",
        "Gaza Strip",
        "Gabon",
        "Gambia",
        "Georgia",
        "Ghana",
        "Gibraltar",
        "Grenada",
        "Greece",
        "Greenland",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guyana",
        "French Guiana",
        "Guernsey",
        "Guinea",
        "Equatorial Guinea",
        "Guinea Bissau",
        "Haiti",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "India",
        "Indonesia",
        "Iraq",
        "Ireland",
        "Iran, Islamic Republic of",
        "Norfolk Island",
        "Christmas Island",
        "Isle Of Man",
        "Iceland",
        "Åland Islands",
        "Bermuda",
        "Cayman Islands",
        "Cocos (Keeling) Islands",
        "Cook Islands",
        "Faroe islands",
        "Falkland Islands (Malvinas)",
        "North Mariana Islands",
        "Marshall Islands",
        "Solomon Islands",
        "Turks & Caicos",
        "British Virgin Islands",
        "United States Virgin Islands",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Qatar",
        "Kazakhstan",
        "Kenya",
        "Kyrgyzstan",
        "Kiribati",
        "Kosovo",
        "Kuwait",
        "Lesotho",
        "Latvia",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Lebanon",
        "Macau",
        "North Macedonia",
        "Madagascar",
        "Malaysia",
        "Malawi",
        "Maldives",
        "Malta",
        "Mali",
        "Morocco",
        "Martinique",
        "Mauritius",
        "Mauritania",
        "Mayotte",
        "Micronesia",
        "Moldova",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Mozambique",
        "Mexico",
        "Monaco",
        "Namibia",
        "Nauru",
        "Nepal",
        "Nicaragua",
        "Nigeria",
        "Niue",
        "Norway",
        "New Caledonia",
        "New Zealand",
        "Niger",
        "Oman",
        "Pakistan",
        "Palau",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Netherlands",
        "Peru",
        "Pitcairn",
        "French Polynesia",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "United Kingdom",
        "Central African Rep",
        "Czech Republic",
        "Lao People's Democratic Republic",
        "Réunion",
        "Rwanda",
        "Romania",
        "Western Sahara",
        "Samoa",
        "American Samoa",
        "Saint Berthélemy",
        "St Kitts & Nevis",
        "San Marino",
        "Saint Martin",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "St Vincent & Gren",
        "Saint Helena, Ascension and Tristan",
        "St Lucia",
        "Sao Tome & Prin.",
        "Seychelles",
        "Senegal",
        "Serbia",
        "Sierra Leone",
        "Singapore",
        "Syria",
        "Somalia",
        "Sri Lanka",
        "Eswatini",
        "South Africa",
        "Sudan",
        "South Sudan",
        "Sweden",
        "Switzerland",
        "Suriname",
        "Svalbard and Mayen",
        "Thailand",
        "Taiwan",
        "Tanzania",
        "Tajikistan",
        "British Indian Ocean Territory",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad & Tobago",
        "Turkmenistan",
        "Turkey",
        "Tuvalu",
        "Tunisia",
        "Ukraine",
        "Uganda",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela",
        "Vietnam",
        "Wallis and Futuna",
        "Yemen",
        "Djibouti",
        "Zambia",
        "Zimbabwe"
    ],
    'zonaGeograficaNacional': [
        " ",
        "Distrito Nacional",
        "Santo Domingo",
        "Santiago",
        "Punta Cana",
        "Azua",
        "Baoruco",
        "Barahona",
        "Dajabón",
        "Duarte",
        "Elias Piña",
        "El Seibo",
        "Espaillat",
        "Hato Mayor",
        "Hermanas Mirabal",
        "Independencia",
        "La Altagracia",
        "La Romana",
        "La Vega",
        "María Trinidad Sánchez",
        "Monseñor Nouel",
        "Monte Cristi",
        "Monte Plata",
        "Pedernales",
        "Peravia",
        "Puerto Plata",
        "Samaná",
        "San Cristóbal",
        "San José de Ocoa",
        "San Juan de la Maguana",
        "San Pedro de Macorís",
        "Sánchez Ramírez",
        "Santiago Rodríguez",
        "Valverde",
    ],
    'actividades': [
        "Abogados, Notarios, Otros profesionales jurídicos independientes, Contadores",
        "Acabado de muebles, tales como la fumigación, pintura y pulido",
        "Acabado de productos textiles",
        "Acabados, tales como tapicería de sillas y asientos",
        "Aclareo de bosques",
        "Acondicionamiento de edificios",
        "Actividades de acuicultura de agua salada en tanques o reservorios",
        "Actividades de acuicultura en aguas salobre",
        "Actividades de aeropuertos y de control de tráfico aéreo",
        "Actividades de agencias de noticias y de consorcios que proveen noticias, imágenes y reportajes en los medios de comunicación",
        "Actividades de agentes que organizan la venta de energía",
        "Actividades de ambulancias para animales",
        "Actividades de apoyo para el deporte o actividades recreativas",
        "Actividades de arquitectura e ingeniería y actividades conexas de asesoramiento técnico",
        "Actividades de artistas individuales",
        "Actividades de asesoramiento",
        "Actividades de asistentes de veterinarios u otro personal auxiliar",
        "Actividades de asociaciones cuyos miembros son empleados interesados principalmente en la representación de sus opiniones",
        "Actividades de astrología y espiritismo",
        "Actividades de aviación en general",
        "Actividades de bibliotecas de archivos fotográficos",
        "Actividades de casas de subastas",
        "Actividades de casas para personas con problemas mentales que no requieren internación",
        "Actividades de centros de grupos de rehabilitación para personas con problemas sociales o personales",
        "Actividades de chóferes, cuidadores, institutrices, niñeras y tutores",
        "Actividades de cine clubes",
        "Actividades de cinematografía, radio y televisión y servicios de espectáculos artísticos y de diversión N. C. P.",
        "Actividades de compañías de convenios de liquidación por adelantado",
        "Actividades de consultores que no sean las de arquitectura, ingeniería y gestión de consultores",
        "Actividades de crédito para financiar otras actividades económicas (incluye las empresas de factoring y otras formas de adelanto)",
        "Actividades de diagnósticos clínicos patológicos y otros diagnósticos referentes a animales",
        "Actividades de diseñadores gráficos",
        "Actividades de domesticas, cocineros, camareros, vallets, mayordomos, jardineros y guardianes",
        "Actividades de escuelas de arte que entregan educación superior",
        "Actividades de establos, perreras y garajes para carrera",
        "Actividades de estibas",
        "Actividades de expedidores de carga marítima y agentes de carga aérea",
        "Actividades de factoring",
        "Actividades de faro",
        "Actividades de federaciones de tales organizaciones",
        "Actividades de grupo, circos o compañías, orquestas o bandas",
        "Actividades de guía de montaña",
        "Actividades de hincado de pilotes, cimentación y otros trabajos de hormigón armado",
        "Actividades de impresión",
        "Actividades de impresión y reproducción de grabaciones",
        "Actividades de impresión y servicios conexos",
        "Actividades de informática N. C .P.",
        "Actividades de informática N. C. P.",
        "Actividades de instalaciones para el retardado mental",
        "Actividades de investigación y seguridad",
        "Actividades de las sociedades de holding",
        "Actividades de ligas deportivas y la regulación de los órganos",
        "Actividades de logística, planificación, diseño y apoyo a las operaciones de transporte, almacenaje y distribución",
        "Actividades de los agentes de aduanas",
        "Actividades de navegación, pilotaje y de amarraderos",
        "Actividades de oficinas de cambio",
        "Actividades de ópticas",
        "Actividades de organizaciones de servicio de equipamiento de monasterio y conventos",
        "Actividades de organizaciones políticas",
        "Actividades de organizaciones que buscan el desarrollo y prosperidad de empresas",
        "Actividades de organizaciones y órganos extraterritoriales",
        "Actividades de otras agencias",
        "Actividades de otras asesorías y representación además de la legal",
        "Actividades de radio y televisión",
        "Actividades de radiodifusión a través del Internet",
        "Actividades de recuperación conforme a la información solicitada",
        "Actividades de retiro religioso",
        "Actividades de salud para el personal militar en el campo",
        "Actividades de servicios agrícolas y a la ganadería excepto los veterinarios",
        "Actividades de servicios en aeropuertos",
        "Actividades de servicios relacionados con la extracción de petróleo y gas, excepto las actividades de prospección",
        "Actividades de servicios relacionados con la impresión",
        "Actividades de servicios religioso fúnebre",
        "Actividades de subastadores independientes",
        "Actividades de subastas no realizadas en almacenes",
        "Actividades de venta al por mayor en casas de subasta",
        "Actividades especializadas de construcción N. C. P. (incluye el alquiler e instalación de andamios)",
        "Actividades inmobiliarias realizadas a cambio de una retribución o por cuenta",
        "Actividades jurídicas",
        "Actividades ligadas al gas o agentes intermediarios",
        "Actividades ortodoncistas",
        "Actividades para promover la propagación, el crecimiento y la producción de animales",
        "Actividades por correo distintas a las actividades postales nacionales",
        "Actividades postales nacionales",
        "Actividades se salvamento",
        "Actividades teatrales y musicales y otras actividades artísticas",
        "Actores",
        "Acuicultura en agua dulce",
        "Administración de bienes raíces por comisión o por contrato",
        "Administración de los programas de protección del medio ambiente",
        "Administración de políticas de investigación y desarrollo relacionadas con la defensa y la administración de fondos pertinentes",
        "Administración de prisiones y provisión de servicios correccionales",
        "Administración de programas de fidelización",
        "Administración de riesgo de salud",
        "Administración de salvamento",
        "Administración del estado y aplicación de la política económica y social de la comunidad",
        "Administración y operación de brigadas contra incendio auxiliares y regulares",
        "Administración y operación de cortes de leyes civiles y criminales",
        "Administración y operación de las fuerzas policiales y auxiliares apoyadas por autoridades públicas y de puerto, fronteras y guardacostas",
        "Administración y operación de las otras fuerzas policiales especiales incluso regulación del tráfico, inscripción de extranjeros y mantenimiento de registro de arresto",
        "Administración y operación de tribunales militares",
        "Administración y operación del sistema judicial, incluso representación legal y asesoría en representación del gobierno",
        "Administradoras de fondos de pensiones",
        "Adobo y teñido de pieles, fabricación de artículos de piel",
        "Adquisición de los derechos de distribución de películas, cintas de video y DVD",
        "Afeitado de barba y el corte de pelo",
        "Agentes de cambio",
        "Agentes inmobiliarios",
        "Agentes inmobiliarios fideicomisos",
        "Aglomeración de coque",
        "Aglomeración de minerales de hierro",
        "Aglomeración de turba",
        "Agricultura, ganadería, caza y actividades de servicios conexos.",
        "Aislamiento térmico, acústico, hídrico y anti vibratorio",
        "Ajustes de las reclamaciones",
        "Albergue para enfermos mentales",
        "Albergue y cuidado de animales de terceros",
        "Albergues juveniles",
        "Alineación de dirección y balanceo de ruedas",
        "Almacenamiento y actividades complementarias al transporte",
        "Almacenamientos de productos en zonas francas",
        "Alojamiento",
        "Alquiler de andamios y plataformas de trabajo, sin montaje y desmontaje",
        "Alquiler de aspersores de uso agrícola",
        "Alquiler de automóviles privados con conductor",
        "Alquiler de camiones grúa",
        "Alquiler de computadoras y equipos periféricos",
        "Alquiler de copiadoras, máquina de escribir y maquinas de tratamiento de texto",
        "Alquiler de efectos personales y enseres domésticos N. C. P.",
        "Alquiler de efectos personales y enseres domésticos N. C. P. (incluye el alquiler de artículos deportivos y de video)",
        "Alquiler de embarcaciones de recreo con tripulación",
        "Alquiler de embarcaciones de recreo con tripulación para la navegación marítima y las aguas costeras de transporte",
        "Alquiler de equipo de construcción o demolición dotado de operario",
        "Alquiler de equipo de transporte para vía acuática, sin operario ni tripulación",
        "Alquiler de equipo de transporte para vía aérea, sin operario ni tripulación",
        "Alquiler de equipo de transporte para vía terrestre, sin operarios ni tripulación",
        "Alquiler de equipos de comunicación profesional de radio y televisión",
        "Alquiler de equipos de construcción o demolición dotados de operarios",
        "Alquiler de equipos de medición y control",
        "Alquiler de equipos de producción cinematográficas",
        "Alquiler de equipos de transporte",
        "Alquiler de equipos de transporte aéreo con un operador con el fin de transportar pasajeros",
        "Alquiler de equipos electrónicos de uso domésticos",
        "Alquiler de espacios equipados como salas fúnebres",
        "Alquiler de ferrocarriles",
        "Alquiler de flores y plantas",
        "Alquiler de globos de aire caliente",
        "Alquiler de grúas con operador",
        "Alquiler de instalaciones como baños, taquillas, sillas, etc.",
        "Alquiler de instrumentos musicales, estenografías y vestuario",
        "Alquiler de libros, revistas y periódicos",
        "Alquiler de maquinaria agrícola diversa",
        "Alquiler de maquinaria N. C. P.",
        "Alquiler de maquinaria y equipo agropecuario, sin operario",
        "Alquiler de maquinaria y equipo de construcción e ingeniería civil, sin operario (incluye el alquiler de andamios sin montaje)",
        "Alquiler de maquinaria y equipo de oficina, incluso computadora",
        "Alquiler de maquinaria y equipo minero y petrolero, sin personal",
        "Alquiler de maquinaria y equipo N. C. P. sin personal",
        "Alquiler de maquinaria y equipo para la industria manufacturera, sin personal",
        "Alquiler de maquinaria y equipo utilizado por aficionados o como un hobby por ejemplo herramientas para reparación del hogar",
        "Alquiler de maquinaria y equipos contables, cajas registradoras y calculadoras electrónicas",
        "Alquiler de maquinaria y equipos sin operador ",
        "Alquiler de maquinarias y utensilios para fiestas",
        "Alquiler de maquinas para la recolección y trilla",
        "Alquiler de maquinas para ordeñar",
        "Alquiler de maquinas utilizadas para preparar el suelo, plantar y abonar",
        "Alquiler de mobiliario de oficina",
        "Alquiler de motocicleta, caravanas y campers",
        "Alquiler de otras maquinarias científicas, comerciales e industriales",
        "Alquiler de remolques y semirremolques de carga y descarga automática",
        "Alquiler de ropa",
        "Alquiler de segadoras",
        "Alquiler o venta de tumbas",
        "Análisis y control en relación con la producción de alimentos",
        "Análisis y la medición de los indicadores ambientales",
        "Apicultura (incluye la producción de miel, jalea real, polen, propolen, etc.)",
        "Aplicación de arcilla, aislante de calor, aislante de sonido",
        "Aplicación de yeso y estuco en edificios y otras obras de construcción de interior y exterior",
        "Apoyo para la elaboración de planes de contingencia y la realización de ejercicios con la participación de instituciones y civiles",
        "Arbitraje de acciones civiles",
        "Arenas de boxeo",
        "Arenas y estadios para deportes de invierno",
        "Arquitectos",
        "Artistas plásticos",
        "Aserraderos y cepillado de madera",
        "Aserrado y cepillado de madera",
        "Asesoramiento y representación en casos civiles",
        "Asesoramiento y representación en casos penales",
        "Asesoramiento y representación en los conflictos laborales",
        "Asociaciones de ahorros y préstamos",
        "Asociaciones de consumidores",
        "Asociaciones de contadores",
        "Asociaciones de escritores, pintores, artistas, intérpretes, periodistas, etc.",
        "Asociaciones de ingenieros y arquitectos",
        "Asociaciones jurídicas",
        "Asociaciones medicas",
        "Asociaciones para facilitar el contacto con otras personas con intereses similares como clubes de rotarios, logias, etc.",
        "Asociaciones para fines patrióticos, incluyendo veteranos de guerra",
        "Atención de la salud animal y las actividades de control para los animales de granja",
        "Atención de la salud animal y las actividades de control para los animales domésticos",
        "Autodromos",
        "Autores",
        "Bancas de apuestas",
        "Bancas deportivas",
        "Banco mundial",
        "Bancos de ahorros y crédito",
        "Bancos múltiples",
        "Blanqueo de jeans",
        "Boutiques",
        "Cabañas y departamentos para visitantes, vivienda para vacacionar",
        "Cabinas de foto",
        "Cableado de telecomunicación",
        "Cableado eléctrico y accesorios",
        "Café soluble",
        "Cafeterías",
        "Camiones, remolques de utilidad y vehículos de recreo",
        "Campamentos disciplinarios",
        "Campos de golf",
        "Canchas de Bowling",
        "Captación, depuración y distribución de agua de fuentes subterráneas",
        "Captación, depuración y distribución de agua de fuentes superficiales",
        "Captación, tratamiento y suministro de agua",
        "Captura de animales de agua dulce",
        "Captura de animales vivos para zoológicos o como animales de compañía",
        "Captura de tortugas, erizos de mar, etc.",
        "Captura en tierra de mamíferos marinos como la foca o la morsa",
        "Carbonizado de la lana y el tenido de la lana vellón",
        "Carga de automóviles",
        "Carga y descarga de vagones ferroviarios",
        "Carros móviles de suministro de comida",
        "Casas de convalecencia",
        "Casas de empeño",
        "Casas de reposo con atención de enfermería",
        "Casinos",
        "Casinos de apuesta",
        "Caza de ballena, foca, lobo marino y otros mamíferos marinos",
        "Caza y captura con fines comerciales",
        "Caza y captura de animales vivos (incluye la caza de animales para obtener carne, pieles, cueros, etc.)",
        "Caza y captura de animales vivos para la extracción de pieles, cueros o para el uso en investigaciones científicas",
        "Caza y captura de animales vivos, repoblación de animales de caza y servicios conexos",
        "Centro de acopio de leche de ganado bovino",
        "Centros de aprendizajes que ofrecen cursos de recuperación",
        "Centros de rehabilitación para delincuentes y transgresores",
        "Centros de telecomunicaciones",
        "Chalets, casas hogar y cabinas",
        "Clubes de entretenimientos para adultos",
        "Colecciones de catálogos",
        "Colmadones",
        "Colmados",
        "Colocación de cristales en obra (incluye la instalación y revestimiento de vidrio, espejos y otros artículos de vidrio)",
        "Colocación de ladrillos y piedras",
        "Colocación de subtítulos ocultos",
        "Combinaciones de metales preciosos y piedras o de otros materiales preciosos o semipreciosos",
        "Comerciantes de piedras preciosas y comerciantes de metales preciosos",
        "Comercio al por mayor y al por menor, reparación de vehículos automotores y motocicletas",
        "Comercio al por menor no realizado en almacenes, puestos de venta o mercados",
        "Comercio al por menor, excepto el comercio de vehículos automotores y motocicletas",
        "Composición y representación de obras teatrales, musicales y artísticas",
        "Compositores",
        "Compra de vino a granel y embotellado sin transformación",
        "Compra y venta de artículos nuevos y usados",
        "Compra y venta de residuos que tienen un valor restante",
        "Comunidad europea y la asociación de libre comercio europea",
        "Concentración de esos minerales",
        "Condominios",
        "Confección de indumentaria de trabajo, uniformes, guardapolvos y sus accesorios",
        "Confección de indumentaria deportiva",
        "Confección de indumentaria para bebés y niños",
        "Confección de pilotos e impermeables",
        "Confección de prendas de vestir de cuero",
        "Confección de prendas de vestir de piel y sucedáneos",
        "Confección de prendas de vestir N. C. P. excepto las de piel, cuero y sucedáneos, pilotos e impermeables",
        "Confección de ropa interior, prendas de vestir para dormir y para la playa",
        "Confección de trajes de baño",
        "Confección y venta de mapas",
        "Conferencistas",
        "Conservación de frutas, frutos secos u hortalizas: congelación, secado, inmersión en aceite o en vinagre, enlatado, etc.",
        "Construcción de aerodeslizadores",
        "Construcción de almacenes",
        "Construcción de barcos a motor",
        "Construcción de buques y otras embarcaciones",
        "Construcción de chimeneas y hornos industriales",
        "Construcción de diques flotantes, boyas, tanques flotantes, barcazas, grúas flotantes",
        "Construcción de edificios",
        "Construcción de edificios de aeropuertos",
        "Construcción de edificios religiosos",
        "Construcción de embalses",
        "Construcción de estaciones de bombeo",
        "Construcción de garajes incluyendo los garajes subterráneos",
        "Construcción de hospitales, escuelas y edificios de oficinas",
        "Construcción de instalaciones deportivas",
        "Construcción de línea de agua principal",
        "Construcción de obras marítimas",
        "Construcción de plantas de eliminación de aguas residuales",
        "Construcción de plantas de energía",
        "Construcción de plantas químicas",
        "Construcción de plataformas de perforación, flotantes o sumergidas",
        "Construcción de refinerías",
        "Construcción de sistemas de alcantarillado, incluyendo la reparación",
        "Construcción de tuberías en zonas urbanas de comunicación y líneas eléctricas",
        "Construcción de túneles",
        "Construcción de viviendas unifamiliares",
        "Construcción e instalación de equipos de climatización",
        "Construcción, mecanismo, forma, color y acabados superficiales del producto",
        "Construcción, reforma y reparación de edificios no residenciales (incluye la construcción, reforma y reparación de restaurantes, bares, etc.)",
        "Construcción, reforma y reparación de edificios residenciales (incluye construcción, reforma y reparación de viviendas unifamiliares)",
        "Construcción, reforma y reparación de edificios turísticos",
        "Construcción, reforma y reparación de las calles, caminos, puentes, túneles",
        "Construcción, reforma y reparación de obras de infraestructuras de transporte",
        "Construcción, reforma y reparación de obras hidráulicas (incluye obras fluviales y canales, acueductos, diques, etc.)",
        "Construcción, reforma y reparación de redes (incluye la construcción, reforma y reparación de redes de electricidad, gas)",
        "Consultaría de marketing",
        "Consultaría en agronomía",
        "Consultaría en seguridad",
        "Consultoría ambiental",
        "Contracción y reparación de buques y embarcaciones N. C. P.",
        "Contrato de intercambio de futuros y comoditis",
        "Control de plaga (incluidos los conejos) en relación a la agricultura",
        "Control de plagas forestales",
        "Cooperativas",
        "Corredores de seguro",
        "Correos y servicios de mensajería",
        "Corretaje de buques y aeronaves espaciales",
        "Corretaje de contratos de comoditis",
        "Corretaje de valores",
        "Corretaje de vino",
        "Corte en rodaja de la madera",
        "Corte, tallado y acabado de la piedra",
        "Corte, tallado y acabado de la piedra (incluye mármoles y granitos, etc.)",
        "Creación de stand y otras estructuras de visualización",
        "Creación y desarrollo de diseños y especificaciones que optimizan el uso, el valor y la apariencia de los productos",
        "Cría de animales",
        "Cría de animales para la obtención de pelos",
        "Cría de animales para la obtención de pieles y cueros",
        "Cría de animales para la obtención de plumas",
        "Cría de animales y obtención de productos de origen animal N. C. P. (incluye ciervo, conejo excepto para pelo, lombriz, etc.)",
        "Cría de aves como pericos, etc.",
        "Cría de aves para la producción de carne",
        "Cría de aves para la producción de huevos (incluye pollitos BB para postura)",
        "Cría de avestruces y emus",
        "Cría de crustáceos, moluscos y bivalvos",
        "Cría de ganado bovino en cabañas (incluye la producción de semen)",
        "Cría de ganado bovino –excepto en cabañas y para la producción de leche",
        "Cría de ganado caprino, excepto en cabañas para la producción de leche",
        "Cría de ganado equino en haras (incluye la producción de semen)",
        "Cría de ganado equino, excepto en haras (incluye cría de equinos de trabajo)",
        "Cría de ganado N. C. P. (incluye cría de alpaca, asno, guacano, llama, vicuña, etc.)",
        "Cría de ganado ovino, excepto en cabañas y para la producción de lana",
        "Cría de ganado ovino, porcino y caprino en cabañas (incluye la producción de semen)",
        "Cría de ganado porcino, excepto en cabañas",
        "Cría de ganado vacuno y de ovejas, cabras caballo, asnos, mulas y burgedanos, cría de ganado lechero",
        "Cría de gatos y perros",
        "Cría de hámster, etc.",
        "Cría de insectos",
        "Cría de otras aves excepto las de corral",
        "Cría de otros animales acuáticos",
        "Cría de otros animales y elaboración de productos para animales N.C.P.",
        "Cría de peces ornamentales",
        "Cría de peces ornamentales de agua dulce",
        "Cría en cabañas de ganado N. C. P,",
        "Criaderos de gusanos marinos",
        "Criaderos de peces de agua dulce",
        "Criaderos de peces marinos",
        "Criaderos de ranas",
        "Cubrimiento con tejado de los edificios residenciales",
        "Cultivo de abacá, ramio y demás fibras textiles vegetales",
        "Cultivo de aguacate",
        "Cultivo de ajo",
        "Cultivo de ajonjolí",
        "Cultivo de albaricoque",
        "Cultivo de alcachofas",
        "Cultivo de algodón",
        "Cultivo de almendra",
        "Cultivo de anís, badianas e hinojos",
        "Cultivo de árboles de caucho",
        "Cultivo de árboles de navidad",
        "Cultivo de árboles para la extracción de savia",
        "Cultivo de arroz",
        "Cultivo de avellanas",
        "Cultivo de avena",
        "Cultivo de batatas",
        "Cultivo de berenjenas",
        "Cultivo de blueberries",
        "Cultivo de brócolis y coliflor",
        "Cultivo de bulbos, brotes, raíces y hortalizas de frutos N. C. P. (incluye ají, ajo, alcaparra, etc.)",
        "Cultivo de cacahuetes ",
        "Cultivo de cacao",
        "Cultivo de café y cacao",
        "Cultivo de caña de azúcar",
        "Cultivo de canela",
        "Cultivo de castaña de caju",
        "Cultivo de cebada",
        "Cultivo de cebolla",
        "Cultivo de centeno",
        "Cultivo de cereales excepto los forrajeros y las semillas N. C. P.",
        "Cultivo de cereales forrajeros N. C. P. (incluye alpiste, cebada forrajera, mijo)",
        "Cultivo de cereales y otros cultivos N. C. P.",
        "Cultivo de chiles y pimientos",
        "Cultivo de ciruela",
        "Cultivo de coles",
        "Cultivo de colza",
        "Cultivo de corintos",
        "Cultivo de espárragos",
        "Cultivo de especias (de hojas, de semillas, de flor y de fruto) y de plantas aromáticas y medicinales",
        "Cultivo de espinaca",
        "Cultivo de flores",
        "Cultivo de frambuesa",
        "Cultivo de fresa",
        "Cultivo de frijoles",
        "Cultivo de frutas cítricas (incluye kinoto, etc.)",
        "Cultivo de frutas con pepita N. C. P. (incluye membrillo, níspero,  etc.)",
        "Cultivo de frutas de carozo (incluye ciruela, damasco, pelón, etc.)",
        "Cultivo de frutas N. C. P. (incluye cultivo de mamón)",
        "Cultivo de frutas, nueces, plantas cuyas hojas se utilizan para preparar bebidas y especies",
        "Cultivo de girasol",
        "Cultivo de granos de mostaza",
        "Cultivo de grosella",
        "Cultivo de guisantes",
        "Cultivo de habas",
        "Cultivo de higo",
        "Cultivo de hortalizas de hoja y de otras hortalizas frescas (incluye acelga, apio, choclo, etc.)",
        "Cultivo de hortalizas, legumbres y productos de vivero",
        "Cultivo de jengibre",
        "Cultivo de kiwi",
        "Cultivo de laver y otros tipos de algas comestibles",
        "Cultivo de lechosa",
        "Cultivo de lechuga",
        "Cultivo de legumbres frescas (incluye arveja, garbanzos, poroto, judía, etc.)",
        "Cultivo de legumbres secas",
        "Cultivo de lentejas",
        "Cultivo de limones y lima",
        "Cultivo de lino y cáñamo",
        "Cultivo de mago",
        "Cultivo de maíz",
        "Cultivo de mandarinas",
        "Cultivo de manzana",
        "Cultivo de materias vegetales de las especies utilizadas principalmente para el trenzado",
        "Cultivo de melocotones",
        "Cultivo de melones y otros frutales",
        "Cultivo de monte",
        "Cultivo de nabos",
        "Cultivo de ñame",
        "Cultivo de naranjas",
        "Cultivo de nueces",
        "Cultivo de nueces de anacardo",
        "Cultivo de nueces y frutas secas ",
        "Cultivo de nuez moscada",
        "Cultivo de oleaginosas N. C. P. (incluye cultivo de oleaginosas para aceites comestibles y/o uso industrial)",
        "Cultivo de otras bayas",
        "Cultivo de otras fibras",
        "Cultivo de otras frutas secas comestible",
        "Cultivo de otras hortalizas",
        "Cultivo de otras leguminosas",
        "Cultivo de otras raíces y tubérculos",
        "Cultivo de otros productos para la preparación de bebidas",
        "Cultivo de papas",
        "Cultivo de pastos forrajeros (incluye alfalfa, moho, sorgo azucarado y forrajero, etc.)",
        "Cultivo de pepinos y pepinillos",
        "Cultivo de pera",
        "Cultivo de pimienta",
        "Cultivo de piña",
        "Cultivo de pistacho",
        "Cultivo de plantas cuyas hojas se utilizan para preparar bebidas (infusiones)",
        "Cultivo de plantas de interior y viveros",
        "Cultivo de plantas para fines ornamentales, incluyendo césped para trasplantar",
        "Cultivo de plantas para la elaboración de mate",
        "Cultivo de plantas para la elaboración de te ",
        "Cultivo de plantas para la obtención de fibras N. C. P. (incluye cultivo de formio, maíz de guinea, ramio, etc.)",
        "Cultivo de plantas sacaríferas N. C. P. (incluye el cultivo de remolacha azucarera, etc.)",
        "Cultivo de plantas vivas para los bulbos, tubérculos, y raíces, esquejes e injertos",
        "Cultivo de puerros y demás hortalizas albaceas",
        "Cultivo de sandias",
        "Cultivo de semilla de cártamo",
        "Cultivo de semillas de frutas",
        "Cultivo de semillas de hortalizas, excepto la semilla de remolacha",
        "Cultivo de semillas de remolacha (excluye la remolacha azucarera) y semillas de plantas forrajeras",
        "Cultivo de semillas de soja",
        "Cultivo de setas y trufas",
        "Cultivo de sisal y demás fibras textiles del genero agave",
        "Cultivo de sorgo en grano",
        "Cultivo de tabaco",
        "Cultivo de tomates",
        "Cultivo de toronjas",
        "Cultivo de trigo",
        "Cultivo de uvas",
        "Cultivo de vainilla",
        "Cultivo de vegetales para la plantación",
        "Cultivo de vid para vinificar",
        "Cultivo de yuca",
        "Cultivo de yute, el kenaf y otras fibras textiles",
        "Cultivo de zanahorias",
        "Cultivos en General; cultivo de productos de mercado; Horticultura. ",
        "Cultivos industriales N. C. P. (incluye el cultivo de olivo para conserva, palmitos, etc.)",
        "Cursos de repaso para exámenes profesionales",
        "Curtido y adobo de cueros",
        "Curtido y terminación de cueros",
        "Demolición y voladura de edificios y sus partes (incluye los trabajos de limpieza de escombros asociados a la demolición)",
        "Desalinización de agua de mar o subterránea para producir agua como principal producto de interés",
        "Desarrollo y la transformación de películas de cine",
        "Desmontado de algodón y preparación de fibras de algodón",
        "Destilación de alcohol etílico",
        "Destilación, rectificación y mezcla de bebidas alcohólicas",
        "Destilado de whisky",
        "Desulfurización de gas",
        "Devanado y lavado de seda",
        "Dibujantes",
        "Difusión de la información, representación ante agencias estatales",
        "Diplomáticos y/o cónsules",
        "Diseñadores de alta costura",
        "Diseñadores de calzados",
        "Diseñadores de joyería",
        "Diseñadores de muebles y demás decoraciones de interiores",
        "Diseñadores de otros bienes de moda así como otros efectos personales o enseres domésticos",
        "Diseñadores de prendas de vestir",
        "Diseño de productos de imprenta, bocetos y maniquíes",
        "Diseño e instalación de letreros y vallas",
        "Diseño, desarrollo e instalación de software",
        "Disposición de lino, uniformes de trabajo y prendas conexas por las lavanderías",
        "Distribución de agua a través de la red, por camiones u otros medios",
        "Distribución de cintas de video, DVD",
        "Distribución de energía eléctrica",
        "Distribución de espacios publicitarios en las vallas",
        "Distribución de filmes y videocintas",
        "Distribución de producciones similares a los teatros de cine, televisión y redes de estaciones",
        "Distribución o entrega de material publicitario",
        "Distribución y entrega de correspondencias y paquetes",
        "Drenaje de los productos agrícolas y forestales",
        "Drenaje y separación de hidrocarburos líquido",
        "Edición de grabaciones",
        "Edición de libros, folletos, partituras y otras publicaciones",
        "Edición de periódicos, revistas y publicaciones periódicas",
        "Edición N. C. P.",
        "Edición, titilación, subtitulación y colocación de los créditos",
        "Educación escolar general en la segunda etapa del nivel secundario",
        "Educación especial para estudiantes discapacitados en el nivel secundario",
        "Educación especial para estudiantes discapacitados en este nivel",
        "Educación especial para estudiantes discapacitados en formación técnica o profesional",
        "Educación post secundaria no terciaria",
        "Educación primaria",
        "Educación que no es definida por niveles",
        "Ejecución y mantenimiento de instalaciones eléctricas y electrónicas N. C.P. (incluye la instalación de antenas, pararrayos)",
        "Elaboración de aceite y grasa animal no comestible",
        "Elaboración de aceites y grasas de origen vegetal y animal",
        "Elaboración de aceites y grasas vegetales refinadas (no incluye aceite de maíz)",
        "Elaboración de aceites y grasas vegetales sin refinar y sus subproductos; elaboración de aceite virgen",
        "Elaboración de alcoholes cíclicos y acíclicos",
        "Elaboración de alimentos a base de cereales",
        "Elaboración de alimentos preparados para animales",
        "Elaboración de almidones y productos derivados del almidón",
        "Elaboración de almidones y productos derivados del almidón (incluye la elaboración de glucosa, gluten, aceites de maíz)",
        "Elaboración de aluminio primario y semielaborados de aluminio",
        "Elaboración de amoniaco, cloruro de amonio, carbonato de amonio, nitritos y nitratos de potasio",
        "Elaboración de azúcar",
        "Elaboración de azúcar de la remolacha",
        "Elaboración de bebidas no alcohólicas y aguas minerales",
        "Elaboración de cigarrillos y cigarros",
        "Elaboración de combustible nuclear",
        "Elaboración de compuestos orgánicos de nitrógeno, incluyendo la amina",
        "Elaboración de extractos, jarabes y concentrados",
        "Elaboración de fiambres y embutidos",
        "Elaboración de frutas, hortalizas y legumbres congeladas",
        "Elaboración de frutas, hortalizas y legumbres deshidratadas o disecadas",
        "Elaboración de glicerina sintética",
        "Elaboración de hidrocarburos acíclicos saturados y no saturados",
        "Elaboración de hidrocarburos cíclicos saturados y no saturados",
        "Elaboración de hielo, jugos envasados para diluir y otras bebidas no alcohólicas",
        "Elaboración de leches, productos lácteos deshidratados (incluye la estandarización, homogenización, pasterización y esterilizado)",
        "Elaboración de macarrones, fideos alcuzcuz y productos farináceos",
        "Elaboración de margarinas y grasas vegetales",
        "Elaboración de masas y productos de pastelería",
        "Elaboración de otros compuestos de función de oxigeno, incluyendo aldehídos, cetona y quinonas",
        "Elaboración de otros productos alimenticios N. C. P.",
        "Elaboración de pastas alimentarias frescas",
        "Elaboración de pastas alimentarias secas",
        "Elaboración de productos alimenticios N. C. P. (incluye la elaboración de polvos para preparar postres y gelatinas)",
        "Elaboración de productos alimenticios y bebidas",
        "Elaboración de productos de confitería de cacao y chocolate",
        "Elaboración de productos de confiterías N. C. P. (incluye caramelos, frutas confitadas, pastillas, etc.)",
        "Elaboración de productos de molinería",
        "Elaboración de productos de panadería",
        "Elaboración de productos de pescados de mar, crustáceos y productos marinos N. C. P",
        "Elaboración de productos de pescados de río y lagunas y otros productos fluviales y lacustres",
        "Elaboración de productos de tabaco",
        "Elaboración de productos de tabaco N. C. P.",
        "Elaboración de productos lácteos",
        "Elaboración de queso (incluye la producción de suero)",
        "Elaboración de sidra, y otras bebidas alcohólicas fermentadas a partir de frutas",
        "Elaboración de té y yerba mate",
        "Elaboración de tofu",
        "Elaboración de vinos",
        "Elaboración de vinos (incluye el fraccionamiento)",
        "Elaboración de yerba mate",
        "Elaboración industrial de productos de panadería, excluidas galletas y bizcochos",
        "Elaboración primaria de minerales no metálicos N. C. P.",
        "Elaboración y conservación de frutas, legumbres y hortalizas",
        "Elaboración y envasado de dulces, mermeladas y jaleas",
        "Elaboración y molienda de hierbas aromáticas y especias",
        "Eliminación de desperdicios y aguas residuales, saneamiento y servicios similares",
        "Embajadas, Consulados, y Misiones extranjeras",
        "Embalaje de paquetes y regalos",
        "Embalaje de seguridad o preparados farmacéuticos",
        "Embalaje, envasado y almacenamiento de residuos y desechos",
        "Embarcado y cuidado de animales de granja",
        "Embasado de líquidos, incluidos las bebidas y los alimentos",
        "Embotellado de aguas naturales y minerales",
        "Emisión de programas de televisión",
        "Emisión y administración de dinero",
        "Empleados (asalariados)",
        "Empleados y obreros",
        "Empresas de empaque",
        "Engorde en corrales (fed-lot)",
        "Enmarcados",
        "Enrutamiento de correo",
        "Ensaladas",
        "Ensamblado de pieles de peletería, placas, esteras, etc.",
        "Ensamblaje de maquinarias y equipos (incluye las eléctricas)",
        "Ensamblaje de vehículos automotores",
        "Ensayos y análisis técnico",
        "Enseñanza inicial y primaria",
        "Enseñanza para adultos y servicios de enseñanza N. C. P.",
        "Enseñanza para adultos y servicios de enseñanza N. C. P. (incluye instrucción impartida mediante programas de radio, televisión)",
        "Enseñanza primaria",
        "Enseñanza secundaria",
        "Enseñanza secundaria de formación general",
        "Enseñanza secundaria de formación técnica o profesional",
        "Enseñanza superior y formación de posgrado",
        "Enseñanza terciaria (escuelas o institutos técnicos, profesionales o comerciales)",
        "Enseñanza universitaria excepto formación de postgrado",
        "Enterramiento o la prestación de servicios de cremación",
        "Entidades públicas de intermediación financiera",
        "Entrenamiento computacional",
        "Entrenamiento de supervivencia",
        "Entrenamiento para oratoria",
        "Entrenamiento para preparar computadoras",
        "Equipos de producción grafica, animación y efectos especiales",
        "Escritura de constituciones, contratos de sociedades colectivas y documentos similares para la formación de sociedades",
        "Escuela de vuelo y entrenamiento de salvavidas",
        "Escuelas de conducir",
        "Escuelas de conducir para chóferes profesionales",
        "Escuelas de cosmetología y barbería",
        "Escuelas especializadas en minusválidos",
        "Espigado de tela",
        "Estabilización de cultivos",
        "Estadios de futbol, hockey, cricket, baseball",
        "Estadios de pista y campo",
        "Estudio de mercado, realización de encuestas de opinión publica",
        "Estudios de grabación o producción musical",
        "Etiquetado, estampado e impreso",
        "Evaluación de daños",
        "Evaluación de madera",
        "Evaluación de riesgo",
        "Excavación de zanjas, eliminación de rocas y voladuras",
        "Exhibición de filmes y videotecas",
        "Expedición y obtención de documentos de transporte y conocimiento de embarque",
        "Expendio de helados",
        "Explotación de criaderos de peces, granjas piscícolas y otros frutos acuáticos (acuicultura)",
        "Explotación de minas y canteras N. C. P. (incluye aminato, baritina, cuarzo, diatomita, piedra pómez, ágata, agua marina)",
        "Explotación de otras minas y canteras N. C. P.",
        "Explotación de viveros forestales (incluye la propagación de especies forestales)",
        "Extracción de aceites bituminosos o de esquistos bituminosos o de arena de alquitrán",
        "Extracción de arcilla y caolín (incluye andalucita, arcilla, bentonita, caolín, piriofilita, silimanita, mullita, tierra de chamota o de dinas, etc.)",
        "Extracción de arena, canto rodado y triturado pétreos (incluye la arena para la construcción, arena silícea, otras arenas naturales, canto rodado, etc.)",
        "Extracción de asfalto naturales, asfaltito y roca; betún natural sólido",
        "Extracción de boratos naturales y sulfato de magnesio natural",
        "Extracción de cobre",
        "Extracción de condensados",
        "Extracción de guano",
        "Extracción de magnesio, cromo, cobalto, molibdeno, tantalio, etc.",
        "Extracción de materiales abrasivos, asbesto, silicios fósiles, granito natural, esteatita, feldespato, etc.",
        "Extracción de metales preciosos: oro, plata y platino",
        "Extracción de minerales de hierro",
        "Extracción de minerales de hierro (incluye hematitas, limonitas, magnetitas, siderita, etc.)",
        "Extracción de minerales metalíferos no ferrosos, excepto minerales de uranio y torio",
        "Extracción de minerales metalíferos no ferrosos, excepto minerales de uranio y torio (incluye aluminio, níquel)",
        "Extracción de minerales para la fabricación de abonos excepto turba (incluye silvita, silvinita y otras sales de potasio naturales)",
        "Extracción de minerales para la fabricación de fertilizantes y productos químicos",
        "Extracción de minerales para la fabricación de productos químicos (incluye azufre, boracita e hidroboracita, calcita, celestina, celestina, etc.)",
        "Extracción de minerales y concentrados de uranio y torio",
        "Extracción de minerales y concentrados uranio y torio",
        "Extracción de petróleo crudo y gas natural",
        "Extracción de petróleo crudo y gas natural (incluye gas natural licuado y gaseoso, arenas alquitraniferas, esquistos bituminosos, etc.)",
        "Extracción de pichtblende",
        "Extracción de piedra caliza y yeso (incluye caliza, castina, conchilla, riolita, etc.)",
        "Extracción de piedra, arena y arcilla",
        "Extracción de piedras preciosas, cuarzo, mica, etc.",
        "Extracción de plomo, zinc y estaño",
        "Extracción de productos forestales de bosques cultivados (incluye la tala de árboles, devaste de troncos y producción de madera en bruto)",
        "Extracción de productos forestales de bosques nativos (incluye tala de árboles, devaste de troncos y producción de madera en bruto, leña)",
        "Extracción de rocas ornamentales (incluye areniscas, cuarcita, dolomita, granito, mármol, piedra laja, pizarra, pórfido, serpentina, etc.)",
        "Extracción de sal",
        "Extracción de sal de roca incluida la molienda",
        "Extracción de sal en salinas y de roca",
        "Extracción de tiza y dolomita",
        "Extracción y aglomeración de carbón (incluye la producción de hulla no aglomerada, antracita, carbón bituminoso no aglomerado, briqueta)",
        "Extracción y aglomeración de carbón a través de métodos de licuefacción",
        "Extracción y aglomeración de carbón de piedra",
        "Extracción y aglomeración de carbón mediante explotación minera a cielo abierto",
        "Extracción y aglomeración de lignito (carbón marrón)",
        "Extracción y aglomeración de lignito (incluye la producción de lignito aglomerado y no aglomerado)",
        "Extracción y aglomeración de lignito a través de métodos de licuefacción",
        "Extracción y aglomeración de lignito mediante explotación minera a cielo abierto",
        "Extracción y aglomeración de turba",
        "Extracción y aglomeración de turba (incluye la producción de turba utilizada como corrector de suelo)",
        "Extracción y dragado de arena industrial",
        "Extracción y dragado de arena para la construcción y grava",
        "Extracción y preparación de piritas y pirrotina",
        "Extractos y concentrados de café",
        "Fabricación cuerda, cordeles, bramante",
        "Fabricación de  bancos, sillas y otros asientos para laboratorios y mobiliarios de laboratorios",
        "Fabricación de abonos y compuestos de nitrógeno",
        "Fabricación de abrazaderas",
        "Fabricación de abridores de lata",
        "Fabricación de abrigos, trajes, conjuntos, chaquetas, pantalones, faldas, etc.",
        "Fabricación de abrillantadores y cremas para cristales y metales",
        "Fabricación de abrillantadores y cremas para maderas",
        "Fabricación de abrillantadores y cremas para pieles",
        "Fabricación de accesorios de vestir de cuero",
        "Fabricación de accesorios de vestir excepto de cuero",
        "Fabricación de accesorios para la iluminación de calle",
        "Fabricación de accesorios sanitarios de cerámica",
        "Fabricación de aceite de frijol refinado",
        "Fabricación de aceite de frijol, soja",
        "Fabricación de aceite de maíz",
        "Fabricación de aceite de oliva",
        "Fabricación de aceite de oliva refinado",
        "Fabricación de aceite de palma",
        "Fabricación de aceite de semilla de algodón",
        "Fabricación de aceite de semilla de girasol",
        "Fabricación de aceite de soja refinado",
        "Fabricación de aceite lubricante a base de aceites o grasas incluidos aceite usado",
        "Fabricación de aceite térmico",
        "Fabricación de aceites y grasas de origen animal comestible",
        "Fabricación de acordeones e instrumentos similares incluyendo los órganos de boca",
        "Fabricación de acumuladores eléctricos",
        "Fabricación de acumuladores y de pilas y baterías primarias e inversores",
        "Fabricación de acumuladores y pilas y baterías primarias",
        "Fabricación de aditivos preparados para cemento",
        "Fabricación de adornos para automóviles",
        "Fabricación de aerodeslizadores para la recreación",
        "Fabricación de aeronaves, naves espaciales y de maquinaria conexa",
        "Fabricación de agua destilada",
        "Fabricación de agua destilada aromática",
        "Fabricación de aguas endulzadas y/o aromatizadas",
        "Fabricación de agujas, revestimientos para el suelo",
        "Fabricación de aisladores eléctricos y piezas aislantes de cerámica",
        "Fabricación de alambre de acero",
        "Fabricación de alambre de púa",
        "Fabricación de álbumes y similares",
        "Fabricación de álcalis, lejía y otros compuestos inorgánicos de bases, salvo el amoniaco",
        "Fabricación de aleaciones de cobre",
        "Fabricación de aleaciones de plomo, zinc y estaño",
        "Fabricación de alfombras",
        "Fabricación de alfombras, tapetes y baldosas",
        "Fabricación de alimentos de frutos y pastas",
        "Fabricación de alimentos para aves, peces, etc.",
        "Fabricación de alimentos para perros y gatos",
        "Fabricación de alquídicas y resinas de poliéster",
        "Fabricación de ametralladoras ligeras",
        "Fabricación de ametralladoras pesadas",
        "Fabricación de amplificadores de instrumentos musicales",
        "Fabricación de anillos de goma y sus accesorios",
        "Fabricación de animales de juguete",
        "Fabricación de antenas de transmisión y recepción",
        "Fabricación de antibióticos",
        "Fabricación de anticongelantes",
        "Fabricación de antisueros y otras fracciones de sangre",
        "Fabricación de aparatos de control de limite hidrónicos",
        "Fabricación de aparatos de destilación, centrifugadoras de laboratorio",
        "Fabricación de aparatos de distribución y control de la energía eléctrica",
        "Fabricación de aparatos de iluminación para árboles de navidad",
        "Fabricación de aparatos eléctricos y otros industriales de laboratorios",
        "Fabricación de aparatos no eléctricos de soldadura y equipos de soldadura",
        "Fabricación de aparatos para control de llamas y quemadores",
        "Fabricación de aparatos para controles ambientales y controles automáticos",
        "Fabricación de aparatos para uso domésticos",
        "Fabricación de aparatos y accesorios eléctricos N. C. P.",
        "Fabricación de aparatos y accesorios para fotografía excepto películas, placas y papeles sensibles",
        "Fabricación de arcos y ballestas",
        "Fabricación de armas y municiones",
        "Fabricación de arnés de cableado de encendido",
        "Fabricación de artefactos para la iluminación excepto los eléctricos",
        "Fabricación de artículos confeccionados de materiales textiles excepto prendas de vestir N. C. P.",
        "Fabricación de artículos confeccionados de materiales textiles, tejeduras de productos textiles, excepto prendas de vestir",
        "Fabricación de artículos de asfalto o material similar",
        "Fabricación de artículos de cemento y fibrocemento",
        "Fabricación de artículos de cestería, caña y mimbre",
        "Fabricación de artículos de cuchillería y utensilios de mesa y de cocina",
        "Fabricación de artículos de cuchillería, herramientas de mano y artículos de ferretería",
        "Fabricación de artículos de deporte",
        "Fabricación de artículos de deporte (incluye equipos de deporte, para gimnasios y campos de juego, equipos de pesca y camping)",
        "Fabricación de artículos de guarnicionaría o talabartería",
        "Fabricación de artículos de hormigón, de cemento y de yeso",
        "Fabricación de artículos de la riqueza natural o aglomerado de corcho, incluida revestimiento para suelo",
        "Fabricación de artículos de lonas y sucedáneos de lona",
        "Fabricación de artículos de madera en tornería",
        "Fabricación de artículos de papel y cartón de uso domestico e higiénico sanitario",
        "Fabricación de artículos de papel y cartón N. C. P.",
        "Fabricación de artículos de piel N. C. P.",
        "Fabricación de artículos de talabartería y artículos de cuero N. C. P.",
        "Fabricación de artículos de vestir de caucho",
        "Fabricación de artículos higiénicos de goma",
        "Fabricación de artículos para afeitar, incluidos los pre-afeitados y para después del afeitado",
        "Fabricación de artículos para la caza, el montañismo",
        "Fabricación de artículos para la pesca deportiva",
        "Fabricación de artillería",
        "Fabricación de ascensores, escaleras mecánicas y pasillos móviles",
        "Fabricación de asientos de automóviles",
        "Fabricación de asientos de avión",
        "Fabricación de aspiradoras",
        "Fabricación de ataúdes",
        "Fabricación de audífonos",
        "Fabricación de autobuses",
        "Fabricación de autopartes de caucho excepto cámaras y cubiertas",
        "Fabricación de aviones para el uso de las fuerzas de defensa",
        "Fabricación de azucares químicamente puros",
        "Fabricación de balones inflables",
        "Fabricación de bandas de relojes no metálicas",
        "Fabricación de bandejas de pulpa moldeada",
        "Fabricación de bandera, pancartas, banderines, etc.",
        "Fabricación de baños plásticos y artículos para el baño de plástico",
        "Fabricación de barcos de pesca y barcos factorías para el procesamiento del pescado",
        "Fabricación de barras de acero",
        "Fabricación de barriles, cubos, tubas y otros productos de madera",
        "Fabricación de baterías de acido de plomo",
        "Fabricación de baterías de celdas húmedas",
        "Fabricación de baterías de litio",
        "Fabricación de baterías de NiCad",
        "Fabricación de baterías de NiMH",
        "Fabricación de bebidas gaseosas exceptuando la soda",
        "Fabricación de bebidas no alcohólicas excepto cervezas sin alcohol y vino",
        "Fabricación de becarán y telas rígidas",
        "Fabricación de bicicletas y sillas de ruedas para inválidos",
        "Fabricación de bisutería y accesorios",
        "Fabricación de bloqueadores solares",
        "Fabricación de bloques de pisos en arcilla cocida",
        "Fabricación de bloques de suelo de parquet montados en paneles",
        "Fabricación de bloques de vidrio",
        "Fabricación de bolas y cojinetes de rodillos y sus partes",
        "Fabricación de bolsas de materiales textiles para productos a granel",
        "Fabricación de bombas hidráulicas",
        "Fabricación de bombas manuales",
        "Fabricación de bombas para aceite y de agua, bombas de combustibles de los vehículos de motor",
        "Fabricación de bombas para líquidos que estén o no provistos de un dispositivo de medición",
        "Fabricación de bombas; compresores; grifos y válvulas",
        "Fabricación de botellas y otros recipientes de vidrio o cristal",
        "Fabricación de botes inflables y balsas",
        "Fabricación de botones, sujetadores de equipos y cremalleras",
        "Fabricación de brandy",
        "Fabricación de brindas planas y brindas forjadas con anillos",
        "Fabricación de briquetas de petróleo",
        "Fabricación de briquete de combustible",
        "Fabricación de brocas, fresas, punzones, etc.",
        "Fabricación de brochas, pinceles, escobas y cepillos que constituyan entre ellos partes de maquinas",
        "Fabricación de buques de guerra",
        "Fabricación de buscadores de rango",
        "Fabricación de cabañas, elementos modulares para exposición, etc.",
        "Fabricación de cable de metal, trenzas y artículos similares",
        "Fabricación de cacao, chocolate y productos a base de cacao",
        "Fabricación de cadenas de eslabones articulados",
        "Fabricación de cadenas de transmisión de potencia",
        "Fabricación de cajas de archivos para oficinas y artículos similares",
        "Fabricación de cajas de cables eléctricos ",
        "Fabricación de cajas de música",
        "Fabricación de cajas de seguridad",
        "Fabricación de cajas registradoras operadas mecánicamente",
        "Fabricación de cajas y moldes, excepto lingoteras",
        "Fabricación de cajas y otras plataformas de carga",
        "Fabricación de cajas, sobres y presentaciones similares con un surtido de artículos de papelería",
        "Fabricación de cal",
        "Fabricación de calandrias u otras maquinas laminadoras (a excepción de metal y vidrio)",
        "Fabricación de calculadoras, eléctricas o no",
        "Fabricación de calderas de calefacción central y radiadores",
        "Fabricación de caldera-turbina",
        "Fabricación de calefactores eléctricos de resistencia",
        "Fabricación de calentadores de agua eléctricos",
        "Fabricación de calzado de cuero, excepto el ortopédico",
        "Fabricación de calzado de encaje",
        "Fabricación de calzado de tela, plástico, goma, caucho y otros materiales, excepto los ortopédicos y de asbesto",
        "Fabricación de calzado y sus partes",
        "Fabricación de cama de bronceado",
        "Fabricación de cámaras de películas y cámaras digitales",
        "Fabricación de camas de hospitales con ajustes mecánicos",
        "Fabricación de camines mezcladores de hormigón",
        "Fabricación de camiones bomberos, barredores de calle y vehículos blindados",
        "Fabricación de camiones de obras sean o no equipados con equipos de elevación o manipulación",
        "Fabricación de camisas, camisetas y blusas",
        "Fabricación de campanas eléctricas",
        "Fabricación de candados, cerraduras, llaves, bisagras y similares, de hardware para los edificios, mobiliarios, vehículos, etc.",
        "Fabricación de cañones móviles",
        "Fabricación de cañones y pistolas de aire o gas",
        "Fabricación de carbón activado, aditivos para aceite lubricante, aceleradores y catalizadores",
        "Fabricación de carbón duro y lignito y briquetas combustibles",
        "Fabricación de carburadores",
        "Fabricación de cargadores de batería de estado sólido",
        "Fabricación de carpintería metálica",
        "Fabricación de carretes de madera para cables",
        "Fabricación de carrocería de vehículos automotores; fabricación de remolques y semirremolques",
        "Fabricación de carrocería para vehículos automotores, fabricación de remolques y semirremolque",
        "Fabricación de carrocerías de vehículos automotores; fabricación de remolques y semirremolques",
        "Fabricación de cartuchos de tóner",
        "Fabricación de casas móviles",
        "Fabricación de cascos de realidad virtual",
        "Fabricación de casetes magnéticos de video y de audio",
        "Fabricación de células que contienen dióxido de magnesio, dióxido de mercurio, oxido de plata",
        "Fabricación de celulosas y sus derivados químicos",
        "Fabricación de cemento de la cal y del yeso",
        "Fabricación de cementos",
        "Fabricación de central telefónica privada, equipo (PBX)",
        "Fabricación de centrifugadoras (excepto separadores de crema y secadoras de ropa)",
        "Fabricación de cera de parafina",
        "Fabricación de cerámica no refractaria",
        "Fabricación de cerámica refractaria",
        "Fabricación de cerámica y los imanes de ferrita",
        "Fabricación de ceras",
        "Fabricación de ceras artificiales y ceras preparadas",
        "Fabricación de cercas de alambre",
        "Fabricación de cerraduras de tiempo",
        "Fabricación de cerraduras, herraje y artículos de ferretería N. C. P. (no incluye clavos, productos de buhonería, vajilla de mesa)",
        "Fabricación de cerveza negra",
        "Fabricación de cerveza, bebidas malteadas y de malta",
        "Fabricación de chalecos",
        "Fabricación de chales",
        "Fabricación de champú, lacas para el cabello",
        "Fabricación de chocolates y confitería de chocolate",
        "Fabricación de cigarros",
        "Fabricación de cilindros hidráulicos y neumáticos",
        "Fabricación de cintas de tela sensibles a la presión",
        "Fabricación de cintas magnéticas de video y de audio",
        "Fabricación de cintas transportadoras",
        "Fabricación de cintas transportadoras de goma o correas de transmisión o de bandas",
        "Fabricación de cinturones",
        "Fabricación de cinturones de conducción, envases etc.",
        "Fabricación de cinturones de seguridad, airbags, puertas y parachoques",
        "Fabricación de circuitos impresos",
        "Fabricación de circuitos integrados (análogos, digitales o híbridos)",
        "Fabricación de coches de viajeros, vagones de mercancía y vagones cisternas",
        "Fabricación de cocinas, estufas y calefactores de uso domestico no eléctricos",
        "Fabricación de cojines de descarga",
        "Fabricación de cojinetes; engranajes; trenes de engranaje y piezas de transmisión",
        "Fabricación de cola, adhesivos y cementos excepto los odontológicos obtenidos de sustancias minerales y vegetales",
        "Fabricación de colores preparados de pigmentos y colorantes ",
        "Fabricación de combustible nuclear",
        "Fabricación de combustibles de la refinación del petróleo",
        "Fabricación de combustibles gaseosos con un valor calorífico",
        "Fabricación de comparadores ópticos",
        "Fabricación de componentes de cuero",
        "Fabricación de componentes de pantallas",
        "Fabricación de compuesto de calafateo y similares",
        "Fabricación de compuestos para diagnósticos de laboratorio",
        "Fabricación de computadoras de escritorio",
        "Fabricación de computadoras portátiles",
        "Fabricación de concentrados de frutas y hortalizas frescas",
        "Fabricación de condensadores eléctricos",
        "Fabricación de condensadores, economizadores y colectores de vapor",
        "Fabricación de conductos de admisión y válvulas de escapes de los motores de combustión interna",
        "Fabricación de conductos de los aparatos eléctricos",
        "Fabricación de conductos eléctricos",
        "Fabricación de conservas o congelados de pastas",
        "Fabricación de consolas de videojuegos",
        "Fabricación de contenedores de papel o cartón corrugado",
        "Fabricación de contenedores metálicos para gases comprimidos o licuados",
        "Fabricación de contenedores para el transporte",
        "Fabricación de coque y de productos de refinación del petróleo",
        "Fabricación de corbatas",
        "Fabricación de cordón de cuero",
        "Fabricación de cortinas estéril, cadenas y tejidos quirúrgicos",
        "Fabricación de cortinas, doseles, colchas, cubre muebles, etc.",
        "Fabricación de cosechadoras, trilladoras y clasificadoras",
        "Fabricación de cosméticos, perfumes  y productos de higiene y tocador",
        "Fabricación de crema de leche fresca esterilizada",
        "Fabricación de crema de leche fresca homogeneizada",
        "Fabricación de crema de leche fresca pasteurizada",
        "Fabricación de cremas depiladoras",
        "Fabricación de crisoles, espátulas, ánodos de galvanoplasta",
        "Fabricación de cristales electrónicos",
        "Fabricación de cubiertas y cámaras de caucho",
        "Fabricación de cuchillas",
        "Fabricación de cuchillos y hojas cortantes para maquinas o aparatos mecánicos",
        "Fabricación de cuerdas o cables equipados con aro de metal",
        "Fabricación de cuerdas, cordeles, bramantes y redes",
        "Fabricación de curtientes naturales y sintéticos",
        "Fabricación de cuscús",
        "Fabricación de dentífrico y artículos para la higiene bucal",
        "Fabricación de desinfectantes (para la agricultura y otros usos)",
        "Fabricación de desodorantes y sales de baño",
        "Fabricación de detectores de mina, detectores de metales",
        "Fabricación de detectores de movimientos",
        "Fabricación de detergentes en polvo en estado sólido o líquido",
        "Fabricación de dientes artificiales, puentes realizados en laboratorios dentales",
        "Fabricación de diodos emisores de luz (LED)",
        "Fabricación de diodos, transistores y dispositivos discretos",
        "Fabricación de dirigibles y globos aerostáticos",
        "Fabricación de discos duros",
        "Fabricación de discos magnéticos, unidades flash y otros dispositivos de almacenamiento",
        "Fabricación de discos ópticos en blanco",
        "Fabricación de diskettes",
        "Fabricación de disolventes y diluyentes de compuestos orgánicos",
        "Fabricación de dispensadores de cinta",
        "Fabricación de dispositivos de propulsión de vehículos",
        "Fabricación de dispositivos GPS",
        "Fabricación de disyuntores de potencia (fusibles-breakers)",
        "Fabricación de diversos productos de plástico",
        "Fabricación de dolomita calcinada",
        "Fabricación de edredones, cojines, almohadas, sacos de dormir, etc.",
        "Fabricación de ejes de transmisión y manivelas, árboles de levas, cigüeñales, bielas, etc.",
        "Fabricación de ejes, ruedas, frenos, partes de freno, amortiguadores y partes de amortiguación",
        "Fabricación de ejes, ruedas, suspensiones y amortiguadores",
        "Fabricación de electrodomésticos del tipo de hornos",
        "Fabricación de elementos químicos",
        "Fabricación de eliminadores de residuos",
        "Fabricación de embragues y órganos de acoplamientos",
        "Fabricación de empastes dentales, cementos, cera dental y otras preparaciones dentales en yeso",
        "Fabricación de encendedoras, pulidoras, batidoras, licuadoras y similares",
        "Fabricación de encendedores de cigarrillos",
        "Fabricación de engranajes, cajas de engranajes y otros variadores de velocidad",
        "Fabricación de envases a partir de residuos sólidos de cartón",
        "Fabricación de envases de cartón",
        "Fabricación de envases de papel",
        "Fabricación de envases de vidrio",
        "Fabricación de envases metálicos",
        "Fabricación de envases plásticos",
        "Fabricación de envases plegables de cartón",
        "Fabricación de equipamientos de todos los tipos de vehículos de motor, remolques y semirremolques",
        "Fabricación de equipo de comunicación móvil",
        "Fabricación de equipo de elevación y manipulación (incluye la fabricación de ascensores, escaleras mecánicas, montacargas, etc.)",
        "Fabricación de equipo de transporte N. C. P.",
        "Fabricación de equipo deportivo para gimnasio",
        "Fabricación de equipo electrónico N. C. P.",
        "Fabricación de equipo médico y quirúrgico y aparatos ortopédicos ",
        "Fabricación de equipo médico y quirúrgico y de aparatos ortopédicos",
        "Fabricación de equipo óptico de posicionamiento",
        "Fabricación de equipos de comunicaciones de datos",
        "Fabricación de equipos de conmutación de potencia",
        "Fabricación de equipos de conmutación para oficina",
        "Fabricación de equipos de control de incendio",
        "Fabricación de equipos de controles de procesos industriales",
        "Fabricación de equipos de iluminación para equipos de transporte",
        "Fabricación de equipos de inspección y pruebas de las propiedades físicas",
        "Fabricación de equipos de karaoke",
        "Fabricación de equipos de medición y pruebas de electricidad y señales eléctricas",
        "Fabricación de equipos de preparación de aire para su uso en sistema neumático",
        "Fabricación de equipos de radar",
        "Fabricación de equipos de sistemas de grabación de sonido",
        "Fabricación de equipos de transmisión hidráulica",
        "Fabricación de equipos estereos",
        "Fabricación de equipos ópticos de observación para armas",
        "Fabricación de equipos para verificación de emisiones automotriz",
        "Fabricación de escaleras y barandillas",
        "Fabricación de escáneres",
        "Fabricación de escobillas de goma",
        "Fabricación de escopetas",
        "Fabricación de esmaltes y barnices vitrificables, engobes y preparaciones similares",
        "Fabricación de espectrómetros",
        "Fabricación de espejos ópticos",
        "Fabricación de espejos y cristales",
        "Fabricación de esquís, bastones y botas de esquí",
        "Fabricación de estatuas, muebles, bajorrelieves, floreros y macetas",
        "Fabricación de estatuillas de madera y objetos de adornos",
        "Fabricación de estatuillas y otros artículos ornamentales de cerámica",
        "Fabricación de esteras",
        "Fabricación de esterilizadores de laboratorios",
        "Fabricación de estructuras metálicas para la construcción",
        "Fabricación de etiquetas (labels)",
        "Fabricación de etiquetas, insignias, etc.",
        "Fabricación de excavadoras",
        "Fabricación de explosivos como bombas, minas y torpedos",
        "Fabricación de explosivos, municiones y productos de pirotecnia",
        "Fabricación de extractos de glándulas y tratamientos de glándulas",
        "Fabricación de extractos de productos aromáticos naturales",
        "Fabricación de facticio",
        "Fabricación de fenólicas y resinas epoxi y poliuretanos",
        "Fabricación de fibra de vidrio",
        "Fabricación de fibras artificiales, excepto el vidrio",
        "Fabricación de fibras de carbono, de grafito y sus productos",
        "Fabricación de fibras manufacturadas",
        "Fabricación de figuras de acción",
        "Fabricación de figuras de cristal",
        "Fabricación de filamentos sintéticos o artificiales de hilo",
        "Fabricación de fósforos",
        "Fabricación de fraguas y yunques",
        "Fabricación de frazadas, mantas, ponchos, colchas, cobertores, etc.",
        "Fabricación de frenos hidráulicos, martillos de caída",
        "Fabricación de furgonetas, camiones, tractores de carretera para semirremolque",
        "Fabricación de fusibles eléctricos",
        "Fabricación de fusibles o tiras",
        "Fabricación de galletas",
        "Fabricación de galletitas y biscochos",
        "Fabricación de ganchos y dispositivos de acoplamiento",
        "Fabricación de gas, distribución de combustible gaseoso por tubería",
        "Fabricación de gases comprimidos y licuados",
        "Fabricación de generadores de energía (excepto alternadores de carga de baterías)",
        "Fabricación de generadores de motor (excepto el generador de turbina)",
        "Fabricación de generadores de vapor",
        "Fabricación de generadores y motores eléctricos",
        "Fabricación de generadores, alternadores y bujías",
        "Fabricación de ginebra",
        "Fabricación de glicerol crudo",
        "Fabricación de glucosa, jarabe de glucosa, maltosa, inulina, etc.",
        "Fabricación de gluten",
        "Fabricación de go-karts y similares incluyendo carros de carrera",
        "Fabricación de goma de mascar",
        "Fabricación de grabadoras de video",
        "Fabricación de grapadoras y saca grapas",
        "Fabricación de grifos y válvulas para los sistemas de calefacción",
        "Fabricación de grifos y válvulas sanitarios",
        "Fabricación de grúas, bastidores y elevadores móviles",
        "Fabricación de guantes",
        "Fabricación de guata de celulosa y napa de fibras de celulosa",
        "Fabricación de habitaciones de metal",
        "Fabricación de harina de papa",
        "Fabricación de harina, aceite y grasa a base de pescado N. C. P.",
        "Fabricación de heladeras, frezar, lavaplatos y secarropas",
        "Fabricación de helicópteros",
        "Fabricación de herramientas agrícolas de mano sin motor",
        "Fabricación de herramientas de mano y sus accesorios",
        "Fabricación de herramientas de prensado",
        "Fabricación de herramientas, piezas y accesorios para maquinas de trabajar los metales y otros materiales",
        "Fabricación de hilados de algodón y sus mezclas",
        "Fabricación de hilados de filamentos sintéticos o artificiales de remolque",
        "Fabricación de hilados de lana y sus mezclas",
        "Fabricación de hilados metalizados o entorchado",
        "Fabricación de hilados textiles excepto de lana y algodón",
        "Fabricación de hilo y cuerda de goma",
        "Fabricación de hilos de estos metales antes mencionados",
        "Fabricación de hilos y cables aislados",
        "Fabricación de hojas corrugadas y otras hojas, paneles y losetas",
        "Fabricación de hojas de madera para enchapado",
        "Fabricación de hojas de madera para enchapado fabricación de tableros y contrachapados, tableros laminados y paneles ",
        "Fabricación de hornos de laboratorio dental",
        "Fabricación de hornos y quemadores",
        "Fabricación de impresoras",
        "Fabricación de indicadores de nivel neumático",
        "Fabricación de inductores",
        "Fabricación de inhibidores de germinación y reguladores de crecimiento de plantas",
        "Fabricación de instrumentos analíticos de laboratorios",
        "Fabricación de instrumentos de cuerda con teclado, incluidos los pianos automáticos",
        "Fabricación de instrumentos de detección y seguimiento de radiación",
        "Fabricación de instrumentos de topografía",
        "Fabricación de instrumentos de viento",
        "Fabricación de instrumentos dentales",
        "Fabricación de instrumentos meteorológicos",
        "Fabricación de instrumentos musicales",
        "Fabricación de instrumentos musicales de juguete",
        "Fabricación de instrumentos musicales de percusión",
        "Fabricación de instrumentos musicales que el sonido se produce por vía electrónica",
        "Fabricación de instrumentos ópticos de aumento",
        "Fabricación de instrumentos ópticos y equipo fotografito",
        "Fabricación de instrumentos para motores de aeronaves",
        "Fabricación de instrumentos y aparatos para medir, verificar, ensayar, navegar y otros fines, excepto el equipo de control de procesos industriales",
        "Fabricación de instrumentos, piezas y accesorios",
        "Fabricación de intercambiadores a base de polímeros",
        "Fabricación de interruptores de cables eléctricos",
        "Fabricación de interruptores de energía eléctrica",
        "Fabricación de inversores de estado sólido, pilas de combustibles",
        "Fabricación de jabones y detergentes",
        "Fabricación de jabones y detergentes, preparados para limpiar y pulir, perfumes y preparados de tocador",
        "Fabricación de jarabe de azúcar",
        "Fabricación de jerseys",
        "Fabricación de joyas que contienen piedras de imitación tales como imitación de diamantes",
        "Fabricación de joyas y artículos conexos",
        "Fabricación de juegos de mesa y similares",
        "Fabricación de juegos electrónicos",
        "Fabricación de juegos que funcionan con monedas, billares, mesas especiales para juego de casino",
        "Fabricación de juegos y juguetes",
        "Fabricación de jugos naturales y sus concentrados de frutas y hortalizas",
        "Fabricación de juntas y uniones similares hechas de una combinación de materiales o capas del mismo material",
        "Fabricación de juntas, hojas y paneles de yeso",
        "Fabricación de la maquinaria para uso en general",
        "Fabricación de la turbina-generador",
        "Fabricación de ladrillos",
        "Fabricación de laminados con papel y cartón",
        "Fabricación de laminados de acero",
        "Fabricación de laminados de acero en caliente, barras y varillas de acero",
        "Fabricación de laminados de metales preciosos",
        "Fabricación de lámparas",
        "Fabricación de lámparas de carburo, eléctricas, de gas, queroseno",
        "Fabricación de lámparas de mesa",
        "Fabricación de lámparas eléctrica y equipos de iluminación ",
        "Fabricación de lámparas eléctricas contra insectos",
        "Fabricación de lana de madera, harina de madera, astillas",
        "Fabricación de lanzadores de cohetes",
        "Fabricación de lápices conduce",
        "Fabricación de lápices, lapiceras, bolígrafos, sellos y artículos similares para oficinas",
        "Fabricación de las partes de calzados",
        "Fabricación de las partes internas y externas de los calzados",
        "Fabricación de latas para productos alimenticios, tubos plegables",
        "Fabricación de lava platos",
        "Fabricación de lavavajillas",
        "Fabricación de leche líquida fresca esterilizada",
        "Fabricación de leche líquida fresca homogeneizada",
        "Fabricación de leche líquida fresca pasteurizada",
        "Fabricación de leche o nata en estado sólido",
        "Fabricación de lectores de tarjetas inteligentes",
        "Fabricación de lentes y otros artículos oftálmicos",
        "Fabricación de levadura",
        "Fabricación de lienzos preparados para el uso del pintor",
        "Fabricación de locomotoras y de material rodante",
        "Fabricación de locomotoras y de material rodante para ferrocarriles y tranvía con sistemas eléctricos, diesel o vapor",
        "Fabricación de los productos de la refinación del petróleo",
        "Fabricación de maceta con suelo de turba como principal componente",
        "Fabricación de macetas con mezcla de suelo natural",
        "Fabricación de madera desinfectada",
        "Fabricación de maletas, bolsos de mano y artículos de talabartería y guarnicionaría",
        "Fabricación de maletas, bolsos de mano, y similares, artículos de talabartería y artículos de cuero N. C. P.",
        "Fabricación de maltas",
        "Fabricación de mangos de madera para paraguas, bastones y similares",
        "Fabricación de mangueras y accesorios hidráulicos y neumáticos",
        "Fabricación de manipuladores mecánicos y robots industriales diseñados específicamente para elevación, carga y descarga",
        "Fabricación de mantas eléctricas",
        "Fabricación de mantequilla",
        "Fabricación de maquillaje",
        "Fabricación de maquina de lavado y secado de ropa",
        "Fabricación de máquina para la producción de artículos de papel o cartón",
        "Fabricación de maquinaria agropecuaria y forestal",
        "Fabricación de maquinaria agropecuaria y forestal, excepto tractores",
        "Fabricación de maquinaria de impresión textil",
        "Fabricación de maquinaria de oficina, contabilidad e informática",
        "Fabricación de maquinaria de pulverización para uso agrícola",
        "Fabricación de maquinaria de uso especial",
        "Fabricación de maquinaria de uso especial N. C. P.",
        "Fabricación de maquinaria de uso general N. C. P.",
        "Fabricación de maquinaria metalúrgica",
        "Fabricación de maquinaria para el lavado, blanqueo, teñido, acabado y recubrimiento de tejidos",
        "Fabricación de maquinaria para el tratamiento de materiales mediante cribado, selección, clasificación, lavado, trituración, etc.",
        "Fabricación de maquinaria para embasado de moneda y conteo de moneda",
        "Fabricación de maquinaria para hacer confitería de cacao o chocolate",
        "Fabricación de maquinaria para la avicultura, apicultura, equipos para la preparación de forraje",
        "Fabricación de maquinaria para la elaboración de alimentos, bebidas y tabaco",
        "Fabricación de maquinaria para la elaboración de productos textiles, prendas de vestir y cueros",
        "Fabricación de maquinaria para la explotación de minas y canteras y para obras de construcción",
        "Fabricación de maquinaria para la industria del papel y las artes graficas",
        "Fabricación de maquinaria para la limpieza de laboratorios de ultrasonido",
        "Fabricación de maquinaria para la perforación, corte, hundimiento de túneles",
        "Fabricación de maquinaria para la preparación de alimentos en hoteles y restaurantes",
        "Fabricación de maquinaria para la preparación de tabaco",
        "Fabricación de maquinaria para limpiar, seleccionar o clasificar huevos",
        "Fabricación de maquinaria para preparar frutas y vegetales",
        "Fabricación de maquinaria para preparar pescado y mariscos",
        "Fabricación de maquinaria para procesar carne de aves de corral",
        "Fabricación de maquinaria y equipo de oficina (excepto computadoras y equipos periféricos)",
        "Fabricación de maquinaria y equipo N. C. P.",
        "Fabricación de maquinarias para la extracción o preparación de aceites o grasas animales o vegetales",
        "Fabricación de maquinas auxiliares o equipos para maquinaria textil",
        "Fabricación de maquinas comerciales de lavado y secado",
        "Fabricación de maquinas de afeitar eléctricas, cepillos de dientes eléctricos y otros aparatos eléctricos del cuidado personal",
        "Fabricación de maquinas de afeitar y hojas de afeitar",
        "Fabricación de maquinas de coser y tejer",
        "Fabricación de maquinas de escribir",
        "Fabricación de maquinas de hilado",
        "Fabricación de maquinas de lavado en seco",
        "Fabricación de maquinas de limpieza por ultrasonidos",
        "Fabricación de maquinas de planchar incluyendo las prensas de fusión",
        "Fabricación de maquinas de polígrafos",
        "Fabricación de maquinas de protección de cheques",
        "Fabricación de maquinas de taquigrafía",
        "Fabricación de maquinas de telares, incluidos los telares de mano",
        "Fabricación de maquinas de ventas automáticas de productos",
        "Fabricación de maquinas estacionaria para clavar, grapar madera, corcho,  hueso, plástico",
        "Fabricación de maquinas fotocopiadoras",
        "Fabricación de maquinas herramienta, piezas para maquina de trabajar los metales y la madera (no eléctrica)",
        "Fabricación de maquinas ópticas de herramientas de precisión",
        "Fabricación de maquinas para el devanado de tejido",
        "Fabricación de maquinas para fabricar o reparar calzado u otro artículos de cuero, pieles",
        "Fabricación de maquinas para hacer nudo",
        "Fabricación de maquinas para la preparación de fibras textiles",
        "Fabricación de maquinas para la preparación de hilados textiles",
        "Fabricación de maquinas para la preparación, curtido o trabajo de cuero y pieles",
        "Fabricación de maquinas para la producción o acabado de fieltro o tela sin tejer",
        "Fabricación de maquinas y herramientas para el estampado y pulsado",
        "Fabricación de maquinas y herramientas para el torneado, taladrado y fresado",
        "Fabricación de marcadoras de fecha y hora",
        "Fabricación de marcos de madera para espejos y fotos",
        "Fabricación de marcos de madera para obras de arte",
        "Fabricación de masillas",
        "Fabricación de materia química inorgánica básica N. C. P.",
        "Fabricación de materiales a base de sustancias radioactiva para el diagnostico",
        "Fabricación de materiales de construcción de sustancias vegetales aglomerados con cemento, yeso u otros minerales",
        "Fabricación de materiales de fricción y artículos con una base de sustancias minerales o de celulosa",
        "Fabricación de materiales de vía férrea de acero",
        "Fabricación de materiales para pavimento y techado",
        "Fabricación de materiales utilizados en el acabado de los productos textiles y de cuero",
        "Fabricación de materias colorantes básicas, excepto pigmentos preparados",
        "Fabricación de materias plásticas en formas primarias N. C. P.",
        "Fabricación de materias químicas orgánicas básicas N. C. P. (incluye fabricación de alcoholes excepto el etílico, sustancias químicas para laboratorios",
        "Fabricación de mecanismos de filtrado y purificación",
        "Fabricación de mechas textiles y manguitos de incandescencia",
        "Fabricación de medias",
        "Fabricación de medicamentos de uso humano y productos farmacéuticos",
        "Fabricación de medicamentos para uso veterinario",
        "Fabricación de medidores de consumo",
        "Fabricación de medidores de flujos y aparatos para contar",
        "Fabricación de medidores de luz fotográfica",
        "Fabricación de melaza",
        "Fabricación de mesas de operación",
        "Fabricación de metales básicos",
        "Fabricación de mezcla de caucho sintético y caucho natural",
        "Fabricación de mezclas odoríferas de productos para la fabricación de perfumes o alimentos",
        "Fabricación de micrófonos",
        "Fabricación de microprocesadores",
        "Fabricación de microscopios de electrones y protones",
        "Fabricación de microscopios ópticos, binoculares y telescopios",
        "Fabricación de mobiliario para oficina",
        "Fabricación de molduras, tejas y listones de madera",
        "Fabricación de molinos, mezcladores, exprimidores de zumo",
        "Fabricación de monitores",
        "Fabricación de monitores de televisión",
        "Fabricación de monofilamentos o tiras sintéticas o artificiales",
        "Fabricación de morteros en polvo",
        "Fabricación de mosaicos",
        "Fabricación de mostaza",
        "Fabricación de motocicleta",
        "Fabricación de motores de ferrocarril",
        "Fabricación de motores de los vehículos automotores",
        "Fabricación de motores hidráulicos",
        "Fabricación de motores para motocicleta",
        "Fabricación de motores y turbinas, excepto motores para aeronaves, vehículos automotores y motocicletas",
        "Fabricación de motores, generadores y transformadores eléctricos",
        "Fabricación de motos de nieve, carritos de golf, vehículos anfibios",
        "Fabricación de mueblas para cocina",
        "Fabricación de muebles de piedra",
        "Fabricación de muebles especiales para tiendas, mostradores, vitrinas y estanterías",
        "Fabricación de muebles para iglesias y escuelas",
        "Fabricación de muebles y colchones",
        "Fabricación de muebles y marcos de ventana",
        "Fabricación de muebles y partes de muebles, principalmente de madera",
        "Fabricación de muebles y partes de muebles, principalmente de otros materiales (metal, plástico)",
        "Fabricación de múltiples unidades aislantes de paredes de vidrio",
        "Fabricación de muñecas, partes y accesorios",
        "Fabricación de municiones para guerra",
        "Fabricación de naipes",
        "Fabricación de neumáticos de rodaduras intercambiables, camelback tiras para el recauchutado de neumáticos",
        "Fabricación de neumáticos macizos o huecos",
        "Fabricación de objetos cerámicos excepto revestimiento de pisos y paredes N.C.P.",
        "Fabricación de objetos cerámicos para uso domestico excepto artefactos sanitario",
        "Fabricación de objetos de barro, loza, porcelana, etc.",
        "Fabricación de objetos de platería y artículos enchapados",
        "Fabricación de ojos de vidrio",
        "Fabricación de ollas de cerámica, frascos y artículos similares",
        "Fabricación de ordenadores de bolsillos",
        "Fabricación de órganos de tubo y teclado",
        "Fabricación de otras embarcaciones de recreo y deporte",
        "Fabricación de otros artículos de papel y cartón",
        "Fabricación de otros artículos similares",
        "Fabricación de otros cables eléctricos y electrónicos",
        "Fabricación de otros compuestos inorgánicos",
        "Fabricación de otros productos agroquímicos N. C. P.",
        "Fabricación de otros productos de caucho natural o sintético ",
        "Fabricación de otros productos de madera, fabricación de artículos de corcho, paja y materiales trenzables",
        "Fabricación de otros productos de metal N. C. P.",
        "Fabricación de otros productos minerales N. C. P.",
        "Fabricación de otros productos minerales no metálicos",
        "Fabricación de otros productos químicos N. C. P.",
        "Fabricación de otros textiles N. C. P.",
        "Fabricación de otros vinos de frutas y bebidas mezcladas con contenido alcohólico",
        "Fabricación de pagers (buscadores)",
        "Fabricación de pan y panecillos",
        "Fabricación de paneles de control para la distribución de la energía",
        "Fabricación de paneles de instrumentos, reguladores de voltaje",
        "Fabricación de panqueques",
        "Fabricación de pantallas, etc.",
        "Fabricación de papel a mano",
        "Fabricación de papel carbón",
        "Fabricación de papel crêped y papel plegado",
        "Fabricación de papel engomado o papel adhesivo",
        "Fabricación de papel higiénico",
        "Fabricación de papel para equipos de impresión",
        "Fabricación de papel para la impresión",
        "Fabricación de papel pintado y revestimientos similares de paredes",
        "Fabricación de papel prensa",
        "Fabricación de papel y cartón",
        "Fabricación de papel y cartón corrugado",
        "Fabricación de papel y cartón excepto envases",
        "Fabricación de papel y cartón filtro",
        "Fabricación de papel y cartón ondulado y envases de papel y cartón",
        "Fabricación de papel y de los productos de papel",
        "Fabricación de papel, guata, fieltro recubierto o revestido de jabón o detergente",
        "Fabricación de paraguas, sombrillas de sol, bastones",
        "Fabricación de parquímetros",
        "Fabricación de parrilla",
        "Fabricación de partes de mantas eléctricas",
        "Fabricación de partes de turborreactores para las aeronaves",
        "Fabricación de partes tales como fuselajes, alas, puertas, superficies de control, tren de aterrizaje y tanques de combustible",
        "Fabricación de partes y accesorios para bicicletas",
        "Fabricación de partes y accesorios para motores de vehículos",
        "Fabricación de partes y piezas de carpintería para edificios y construcciones",
        "Fabricación de partes; piezas y accesorios para vehículos automotores y sus motores",
        "Fabricación de pastas y polvos para el desengrasado",
        "Fabricación de pastas y polvos utilizados en soldadura",
        "Fabricación de patines de hielo, patines",
        "Fabricación de pegamento para madera estratificada, laminado de chapas madera",
        "Fabricación de películas y proyectores de diapositivas",
        "Fabricación de pelotas inflables duras y suaves",
        "Fabricación de pelucas",
        "Fabricación de peptonas, derivados de peptonas, otras sustancias proteicas y sus derivados N. C. P.",
        "Fabricación de perforadoras de papel",
        "Fabricación de pesticidas y otros productos químicos de uso agropecuario",
        "Fabricación de piedra artificial",
        "Fabricación de piezas de repuestos y accesorios para motocicleta",
        "Fabricación de piezas especializadas para el levantamiento y manejo de equipo",
        "Fabricación de piezas móviles de todo tipo de relojes",
        "Fabricación de piezas para maquinaria de uso general",
        "Fabricación de piezas y accesorios para radio y televisión",
        "Fabricación de pilas secas",
        "Fabricación de pintura, barnices y productos similares de revestimiento",
        "Fabricación de pinturas, barnices y productos de revestimiento similares; tintas de imprenta y masillas",
        "Fabricación de piso, paredes o techos en rollo o en forma de baldosa de plástico",
        "Fabricación de pisos de madera",
        "Fabricación de placas de cocción",
        "Fabricación de placas fotográficas, películas, papel sensibilizado",
        "Fabricación de placas, hojas, tiras, barras y perfiles de caucho",
        "Fabricación de placas, laminas, bloques, películas, cintas y tiras de plástico",
        "Fabricación de plaguicidas, y productos químicos de uso agropecuario",
        "Fabricación de plancha eléctrica",
        "Fabricación de planchas, calefactores, hornos eléctricos, tostadoras y otros aparatos generadores de calor",
        "Fabricación de planeadores",
        "Fabricación de plástico actual no portadora de dispositivos de cableado",
        "Fabricación de plástico y caucho sintético en forma primaria",
        "Fabricación de polainas, botines y artículos análogos",
        "Fabricación de poliamidas",
        "Fabricación de polvos propulsores (pólvora)",
        "Fabricación de pozos de agua",
        "Fabricación de premoldeados para la construcción",
        "Fabricación de prendas de vestir",
        "Fabricación de prendas de vestir, excepto prendas de piel",
        "Fabricación de prensas de troquelado",
        "Fabricación de prensas hidráulicas",
        "Fabricación de prensas para la fabricación de tableros de partículas y similares",
        "Fabricación de preparado para limpieza, pulido y saneamiento",
        "Fabricación de preparados para perfumar o desodorizar habitaciones",
        "Fabricación de preparados para quitar pintura o barniz",
        "Fabricación de preparados químicos para uso fotográfico",
        "Fabricación de procesadoras de temporizadores",
        "Fabricación de producto de horno de coque",
        "Fabricación de productos anticonceptivos para uso externo y medicamentos anticonceptivos hormonales",
        "Fabricación de productos aromáticos sintéticos",
        "Fabricación de productos cerámicos para uso industrial y de laboratorio",
        "Fabricación de productos de aperitivos",
        "Fabricación de productos de arcilla y cerámica no refractaria para uso estructural",
        "Fabricación de productos de arcilla y cerámica no refractaria para uso estructural N. C. P.",
        "Fabricación de productos de caucho N. C. P.",
        "Fabricación de productos de caucho y plástico",
        "Fabricación de productos de cerámica refractaria",
        "Fabricación de productos de cerámicas no refractaria para uso no industrial",
        "Fabricación de productos de corcho",
        "Fabricación de productos de herrería y soldadura",
        "Fabricación de productos de hornos de coque",
        "Fabricación de productos de laboratorio, sustancias químicas medicinales y productos botánicos N. C. P.",
        "Fabricación de productos de madera N. C. P.",
        "Fabricación de productos de panadería congelados: panqueques, wafles, rollos, etc.",
        "Fabricación de productos de panadería N. C. P. (incluye elaboración de churros, prepizas, masas fritas, hojaldre, etc.)",
        "Fabricación de productos de plástico",
        "Fabricación de productos de plástico en su forma básica y artículos de plástico N.C.P.",
        "Fabricación de productos de tejeduría N. C. P.",
        "Fabricación de productos de vidrio N. C. P.",
        "Fabricación de productos derivados del metal, excepto maquinaria y equipo",
        "Fabricación de productos farmacéuticos, sustancias químicas medicinales y de productos botánicos",
        "Fabricación de productos lácteos N. C. P. (incluye la producción de caseintos lácteos, cremas, manteca, etc.)",
        "Fabricación de productos médicos de diagnósticos, incluyendo las pruebas de embarazo",
        "Fabricación de productos metálicos de tornería y/o matricera",
        "Fabricación de productos metálicos N. C. P. (incluye clavos, productos de bulonería, vajilla de mesa y de cocina, etc.)",
        "Fabricación de productos metálicos para uso estructural",
        "Fabricación de productos metálicos para uso estructural, tanques, depósitos y los generadores de vapor",
        "Fabricación de productos minerales no metálicos N. C. P.",
        "Fabricación de productos oftálmicos, anteojos, lentes de sol, lentes de terreno para la prescripción, lentes de contacto",
        "Fabricación de productos para el aislamiento térmico",
        "Fabricación de productos para el manicure y el pedicura",
        "Fabricación de productos para el revestimiento de carretera",
        "Fabricación de productos para la industria petroquímica",
        "Fabricación de productos primarios de metales preciosos y metales no ferrosos",
        "Fabricación de productos químicos N. C. P.",
        "Fabricación de productos químicos N. C. P. (incluye la producción de aceites esenciales, etc.)",
        "Fabricación de proyectores",
        "Fabricación de puertas de apertura y cierre con dispositivos eléctricos",
        "Fabricación de puertas y ventanas de madera para la construcción",
        "Fabricación de puertas, ventanas, marcos, postigos, persianas y zócalos de plástico",
        "Fabricación de puertas, ventanas, persianas y sus marcos en metal",
        "Fabricación de pulpa a partir de la borra de algodón",
        "Fabricación de pulpa de madera",
        "Fabricación de pulpa, papel y cartón",
        "Fabricación de puré de papas deshidratado",
        "Fabricación de radiadores, silenciadores y tubos de escapes",
        "Fabricación de ramos, coronas y cestas de flores, flores, frutas y follaje artificiales",
        "Fabricación de ratones, joystick, TrackBall",
        "Fabricación de reactores nucleares",
        "Fabricación de receptores de radio y televisión, aparatos de grabación y reproducción de sonido y video y productos conexos",
        "Fabricación de recipientes de madera",
        "Fabricación de redes anudadas de cordeles, cuerdas o cordajes",
        "Fabricación de redes para pesca",
        "Fabricación de registros y libros, carpeta",
        "Fabricación de relojes",
        "Fabricación de relojes de metales preciosos",
        "Fabricación de relojes de metales preciosos, muñequeras y correas de relojes",
        "Fabricación de relojes de tiempo",
        "Fabricación de remolques para el transporte de mercancías",
        "Fabricación de remolques para el transporte de pasajeros",
        "Fabricación de replicas, crisoles, mufles, boquillas, tubos, caños, etc.",
        "Fabricación de reproductores de CD y DVD",
        "Fabricación de resinas y caucho sintético",
        "Fabricación de resistencias electrónicas",
        "Fabricación de resortes y otras piezas",
        "Fabricación de revestimiento cerámico",
        "Fabricación de revestimiento de suelo",
        "Fabricación de revólveres y pistolas",
        "Fabricación de rieles eléctrica",
        "Fabricación de ron",
        "Fabricación de ropa de cama, para mesa y de tocador o cocina",
        "Fabricación de roscado",
        "Fabricación de rotores de helicópteros y palas del rotor",
        "Fabricación de sables, espadas, bayonetas, etc.",
        "Fabricación de sacapuntas",
        "Fabricación de sacos y bolsas de papel",
        "Fabricación de sake",
        "Fabricación de salsa de tomate",
        "Fabricación de sartenes, asadores y parrillas",
        "Fabricación de secadores de pelo, peines y cepillos",
        "Fabricación de secadores para madera, pasta de papel o cartón",
        "Fabricación de segadoras, incluidas las cortadoras de césped",
        "Fabricación de selonoides, interruptores para aplicaciones electrónicas",
        "Fabricación de semiconductores acabados o semiacabados",
        "Fabricación de señales no eléctricas de plástico",
        "Fabricación de separadores y contenedores",
        "Fabricación de servidores informáticos",
        "Fabricación de sidecar",
        "Fabricación de sidra",
        "Fabricación de sierras",
        "Fabricación de siliconas",
        "Fabricación de sillas de ruedas, partes y accesorios",
        "Fabricación de sillas odontológicas",
        "Fabricación de sillas para bebes",
        "Fabricación de sillas y asientos de jardín",
        "Fabricación de sillas y asientos para oficinas, talleres, hoteles y restaurantes",
        "Fabricación de sillas y asientos para teatros y cines",
        "Fabricación de sistemas de alimentación interrumpida UPS",
        "Fabricación de sistemas de altavoces",
        "Fabricación de sistemas de energía de fluidos",
        "Fabricación de snacks de papas",
        "Fabricación de sobres y tarjetas",
        "Fabricación de sodas y agua tónica",
        "Fabricación de sofás, sofás camas",
        "Fabricación de somieres y colchones",
        "Fabricación de soportes de rodamiento y cojinetes",
        "Fabricación de suavizantes textiles",
        "Fabricación de sucedáneos de café",
        "Fabricación de suéteres y artículos similares de punto",
        "Fabricación de sustancias químicas",
        "Fabricación de sustancias químicas básicas, abonos, compuestos de nitrógeno, plásticos y caucho",
        "Fabricación de sustancias químicas básicas, excepto abonos y compuestos de nitrógeno",
        "Fabricación de tabaco para masticar",
        "Fabricación de tabiques de madera",
        "Fabricación de Tabla de examinación",
        "Fabricación de tableros contrachapados",
        "Fabricación de tableros de partículas de fibras",
        "Fabricación de tableros laminados",
        "Fabricación de tableros y paneles N. C. P.",
        "Fabricación de tacones, etc.",
        "Fabricación de tanques",
        "Fabricación de tanques, depósitos y recipientes de metal",
        "Fabricación de tapices y alfombras",
        "Fabricación de tarjetas de interfaz",
        "Fabricación de tazas, platos y bandejas",
        "Fabricación de techo de luminaria",
        "Fabricación de teclados",
        "Fabricación de tejidos de alambre",
        "Fabricación de tejidos de carbono y los hilos de aramida",
        "Fabricación de tejidos de fibra de vidrio",
        "Fabricación de tejidos de punto y artículos de punto y ganchillo",
        "Fabricación de tejidos estrecho, incluidos los tejidos que consisten en deformar sin trama reunidos por medio de un adhesivo",
        "Fabricación de tejidos para cuerdas de neumáticos de alta tenacidad",
        "Fabricación de tejidos planos de algodón y sus mezclas",
        "Fabricación de tejidos planos de fibras manufacturadas y de seda",
        "Fabricación de tejidos planos de fibras textiles N. C. P. (incluye heladerías y tenedurías integradas)",
        "Fabricación de tejidos planos de lana y sus mezclas",
        "Fabricación de tejidos y artículos de punto N. C. P.",
        "Fabricación de telas impregnadas, recubiertas, revestidas o estratificadas con plásticos",
        "Fabricación de telas recubiertas con goma de mascar o de materiales amiláceas",
        "Fabricación de teléfonos celulares",
        "Fabricación de teléfonos inalámbricos",
        "Fabricación de teléfonos y equipos de fax, incluyendo los contestadores",
        "Fabricación de terminales de ordenadores especializados",
        "Fabricación de termómetros líquidos en vidrio y tipos bimétalicos",
        "Fabricación de termómetros médicos",
        "Fabricación de tijeras",
        "Fabricación de tintas",
        "Fabricación de tisúes",
        "Fabricación de toallas",
        "Fabricación de toallas sanitarias, tampones, pañales y mantillas para bebes",
        "Fabricación de todo tipo de relojes",
        "Fabricación de tomas de electricidad",
        "Fabricación de tornillos, jeringas, agujas, catéteres y cánulas",
        "Fabricación de tortas, pasteles, tartas, etc.",
        "Fabricación de tortillas",
        "Fabricación de tostadoras y cafeteras eléctricas",
        "Fabricación de tractores",
        "Fabricación de tractores (controlado peatonalmente)",
        "Fabricación de tractores usados en la construcción y minería",
        "Fabricación de transmisores de radio y televisión y de aparatos para la telefonía y telegrafía con hilos",
        "Fabricación de transportadores, teleféricos",
        "Fabricación de trenzas, borlas, pompones, etc.",
        "Fabricación de tubo de goma dura",
        "Fabricación de tubos con soldaduras",
        "Fabricación de tubos de plástico, mangueras y accesorios para tuberías",
        "Fabricación de tubos de torpedos",
        "Fabricación de tubos sin soldadura, tubos y perfiles huecos de acero",
        "Fabricación de tubos y neumáticos de caucho, reconstrucción de neumáticos de caucho",
        "Fabricación de tubos, caños y mangueras",
        "Fabricación de tubos, caños, embalses, canales, cuencas y sumideros",
        "Fabricación de tubos, válvulas y otros componentes electrónicos",
        "Fabricación de tules y otros tejidos",
        "Fabricación de turbinas de gas, excepto turborreactores o turbo hélices para aviones de propulsión",
        "Fabricación de turbinas de vapor",
        "Fabricación de turbinas eólicas",
        "Fabricación de turbinas hidráulicas, ruedas hidráulicas y los reguladores del mismo",
        "Fabricación de unidades ópticas como CD-RW, CD ROM, DVD ROM",
        "Fabricación de utensilios de madera para el hogar y utensilios de cocina",
        "Fabricación de vacunas",
        "Fabricación de vajillas de plástico, utensilios de cocina y artículos de tocador",
        "Fabricación de vajillas, cubiertos, artículos de tocador, artículos de oficina o de escritorio y artículos para uso religioso",
        "Fabricación de válvulas hidráulicas y neumáticas",
        "Fabricación de vaselina",
        "Fabricación de vehículos automotores",
        "Fabricación de vehículos automotores, remolques y semirremolques",
        "Fabricación de vehículos de mantenimiento",
        "Fabricación de vehículos tirados por animales",
        "Fabricación de velas y Tablas de surf",
        "Fabricación de velas, cirios y similares",
        "Fabricación de veleros con o sin motor auxiliar",
        "Fabricación de ventiladores (ventiladores de techo, etc.)",
        "Fabricación de ventiladores, extractores y acondicionadores de aire, aspiradores y similares",
        "Fabricación de vermut y similares",
        "Fabricación de vestidos de gamuza, vestidos pergamino, patente o cueros metalizados",
        "Fabricación de vidrio en barra o tubos",
        "Fabricación de vidrio para reloj, para gafas, vidrios ópticos",
        "Fabricación de vidrio plano templado o laminado",
        "Fabricación de vidrio y productos de vidrio",
        "Fabricación de vidrios y parabrisas para automóviles",
        "Fabricación de vigas y estructuras para techo",
        "Fabricación de vinagre",
        "Fabricación de vinilo recubierto de textil y papel tapiz",
        "Fabricación de vino a base de concentrado de mosto de uva",
        "Fabricación de vinos espumosos",
        "Fabricación de vitaminas básicas",
        "Fabricación de viviendas prefabricadas de madera",
        "Fabricación de volantes y poleas",
        "Fabricación de volantes, columnas de dirección y cajas de dirección",
        "Fabricación de yeso",
        "Fabricación de yogurt",
        "Fabricación en industrias básicas de productos de hierro y acero N. C. P.",
        "Fabricación industrial de grifos y válvulas incluyendo la regulación de grifos y válvulas de admisión",
        "Fabricación industrial de helados (no incluye las heladerías artesanales)",
        "Fabricación industrial de marcos de metal (marcos para los altos hornos, aparatos elevadores y de manejo de equipos, etc.)",
        "Fabricación y distribución de combustibles gaseosos N. C. P.",
        "Fabricación y distribución de gas (no incluye el transporte por gaseoductos)",
        "Fabricación y el montaje permanente de calentadores eléctricos, calentadores eléctricos de piscina",
        "Fabricación y elaboración de vidrio plano y templado",
        "Fabricación y montaje de calefacción de vapor",
        "Fabricación y montaje de calefacción solar",
        "Fabricación y montaje de hornos y equipos de calefacción",
        "Fabricación y reparación de aviones",
        "Fabricación y reparación de baterías",
        "Fabricación y reparación de buques (incluye la construcción de motores y piezas para navíos, etc.)",
        "Fabricación y reparación de maquinaria de la industria petrolera",
        "Fabricación, blanqueo y semi-blanqueado de pasta de papel por medios mecánicos o químicos",
        "Fabricaron de instrumento de óptica",
        "Factoría de arroz",
        "Ferias y exposiciones",
        "Fermentación de la caña de azúcar, maíz y similares para producir alcohol y esteres",
        "Fideicomisos",
        "Financiación del comercio internacional",
        "Financiación por enfermedad, accidentes de trabajo y seguros de desempleo",
        "financieros excepto los de la banca central y las entidades financieras",
        "Fondo monetario internacional",
        "Fondos de inversión abierto",
        "Fondos de inversión cerrado",
        "Fondos de inversiones de portafolio",
        "Forjado, prensado, estampado y laminados de metales; pulvimetalurgia",
        "Formación de postgrado",
        "Fotograbado, flexográfica y otras prensas, maquinas de duplicación, impresoras de computadora",
        "Fotografía aérea",
        "Fotografía de publicidad, editoriales, moda, inmobiliarias o turísticas",
        "Fuerzas de combate de ejército, marina y fuerza aérea",
        "Funcionamiento de cantinas y cafeterías sobre una base de concesión",
        "Fundición de acero",
        "Fundición de acero en hornos de alta temperatura, producción de lingotes o planchas de acero",
        "Fundición de grafito esferoidal",
        "Fundición de hierro gris",
        "Fundición de hierro maleable",
        "Fundición de hierro y acero",
        "Fundición de metales",
        "Fundición de metales ligeros",
        "Fundición de metales no ferrosos",
        "Fundición de piezas de metales pesados",
        "Fundición de piezas de metales preciosos",
        "Fundición de productos semiacabados de aluminio, magnesio, titanio, zinc, etc.",
        "Fundición despiezas de acero",
        "Fundición y refinación de uranio",
        "Generación de energía hidráulica (incluye la producción de energía eléctrica mediante centrales de bombeo)",
        "Generación de energía N. C. P. (incluye la producción de energía eléctrica mediante fuentes de energía solar, biomosa, eólica, etc.)",
        "Generación de energía térmica convencional (incluye la producción de energía eléctrica mediante maquinas turbogas, turbo vapor)",
        "Generación de energía térmica nuclear (incluye la producción de energía mediante combustible nuclear)",
        "Generación de informes especializados a partir de los datos suministrados por los clientes",
        "Gestión de cobro",
        "Gimnasios",
        "Giros postales y actividades postales de bancos",
        "Hipódromo",
        "Hogares de ancianos con cuidado de enfermería",
        "Hogares para ciegos",
        "Hogares y albergues infantiles",
        "Hoteles Resorts",
        "Humidificación de los edificios",
        "Hundimiento de ejes",
        "Impregnación o revestimiento de prendas de vestir para la impermeabilización",
        "Impresión de libros y folletos",
        "Impresión de manuscritos, mapas, atlas, carteles, catalogo de publicidad y otros impresos publicitarios",
        "Impresión de periódicos, revistas",
        "Impresión directa sobre materiales textiles, plásticos, vidrio, metal, madera y cerámica",
        "Impresión en las etiquetas o tags",
        "Impresión excepto de periódicos, revistas",
        "Impresión y ampliado de los negativos de rollo de cine",
        "Impuesto sucesoral",
        "Industria básica de hierro y acero",
        "Industrias de explotación de recursos naturales y minería",
        "Ingeniería acústica",
        "Ingeniería de sistemas y de seguridad",
        "Ingeniería química",
        "Ingeniero agrónomo",
        "Ingeniero calculista",
        "Ingeniero comercial",
        "Ingeniero electrónico",
        "Ingeniero mecánico",
        "Ingenieros, transporte, comunicaciones, inteligencia, personal y otras fuerzas no de combate y comandos",
        "Iniciativas ciudadanas y movimientos de protesta",
        "Inseminación artificial y servicios N. C. P. para mejorar la reproducción de los animales y el rendimiento de sus productos",
        "Instalación (configuración) de computadoras personales",
        "Instalación de alarmas contra incendios",
        "Instalación de alfombras y linóleo para suelos, incluidos los de caucho o de plástico",
        "Instalación de antenas parabólicas",
        "Instalación de ascensores, montacargas y escaleras mecánicas",
        "Instalación de barreras, señales de tráfico",
        "Instalación de carpintería, herrería de obra y artística",
        "Instalación de cerámica, hormigón, paredes talladas en piedras o baldosas",
        "Instalación de cocinas equipadas",
        "Instalación de colectores de energía solar no eléctricos",
        "Instalación de equipos de red, cableado de televisión por cable",
        "Instalación de hornos, torres de enfriamiento",
        "Instalación de mobiliarios",
        "Instalación de papel tapiz",
        "Instalación de pararrayos",
        "Instalación de puertas giratorias automatizadas",
        "Instalación de redes informáticas",
        "Instalación de sistema de riego de césped",
        "Instalación de sistemas de alarmas de seguridad",
        "Instalación de sistemas de iluminación de pistas de aterrizajes en aeropuertos",
        "Instalación de sistemas de iluminación, control y señalización eléctrica para el transporte",
        "Instalación de sistemas de limpieza",
        "Instalación de sistemas de rociadores contra incendio",
        "Instalación de tacones",
        "Instalación de terrazo, mármol, granito o revestimiento de paredes",
        "Instalación de tuberías de vapor",
        "Instalación de ventilador, refrigeración o aire acondicionado o conductos",
        "Instalación y reparación de caños de escape",
        "Instalación y reparación de lunetas y ventanillas, alarmas, cerraduras,  radios, sistemas de climatización automotor",
        "Instalación, reparación, reconstrucción de cajas fuertes y bóvedas de seguridad",
        "Instalación, reparación, reconstrucción de dispositivos de bloqueo mecánico o electrónico",
        "Instalaciones de carpintería, herrería de obra y artística (incluye la instalación de puertas y ventanas, carpintería metálica y no metálica)",
        "Instalaciones de cuidado de enfermería",
        "Instalaciones de gas, agua y sanitarios con sus artefactos conexos (incluyendo las instalaciones de compactadores, calderas)",
        "Instalaciones de procesamiento de datos y servicios de soporte relacionado",
        "Instalaciones para edificios y obras de ingeniería N. C. P.",
        "Instalaciones para el tratamiento de alcoholismo y adicción a las drogas",
        "Institutos meteorológicos",
        "Instrucción en habilidades para conversar e idiomáticas, cursos de lectura  rápida, instrucción religiosa",
        "Instrucción para chef, hoteleros y dueños de restaurantes",
        "Instrucción para guías turísticos",
        "Intercambio de opciones de comoditis o acciones",
        "Intercambio de valores",
        "Intermediación monetaria y financiera de la banca central",
        "Intermediación monetaria y financiera de las entidades financieras y bancarias y no bancarias",
        "Interpretar el rol de banquero del gobierno",
        "Inventarios forestales",
        "Invernada de ganado bovino excepto el engorde en corrales (fed-lot)",
        "Investigación de aceptación y la familiaridad de los productos",
        "Investigación de ciencias biológicas",
        "Investigación de los hábitos de compra de los consumidores con el propósito de la promoción y desarrollo de nuevos productos",
        "Investigación interdisciplinaria predominantemente en ciencias sociales y humanas",
        "Investigación y desarrollo científico",
        "Investigación y desarrollo experimental en el campo de la ingeniería y de las ciencias exactas y naturales",
        "Investigación y desarrollo experimental en el campo de la ingeniería y la tecnología",
        "Investigación y desarrollo experimental en el campo de las ciencias agropecuarias",
        "Investigación y desarrollo experimental en el campo de las ciencias exactas y naturales N. C. P.",
        "Investigación y desarrollo experimental en el campo de las ciencias humanas",
        "Investigación y desarrollo experimental en el campo de las ciencias médicas",
        "Investigación y desarrollo experimental en el campo de las ciencias sociales",
        "Investigación y desarrollo experimental en el campo de las ciencias sociales y las humanas",
        "Laboratorios de revelado e impresión de fotos",
        "Laminación y estirado",
        "Lana de escoria, lana de roca y lanas minerales similares",
        "Lanzamiento de satélites y vehículos espaciales",
        "Lavado automático y manual",
        "Lavado de alfombras y tapices",
        "Lavado y limpieza de artículos de tela, cuero y/o de piel, incluso la limpieza en seco",
        "Lavandería y servicio relacionado a las actividades de apoyo",
        "Leasing automotor",
        "Licuefacción y regasificación del gas natural con fines de transporte",
        "Limpiabotas, portadores de maleta y personas encargadas de estacionar vehículos",
        "Limpieza de casas o apartamentos",
        "Limpieza de fábricas",
        "Limpieza de los edificios nuevos después de la construcción",
        "Limpieza de obras de construcción",
        "Limpieza de oficinas e instituciones",
        "Limpieza de tiendas",
        "Limpieza general de interior, mantenimiento y eliminación de basura",
        "Líneas ciudad – aeropuerto y viceversa",
        "Logística militar (suministro de equipos y estructuras)",
        "Lotería y otros juegos de azar",
        "Lucha contra los incendios forestales",
        "Manejo de concesiones de alimentos en instalaciones de deportes y similares",
        "Mantenimiento de la tierra para uso agrícola",
        "Mantenimiento de tumbas y mausoleos",
        "mantenimiento y reparación de frenos",
        "Mantenimiento y reparación de maquinaria de oficina, contabilidad e informática",
        "mantenimiento y reparación de maquinaria de oficina, contabilidad e informática",
        "Mantenimiento y reparación de motocicletas",
        "Mantenimiento y reparación de vehículos de motor",
        "Mantenimiento y reparación del motor N. C. P. mecánica integral (incluye auxilio y servicio de grúa)",
        "Maquinas para el control de la presión arterial que funciona con moneda",
        "Marketing de los puntos de venta",
        "Matadero de ganado bovino",
        "Matadero de ganado excepto el bovino y el procesamiento de su carne (incluye ganado ovino, porcino, equino, búfalo, etc.)",
        "Matadero y procesamiento de carne de aves",
        "Matanza de animales N. C. P. y procesamiento de su carne; elaboración de subproductos cárnicos N. C. P.",
        "Mezcla de bebidas alcohólicas",
        "Mezcla de biocarburantes, es decir mezcla de alcohol con petróleo",
        "Mezcla de té y yerba mate",
        "Minería de sulfato de bario y carbonato (baritina y witherita)",
        "Minería de tierras colorantes y fluorita",
        "Minería de yeso y anhidrita",
        "Modificación química de aceites y grasas",
        "Molienda de trigo",
        "Monitorio de sistemas de seguridad de alarmas electrónicas",
        "Montaje de diapositivas Montaje de diapositivas",
        "Montaje y desmontaje de andamios y plataformas de trabajo excluyendo el alquiler de andamios y plataformas de trabajo",
        "Movimiento de suelos y preparación de terrenos para obras N. C. P. (incluye el drenaje, remoción de rocas, excavación de zanjas)",
        "Movimientos ecologistas y de medio ambiente",
        "Mudanzas y acarreo",
        "Museo de historia natural, museos tecnológicos, museos históricos incluyendo los museos militares",
        "Museos al aire libre",
        "Museos de arte, Museos de joyas, muebles, trajes, cerámica y platería",
        "Músicos",
        "Naciones Unidas y sus organismos especializados y órganos regionales",
        "Negocios de canje de cheques",
        "Negocios de juegos de azar (Bancas de Lotería y Apuestas)",
        "Obras artísticas incluidas la preparación de piedra litográfica",
        "Obras de drenaje",
        "Obras de ingeniería civil N. C.P. (incluye los trabajos generales de construcción para la minería y la industria y centrales eléctricas)",
        "Obras de vías férreas",
        "Obreros",
        "Obtención y dotación de personal",
        "Oficinas de organismos internacionales",
        "Operación (explotación) de juegos que funcionan con monedas",
        "Operación de almacenes generales de mercancías",
        "Operación de almacenes refrigerados",
        "Operación de autobuses para el transporte de los empleados",
        "Operación de coches camas o coches comedores como parte integrada de operaciones de compañías ferroviarias",
        "Operación de electricidad y capacidad de transmisión para los intercambios de energía eléctrica",
        "Operación de equipos de riego agrícola",
        "Operación de excursión, cruceros o embarcaciones turísticas",
        "Operación de funiculares, teleféricos si son parte del sistema de transito urbano o suburbano",
        "Operación de infraestructura ferroviaria",
        "Operación de instalaciones de la terminal tales como la estación de tren",
        "Operación de instalaciones de la terminal, estación de autobuses",
        "Operación de instalaciones de la terminal, estaciones para la manipulación de mercancías",
        "Operación de intermediación de carne (consignatario directo)",
        "Operación de intermediación de carne excepto consignatario directo",
        "Operación de intermediación de ganado en pie (incluye consignatarios de hacienda y ferieros)",
        "Operación de los canales de riego",
        "Operación de pesca deportiva y de caza de preservación",
        "Operación de portales de Internet de apuestas",
        "Operación de reservas naturales, incluida la preservación de la fauna silvestre, etc.",
        "Operación de silos de granos",
        "Operación de tanque de almacenamiento",
        "Operación de teleféricos, funiculares, telesillas",
        "Operación de una variedad de atracciones mecánicas",
        "Operación de una variedad de juegos",
        "Operaciones de desembalaje",
        "Operaciones de embalaje temporal con el único proteger las mercancías durante el transito",
        "Operaciones de esclusas",
        "Operaciones de ferries, taxis acuáticos, etc.",
        "Operaciones de intermediación de lanas, cueros y productos afines de terceros",
        "Operaciones de vehículos de motor",
        "Operaciones inmobiliarias de inversionistas extranjeros",
        "Operadoras de franquicias",
        "Operadoras de restaurantes",
        "Operadoras de zonas francas",
        "Operadores de hoteles",
        "Orfanatos",
        "Organización de colección, sean estas especializadas o no",
        "Organización de envíos grupales o individuales",
        "Organización de países exportadores de petróleo",
        "Organización y montaje de tours con transporte, alojamiento y comida",
        "Organizaciones de apoyo a la comunidad y centros de enseñanzas N. C. P.",
        "Organizaciones genealógicas",
        "Organizaciones no Gubernamentales, Organizaciones sin fines de lucro, y Asociaciones Civiles con fines caritativos o religiosos",
        "Organizaciones para la cooperación y el desarrollo económico",
        "Organizaciones para la protección y mejoramiento de los grupos especiales",
        "Ostricultura",
        "Otorgamiento de crédito para viviendas por entidades especializadas no depositarias",
        "Otras actividades de desarrollo y preparación de los minerales y propiedades de los sitios",
        "Otras actividades de edición",
        "Otras actividades de entretenimiento N. C. P.",
        "Otras actividades de esparcimiento",
        "Otras actividades de servicios N. C. P.",
        "Otras actividades empresariales",
        "Otras actividades financieras, excepto seguros y fondos de pensiones",
        "Otras actividades recreativas no clasificadas en otra parte",
        "Otras actividades relacionadas con la silvicultura N. C. P.",
        "Otras consultarías técnicas",
        "Otras industrias manufactureras",
        "Otras industrias manufactureras N. C. P.",
        "Otras industrias manufactureras N. C. P. (incluye la fabricación de cochecitos de bebe, termos, etc.)",
        "Otros cultivos de frutas cítricas",
        "Otros cultivos de frutas con hueso y con pepa",
        "Otros cultivos de frutas tropicales y subtropicales",
        "Otros cultivos de hojas o tallos vegetales",
        "Otros cultivos de raíces y bulbos",
        "Otros museos especializados",
        "Otros no clasificados",
        "Otros servicios (estudiantes, amas de casa, pensionados)",
        "Otros servicios de ingeniería",
        "Otros tipos de transporte por vía terrestre",
        "Participación en empresas",
        "Patentes y derechos de autor",
        "Payasos",
        "Pedicuros (podólogos)",
        "Pelado y cortado de verduras",
        "Peluquería y otros tratamientos de belleza",
        "Pensiones de jubilación",
        "Perforación y prueba de pozos taladrados",
        "Perforación y sondeo excepto la perforación de pozos de petróleo, de gas, de minas",
        "Periodistas",
        "Personas físicas designadas como directivos o representantes de partidos políticos",
        "Pesca continental, fluvial y lacustre",
        "Pesca de altamar, costera y en estuarios",
        "Pesca de camarones ",
        "Pesca marítima (incluye peces, crustáceos, moluscos, mariscos excepto camarones)",
        "Pesca y servicios conexos",
        "Pintores",
        "Pintura de estructuras de ingeniería civil",
        "Pintura sobre el pavimento y otro tipo de marcado",
        "Pintura y trabajos de decoración",
        "Piscinas y centros de fitness",
        "Planeación de bosques",
        "Planeamiento de pueblos y ciudades (urbano) y arquitectura de paisajes",
        "Planificación y diseño de los sistemas informáticos",
        "Plegado de acero",
        "Pompas fúnebres y servicios conexos",
        "Preparación de alimentos con ingredientes homogeneizados",
        "Preparación de alimentos en puestos de mercado",
        "Preparación de arroz",
        "Preparación de conserva de frutas, hortalizas y legumbres",
        "Preparación de declaraciones de ingresos para personas y empresas",
        "Preparación de fibras animales de uso textil, incluso lavado de lana",
        "Preparación de fibras textiles vegetales excepto de algodón (incluye la preparación de fibras de yute, ramio, cáñamo y limo)",
        "Preparación de hoja de tabaco",
        "Preparación de hojas de te",
        "Preparación de la turba",
        "Preparación de mezcla (única) para la alimentación de animales de granja",
        "Preparación de planchas o troqueles para la impresión o estampación",
        "Preparación de productos botánicos para uso farmacéutico",
        "Preparación de terrenos para obras",
        "Preparación e hilatura de fibras textiles, tejeduras de productos textiles",
        "Preparación o auditoría de las cuentas financieras",
        "Preparación para procesos de admisión",
        "Preparación y congelación de papas",
        "Preparación y molienda de legumbres y cereales N. C. P. (excepto trigo)",
        "Preparación y venta de comidas para llevar N. C. P. (incluye casas de comidas, rosticerías, etc.)",
        "Preparación, curtido y acabado del cuero, fabricación de maletas, bolsos de mano, artículos de talabartería y guarnicionería, y calzado",
        "Preparados para lactantes",
        "Preservación en azúcar de frutas, nueces, cáscaras de frutas",
        "Prestación de dinero fuera del sistema financiero",
        "Prestación de los fallos y de la interpretación de la ley",
        "Prestación de servicios de entrada de datos",
        "Prestación de servicios ordinarios",
        "Prestación publica de servicios a la comunidad en general",
        "Prestamos y almacenaje de libros, mapas, periódicos, revistas, películas, expedientes, cintas y obras de arte",
        "Procesamiento de carne de ganado bovino (incluye los mataderos y frigoríficos que sacrifican principalmente ganado bovino)",
        "Procesamiento de carne fresca refrigerada o congelada en trozos",
        "Procesamiento de carne fresca refrigeradas o congeladas en porciones individuales",
        "Procesamiento de datos",
        "Procesamiento de la sangre",
        "Procesamiento de peces, crustáceos y moluscos: pescado cocido, filetes de pescado, huevas, caviar, sucedáneos de caviar, etc.)",
        "Procesamiento y conservación de pescado, crustáceos y moluscos",
        "Procesos para obtener aceites crudos: decantación, desalinización, deshidratación, estabilización, etc.",
        "procuradores y alguaciles",
        "Producción de acero en lingotes o demás formas primarias",
        "Producción de aire comprimido",
        "Producción de aleación de aluminio",
        "Producción de aleaciones de acero",
        "Producción de aleaciones de cromo, manganeso y níquel",
        "Producción de aleaciones de metales preciosos",
        "Producción de aluminio a base del refinado electrolítico de aluminio",
        "Producción de avena",
        "Producción de bananas",
        "Producción de brea y coque de brea",
        "Producción de carbón de leña en los bosques (utilizando los métodos tradicionales)",
        "Producción de cobre a base de refinado electrolítico del cobre",
        "Producción de comida a base de pescado y otros animales acuáticos no aptas para el consumo humano",
        "Producción de coque en horno de gas",
        "Producción de coque y semi coque",
        "Producción de cromo, manganeso y níquel a base de refinado electrolítico de cromo, manganeso y níquel",
        "Producción de cromo, manganeso y níquel de los minerales u óxidos",
        "Producción de crudo de alquitrán, de carbón y de lignito alquitranes",
        "Producción de crudo de hidrocarburos gaseosos (gas natural)",
        "Producción de espectáculos teatrales y musicales",
        "Producción de filmes y videocintas",
        "Producción de fuel oil ligero, medio y pesado, refinería de gases como el etano, butano, propano, etc.",
        "Producción de gases inertes como el dióxido de carbono",
        "Producción de gases mixtos industriales",
        "Producción de gases refrigerantes",
        "Producción de harina de arroz",
        "Producción de harina de centeno",
        "Producción de harina o sémola de frutos secos comestible",
        "Producción de hielo",
        "Producción de hierro de pureza excepcional por electrolisis u otros procesos químicos",
        "Producción de hierro granulado y polvo de hierro",
        "Producción de hierro por reducción directa de productos de hierro y otros productos férreos esponjosos",
        "Producción de huevo",
        "Producción de jarabe de arce y azúcar",
        "Producción de laminados de oro",
        "Producción de laminados de plata a base de metales",
        "Producción de láminas de aluminio",
        "Producción de lana",
        "Producción de lana ovina y caprina",
        "Producción de larvas de camarones y alevines",
        "Producción de leche de ganado bovino",
        "Producción de leche de ganado N. C. P. (incluye la cría de búfalos, cabra, etc. Para la producción de leche)",
        "Producción de madera en rollo basado en las industrias manufactureras",
        "Producción de madera y fabricación de productos de madera y corcho, excepto muebles",
        "Producción de metales no ferrosos N. C. P. y sus semielaborados",
        "Producción de minerales de cobre",
        "Producción de otras formas de propagación de cultivos agrícolas (incluye gajos, bulbos, estacas enraizadas o no, esquejes, plantines, etc.)",
        "Producción de oxido de aluminio",
        "Producción de pelos (incluye la cría de caprinos, camélidos, etc. Para la obtención de pelos)",
        "Producción de petróleo extraído del esquito bituminoso y arena de alquitrán",
        "Producción de platino y metales del grupo del platino",
        "Producción de plomo, zinc y estaño",
        "Producción de plomo, zinc y estaño a base de refinado electrolítico de aluminio",
        "Producción de programas de televisión o comerciales de televisión",
        "Producción de semillas de cultivos agrícolas N. C. P. ",
        "Producción de semillas de hortalizas y legumbres, flores y plantas ornamentales y árboles frutales",
        "Producción de semillas hibridas de cereales y oleaginosas",
        "Producción de semillas varietales o autofecundadas de cereales, oleaginosas y forrajeras",
        "Producción de uranio metálico de pitchblende u otros materiales",
        "Producción de videos",
        "Producción y distribución de agua fría para refrigeración",
        "Producción y distribución de aire frío",
        "Producción y distribución por televisión (no incluye la transmisión)",
        "Producción y refinado de metales preciosos como el oro, plata, platino, etc.",
        "Producción, procesamiento y conservación de carnes y productos cárnicos",
        "Producción, transmisión y distribución de energía eléctrica",
        "Productos agrícolas en general",
        "Productos básicos y la capacidad de transporte de los combustibles gaseosos",
        "Programación informática, consultarías y actividades relacionadas",
        "Programas que cubren la pérdida de ingresos debido a la maternidad, incapacidad temporal y viudez",
        "Promedio y ajuste por pérdida",
        "Promoción de los productos",
        "Promoción y producción de espectáculos deportivos",
        "Promotores de espectáculos",
        "Proveedores de servicios societarios y fideicomisos",
        "Proveedores e intermediarios de Servicios de Activos Virtuales (PSAV)",
        "Provisión de comidas preparadas para empresas (incluye el servicio de suministro de comidas para banquetes, etc.)",
        "Provisión de programas de alfabetización para adultos",
        "Proyecto de gestión de las actividades relacionadas con la construcción",
        "Prueba de humedad y agua",
        "Prueba y pesaje de productos",
        "Pruebas de calificación y fiabilidad",
        "Pruebas de composición y de pureza de los minerales",
        "Pruebas de las características físicas y el rendimiento de los materiales tales como fuerza, espesor, durabilidad y radioactividad",
        "Pruebas de rendimiento de maquinaria completa: motores, automóviles y equipos electrónicos",
        "Pruebas en el ámbito de la higiene de los alimentos, incluidos los veterinarios",
        "Pruebas radiográficas de las soldaduras y las articulaciones, análisis de falla",
        "Publicidad aérea",
        "Publicidad directa por correo",
        "Purificación de agua para fines de abastecimiento de agua",
        "Radiodifusión de datos integrada",
        "Raspado, curtido, decoloración y teñido de pieles",
        "Reaseguros",
        "Reciclamiento de desperdicios y desechos no metálicos",
        "Recogida de desperdicios y desechos metálicos",
        "Recogida del agua de lluvia",
        "Recolección de bálsamos",
        "Recolección de bayas",
        "Recolección de bellotas",
        "Recolección de cartas y paquetes de correos públicos, de buzones o de las oficinas de correo",
        "Recolección de crustáceos y moluscos de agua dulce",
        "Recolección de frutos secos",
        "Recolección de lacas y resinas",
        "Recolección de musgos y líquenes",
        "Recolección de productos marinos (incluye la recolección de algas marinas y otras plantas acuáticas, corales, esponjas)",
        "Recolección de productos silvestres",
        "Recolección y distribución de ropas por lavanderías",
        "Recolección, reducción y eliminación de desperdicios",
        "Reconstrucción y recauchutado de neumáticos",
        "Recopilación y producción de leña",
        "Rectificación de motores",
        "Recuperación de datos ante desastres computacionales",
        "Reformatorios",
        "Refugios temporales para indigentes",
        "Refundición de lingotes de chatarra de hierro o acero",
        "Remodelación o renovación de estructuras residenciales existentes",
        "Renta y venta de videos",
        "Rentista de valores mobiliarios",
        "Reparación de amortiguadores, alineación de dirección y balanceo de ruedas",
        "Reparación de aparatos de video (VCR), lectores de CD",
        "Reparación de artículos deportivos",
        "Reparación de artículos eléctricos de uso domestico",
        "Reparación de artículos electrodomésticos",
        "Reparación de bicicletas",
        "Reparación de cámaras de video tipo domésticas",
        "Reparación de cámaras y cubiertas (incluye reparación de llantas)",
        "Reparación de computadoras hand-held (PDA)",
        "Reparación de cortadoras de césped, sopladores de hojas",
        "Reparación de disco magnético, flash drives y otros dispositivos de almacenaje",
        "Reparación de discos ópticos (CD-RW, CD-ROM, DVD-ROM, DVD-RW)",
        "Reparación de equipaje y similares",
        "Reparación de equipo de transmisión de comunicaciones",
        "Reparación de escáneres, incluyendo los escáneres de código de barras, lectores de tarjetas",
        "Reparación de impresoras, monitores, teclados, ratones, palancas de mando, y accesorios de TrackBall",
        "Reparación de instrumentos musicales y de artículos de pasatiempo, afinación de piano",
        "Reparación de libros",
        "Reparación de máquinas fax",
        "Reparación de módems internos y externos de la computadora",
        "Reparación de otros bienes personales y domésticos N. C. P.",
        "Reparación de otros enseres personales y domésticos",
        "Reparación de piezas de vehículos de motor",
        "Reparación de portadores de equipos MODEM",
        "Reparación de servidores de computadora",
        "Reparación de teléfonos inalámbricos y celulares",
        "Reparación de televisión, receptores de radio",
        "Reparación de terminales como cajeros automáticas y de puntos de venta, que funcionan en forma no mecánica",
        "Reparación de zapatos, botas, artículos de marroquería, etc.",
        "Reparación y modificación de joyas, relojes y sus partes",
        "Reparación y modificación de la ropa",
        "Reparación y pintura de carrocería; colocación de guardabarros y protecciones de exteriores",
        "Reparación y venta de artículos de refrigeración",
        "Reparaciones de sistemas de inyección electrónica",
        "Reparaciones eléctricas, del tablero e instrumental, reparación y recarga de baterías",
        "Replantación de árboles",
        "Repoblación de animales",
        "Repoblación y conservación de bosques nativos y zonas forestadas",
        "Representación de medios y venta de tiempo y espacio para varios medios solicitantes de publicidad",
        "Representantes de sucesiones y/o donaciones",
        "Reproducción de copias masters de software y datos",
        "Reproducción de DVD, cintas con imágenes en movimiento y otras grabaciones de video",
        "Reproducción de grabaciones",
        "Reproducción de películas de cine para la distribución teatral",
        "Reservas y fuerzas auxiliares de defensa",
        "Restaurantes de comida rápida",
        "Restaurantes y cantinas sin espectáculos",
        "Retapizado, reacabado, reparación y restauración de los muebles y mobiliarios caseros incluyendo los muebles de oficinas",
        "Revelado de rollos de películas",
        "Revelados de fotos en una hora",
        "Revestimiento y la impregnación de papel y cartón",
        "Saladero y peladero de cueros de ganado bovino",
        "Sastrerías y atelier",
        "Secado de madera",
        "Secado, vaporizado, reducción y reparación de productos textiles",
        "Segunda etapa de educación terciaria",
        "Seguro de responsabilidad civil y pérdida pecuniaria",
        "Seguro para transporte con motor, marina, la aviación",
        "Seguros de salud (incluye medicina prepagada)",
        "Seguros de viaje",
        "Seguros, reaseguros, fondos de pensiones, excepto los planes de seguridad social de afiliación obligatoria",
        "Sericultura (cría de gusanos de seda)",
        "Serigrafiado de prendas de vestir",
        "Servicio de alimento y bebida",
        "Servicio de atención ambulatoria (incluye las actividades de consultorios médicos de establecimiento sin internación)",
        "Servicio de atención domiciliaria (incluye las actividades llevadas a cabo en establecimiento que ofrecen atención por módulos a domicilio)",
        "Servicio de organización, dirección y gestión de prácticas deportivas y explotación de las instalaciones",
        "Servicio de taquimecanografía",
        "Servicio de transporte de pasajeros por líneas férreas interurbanas",
        "Servicio de transporte escolar (incluye el servicio de transporte para colonias de vacaciones y clubes)",
        "Servicios actuariales",
        "Servicios agrícolas N. C. P. (incluye planificación y diseño paisajista, plantación y mantenimiento de jardines, parques y cementerios)",
        "Servicios auxiliares a la administración de fondos jubilados y pensiones",
        "Servicios auxiliares a la intermediación financiera N. C. P. excepto a los servicios de seguros y de administración de fondos de jubilaciones",
        "Servicios auxiliares a los servicios de seguros N. C. P.",
        "Servicios auxiliares a los servicios de seguros y administradoras de fondos de jubilaciones y pensiones",
        "Servicios auxiliares para los servicios generales de la administración pública N. C. P. (incluye las actividades de servicios generales y de personal)",
        "Servicios bursátiles de mediación o por cuenta de terceros (incluye la actividad de agentes y sociedades de bolsas)",
        "Servicios complementarios de apoyo turístico",
        "Servicios complementarios para el transporte",
        "Servicios complementarios para el transporte aéreo N. C. P. (incluye servicio de prevención y extinción de incendios)",
        "Servicios complementarios para el transporte por agua N. C. P. (incluye explotación de servicios de terminales como puertos y muelles)",
        "Servicios complementarios para el transporte terrestre N. C. P.",
        "Servicios conexos a la producción de espectáculos teatrales y musicales (incluyendo diseño y manejo de escenografía, montaje de iluminación)",
        "Servicios de acompañantes, servicios de citas",
        "Servicios de administración de fondos de pensiones",
        "Servicios de agencias de noticias",
        "Servicios de agencias de viaje y otras actividades complementarias de apoyo turístico",
        "Servicios de agencias matrimoniales",
        "Servicios de agentes de mercado abierto puros (incluye las transacciones extrabursátiles por cuenta propia)",
        "Servicios de almacenamiento y depósito",
        "Servicios de alojamiento en camping (incluye refugios de montaña)",
        "Servicios de alojamiento en hoteles, campamentos y otros tipos de hospedaje temporal",
        "Servicios de alojamiento en hoteles, hosterías y residencias similares, excepto por hora que incluyen servicios de restaurantes",
        "Servicios de alojamiento en hoteles, hosterías y residencias similares, excepto por hora que no incluyen servicios de restaurantes",
        "Servicios de alojamiento en pensiones",
        "Servicios de alojamiento por hora, moteles y cabañas",
        "Servicios de alquiler y explotación de inmuebles para fiestas, convenciones y otros eventos similares",
        "Servicios de arquitectura e ingeniería y servicios conexos de asesoramiento técnico N. C. P.",
        "Servicios de asesoramiento, dirección y gestión empresarial N. C. P.",
        "Servicios de asesoramiento, dirección y gestión empresarial realizados por integrantes de los órganos de administración y/o fiscalización en sociedades anónimas",
        "Servicios de asesoramiento, dirección y gestión empresarial realizados por integrantes de órganos de dirección en sociedades excepto las sociedades anónimas",
        "Servicios de asociaciones de especialistas en disciplinas científicas, prácticas profesionales y esferas técnicas",
        "Servicios de asociaciones N. C. P.",
        "Servicios de asuntos exteriores",
        "Servicios de atención a mujeres con alojamiento",
        "Servicios de atención a personas minusválidas con alojamiento",
        "Servicios de autos blindados",
        "Servicios de bares y confiterías (incluye locales de expendio de bebida con servicio de mesa y/o mostrador)",
        "Servicios de bibliotecas y archivos",
        "Servicios de bibliotecas, archivos y museos y servicios culturales N. C. P.",
        "Servicios de bolsas de comercio",
        "Servicios de buses de larga distancias regulares",
        "Servicios de búsqueda de información a cambio de una retribución o por contrato",
        "Servicios de camarería",
        "Servicios de centros de planificación familiar que provee tratamiento medico",
        "Servicios de comunicación por medio de teléfono, beeper, telégrafo y telex",
        "Servicios de consultaría en informática y suministros de programas de informática",
        "Servicios de consultaría sobre gestión de bosques",
        "Servicios de consultores en equipo de informática",
        "Servicios de consultores en equipos de informática",
        "Servicios de consultores en informática y suministro de programas de informática",
        "Servicios de contabilidad y teneduría de libros, auditoría y asesoría fiscal",
        "Servicios de contratistas de mano de obra agrícola (incluye la poda de árboles, trasplante, fumigación y desinfección manual, etc.)",
        "Servicios de contratistas de mano de obra pecuaria (incluye el arreo, castración de ovejas, recolección de estiércol, etc.)",
        "Servicios de correo",
        "Servicios de cosecha mecánica (incluye la cosecha mecánica de granos, caña de azúcar, algodón, forrajes, el enfardado, enrollado, etc.)",
        "Servicios de crédito N. C. P. (incluye el otorgamiento de préstamos por entidades que no reciben depósitos)",
        "Servicios de cuidado y entrenamiento de animales domésticos",
        "Servicios de defensa",
        "Servicios de depuración de aguas residuales, alcantarillado y cloacas",
        "Servicios de detección de huellas dactilares",
        "Servicios de diagnósticos (incluye las actividades de laboratorios de análisis clínicos y patológicos)",
        "Servicios de direccionamiento de código de barras",
        "Servicios de drenaje y bombeo por comisión o por contrato",
        "Servicios de drenaje y bombeo por contrato o por comisión",
        "Servicios de elaboración de placas",
        "Servicios de elaboración de trofeos",
        "Servicios de electromecánica",
        "Servicios de emergencias y traslados",
        "Servicios de entidades de tarjetas de compra y/o crédito",
        "Servicios de entregas a domicilio",
        "Servicios de envases y empaque",
        "Servicios de espectáculos artísticos y de diversión N. C. P. (incluye parques de diversión, centros similares)",
        "Servicios de expendio de comida y bebida en establecimientos con mesa y/o mostrador",
        "Servicios de exploración",
        "Servicios de explotación de infraestructura para el transporte por agua",
        "Servicios de explotación de infraestructuras para el transporte terrestre, peaje y otros derechos",
        "Servicios de federaciones, asociaciones, cámaras, gremios y organizaciones similares",
        "Servicios de financiación y actividades financieras N. C. P. incluye actividades de inversión en acciones, títulos, fondos comunes)",
        "Servicios de fotografía",
        "Servicios de gestión y logística para el transporte de mercancías",
        "Servicios de gravado en cilindros y placas",
        "Servicios de guardaespaldas",
        "Servicios de guardería náuticas",
        "Servicios de guardias de seguridad",
        "Servicios de hangares, estacionamiento y remolque de aeronaves",
        "Servicios de hospedajes temporales N. C. P. (incluye hospedaje en estancias, residencias para estudiantes y albergues juveniles)",
        "Servicios de hospital de día (incluye las actividades de tratamiento que no necesitan hospitalización a tiempo completo)",
        "Servicios de impresión de códigos de barras",
        "Servicios de impresión heliográfica, fotocopia y otras formas de reproducciones",
        "Servicios de información por teléfono",
        "Servicios de ingeniería civil",
        "Servicios de intermediación financiera realizada por caja de crédito",
        "Servicios de intermediación financiera realizada por las compañías financieras",
        "Servicios de internación",
        "Servicios de investigación N. C. P.",
        "Servicios de jardines botánicos, zoológicos y de parques nacionales",
        "Servicios de justicia",
        "Servicios de la administración publica",
        "Servicios de la banca central 9incluye las actividades del banco central)",
        "Servicios de la banca de inversión",
        "Servicios de la banca mayorista",
        "Servicios de la banca minorista o comerciales",
        "Servicios de la seguridad social obligatoria",
        "Servicios de labranza, siembra, trasplante y cuidados culturales",
        "Servicios de limpieza, conservación, mantenimiento y pintura de edificios",
        "Servicios de los hogares privados que contratan servicios domésticos",
        "Servicios de manejadoras y/o representantes de las aerolíneas",
        "Servicios de manipulación de carga",
        "Servicios de manipulación de carga (incluye los servicios de carga y descarga de mercancías o equipajes de pasajeros)",
        "Servicios de maquinaria agrícola N. C. P. excepto los de cosecha mecánica (incluye enfardado, enrollado, envasado silo pack, etc.)",
        "Servicios de mensajería (courrier)",
        "Servicios de mercados a término",
        "Servicios de mercados y cajas de valores",
        "Servicios de museos y preservación de lugares de edificios históricos",
        "Servicios de organización de colectas de fondos a cambio de una retribución o contrato",
        "Servicios de organización de eventos",
        "Servicios de organizaciones empresariales, profesionales y de empleados",
        "Servicios de organizaciones religiosas",
        "Servicios de organizaciones y órganos extraterritoriales",
        "Servicios de peluquería",
        "Servicios de perforación direccional y redireccionado, reparación y desmantelamiento, cementación de petróleo y gas, bombeo de los pozos, taponamiento y abandono de los pozos",
        "Servicios de personal médico y paramédico",
        "Servicios de pizzería, Fast food y locales de venta de comidas y bebidas al paso",
        "Servicios de plomería y afines",
        "Servicios de polígrafos",
        "Servicios de preselección de correos",
        "Servicios de productores y asesores de seguros",
        "Servicios de protección civil",
        "Servicios de prueba de perforación en relación a la extracción de petróleo o gas",
        "Servicios de publicidad",
        "Servicios de pulverización, desinfección y fumigación de áreas y terrenos",
        "Servicios de radio (no incluye la transmisión)",
        "Servicios de recibos de artículos valiosos con el personal y equipo para proteger tales propiedades",
        "Servicios de recolección de monedas en los parquímetros",
        "Servicios de recortes de noticias y prensa",
        "Servicios de rehabilitación, realizada por unidades del gobierno o por unidades privadas a cambio de una retribución o por contrato",
        "Servicios de restaurantes y cantinas con espectáculos",
        "Servicios de restaurantes y cantinas sin espectáculos",
        "Servicios de salines de baile, discotecas y similares",
        "Servicios de salones de juegos (incluye salones de billar, pool, Bowling)",
        "Servicios de saneamiento público N. C. P.",
        "Servicios de seguridad N. C. P.",
        "Servicios de seguro",
        "Servicios de seguros a las personas excepto los de salud y de vida (incluye los seguros de accidente)",
        "Servicios de seguros de vida (incluye los seguros de vida, retiro y sepelio)",
        "Servicios de seguros patrimoniales",
        "Servicios de sindicatos",
        "Servicios de sociedades calificadoras de riesgo",
        "Servicios de suministro de comidas para contratistas",
        "Servicios de suministros de pañales",
        "Servicios de tasación de propiedades inmobiliaria",
        "Servicios de telecomunicaciones",
        "Servicios de telemarketing y/o profesional mercadeo",
        "Servicios de transferencia de dinero o valores; Intermediarios cambiarios aprobados e inscriptos en la SIB; Cooperativas de ahorro y crédito",
        "Servicios de transmisión de radio y televisión",
        "Servicios de transmisión N. C. P. de sonido, imágenes, datos u otra información",
        "Servicios de transporte automotor",
        "Servicios de transporte automotor de oferta libre de pasajero excepto mediante taxis, alquiler de autos con chofer y transporte escolar",
        "Servicios de transporte automotor de pasajeros mediante taxis y remises; alquiler de autos con chofer",
        "Servicios de transporte automotor de pasajeros para el turismo",
        "Servicios de transporte automotor interurbano de pasajeros (incluye los servicios de transporte regular de más de 50km)",
        "Servicios de transporte de caudales y objetos de valor",
        "Servicios de transporte ferroviario urbano y suburbano de pasajeros (incluye el servicio de subterráneo)",
        "Servicios de tratamiento (incluye las actividades de centros de cobaltoterapia, de radiología convencional, de acelerador lineal)",
        "Servicios de tratamiento de belleza, excepto los de peluquería",
        "Servicios de tutoría académica",
        "Servicios directos al sistema minero",
        "Servicios empresariales N. C. P.",
        "Servicios forestales de extracción de madera (incluye tala de árboles, acarreo y transporte en el interior del bosque, servicios realizados de terceros)",
        "Servicios forestales excepto los relacionados con la extracción de madera (incluye la protección contra incendios, evaluación de masas forestales)",
        "Servicios generales de la administración pública (incluye el desempeño de funciones ejecutivas y legislativas de administración por parte de las entidades públicas)",
        "Servicios geológicos y de prospección",
        "Servicios hospitalarios N. C. P.",
        "Servicios inmobiliarios realizados a cambio de una retribución o por contrata (incluye compra, venta, alquiler, reate, tasación)",
        "Servicios inmobiliarios realizados a cuenta propia, con bienes propios o arrendados",
        "Servicios inmobiliarios realizados por cuenta propia, con bienes propios o arrendados N. C. P.",
        "Servicios jurídicos",
        "Servicios jurídicos y de contabilidad, teneduría de libro y auditoria; asesoramiento en materia de impuestos",
        "Servicios mayoristas de agencias de viaje",
        "Servicios minoristas de agencias de viaje",
        "Servicios N. C. P.",
        "Servicios náuticos (escuelas de buceo y alquiler de equipos náuticos)",
        "Servicios notariales",
        "Servicios odontológicos",
        "Servicios para el control de plagas, baños parasiticidas, etc.",
        "Servicios para el mantenimiento físico-corporal (incluye baños turcos, saunas, solarios, centros de masajes y adelgazamiento, etc.)",
        "Servicios para el orden público y la seguridad",
        "Servicios para la aeronavegación",
        "Servicios para la caza",
        "Servicios para la navegación (incluye servicio de practicaje y pilotaje, atraque)",
        "Servicios para la pesca",
        "Servicios para la práctica deportiva y de entretenimiento N. C. P.",
        "Servicios para la regulación de la actividad económica (incluye la administración pública y la regulación de varios sectores económicos)",
        "Servicios para la regulación de las actividades sanitarias, educación y servicios sociales",
        "Servicios pecuarios N. C. P. excepto los veterinarios",
        "Servicios personales en general",
        "Servicios prestados por parqueos de estacionamiento y garajes",
        "Servicios prestados por profesionales y técnicos, para la realización de prácticas deportivas (incluye las realizadas por deportistas)",
        "Servicios relacionados con bases de datos",
        "Servicios relacionados con la electrónica y las comunicaciones",
        "Servicios relacionados con la impresión",
        "Servicios relacionados con la prevención de incendios",
        "Servicios relacionados con la salud humana",
        "Servicios relacionados con la salud humana N. C. P.",
        "Servicios sociales con alojamiento",
        "Servicios sociales con alojamiento N. C. P.",
        "Servicios veterinarios",
        "Silvicultura y extracción de madera",
        "Sociedades de inversión",
        "Subastas de coches",
        "Subtitulación en tiempo real de televisión, de reuniones y conferencias",
        "Suite y apartahoteles",
        "Suministro de acceso a Internet por el operador de la infraestructura del cableado",
        "Suministro de comidas basado en acuerdos contractuales",
        "Suministro de comidas para banquetes, bodas, fiestas y otras celebraciones",
        "Suministro de electricidad, gas, vapor y aire acondicionado",
        "Suministro de vapor y agua caliente",
        "Supervisión de las operaciones bancarias",
        "Suplidores de equipos y materiales para hoteles y restaurantes",
        "Swaps, opciones y otros acuerdos de coberturas",
        "Tapizado y retapizado",
        "Técnicos de suelo",
        "Tenedoras de las reservas internacionales de un país",
        "Terminación de edificios",
        "Terminación de obras de ingeniería civil N. C. P. (incluye trabajos de ornamentación, limpieza de exterior de edificios)",
        "Terminación y revestimiento de paredes y pisos (incluye la instalación de yesería, salpicré, pulido de pisos y colocación de revestimiento de cerámica)",
        "Terminación y teñido de cueros",
        "Tierras",
        "Toma de depósitos que son utilizados para compensaciones entre instituciones financieras",
        "Torrefacción de café",
        "Tostado, torrado, y molienda de café",
        "Trabajo en mica y articulo de mica, de turba, grafito (que no sean artículos eléctricos)",
        "Trabajos sobre estructuras altas",
        "Traductores",
        "Transferencia de películas/cintas",
        "Transformación de aceite vegetal mediante deshidratación o hidrogenación",
        "Transformación de aceite vegetal mediante ebullición",
        "Transformación de aceite vegetal mediante soplado",
        "Transmisión de programaciones radiales",
        "Transporte a granel, incluido los transportes en camiones cisterna",
        "Transporte automotor de pasajeros N. C. P.",
        "Transporte automotor urbano regular de pasajeros",
        "Transporte de agregados para la construcción (arena, grava, entre otros)",
        "Transporte de agua",
        "Transporte de animales vivos",
        "Transporte de carga pesada N. C. P. (incluye servicio de carga de refrigerada, automotores, transporte)",
        "Transporte de carga por líneas férreas de corto recorrido",
        "Transporte de carga por líneas férreas principales",
        "Transporte de carga por vía aérea",
        "Transporte de energía eléctrica",
        "Transporte de gases a través de gaseoductos",
        "Transporte de líquidos",
        "Transporte de mercadería y materiales pesados",
        "Transporte de mercancías por vía aérea en rutas regulares y en horarios regulares",
        "Transporte de otros productos básicos a través de gaseoductos",
        "Transporte de pasajeros por vía aérea",
        "Transporte de residuos y materiales de desechos, sin recogida o eliminación",
        "Transporte de troncos",
        "Transporte de troncos dentro del bosque",
        "Transporte de valores",
        "Transporte espacial",
        "Transporte fluvial de carga",
        "Transporte fluvial de pasajeros",
        "Transporte marítimo de pasajeros",
        "Transporte marítimo y cabotaje",
        "Transporte marítimo y de cabotaje de carga",
        "Transporte no regulares de carga por vía aérea",
        "Transporte por oleoductos y poliductos",
        "Transporte por remolque o tracción de barcazas, plataformas petroleras, etc.",
        "Transporte por tuberías",
        "Transporte por vía acuática",
        "Transporte por vía férrea",
        "Transporte por vía terrestre y transporte por tuberías",
        "Transporte refrigerado de productos",
        "Transporte terrestre de pasajeros por autobús",
        "Transporte terrestre de pasajeros por metro y ferrocarriles elevados",
        "Transporte terrestre de pasajeros por tranvía",
        "Transporte urbano de carga N. C. P. (incluye el transporte realizado por fleteros y distribuidores dentro del Egido urbano)",
        "Transporte y venta al por menor de combustible",
        "Trasplante de arroz",
        "Trasporte de carga por vías de navegación interiores",
        "Tratamiento antióxido",
        "Tratamiento de agua industrial y para otros fines",
        "Tratamiento de cultivos",
        "Tratamiento y revestimiento de metales; obras de ingeniería mecánica realizadas a cambio de una retribución o por contrato",
        "Trituración de piedra y grava",
        "Trituración, perforación y refinado de sal",
        "Unidades (establecimientos) con cama y desayuno",
        "Uniones y/o corporaciones de crédito",
        "Urea, fosfatos naturales en bruto y crudo, potasio de sales naturales",
        "Venta al por mayor a cambio de una retribución o contrata",
        "Venta al por mayor d tubo para neumáticos y cubiertas",
        "Venta al por mayor de aberturas (ventanas, puertas, cortinas enrollables)",
        "Venta al por mayor de aceites esenciales",
        "Venta al por mayor de aceites lubricantes y grasas, excepto para automotores, leña y carbón",
        "Venta al por mayor de ácidos y azufres",
        "Venta al por mayor de alimentos N. C. P. (incluye la venta de miel y derivados, productos congelados, etc.)",
        "Venta al por mayor de alimentos para animales",
        "Venta al por mayor de almidón, fécula",
        "Venta al por mayor de anilina, parafina",
        "Venta al por mayor de animales vivos",
        "Venta al por mayor de aparatos de iluminación",
        "Venta al por mayor de aparatos fotográficos e instrumentos de óptica (incluye la venta de lentes de contacto, líquidos oftalmológicos, armazones, etc.)",
        "Venta al por mayor de arados, esparcidor de estiércol y sembradoras",
        "Venta al por mayor de aromas y perfumes",
        "Venta al por mayor de artefactos eléctricos, gas, kerosene u otros combustibles para el hogar",
        "Venta al por mayor de artículos de bazar, menaje excepto de vidrio",
        "Venta al por mayor de artículos de cuero y accesorios de viaje",
        "Venta al por mayor de artículos de ferretería",
        "Venta al por mayor de artículos de librería y papelería",
        "Venta al por mayor de artículos de loza, porcelana y cerámica de uso en la construcción",
        "Venta al por mayor de artículos de marroquería, paraguas y productos similares N. C. P.",
        "Venta al por mayor de artículos de mercería (incluye la venta de puntillas, galones, hombreras, agujas, botones, etc.)",
        "Venta al por mayor de artículos de mimbre y corcho; colchones y Simones",
        "Venta al por mayor de artículos de plásticos",
        "Venta al por mayor de artículos de plomería, electricidad, calefacción, obras sanitarias, etc.",
        "Venta al por mayor de artículos de uso domestico y/o personal N. C. P.",
        "Venta al por mayor de artículos de vidrio",
        "Venta al por mayor de artículos deportivos (incluye embarcaciones deportivas, armas y municiones, equipo de pesca)",
        "Venta al por mayor de artículos regionales",
        "Venta al por mayor de aves, huevos y productos de granjas y de la caza N. C. P.",
        "Venta al por mayor de azúcar",
        "Venta al por mayor de baños, lavado, inodoros y otros sanitarios de porcelana",
        "Venta al por mayor de bebidas alcohólicas N. C. P. (incluye la venta de aperitivos con alcohol, cerveza, sidra, etc.)",
        "Venta al por mayor de bebidas espiritosas",
        "Venta al por mayor de bebidas no alcohólicas (incluye la venta de aguas, sodas, bebidas refrescantes, jarabes, extractos, etc.)",
        "Venta al por mayor de bicicletas, sus partes y accesorios",
        "Venta al por mayor de café, té, yerba mate y otras infusiones ",
        "Venta al por mayor de calentadores de agua",
        "Venta al por mayor de calzados de todo tipo excepto los ortopédicos (incluye venta de calzado de cuero, tela, plástico, etc.)",
        "Venta al por mayor de carbón de leña, carbón de coque, combustible nafta",
        "Venta al por mayor de carnes y productos derivados excepto las de aves",
        "Venta al por mayor de caucho y productos de caucho excepto de calzado y autopartes",
        "Venta al por mayor de cereales (arroz), oleaginosas y forrajeras excepto semillas",
        "Venta al por mayor de cerraduras",
        "Venta al por mayor de chocolates, golosinas y productos de confitería para quioscos",
        "Venta al por mayor de cigarrillos y productos de tabaco",
        "Venta al por mayor de colas químicas, resinas sintéticas",
        "Venta al por mayor de combustibles sólidos, líquidos, gaseosos y de productos conexos",
        "Venta al por mayor de combustibles y lubricantes para automotores",
        "Venta al por mayor de condimentos y especias",
        "Venta al por mayor de corbatas, tirantes y guantes",
        "Venta al por mayor de desperdicios y desechos de papel y cartón",
        "Venta al por mayor de desperdicios y desechos textiles",
        "Venta al por mayor de diarios y revistas",
        "Venta al por mayor de envases de papel y cartón",
        "Venta al por mayor de equipo profesional y científico",
        "Venta al por mayor de equipos controlados por maquinaria para la industria textil",
        "Venta al por mayor de equipos de sonido, radio y televisión, comunicaciones y sus componentes",
        "Venta al por mayor de equipos e instrumentos de medida y control",
        "Venta al por mayor de equipos informáticos y maquinas electrónicas de escribir y calcular",
        "Venta al por mayor de equipos y materiales eléctricos",
        "Venta al por mayor de fertilizantes y productos agroquímicos",
        "Venta al por mayor de fiambres y quesos",
        "Venta al por mayor de fibras textiles",
        "Venta al por mayor de frutas, legumbres y cereales secos en conserva",
        "Venta al por mayor de gases industriales, metanol",
        "Venta al por mayor de gases licuados de petróleo, butano y gas propano",
        "Venta al por mayor de herrajes y accesorios",
        "Venta al por mayor de instrumental médico, odontológico y artículos ortopédicos (incluye venta de vaporizadores, nebulizadores, etc.)",
        "Venta al por mayor de instrumentos musicales, discos y casetes de audio y video",
        "Venta al por mayor de juegos y juguetes",
        "Venta al por mayor de ladrillos, cemento, cal, arena, piedra, mármol y materiales para la construcción N. C. P.",
        "Venta al por mayor de lanas, cueros en bruto y productos afines",
        "Venta al por mayor de leche",
        "Venta al por mayor de libros y publicaciones",
        "Venta al por mayor de madera en bruto",
        "Venta al por mayor de mantelería y artículos textiles para el hogar",
        "Venta al por mayor de maquinaria, equipo y materiales conexos",
        "Venta al por mayor de maquinas avícolas y apicultoras",
        "Venta al por mayor de maquinas de ordeño",
        "Venta al por mayor de maquinas y equipos de comunicación, control y seguridad (incluye la venta de teléfonos y equipos de comunicación)",
        "Venta al por mayor de maquinas y equipos de oficina",
        "Venta al por mayor de maquinas, equipos e implementos de uso en imprentas, artes graficas y actividades conexas",
        "Venta al por mayor de maquinas, equipos e implementos de uso en la construcción",
        "Venta al por mayor de maquinas, equipos e implementos de uso en la elaboración de alimentos, bebidas y tabacos",
        "Venta al por mayor de maquinas, equipos e implementos de uso en la industria de caucho y plástico",
        "Venta al por mayor de maquinas, equipos e implementos de uso en los sectores agropecuario, jardinería, silvicultura, pesca y caza",
        "Venta al por mayor de maquinas, equipos e implementos de uso especial N.C.P.",
        "Venta al por mayor de maquinas, equipos e implementos de uso médico y paramédico",
        "Venta al por mayor de maquinas, equipos y materiales conexos",
        "Venta al por mayor de maquinas-herramientas de uso general",
        "Venta al por mayor de mariscos",
        "Venta al por mayor de materia prima agrícola y de silvicultura N. C. P. (incluye el acopio y venta al por mayor de frutas, flores, etc.)",
        "Venta al por mayor de materiales de construcción, artículos de ferretería y equipos y materiales de fontanería",
        "Venta al por mayor de materiales y productos para la limpieza",
        "Venta al por mayor de materias primas agropecuarias y animales vivos",
        "Venta al por mayor de medias y prendas de puntos",
        "Venta al por mayor de mercancías N. C. P.",
        "Venta al por mayor de metales ferrosos y no ferrosos en formas primaria",
        "Venta al por mayor de metales ferrosos y no ferrosos semi-acabado de productos metálicos N. C. P.",
        "Venta al por mayor de metales y minerales metalíferos",
        "Venta al por mayor de muebles metálicos excepto de oficina",
        "Venta al por mayor de muebles N. C. P. excepto de oficinas, artículos de mimbre y corcho",
        "Venta al por mayor de oro y otros metales preciosos",
        "Venta al por mayor de otros enseres domésticos",
        "Venta al por mayor de otros productos",
        "Venta al por mayor de otros productos intermedios desperdicios y desechos",
        "Venta al por mayor de pan, productos de confitería y pastas frescas",
        "Venta al por mayor de papel a granel",
        "Venta al por mayor de papel y productos de papel y cartón excepto envases",
        "Venta al por mayor de papeles para pared, revestimiento de suelo",
        "Venta al por mayor de partes y piezas y accesorios de vehículos automotores",
        "Venta al por mayor de pescado",
        "Venta al por mayor de pieles, cueros curtidos y salados",
        "Venta al por mayor de pinturas y productos conexos",
        "Venta al por mayor de prendas de vestir de cuero",
        "Venta al por mayor de prendas de vestir N. C. P.",
        "Venta al por mayor de prendas de vestir y ropa de cama",
        "Venta al por mayor de productos cosméticos, de artículos de tocador y de perfumería",
        "Venta al por mayor de productos de primera transformación de la madera",
        "Venta al por mayor de productos del petróleo refinado",
        "Venta al por mayor de productos en almacenes y supermercados mayoristas con predominio de alimentos y bebidas",
        "Venta al por mayor de productos farmacéuticos (incluye venta de medicamentos y kits de diagnósticos)",
        "Venta al por mayor de productos intermedios de papel N. C. P.",
        "Venta al por mayor de productos intermedios N. C. P. desperdicios y desechos metálicos (incluye chatarra, viruta de metales diversos)",
        "Venta al por mayor de productos intermedios N. C. P. desperdicios y desechos textiles",
        "Venta al por mayor de productos intermedios, desperdicios y desechos N. C. P.",
        "Venta al por mayor de productos lácteos",
        "Venta al por mayor de productos textiles, excepto telas, tejidos, prendas y accesorios de vestir",
        "Venta al por mayor de productos veterinarios",
        "Venta al por mayor de productos y subproductos de molinería",
        "Venta al por mayor de relojes y joyas",
        "Venta al por mayor de ropa",
        "Venta al por mayor de ropa para deportes",
        "Venta al por mayor de semillas",
        "Venta al por mayor de soda, sal industrial",
        "Venta al por mayor de software",
        "Venta al por mayor de suelas y afines (incluye talabartería, artículos regionales de cuero, almacenes de suela, etc.)",
        "Venta al por mayor de tabaco sin manufacturar",
        "Venta al por mayor de tapices y alfombras de materiales textiles",
        "Venta al por mayor de tejidos (telas)",
        "Venta al por mayor de textiles, prendas de vestir y calzado",
        "Venta al por mayor de tinta de imprenta y colorante",
        "Venta al por mayor de tractores utilizados en la agricultura y silvicultura",
        "Venta al por mayor de trilladoras",
        "Venta al por mayor de vehículos, equipos y maquinas para el transporte ferroviario, aéreo y de navegación",
        "Venta al por mayor de vidrio plano y templado",
        "Venta al por mayor de vino",
        "Venta al por mayor e instalación de muebles de oficinas",
        "Venta al por mayor e instalación de muebles para industrias, comercios",
        "Venta al por mayor en comisión o consignación de alimentos, bebidas y tabaco N. C. P.",
        "Venta al por mayor en comisión o consignación de cereales (incluye arroz), oleaginosas y forrajeras",
        "Venta al por mayor en comisión o consignación de energía eléctrica, gas y combustibles",
        "Venta al por mayor en comisión o consignación de madera y materiales de construcción",
        "Venta al por mayor en comisión o consignación de maquinaria, equipo profesional industrial y comercial, embarcaciones y aeronaves",
        "Venta al por mayor en comisión o consignación de materiales N. C. P.",
        "Venta al por mayor en comisión o consignación de minerales, metales y productos químicos industriales",
        "Venta al por mayor en comisión o consignación de papel, cartón, libros, revistas, diarios y materiales de embalaje",
        "Venta al por mayor en comisión o consignación de productos agrícolas N. C. P.",
        "Venta al por mayor en comisión o consignación de productos textiles, prendas de vestir, calzados, paraguas",
        "Venta al por mayor en comisión o consignación de semillas",
        "Venta al por mayor o al por menor por comisión de agentes",
        "Venta al por mayor y al por menor de partes y piezas de motocicletas",
        "Venta al por mayor y empaque de frutas, legumbres y hortalizas frescas (incluye la conservación en cámaras frigoríficas)",
        "Venta al por menor a través de maquinas expendedoras",
        "Venta al por menor a través de pedio por correo o vía Internet",
        "Venta al por menor de agujas, hilo de cocer, etc. (mercerías)",
        "Venta al por menor de alfombras y tapetes",
        "Venta al por menor de alimenticios, bebidas o tabaco en almacenes especializados",
        "Venta al por menor de alimentos para animales de compañía",
        "Venta al por menor de alimentos, bebidas y productos de tabaco en puestos de ventas ambulantes",
        "Venta al por menor de antigüedades",
        "Venta al por menor de aparatos para el hogar y equipo N. C. P.",
        "Venta al por menor de armas y artículos de cuchillería, artículos para la caza y pesca",
        "Venta al por menor de armas y municiones",
        "Venta al por menor de artefactos para el hogar electrónicos, gas, a kerosene u otros combustibles",
        "Venta al por menor de artefactos y juguetes",
        "Venta al por menor de artículos de caucho excepto tubos para neumáticos y cubiertas",
        "Venta al por menor de artículos de colección y objetos de arte",
        "Venta al por menor de artículos de cuero",
        "Venta al por menor de artículos de deporte",
        "Venta al por menor de artículos de fantasía",
        "Venta al por menor de artículos de ferretería",
        "Venta al por menor de artículos de ferretería, pinturas y productos de vidrio",
        "Venta al por menor de artículos de iluminación",
        "Venta al por menor de artículos de limpieza",
        "Venta al por menor de artículos de plomería e instalación de gas",
        "Venta al por menor de artículos deportivos",
        "Venta al por menor de artículos nuevos N. C. P. (incluye casas de regalos, de artesanías y artículos regionales)",
        "Venta al por menor de artículos para acampar",
        "Venta al por menor de artículos para el hogar y equipo de uso domestico N.C.P.",
        "Venta al por menor de artículos para la pesca deportiva",
        "Venta al por menor de artículos regionales y de talabartería",
        "Venta al por menor de artículos relacionados con la salud",
        "Venta al por menor de artículos religiosos",
        "Venta al por menor de artículos textiles N. C. P. excepto prendas de vestir",
        "Venta al por menor de audífonos",
        "Venta al por menor de baldosas",
        "Venta al por menor de baterías",
        "Venta al por menor de bebidas",
        "Venta al por menor de bebidas alcohólicas (licor store)",
        "Venta al por menor de bebidas no alcohólicas",
        "Venta al por menor de bebidas y productos del tabaco",
        "Venta al por menor de bicicletas",
        "Venta al por menor de bombones, golosinas y demás artículos de confitería",
        "Venta al por menor de botes",
        "Venta al por menor de café y te",
        "Venta al por menor de calzados excepto los ortopédicos",
        "Venta al por menor de carne y productos cárnicos",
        "Venta al por menor de carteras",
        "Venta al por menor de cigarros y cigarrillos",
        "Venta al por menor de colchones y Simones",
        "Venta al por menor de combustible para uso domestico, gas embasado, carbón y leña",
        "Venta al por menor de combustible para vehículos automotores y motocicletas (incluye estaciones de servicios)",
        "Venta al por menor de combustibles para vehículos en almacenes especializados",
        "Venta al por menor de computadoras",
        "Venta al por menor de confecciones para el hogar (incluye la venta al por menor de cortinas, sabanas y toallas)",
        "Venta al por menor de consolas de videojuegos",
        "Venta al por menor de cortadoras de césped",
        "Venta al por menor de cosméticos",
        "Venta al por menor de cristales, espejos, mamparas y cerramientos",
        "Venta al por menor de cualquier tipo de producto a través de Internet",
        "Venta al por menor de cualquier tipo de producto por correo",
        "Venta al por menor de electrodomésticos",
        "Venta al por menor de electrodomésticos y electrónica de consumo",
        "Venta al por menor de embutidos y fiambre",
        "Venta al por menor de equipos de telecomunicaciones",
        "Venta al por menor de equipos profesionales y científicos e instrumentos de medidas de control",
        "Venta al por menor de equipos sanitarios",
        "Venta al por menor de equipos y materiales del tipo hágalo usted mismo",
        "Venta al por menor de equipos y materiales eléctricos",
        "Venta al por menor de flores y plantas",
        "Venta al por menor de frutas y hortalizas frescas o en conserva",
        "Venta al por menor de grava, cascajo en estado natural",
        "Venta al por menor de hilados de tejidos de punto",
        "Venta al por menor de huevo, carne de aves y productos de granja y de la caza N. C. P.",
        "Venta al por menor de indumentaria para bebes y niños",
        "Venta al por menor de indumentaria para trabajo, uniformes y guardapolvos",
        "Venta al por menor de instrumentos musicales, equipos de sonido, casetes de audio y video",
        "Venta al por menor de joyas",
        "Venta al por menor de juegos y juguetes",
        "Venta al por menor de juegos y juguetes hechos de cualquier material",
        "Venta al por menor de ladrillos",
        "Venta al por menor de lana",
        "Venta al por menor de lápices, bolígrafos, papel, etc.",
        "Venta al por menor de libros",
        "Venta al por menor de libros usados",
        "Venta al por menor de madera",
        "Venta al por menor de madera, artículos de madera y corcho excepto muebles",
        "Venta al por menor de maquinas y equipos para oficinas y sus componentes y repuestos",
        "Venta al por menor de maquinas y motores y sus repuestos",
        "Venta al por menor de marroquerías, paraguas y similares",
        "Venta al por menor de material fotográfico, óptico y de precisión",
        "Venta al por menor de materiales básicos para hacer alfombras, tapices o bordados",
        "Venta al por menor de materiales de construcción N. C. P.",
        "Venta al por menor de mercancías de segunda mano",
        "Venta al por menor de metales y similares",
        "Venta al por menor de mobiliario domestico",
        "Venta al por menor de muebles",
        "Venta al por menor de muebles usados",
        "Venta al por menor de música y grabaciones de video",
        "Venta al por menor de otros bienes de segunda mano N. C. P.",
        "Venta al por menor de pan y de productos de panadería",
        "Venta al por menor de papel pintado y revestimiento de piso y artículos similares para la decoración",
        "Venta al por menor de papel, cartón y materiales de embalaje y artículos de librería",
        "Venta al por menor de partes, piezas y accesorios excepto neumáticos, cubiertas, parabrisas",
        "Venta al por menor de perfumes y cosméticos",
        "Venta al por menor de periódicos y artículos de papelería",
        "Venta al por menor de pescados, mariscos y otros productos",
        "Venta al por menor de pintura, barnices y lacas",
        "Venta al por menor de pinturas",
        "Venta al por menor de prendas de vestir",
        "Venta al por menor de prendas y accesorios de vestir N. C. P. excepto calzados, artículos de marroquería, paraguas, etc.",
        "Venta al por menor de productos alimenticios N. C. P. en comercios especializados",
        "Venta al por menor de productos de almacén y dietética",
        "Venta al por menor de productos de herbostería",
        "Venta al por menor de productos farmacéuticos",
        "Venta al por menor de productos farmacéuticos, medicinales, cosméticos y artículos de tocador en almacenes especializados",
        "Venta al por menor de productos lácteos",
        "Venta al por menor de productos lubricantes y productos de refrigeración para vehículos de motor",
        "Venta al por menor de productos médicos y ortopédicos",
        "Venta al por menor de productos nuevos en almacenes especializados",
        "Venta al por menor de productos textiles",
        "Venta al por menor de productos textiles, prendas de vestir, calzados y artículos de cuero en almacenes especializados",
        "Venta al por menor de productos veterinario y animales domésticos",
        "Venta al por menor de puertas, ventanas, cortinas enrollables y puertas corredizas",
        "Venta al por menor de relojes",
        "Venta al por menor de rodados excepto bicicletas",
        "Venta al por menor de ropa interior, medias, prendas para dormir y prendas para la playa",
        "Venta al por menor de saunas",
        "Venta al por menor de sellos y monedas",
        "Venta al por menor de semillas y fertilizantes",
        "Venta al por menor de software no personalizados y juegos de video",
        "Venta al por menor de tabaco",
        "Venta al por menor de tejidos",
        "Venta al por menor de telas",
        "Venta al por menor de todo tipo de libros",
        "Venta al por menor en almacenes con predominio de productos alimenticios y bebidas",
        "Venta al por menor en almacenes no especializados",
        "Venta al por menor en almacenes no especializados, con surtido compuesto principalmente de alimentos, bebidas y tabaco",
        "Venta al por menor en hipermercados con predominio en productos alimentarios y bebidas, grandes tiendas, plazas",
        "Venta al por menor en kioscos, poli rubros y comercios no especializados N.C.P.",
        "Venta al por menor en puestos móviles",
        "Venta al por menor en subastas por Internet",
        "Venta al por menor en supermercados con predominio de productos alimenticios y bebidas",
        "Venta al por menor excepto la especializada, sin predominio de productos alimenticios y bebidas",
        "Venta al por menor no realizada en establecimientos N. C. P. (incluye venta mediante maquinas expendedoras, vendedores ambulantes)",
        "Venta al por menor por comisionistas",
        "Venta al por menor por correo, televisión, Internet y otros medios de comunicación",
        "Venta de animales y aves vivas",
        "Venta de autos, camionetas y utilitarios, nuevos (incluye taxis, jeeps, 4 X 4 y vehículos similares)",
        "Venta de autos, camionetas y utilitarios, usados (incluye taxis, jeeps, 4 X 4 y vehículos similares)",
        "Venta de combustible, minerales, metales y productos químicos industriales incluyendo los fertilizantes",
        "Venta de combustibles entregado directamente a los clientes",
        "Venta de consolas de videojuego",
        "Venta de electricidad para el usuario",
        "Venta de equipos estéreos",
        "Venta de equipos y aparatos de transporte aéreo y marítimo",
        "Venta de gas a los usuarios",
        "Venta de hielo",
        "Venta de llantas de goma y tubos",
        "Venta de maquinaria incluyendo de oficina y computadoras, equipos industriales, barcos y aviones",
        "Venta de materias primas agrícolas, animales vivos, materias primas textiles y productos semielaborados",
        "Venta de motocicleta y de sus partes, piezas y accesorios",
        "Venta de muebles y enseres domésticos",
        "Venta de partes, piezas y accesorios de vehículos automotores",
        "Venta de productos para la fabricación de equipos para la generación de energía alternativa",
        "Venta de reproductores y grabadoras de CD y DVD",
        "Venta de sombreros, guantes, pañuelo y corbata",
        "Venta de tapices, cortinas y alfombras",
        "Venta de vehículos automotores de pasajeros y vehículos de motor especializados como ambulancias y minibuses",
        "Venta de vehículos automotores, nuevos N. C. P. (incluye casas rodantes, tráiler, remolques, ambulancias, ómnibus)",
        "Venta de vehículos automotores, usados N. C. P. (incluye casas rodantes, tráiler, camiones, remolques, ambulancias, ómnibus)",
        "Venta de vehículos de camping, como caravanas y autocaravanas",
        "Venta directa a través de la televisión, radio y teléfono",
        "Venta y distribución de fósforos y materiales para su fabricación",
        "Venta y distribución de fuegos artificiales",
        "Venta y distribución de tarjetas de llamadas telefónicas",
        "Venta, mantenimiento y reparación de motocicletas y de sus partes y piezas",
        "Venta, reparación o alquilar de plantas eléctricas",
        "Ventas al por mayor de aceites y grasas",
        "Ventas al por mayor de alimentos, bebidas y tabaco",
        "Ventas al por mayor de artículos de cuero",
        "Ventas al por mayor de flores y plantas naturales y artificiales",
        "Ventas al por menor de artículos de bazar y menaje",
        "Ventas de vehículos automotores, excepto motocicleta",
        "Verificación de las cuentas y la certificación de su exactitud",
        "Video grabación de eventos como bodas, reuniones, etc.",
        "Vigilancia y seguridad",
        "Visitas a museos históricos o culturales, teatrales, musicales o eventos deportivos",
        "Viviendas residenciales para el perturbado emocionalmente",
        "Vuelos charter de pasajeros",
        "Vuelos de exhibición y de turismo"
    ],
    'ciudadesRD': [
        "AGUA SANTA DEL YUNA (D.M.)",
        "ALTAMIRA",
        "AMIAMA GOMEZ",
        "AMINA (D.M.)",
        "ANGELINA",
        "ARENOSO",
        "ARROYO  TORO - MASIPEDRO",
        "ARROYO AL MEDIO",
        "ARROYO BARRIL",
        "ARROYO CANO",
        "ARROYO DULCE",
        "ARROYO SALADO (D.M.)",
        "AZUA",
        "BAHORUCO",
        "BAITOA (D.M.)",
        "BAJOS DE HAINA",
        "BANI",
        "BANICA",
        "BARAHONA",
        "BARRAQUITO",
        "BARRERAS",
        "BARRO ARRIBA",
        "BATEY 8",
        "BATISTA (D. M.)",
        "BAYAGUANA",
        "BAYAHIBE",
        "BELLOSO",
        "BLANCO (D.M.)",
        "BOCA CHICA",
        "BOCA DE CACHON",
        "BOCA DE MAO",
        "BOCA DE YUMA (D.M.)",
        "BOHECHIO",
        "BOYA",
        "BUENA VISTA",
        "CABALLERO",
        "CABARETE",
        "CABEZA DE TORO",
        "CABRAL",
        "CABRERA",
        "CALETA",
        "CAMBITA EL PUEBLECITO",
        "CAMBITA GARABITOS",
        "CANA CHAPETON (D.M.)",
        "CANABACOA",
        "CANCA LA PIEDRA",
        "CANCA LA REYNA",
        "CANOA (D.M.)",
        "CAPOTILLO",
        "CARRERA DE YEGUAS",
        "CASTAÑUELAS",
        "CASTILLO",
        "CATALINA",
        "CAYETANO GERMOSEN",
        "CAÑONGO",
        "CENOVI (D.M.)",
        "CEVICOS",
        "CHIRINO",
        "CLAVELLINA",
        "COMEDERO ARRIBA",
        "COMENDADOR",
        "CONCEPCION DE LA VEGA",
        "CONSTANZA",
        "CONSUELO",
        "COTUI",
        "CRISTO REY DE GUARAGUAO (D.",
        "CRISTOBAL (D.M.)",
        "CRUCE DE GUAYACANES",
        "CUMAYASA",
        "DAJABON",
        "DERRUMBADERO (D. M.)",
        "DON JUAN (D.M.)",
        "DORAL",
        "DOÑA EMMA BALAGUER VIUDA VALLEJO",
        "DUVERGE",
        "EL AGUACATE",
        "EL CACHON (D.M.)",
        "EL CAIMITO",
        "EL CARRETON",
        "EL CARRIL",
        "EL CEDRO",
        "EL CERCADO",
        "EL ESTRECHO DE LUPERON OMAR BROSS",
        "EL FACTOR",
        "EL HIGUERITO",
        "EL LIMON",
        "EL LIMONAL",
        "EL LLANO",
        "EL NARANJAL",
        "EL PALMAR (D.M.)",
        "EL PEÑON (D.M.)",
        "EL PINAR",
        "EL PINO (D.M.)",
        "EL POZO (D.M.)",
        "EL PUERTO (D.M.)",
        "EL RANCHITO",
        "EL ROSARIO",
        "EL RUBIO (D.M.)",
        "EL SALADO",
        "EL VALLE",
        "ELUPINA CORDERO DE LAS CAÑITAS (D.M",
        "ENRIQUILLO",
        "ESPERALVILLO (D.M)",
        "ESPERANZA",
        "ESTEBANIA (D.M.)",
        "ESTERO HONDO (D.M.)",
        "FANTINO",
        "FONDO NEGRO",
        "FUNDACION (D.M.)",
        "GALVAN",
        "GANADERO",
        "GASPAR HERNANDEZ",
        "GAUTIER",
        "GEORGIA",
        "GONZALO (D.M.)",
        "GUALETE",
        "GUANANICO",
        "GUANITO",
        "GUATAPANAL (D.M.)",
        "GUAYABAL (D.M.)",
        "GUAYABAL",
        "GUAYABO DULCE (D.M.)",
        "GUAYABO",
        "GUAYACANES",
        "GUAYMATE",
        "GUAYUBIN",
        "HATILLO PALMA (D.M.)",
        "HATO DAMAS",
        "HATO DEL PADRE",
        "HATO DEL YAQUE",
        "HATO MAYOR DEL REY",
        "HATO NUEVO CORTES",
        "HATO VIEJO",
        "HERNANDO ALONZO",
        "HIGUEY",
        "HONDO VALLE",
        "HOSTOS (D.M.)",
        "IMBERT",
        "JAIBON (D.M.)",
        "JAIBÓN O PUEBLO NUEVO (DM)",
        "JAMAO AFUERA",
        "JAMAO AL NORTE",
        "JANICO",
        "JAQUIMEYES (D.M.)",
        "JARABACOA",
        "JAYA",
        "JAYACO",
        "JICOME (D.M.)",
        "JIMA ABAJO",
        "JIMANI",
        "JINOVA",
        "JOBA ARRIBA (D.M.)",
        "JORJILLO",
        "JOSE CONTRERAS (D.M.)",
        "JOSE FRANCISCO PEÑA GOMEZ",
        "JUAN ADRIAN (D.M.)",
        "JUAN DE HERRERA",
        "JUAN LOPEZ D.M.",
        "JUAN SANTIAGO (D.M.)",
        "JUANCHO (D.M.)",
        "JUMA BEJUCAL",
        "JUNCALITO (D.M.)",
        "LA BIJA",
        "LA CALETA",
        "LA CANELA (D.M.)",
        "LA CAYA",
        "LA CIENAGA (D.M.)",
        "LA COLONIA",
        "LA CUABA",
        "LA CUCHILLA",
        "LA CUESTA",
        "LA CUEVA (D.M.)",
        "LA DESCUBIERTA",
        "LA ENTRADA (D.M.)",
        "LA GINA",
        "LA GUAYIGA",
        "LA GUAZARA",
        "LA ISABELA (D.M.)",
        "LA JAGUA",
        "LA JAIBA",
        "LA MATA (D.M.)",
        "LA ORTEGA",
        "LA PEÑA (D.M.)",
        "LA ROMANA",
        "LA SABINA",
        "LA SALVIA - LOS QUEMADOS",
        "LA SIEMBRA",
        "LA VICTORIA",
        "LAGUNA SALADA",
        "LAGUNAS DE NISIBON (D.M.)",
        "LAS BARIAS",
        "LAS BARIAS-LA ESTANCIA",
        "LAS CHARCAS (D.M.)",
        "LAS CHARCAS DE MARIA NOVA",
        "LAS CLAVELLINAS",
        "LAS COLES",
        "LAS GALERAS",
        "LAS GORDAS",
        "LAS GUARANAS",
        "LAS LAGUNAS",
        "LAS LOMAS",
        "LAS MAGUANAS-HATO NUEVO",
        "LAS MATAS DE FARFAN",
        "LAS MATAS DE SANTA CRUZ",
        "LAS PALOMAS",
        "LAS PLACETAS",
        "LAS SALINAS (D.M.)",
        "LAS TARANAS",
        "LAS TERRENAS",
        "LAS YAYAS DE VIAJAMA (D.",
        "LAS ZANJAS",
        "LICEY AL MEDIO",
        "LOMA DE CABRERA",
        "LOS ALCARRIZOS",
        "LOS BOTADOS (D.M.)",
        "LOS CACAOS (D.M.)",
        "LOS FRIOS",
        "LOS HIDALGOS",
        "LOS JOVILLOS",
        "LOS PATOS",
        "LOS RIOS (D.M.)",
        "LOS TOROS",
        "LUPERON",
        "MAIMON",
        "MAIZAL (D.M.)",
        "MAJAGUAL (D.M.)",
        "MAMA TINGO",
        "MANABAO",
        "MANUEL BUENO",
        "MAO",
        "MATA PALACIO (D.M.)",
        "MATANZAS (D.M.)",
        "MATAYAYA (D.M.)",
        "MEDINA",
        "MELLA (D.M.)",
        "MENA",
        "MICHES",
        "MOCA",
        "MONCION",
        "MONSERRATE (MONTSERRAT)",
        "MONSEÑOR NOUEL (BONAO)",
        "MONTE BONITO",
        "MONTE DE LA JAGUA",
        "MONTE PLATA",
        "NAGUA",
        "NAVAS",
        "NEIBA",
        "NIZAO - LAS AUYAMAS",
        "NIZAO",
        "NUEVA YORK",
        "NUEVO SABANA YEGUA (",
        "OTRA BANDA (D.M.)",
        "OVIEDO",
        "PADRE LAS CASAS",
        "PALMAR ARRIBA",
        "PALMAR DE OCOA (D.M.)",
        "PALMAREJO-VILLA LINDA",
        "PALO ALTO",
        "PALO VERDE",
        "PANTOJA",
        "PARADERO",
        "PARAISO",
        "PARTIDO",
        "PAYA (D.M.)",
        "PEDERNALES",
        "PEDRO BRAND",
        "PEDRO CORTO (D.M.)",
        "PEDRO GARCIA (D.M.)",
        "PEDRO SANCHEZ (D.M.)",
        "PEDRO SANTANA",
        "PEPILLO SALCEDO (MANZANILLO)",
        "PERALTA",
        "PESCADERIA",
        "PIEDRA BLANCA",
        "PIMENTEL",
        "PIZARRETE (D.M.)",
        "PLATANAL",
        "POLO (D.M.)",
        "POSTRER RIO",
        "PRESIDENTE DON ANTONIO GUZMAN FERNANDEZ",
        "PROYECTO 2-C",
        "PROYECTO 4",
        "PUEBLO VIEJO (D.M.)",
        "PUERTO VIEJO",
        "PUÑAL",
        "QUISQUEYA",
        "QUITA CORAZA",
        "QUITA SUEÑO",
        "RAMON SANTANA",
        "RANCHO ARRIBA",
        "RANCHO DE LA GUARDIA",
        "RESTAURACION",
        "RINCON (D.M.)",
        "RIO GRANDE",
        "RIO LIMPIO (D.M.)",
        "RIO SAN JUAN",
        "RIO VERDE ARRIBA (D.",
        "SABANA ALTA",
        "SABANA BUEY (D.M.)",
        "SABANA CRUZ",
        "SABANA DE LA MAR",
        "SABANA DEL PUERTO (D.M.)",
        "SABANA GRANDE DE BOYA",
        "SABANA GRANDE DE PALENQUE",
        "SABANA GRANDE",
        "SABANA HIGUERO",
        "SABANA IGLESIA (D.M.)",
        "SABANA LARGA",
        "SABANETA DE YASICA",
        "SABANETA",
        "SALCEDO",
        "SAN ANTONIO DE GUERRA",
        "SAN CRISTOBAL",
        "SAN FELIPE DE PUERTO PLATA",
        "SAN FERNANDO DE MONTE CRISTI",
        "SAN FRANCISCO DE JACAGUA",
        "SAN FRANCISCO DE MACORIS",
        "SAN FRANCISCO-VICENTILLO",
        "SAN GREGORIO DE NIGUA",
        "SAN IGNACIO DE SABANETA",
        "SAN JOSE DE LAS MATAS",
        "SAN JOSE DE LOS LLANOS",
        "SAN JOSE DE MATANZAS (D.M.)",
        "SAN JOSE DE OCOA",
        "SAN JOSE DEL PUERTO",
        "SAN JUAN DE LA MAGUANA",
        "SAN LUIS",
        "SAN PEDRO DE MACORIS",
        "SAN RAFAEL DEL YUMA",
        "SAN VICTOR (D.M.)",
        "SANCHEZ",
        "SANTA BARBARA DE SAMANA",
        "SANTA BARBARA EL 6",
        "SANTA CRUZ DE EL SEIBO",
        "SANTA LUCIA",
        "SANTANA (D.M.)",
        "SANTANA",
        "SANTIAGO DE LA CRUZ",
        "SANTIAGO",
        "SANTO DOMINGO DE GUZMAN",
        "SANTO DOMINGO ESTE",
        "SANTO DOMINGO NORTE",
        "SANTO DOMINGO OESTE",
        "SANTURCE",
        "SOSUA",
        "TABARA ABAJO",
        "TAMAYO",
        "TAMBORIL",
        "TAVERAS",
        "TENARES",
        "TIREO (D.M.)",
        "UBILLA (D.M.)",
        "VALLEJUELO",
        "VENGAN A VER",
        "VERAGUA (D.M.)",
        "VERON PUNTA CANA (D. M.) (INCLUYE BAVARO)",
        "VICENTE NOBLE",
        "VILLA ALTAGRACIA",
        "VILLA BISONO (NAVARRETE)",
        "VILLA CENTRAL",
        "VILLA DE SONADOR (D.M.)",
        "VILLA ELISA (D.M.)",
        "VILLA FUNDACION (D.M.)",
        "VILLA GONZALEZ",
        "VILLA HERMOSA",
        "VILLA ISABELA",
        "VILLA JARAGUA",
        "VILLA LOS ALMACIGOS",
        "VILLA MAGANTE",
        "VILLA MONTELLANO (D.",
        "VILLA RIVAS",
        "VILLA SOMBRERO",
        "VILLA TABARA ARRIBA (D.",
        "VILLA TAPIA",
        "VILLA VAZQUEZ",
        "VILLARPANDO",
        "YAGUATE",
        "YAMASA",
        "YAQUE",
        "YASICA ARRIBA",
        "YERBA BUENA (D.M.)"
    ],
    // 'sectoresRD': [
    //     "1 DE MAYO",
    //     "12 DE HAINA",
    //     "15 DE AGOSTO",
    //     "16 DE AGOSTO",
    //     "19 DE JUNIO O LA RUSIA",
    //     "19 DE MARZO",
    //     "2 DE ENERO ",
    //     "20-30",
    //     "21 DE ENERO",
    //     "24 DE ABRIL",
    //     "26 DE ENERO",
    //     "27 DE FEBRERO ",
    //     "27 PARTE ATRAS LA NORIA ",
    //     "30 DE MAYO ",
    //     "30 DE MAYO O LA POLICIA ",
    //     "30 DE MAYO",
    //     "33 DE SANTANA CERRA ",
    //     "3½ ",
    //     "5 DE ABRIL ",
    //     "50",
    //     "6TO",
    //     "ABADESA",
    //     "ABAJO",
    //     "ABANICO",
    //     "ABRA GRANDE",
    //     "ABRAS LAS YAYAS ",
    //     "ABREU",
    //     "ACAPULCO ",
    //     "ACIBA",
    //     "ACICATE ADENTRO ",
    //     "ACICATE",
    //     "ACITRON",
    //     "ACOSTA ",
    //     "ADUANA ",
    //     "AEROPUERTO INTERNACIONAL",
    //     "AESA ",
    //     "AFORTUNADA ",
    //     "AFRICA ",
    //     "AGAPITO SANCHEZ (LA GALLERA)",
    //     "AGAPITO",
    //     "AGRARIO",
    //     "AGRICOLA ",
    //     "AGRICULTURA O LOS BARRANCONES ",
    //     "AGUA AMARGA",
    //     "AGUA BLANCA",
    //     "AGUA BUENA ",
    //     "AGUA CLARA ",
    //     "AGUA DE JUAN",
    //     "AGUA DE LA PALMA (LA RECTA) ",
    //     "AGUA DE LAS PALMAS",
    //     "AGUA DE LUIS",
    //     "AGUA DE RATON ",
    //     "AGUA DEL HIGO ",
    //     "AGUA FRESCA",
    //     "AGUA FRIA",
    //     "AGUA HEDIONDA ",
    //     "AGUA LARGA ",
    //     "AGUA LAS PALMAS ",
    //     "AGUA LLUVIA",
    //     "AGUA MALA",
    //     "AGUA PRIETA",
    //     "AGUA SABROSA",
    //     "AGUA SANTA ",
    //     "AGUA SANTA DEL YUNA ",
    //     "AGUA SANTA DEL YUNA (ZONA URBANA) ",
    //     "AGUA SARCA ",
    //     "AGUA VIVA",
    //     "AGUACATE ",
    //     "AGUACATE ADENTRO",
    //     "AGUACATE ARRIBA ",
    //     "AGUACATE DE NAVARRETE ",
    //     "AGUACERO ",
    //     "AGUAELICO",
    //     "AGUAS ALTAS",
    //     "AGUAS NEGRAS",
    //     "AGUAS VIVAS",
    //     "AGUAYOS",
    //     "AGUSADERA",
    //     "AGÜITA BLANCA ",
    //     "AGÜITA PRIETA ",
    //     "AHOGA PERRO",
    //     "AHORCA LOS PERROS ",
    //     "ALAMEDA",
    //     "ALBA ROSA",
    //     "ALBANA ",
    //     "ALBANITA O LA BOCA DE ALBANITA",
    //     "ALCARRIZOS VIEJO",
    //     "ALCOA",
    //     "ALEJANDRO BASS",
    //     "ALEJANDRO BUENO ",
    //     "ALEMAN ",
    //     "ALEMANIA ",
    //     "ALETON ",
    //     "ALFIMAR",
    //     "ALGARROBAL ",
    //     "ALGARROBO",
    //     "ALMA ROSA I",
    //     "ALMA ROSA II",
    //     "ALMA ROSA O EL BRONX",
    //     "ALMA ROSA",
    //     "ALMIRANTE II O LOS SOLARES",
    //     "ALMIRANTE",
    //     "ALONCILLO",
    //     "ALTAGRACIA ",
    //     "ALTAGRACIA I",
    //     "ALTAGRACIA II ",
    //     "ALTAGRACIA IL ",
    //     "ALTAMIRA ",
    //     "ALTAMIRA (ZONA URBANA)",
    //     "ALTAMISAR",
    //     "ALTO ALEGRE",
    //     "ALTO BONITO",
    //     "ALTO DE AMACEY",
    //     "ALTO DE BOHIO ",
    //     "ALTO DE BULULO (EL CAIMITO) ",
    //     "ALTO DE CAIMITO ",
    //     "ALTO DE CANA",
    //     "ALTO DE CASIANO ",
    //     "ALTO DE CEDRO ",
    //     "ALTO DE CIRIACO (ALTO DE SIRIACO) ",
    //     "ALTO DE CUBA",
    //     "ALTO DE CUEVAS",
    //     "ALTO DE GURABO",
    //     "ALTO DE JALISCO ",
    //     "ALTO DE LA ESTANCIA ",
    //     "ALTO DE LA FLORES O ALTO DE LA PALOMA ",
    //     "ALTO DE LA JAGUA",
    //     "ALTO DE LA PALOMA O MANHATTAN ",
    //     "ALTO DE LA PEÑA ",
    //     "ALTO DE LA PE�A",
    //     "ALTO DE LA PIEDRA ",
    //     "ALTO DE LA SIERRA (LA SIERRA) ",
    //     "ALTO DE LAS COLINAS ",
    //     "ALTO DE LAS FLORES",
    //     "ALTO DE LOPEZ ",
    //     "ALTO DE LOS CASTILLO",
    //     "ALTO DE LOS GOMEZ ",
    //     "ALTO DE LOS LIMONES ",
    //     "ALTO DE LOS MELONES ",
    //     "ALTO DE LOS POZOS ",
    //     "ALTO DE LOS VASQUEZ ",
    //     "ALTO DE MARCHENA",
    //     "ALTO DE MATANZAS",
    //     "ALTO DE PIEDRA",
    //     "ALTO DE RIO DULCE ",
    //     "ALTO DEL AGUACATE ",
    //     "ALTO DEL CABALLO",
    //     "ALTO DEL CRISTO ",
    //     "ALTO DEL DAJAO",
    //     "ALTO DEL JOBO ",
    //     "ALTO DEL JOBO (ANT. LAS CUCHILLAS)",
    //     "ALTO DEL JOBO DULCE O YABANA",
    //     "ALTO DEL LIMONAL",
    //     "ALTO DEL MACAO",
    //     "ALTO DEL PILON ABAJO",
    //     "ALTO DEL PILON ARRIBA ",
    //     "ALTO DEL PINO ",
    //     "ALTO DEL RAYO ",
    //     "ALTO DEL SAMO ",
    //     "ALTO DEL ZAMO ",
    //     "ALTO GORDO ",
    //     "ALTO GRANDE",
    //     "ALTO MANHATTAN",
    //     "ALTO VELO",
    //     "ALTOS DE ARROYO HONDO ",
    //     "ALTOS DE ARROYO HONDO II",
    //     "ALTOS DE ARROYO HONDO",
    //     "ALTOS DE CANCINO",
    //     "ALTOS DE CHAVON ",
    //     "ALTOS DE CHAVON",
    //     "ALTOS DE GASPAR HERNANDEZ ",
    //     "ALTOS DE GUAZUMA",
    //     "ALTOS DE LA HICOTEA ",
    //     "ALTOS DE LAS FLORES ",
    //     "ALTOS DE LAS FLORES O LAS ARAÑAS",
    //     "ALTOS DE LOS ACOSTA ",
    //     "ALTOS DE LOS CERROS ",
    //     "ALTOS DE LOS FRANCISCO",
    //     "ALTOS DE LOS MATES",
    //     "ALTOS DE LOS MELONES (CERRO DE LOS MELONES O LAS TUNAS) ",
    //     "ALTOS DE LOS NARANJOS ",
    //     "ALTOS DE LOS PEÑA ",
    //     "ALTOS DE LOS ROJAS",
    //     "ALTOS DE LOS UBALDOS",
    //     "ALTOS DE MONTERREY",
    //     "ALTOS DE PEGUERO",
    //     "ALTOS DE PIEDRA ",
    //     "ALTOS DE RAFEY",
    //     "ALTOS DE SABANA ",
    //     "ALTOS DE SERAFINA ",
    //     "ALTOS DE SOL DE LUZ ",
    //     "ALTOS DE VIREYA ",
    //     "ALTOS DEL HATICO",
    //     "ALTOS DEL INVI",
    //     "ALTOS DEL PARQUE",
    //     "ALTOS DEL RANCHO",
    //     "ALTOS DEL YAQUE ",
    //     "ALTOS DEL YAQUE 02",
    //     "AMACEY PICADO ",
    //     "AMACEYAL ",
    //     "AMACEYES ",
    //     "AMACEYES ABAJO",
    //     "AMACEYES ARRIBA ",
    //     "AMANDA I ",
    //     "AMANDA I (CAMINERO) ",
    //     "AMANDA III ",
    //     "AMAPOLA",
    //     "AMBAR",
    //     "AMERICA",
    //     "AMIAMA GOMEZ (ZONA URBANA)",
    //     "AMIAMA GOMEZ",
    //     "AMINA ABAJO",
    //     "AMINA CENTRO",
    //     "AMINA",
    //     "AMINILLA ",
    //     "AMOR A DIOS",
    //     "ANA LUCILA I",
    //     "ANA LUCILA II ",
    //     "ANA PATRIA MARTÍNEZ ",
    //     "ANA RAMIREZ",
    //     "ANA RUIZ ",
    //     "ANA SANTANA",
    //     "ANA TERESA BALAGUER ",
    //     "ANACAHUITA (ANACAGÜITA) ",
    //     "ANACAONA ",
    //     "ANADEL ",
    //     "ANAMA",
    //     "ANAMUYA",
    //     "ANAMUYITA",
    //     "ANAYO",
    //     "ANDRES ",
    //     "ANDRES CENTRO ",
    //     "ANGEL FELIX",
    //     "ANGELINA (ZONA URBANA)",
    //     "ANGILLITA",
    //     "ANGOSTO",
    //     "ANGOSTURA",
    //     "ANICETO MARTINEZ",
    //     "ANTILLANO",
    //     "ANTILLAS ",
    //     "ANTILLAS",
    //     "ANTON SANCHEZ ",
    //     "ANTONIO DUVERGE ",
    //     "ANTONIO GUZMAN FERNANDEZ",
    //     "ANTONIO RONZINO ",
    //     "ANTONSAPE",
    //     "APOLINAR ",
    //     "APOLINAR PERDOMO",
    //     "AQUINO ",
    //     "ARABIA ",
    //     "ARBOLEDA ",
    //     "ARBOLEDA I ",
    //     "ARBOLEDA III",
    //     "ARBOLEDA IV",
    //     "ARBOLINES",
    //     "AREA MONUMENTAL ",
    //     "AREA VERDE ",
    //     "AREBALO (AREVANO) ",
    //     "ARENILLA ",
    //     "ARENOSITO O ARENOSO ARRIBA",
    //     "ARENOSO (ZONA URBANA) ",
    //     "ARENOSO I",
    //     "ARENOSO O ARENOSO ARRIBA",
    //     "ARENOSO",
    //     "ARRAIJAN ",
    //     "ARRENQUILLO",
    //     "ARRIBA ",
    //     "ARROYITO ",
    //     "ARROYITO MALO ",
    //     "ARROYO AL MEDIO ",
    //     "ARROYO AL MEDIO (ZONA URBANA) ",
    //     "ARROYO AL MEDIO ARRIBA",
    //     "ARROYO AMARGO ",
    //     "ARROYO AMARILLO ",
    //     "ARROYO ANCHO ABAJO",
    //     "ARROYO ANCHO ARRIBA ",
    //     "ARROYO ANCHO",
    //     "ARROYO ARRIBA ",
    //     "ARROYO ATRAVESADO AL MEDIO",
    //     "ARROYO AVISPA ",
    //     "ARROYO AZUL",
    //     "ARROYO BARRIL (ZONA URBANA) ",
    //     "ARROYO BARRIL O CENTRO DEL PUEBLO ",
    //     "ARROYO BELLACO",
    //     "ARROYO BERNABE",
    //     "ARROYO BLANCO ",
    //     "ARROYO BLANCO ABAJO ",
    //     "ARROYO BLANCO ARRIBA",
    //     "ARROYO BLANCO DE LOS RINCONES ",
    //     "ARROYO BONITO ",
    //     "ARROYO BULLA",
    //     "ARROYO CANO (ZONA URBANA) ",
    //     "ARROYO CANO",
    //     "ARROYO CANOA",
    //     "ARROYO CARRIZAL ",
    //     "ARROYO CAÑA",
    //     "ARROYO CERCADO",
    //     "ARROYO CHICO ABAJO",
    //     "ARROYO CHICO ARRIBA ",
    //     "ARROYO CHIQUITO ",
    //     "ARROYO CLARO (HOYO DEL TORO)",
    //     "ARROYO CLARO",
    //     "ARROYO COLORADO ",
    //     "ARROYO COPEY",
    //     "ARROYO CORAL FALSO (LOS ARROYOS)",
    //     "ARROYO CORBINATO",
    //     "ARROYO COROZO ",
    //     "ARROYO COROZO (EL COROZO) 05",
    //     "ARROYO COROZO",
    //     "ARROYO DE AGUA",
    //     "ARROYO DE LA JAGUA ARRIBA ",
    //     "ARROYO DE LA SABANA ",
    //     "ARROYO DE LECHE ABAJO ",
    //     "ARROYO DE LECHE ARRIBA",
    //     "ARROYO DE LOS MUERTOS ",
    //     "ARROYO DE PEDRO ",
    //     "ARROYO DEL AGUA ",
    //     "ARROYO DEL CABO ",
    //     "ARROYO DEL CAFE ",
    //     "ARROYO DEL CUANO",
    //     "ARROYO DEL DIABLO ",
    //     "ARROYO DEL GATO ",
    //     "ARROYO DEL MEDIO",
    //     "ARROYO DEL RANCHO ",
    //     "ARROYO DICHOSO",
    //     "ARROYO DULCE (ZONA URBANA)",
    //     "ARROYO DULCE RURAL",
    //     "ARROYO DULCE",
    //     "ARROYO EL CLAVO ",
    //     "ARROYO EL DAJAO ",
    //     "ARROYO EL LORO",
    //     "ARROYO EL PINAL ",
    //     "ARROYO EL PINO",
    //     "ARROYO EL TORO",
    //     "ARROYO FRIO",
    //     "ARROYO GRANDE ",
    //     "ARROYO GRANDE (LA PALOMA) ",
    //     "ARROYO GRANDE",
    //     "ARROYO GUAYABO",
    //     "ARROYO HATILLO",
    //     "ARROYO HIGUERO",
    //     "ARROYO HIGÜERO",
    //     "ARROYO HONDO ABAJO 01 ",
    //     "ARROYO HONDO ABAJO",
    //     "ARROYO HONDO ARRIBA ",
    //     "ARROYO HONDO ARRIBA 01",
    //     "ARROYO HONDO",
    //     "ARROYO HOYO",
    //     "ARROYO INDIO",
    //     "ARROYO JANICO ",
    //     "ARROYO LA CHINGUITA ",
    //     "ARROYO LA PISTA 02",
    //     "ARROYO LA PUERTA",
    //     "ARROYO LA VACA",
    //     "ARROYO LA VIEJA ",
    //     "ARROYO LAJA",
    //     "ARROYO LAS BELLACAS ",
    //     "ARROYO LIMON",
    //     "ARROYO LINDO",
    //     "ARROYO LLANO",
    //     "ARROYO LORO",
    //     "ARROYO LOS DAJAOS ",
    //     "ARROYO LUCAS CAMPO",
    //     "ARROYO MAJAGUA",
    //     "ARROYO MAJAGUAL ",
    //     "ARROYO MALO O ARROYO DEL DAJAO",
    //     "ARROYO MALO",
    //     "ARROYO MAMEY",
    //     "ARROYO MANTECA",
    //     "ARROYO MANZANO",
    //     "ARROYO MINA",
    //     "ARROYO MINGO",
    //     "ARROYO MONTAZO",
    //     "ARROYO NARANJO",
    //     "ARROYO NEGRO",
    //     "ARROYO PALERO ",
    //     "ARROYO PALMA",
    //     "ARROYO PIEDRA ",
    //     "ARROYO PINO",
    //     "ARROYO PIYOYO ",
    //     "ARROYO POLO",
    //     "ARROYO POMO",
    //     "ARROYO POMO-PASO DE LA AUYAMA ",
    //     "ARROYO PRIETO ",
    //     "ARROYO PUERTO ",
    //     "ARROYO RANCHO ",
    //     "ARROYO RICO",
    //     "ARROYO SABANA ",
    //     "ARROYO SALADO ",
    //     "ARROYO SALADO (ZONA URBANA",
    //     "ARROYO SAN FRANCISCO",
    //     "ARROYO SANTIAGO ",
    //     "ARROYO SECO",
    //     "ARROYO SORDO",
    //     "ARROYO SURDIO ",
    //     "ARROYO TABACO ",
    //     "ARROYO TORO ABAJO ",
    //     "ARROYO TORO AL MEDIO",
    //     "ARROYO TORO ARRIBA",
    //     "ARROYO TORO-MASIPEDRO (ZONA URBANA) ",
    //     "ARROYO VERRACO",
    //     "ARROYO VIEJITO",
    //     "ARROYO VIEJO",
    //     "ARROYO VUELTA ",
    //     "ARROYO VUELTA ARRIBA",
    //     "ARROYO YAYA",
    //     "ARROYO ZAYAS",
    //     "ARROYON",
    //     "ARROYÓN",
    //     "ASERRADERO ",
    //     "ASFALTO",
    //     "ASIENTO DE LUISA",
    //     "ASIENTO MIGUEL",
    //     "ASIENTO ZAPATA BOTIN",
    //     "ATABALERO ABAJO ",
    //     "ATAJADIZO",
    //     "ATALA",
    //     "ATALAYA ABAJO ",
    //     "ATALAYA ARRIBA",
    //     "ATICO O EL HATICO ",
    //     "ATLANTIDA",
    //     "ATOLLADOR",
    //     "ATORO",
    //     "ATRAS DE LOS CERROS ",
    //     "AUDON",
    //     "AUGUSTO BATISTA ",
    //     "AUQUEYES ",
    //     "AUTORIDAD PORTUARIA ",
    //     "AVEDAÑO O VENDAÑO ",
    //     "AVENIDA CANADA",
    //     "AVILA",
    //     "AZAFRAN",
    //     "AZLOR",
    //     "AZUA ",
    //     "AZUA DE COMPOSTELA",
    //     "AZUL ",
    //     "AZUL O ANDRES ",
    //     "AÑO NUEVO",
    //     "BABARI ",
    //     "BABIECA",
    //     "BABOCICO ",
    //     "BABOR ABAJO",
    //     "BABOR AFUERA O BABOR ARRIBA ",
    //     "BABOSO ",
    //     "BACUI ABAJO",
    //     "BACUI ADENTRO ",
    //     "BACUI AL MEDIO",
    //     "BACUI ARRIBA",
    //     "BACUMI ",
    //     "BADILLO",
    //     "BAGUAZUMA",
    //     "BAHORUCO (ZONA URBANA)",
    //     "BAIGUAQUE",
    //     "BAIGUATE ",
    //     "BAITOA ",
    //     "BAITOA (ZONA URBANA)",
    //     "BAITOA CLARA",
    //     "BAITOAL",
    //     "BAITOITA ",
    //     "BAJABONICO ARRIBA ",
    //     "BAJABONIQUITO O BAJABONOQUITO ",
    //     "BAJO COROZO",
    //     "BAJO DEL PINO ",
    //     "BAJO HONDO ",
    //     "BAJO MULATO (GAJO MULATO) ",
    //     "BAJOS DE HAINA (ZONA URBANA)",
    //     "BALAGUER ",
    //     "BALCON DE ESTANCITA ",
    //     "BALDEMIRO CABRERAS",
    //     "BALDEMIRO CARRERAS",
    //     "BALLESTERO ",
    //     "BALSA MALA ",
    //     "BANCO DE ARENA",
    //     "BANCOLA",
    //     "BANDERA",
    //     "BANEGAS",
    //     "BANI (ZONA URBANA)",
    //     "BANICA (ZONA URBANA)",
    //     "BANILEJO ",
    //     "BAO",
    //     "BAOBA DEL PIÑAL ",
    //     "BAORUCO ABAJO ",
    //     "BAORUCO ARRIBA",
    //     "BAORUQUITO ",
    //     "BARACOA",
    //     "BARBA RUSIA",
    //     "BARBADILLO ",
    //     "BARCELO",
    //     "BARCEQUILLO INDUSTRIAL",
    //     "BARCEQUILLO",
    //     "BARICO ",
    //     "BARRABAS ",
    //     "BARRAGÜEYBANO ",
    //     "BARRANCA ",
    //     "BARRANCA BLANCA ",
    //     "BARRANCA COLORA ",
    //     "BARRANCA",
    //     "BARRANCOLI ",
    //     "BARRANCON (LA MINA) ",
    //     "BARRANCON",
    //     "BARRAQUITO ",
    //     "BARRAQUITO (ZONA URBANA)",
    //     "BARRAQUITO CERCADO",
    //     "BARRERA O LA DIVISORA ",
    //     "BARRERAS ",
    //     "BARRERAS",
    //     "BARRERITA",
    //     "BARRERO",
    //     "BARRIGON ",
    //     "BARRIO A ",
    //     "BARRIO CHINO",
    //     "BARRIO DAVID",
    //     "BARRIO DUARTE ",
    //     "BARRIO EL CARMEN (TIERRA DE PULGUITA) ",
    //     "BARRIO EL PUENTE",
    //     "BARRIO LA 42",
    //     "BARRIO LA GRAMA ",
    //     "BARRIO LA YAGUA DE LA TROCHA",
    //     "BARRIO LINDO O LA FINQUITA",
    //     "BARRIO LINDO",
    //     "BARRIO NUEVO",
    //     "BARRIO SIN NOMBRE ",
    //     "BARRO ARRIBA",
    //     "BARRO EN MEDIO",
    //     "BARTOLO",
    //     "BARTOLOME",
    //     "BASILIO LINIA ",
    //     "BASIMA ",
    //     "BASTIDAS ",
    //     "BATEICITO",
    //     "BATERO ",
    //     "BATERO ARRIBA ",
    //     "BATEY 10 ",
    //     "BATEY 105",
    //     "BATEY 106",
    //     "BATEY 107",
    //     "BATEY 108",
    //     "BATEY 2",
    //     "BATEY 203",
    //     "BATEY 205",
    //     "BATEY 3 O SAN JOSE",
    //     "BATEY 3",
    //     "BATEY 4",
    //     "BATEY 412",
    //     "BATEY 43 ",
    //     "BATEY 5",
    //     "BATEY 6",
    //     "BATEY 62 ",
    //     "BATEY 7",
    //     "BATEY 8 (RURAL) ",
    //     "BATEY 8 (ZONA URBANA) ",
    //     "BATEY 8",
    //     "BATEY 82 ",
    //     "BATEY 9",
    //     "BATEY AB-4 ",
    //     "BATEY AGUA BLANCA ",
    //     "BATEY ALBIZU",
    //     "BATEY ALCIDES ",
    //     "BATEY ALEJANDRO BASS",
    //     "BATEY ALEMAN",
    //     "BATEY ALGODON ",
    //     "BATEY ALMEYDA ",
    //     "BATEY ALTAGRACIA",
    //     "BATEY AMADOR",
    //     "BATEY AMELIA 09 ",
    //     "BATEY AMELIA",
    //     "BATEY AMERICA-EL QUEMADO",
    //     "BATEY AMINA",
    //     "BATEY AMISTADES ",
    //     "BATEY ANITA",
    //     "BATEY ANON ",
    //     "BATEY ANTONCI ",
    //     "BATEY ARA",
    //     "BATEY ARROYO LUCAS",
    //     "BATEY ASERRADERO",
    //     "BATEY ATILANO I ",
    //     "BATEY ATILANO II",
    //     "BATEY BADIA",
    //     "BATEY BARRANCÓN ",
    //     "BATEY BEJUCAL ",
    //     "BATEY BELLA CRUZ",
    //     "BATEY BELLA VISTA ",
    //     "BATEY BERMEJO ",
    //     "BATEY BISONO",
    //     "BATEY BOBADILLA ",
    //     "BATEY BOBITO",
    //     "BATEY BOTECITO",
    //     "BATEY BRADOR 104",
    //     "BATEY BRUGAL",
    //     "BATEY BRUJUELAS ",
    //     "BATEY CABEZA DE TORO",
    //     "BATEY CACATA",
    //     "BATEY CAIMITO ",
    //     "BATEY CAIMONI ",
    //     "BATEY CALLAO",
    //     "BATEY CAMPIÑA ",
    //     "BATEY CAMPO NUEVO ",
    //     "BATEY CANUTILLO ",
    //     "BATEY CARLOS TORRES ",
    //     "BATEY CARMONA ",
    //     "BATEY CASCAJITO ",
    //     "BATEY CASTILLO",
    //     "BATEY CASUI",
    //     "BATEY CATORCE (BATEY CEILA) ",
    //     "BATEY CAYACOITA ",
    //     "BATEY CHIQUITO",
    //     "BATEY CHIRINO ",
    //     "BATEY CINCO",
    //     "BATEY COCINERO 09 ",
    //     "BATEY COJOBAL ",
    //     "BATEY COLON O PELIGRO ",
    //     "BATEY COMO QUIERA ",
    //     "BATEY CONSTANCIA",
    //     "BATEY CONSUELITO 09 ",
    //     "BATEY CONSUELITO",
    //     "BATEY CONTADOR",
    //     "BATEY COPEY",
    //     "BATEY COPEYITO",
    //     "BATEY CORCICA ",
    //     "BATEY CRUCE DE GUERRERO ",
    //     "BATEY CUCHILLO",
    //     "BATEY CUESTA CARIBE ",
    //     "BATEY CULEBRA ",
    //     "BATEY CUQUITO ",
    //     "BATEY CUYA ",
    //     "BATEY DIEGO",
    //     "BATEY DON JUAN",
    //     "BATEY DON LOPEZ ",
    //     "BATEY DOS",
    //     "BATEY DOÑA ANA",
    //     "BATEY DOÑA LILA 09",
    //     "BATEY DOÑA MARIA",
    //     "BATEY EL 15",
    //     "BATEY EL 16",
    //     "BATEY EL 17",
    //     "BATEY EL 18",
    //     "BATEY EL 20",
    //     "BATEY EL 22",
    //     "BATEY EL 24",
    //     "BATEY EL 28",
    //     "BATEY EL 29",
    //     "BATEY EL 30",
    //     "BATEY EL 4 ",
    //     "BATEY EL 40",
    //     "BATEY EL 5 ",
    //     "BATEY EL 80",
    //     "BATEY EL 81",
    //     "BATEY EL BLANCO ",
    //     "BATEY EL BLOCK",
    //     "BATEY EL CAÑO ",
    //     "BATEY EL GATO ",
    //     "BATEY EL GOLFO",
    //     "BATEY EL GUARAL ",
    //     "BATEY EL HIGO ",
    //     "BATEY EL NARANJO",
    //     "BATEY EL QUEMADO",
    //     "BATEY EL TRIPLE ",
    //     "BATEY ENRIQUILLO",
    //     "BATEY ESCUADRA",
    //     "BATEY ESPAÑOL ",
    //     "BATEY ESPERANZA ",
    //     "BATEY ESPINILLO ",
    //     "BATEY ESTANTE ALTO",
    //     "BATEY ESTRELLA",
    //     "BATEY EUREKA",
    //     "BATEY EUSKARDUNA",
    //     "BATEY EXCAVACION",
    //     "BATEY EXPERIMENTAL 09 ",
    //     "BATEY FELIPA",
    //     "BATEY FRIAS",
    //     "BATEY GALENO O GALIANO",
    //     "BATEY GALLARETA ",
    //     "BATEY GENARO QUINO",
    //     "BATEY GINEBRA ",
    //     "BATEY GRAN CALLE",
    //     "BATEY GUANO",
    //     "BATEY GUANUMA ",
    //     "BATEY GUAYABO ",
    //     "BATEY GUAYACANES",
    //     "BATEY GUAYQUIA",
    //     "BATEY GUAZABAL",
    //     "BATEY GUAZUMA ",
    //     "BATEY GUAZUMITA ",
    //     "BATEY GUERRERO",
    //     "BATEY HAITI",
    //     "BATEY HIGO CLARO",
    //     "BATEY HIGÜERAL",
    //     "BATEY HIGÜERO ",
    //     "BATEY HIGÜEYANA ",
    //     "BATEY HOYO DE PUERCO",
    //     "BATEY HOYO DE PUM ",
    //     "BATEY HOYO DE PUM",
    //     "BATEY HOYON",
    //     "BATEY I",
    //     "BATEY II O HATO VIEJO II",
    //     "BATEY ISABEL",
    //     "BATEY ISABELA ",
    //     "BATEY JABONICO",
    //     "BATEY JAGUAL",
    //     "BATEY JUAN GIL",
    //     "BATEY JUAN SANCHEZ",
    //     "BATEY JUBEY",
    //     "BATEY JULIANA ",
    //     "BATEY KILOMETRO 2 ",
    //     "BATEY LA ALTAGRACIA ",
    //     "BATEY LA CERCA",
    //     "BATEY LA CUBANA (LA DOMINICANA) 09",
    //     "BATEY LA FE",
    //     "BATEY LA FLORIDA",
    //     "BATEY LA GINA ",
    //     "BATEY LA GUAZUMA 09 ",
    //     "BATEY LA GUAZUMA 09",
    //     "BATEY LA INOCENCIA",
    //     "BATEY LA JAGUA",
    //     "BATEY LA LAURA",
    //     "BATEY LA MILAGROSA",
    //     "BATEY LA MULITA ",
    //     "BATEY LA NORIA",
    //     "BATEY LA PANGOLA (PROP. ML. DE LEON)",
    //     "BATEY LA TARANA ",
    //     "BATEY LA VEGA CENTRAL ",
    //     "BATEY LA ÑAPITA ",
    //     "BATEY LAGUNETA",
    //     "BATEY LAJAS",
    //     "BATEY LAS ARENAS",
    //     "BATEY LAS CEJAS ",
    //     "BATEY LAS CHARCAS ",
    //     "BATEY LAS FLORES",
    //     "BATEY LAS GUAMAS",
    //     "BATEY LAS HORMIGAS",
    //     "BATEY LAS MAYITAS ",
    //     "BATEY LAS MERCEDES",
    //     "BATEY LAS PARCELAS",
    //     "BATEY LAS TUMBAS",
    //     "BATEY LAURA",
    //     "BATEY LECHERIA",
    //     "BATEY LECHUGA ",
    //     "BATEY LIBERTAD",
    //     "BATEY LIMA ",
    //     "BATEY LITHGOW ",
    //     "BATEY LOS ARROYOS ",
    //     "BATEY LOS BLOCKS DE HAITI ",
    //     "BATEY LOS CAÑOS ",
    //     "BATEY LOS GUINEOS ",
    //     "BATEY LOS HIGOS ",
    //     "BATEY LOS JOBILLOS",
    //     "BATEY LOS LIRIOS",
    //     "BATEY LOS LLANOS",
    //     "BATEY LOS MARTINEZ",
    //     "BATEY LOS MEDINA",
    //     "BATEY LOS RISELES O RIELES",
    //     "BATEY LOS TOCONES ",
    //     "BATEY LUNA ",
    //     "BATEY MADRE",
    //     "BATEY MAGDALENA ",
    //     "BATEY MAGUACA ",
    //     "BATEY MAIMON",
    //     "BATEY MARAGUA ",
    //     "BATEY MARCHENA",
    //     "BATEY MARGARITA 09",
    //     "BATEY MARIA CONSUELO",
    //     "BATEY MEJIA",
    //     "BATEY MENA ",
    //     "BATEY MENA O BLOCK DE MENA",
    //     "BATEY MIRADA",
    //     "BATEY MIRADOR ",
    //     "BATEY MONSERRAT ",
    //     "BATEY MONTE ADENTRO ",
    //     "BATEY MONTE CRISTI",
    //     "BATEY MONTECARLO",
    //     "BATEY MORUNO DE QUISQUEYA ",
    //     "BATEY MOSQUITO 204",
    //     "BATEY MUCARABON ",
    //     "BATEY NARANJO ",
    //     "BATEY NEGRO",
    //     "BATEY NIGUA",
    //     "BATEY NUEVO",
    //     "BATEY OLIVARES",
    //     "BATEY PAJA ",
    //     "BATEY PALAMARA",
    //     "BATEY PALO BLANCO ",
    //     "BATEY PALO BONITO ",
    //     "BATEY PALOMA",
    //     "BATEY PAPAGAYO",
    //     "BATEY PARAISO DOS ",
    //     "BATEY PAYABO",
    //     "BATEY PELIGRO ",
    //     "BATEY PESTAÑA ",
    //     "BATEY PIEDRA",
    //     "BATEY PIRACO",
    //     "BATEY PIÑONES ",
    //     "BATEY PLUMITA ",
    //     "BATEY POLONIO ",
    //     "BATEY PULGUERO",
    //     "BATEY RAMON GORDO ",
    //     "BATEY REALIDAD",
    //     "BATEY REGAJO",
    //     "BATEY RENGUELITO",
    //     "BATEY RODEO",
    //     "BATEY ROMANITA",
    //     "BATEY SABANA DE CHAVON",
    //     "BATEY SABANA LARGA DE GONZALO ",
    //     "BATEY SABANA LARGA",
    //     "BATEY SAN FELIPE",
    //     "BATEY SAN FRANCISCO ",
    //     "BATEY SAN GERMAN",
    //     "BATEY SAN ISIDRO",
    //     "BATEY SAN JOSE",
    //     "BATEY SAN LUIS",
    //     "BATEY SAN RAFAEL",
    //     "BATEY SANTA ROSA",
    //     "BATEY SANTANA ",
    //     "BATEY SANTO ANGEL 09",
    //     "BATEY SANTONI ",
    //     "BATEY SECO ",
    //     "BATEY SIETE PUERTAS ",
    //     "BATEY SOLANO",
    //     "BATEY TABACONES ",
    //     "BATEY TABILA",
    //     "BATEY TAINO (HIGUAMO I) ",
    //     "BATEY TENTACION 27",
    //     "BATEY TRIPLE OZAMA",
    //     "BATEY TRIPLE SAN PEDRO",
    //     "BATEY TUMBA",
    //     "BATEY ULLOA",
    //     "BATEY VARA DE CAPA",
    //     "BATEY VASCA",
    //     "BATEY VELASQUEZ O SAN RAFAEL",
    //     "BATEY VERDE",
    //     "BATEY VICTORIA",
    //     "BATEY VIEJO",
    //     "BATEY WALTERIO",
    //     "BATEY YABACAO ",
    //     "BATEY YAGUA",
    //     "BATEY ZAPOTE",
    //     "BATEY",
    //     "BATISTA O CENTRO DEL PUEBLO ",
    //     "BATISTA",
    //     "BATON CALIENTE",
    //     "BATUTO ",
    //     "BAUL ",
    //     "BAVARO ",
    //     "BAYAGUANA (ZONA URBANA) ",
    //     "BAYAGUANA (ZONA URBANA)",
    //     "BAYAHIBE ",
    //     "BAYAHIBE (ZONA URBANA)",
    //     "BAYAHONDA",
    //     "BAYAHONDO",
    //     "BAYAMON",
    //     "BAYARDO",
    //     "BAYONA ",
    //     "BAÑADERO ",
    //     "BAÑADERO PRIETO ",
    //     "BAÑADEROS",
    //     "BEJUCAL",
    //     "BEJUCALITO ",
    //     "BEJUCO ALAMBRE",
    //     "BEJUCO APLASTADO",
    //     "BEJUCO BLANCO ",
    //     "BEJUCO COLORADO ",
    //     "BEJUCO COLORADO",
    //     "BEJUQUERO",
    //     "BELLA COLINA",
    //     "BELLA VISTA (QUEMA CRETA) ",
    //     "BELLA VISTA O LOMA CLARA",
    //     "BELLA VISTA",
    //     "BELLACO",
    //     "BELLER ",
    //     "BELLEZA DE LOS ALTOS O RESIDENCIAL DON MIGUEL 10",
    //     "BELLO AMANECER",
    //     "BELLO COSTERO ",
    //     "BELLOSO (ZONA URBANA) ",
    //     "BELLOSO",
    //     "BENERITO ",
    //     "BENITO ",
    //     "BENITO MONCION",
    //     "BERBESI",
    //     "BERGANTIN",
    //     "BERMEJO",
    //     "BERNABE",
    //     "BERNARDINO ",
    //     "BERRINCHE",
    //     "BETA ",
    //     "BETANIA",
    //     "BETEL (GRAN DIABLO) ",
    //     "BIBIANA",
    //     "BIENVENIDO ",
    //     "BIJAO AFUERA",
    //     "BIJAO",
    //     "BILLIGUIN",
    //     "BISAN",
    //     "BISONO (ZONA URBANA)",
    //     "BLANCO ",
    //     "BLANCO (EL PINITO)",
    //     "BLANCO (ZONA URBANA)",
    //     "BLANCO ABAJO",
    //     "BLANCO AL MEDIO ",
    //     "BLANCO ARRIBA ",
    //     "BLANCO CAOBAL ",
    //     "BLANCO MAJAGUA",
    //     "BLANCO MATEO",
    //     "BLANCO O BELARMINIO RAMIREZ ",
    //     "BLANCO O JOSE FRANCISCO PEÑA GOMEZ",
    //     "BLANDINO ",
    //     "BLANQUITO",
    //     "BLANQUIZAL ",
    //     "BLANQUIZALES",
    //     "BLAS ",
    //     "BLAS MARTINEZ ",
    //     "BOBA ",
    //     "BOBA ARRIBA",
    //     "BOBITA ABAJO",
    //     "BOBITA AL CENTRO",
    //     "BOBO O MADRE VIEJA ABAJO",
    //     "BOCA CACHON",
    //     "BOCA CANASTA",
    //     "BOCA CHICA ",
    //     "BOCA CHICA (ZONA URBANA)",
    //     "BOCA CHICA CENTRO ",
    //     "BOCA DE BAO",
    //     "BOCA DE BLANCO",
    //     "BOCA DE BURRO ",
    //     "BOCA DE CABIA ",
    //     "BOCA DE CACHON (ZONA URBANA)",
    //     "BOCA DE CACHON",
    //     "BOCA DE CAMU",
    //     "BOCA DE CAONAO",
    //     "BOCA DE CAZUELA ",
    //     "BOCA DE CEVICOS ",
    //     "BOCA DE CHAVON",
    //     "BOCA DE CORRAL",
    //     "BOCA DE CUMAYASA 09 ",
    //     "BOCA DE GAMBOA",
    //     "BOCA DE GUANCHE ",
    //     "BOCA DE GUAZUMA ",
    //     "BOCA DE GÜERA ",
    //     "BOCA DE HENEQUEN",
    //     "BOCA DE HIGUA ",
    //     "BOCA DE JAMAO ",
    //     "BOCA DE JANICO",
    //     "BOCA DE JIBES ",
    //     "BOCA DE JOBA",
    //     "BOCA DE JUMA",
    //     "BOCA DE LA LAJA ",
    //     "BOCA DE LA MULA ",
    //     "BOCA DE LA MULA",
    //     "BOCA DE LAS LAJAS ",
    //     "BOCA DE LICEY ",
    //     "BOCA DE LOPEZ ",
    //     "BOCA DE LOS ARROYOS ",
    //     "BOCA DE LOS DOS RIOS",
    //     "BOCA DE LOS RIOS",
    //     "BOCA DE MAHOMA",
    //     "BOCA DE MAIZAL",
    //     "BOCA DE MAMON ",
    //     "BOCA DE MANA",
    //     "BOCA DE MAO",
    //     "BOCA DE MAYIGA",
    //     "BOCA DE MENEGUEN",
    //     "BOCA DE MONTAZO ",
    //     "BOCA DE NIGUA ",
    //     "BOCA DE OBISPO",
    //     "BOCA DE PARTIDO ",
    //     "BOCA DE PATO",
    //     "BOCA DE PAYABO",
    //     "BOCA DE RIO BLANCO",
    //     "BOCA DE RIO GRANDE",
    //     "BOCA DE TIREO ",
    //     "BOCA DE VEREDA",
    //     "BOCA DE YASICA",
    //     "BOCA DE YUBOA ",
    //     "BOCA DE YUCA",
    //     "BOCA DE YUMA (RURAL)",
    //     "BOCA DE YUMA (ZONA URBANA)",
    //     "BOCA DE YUMA",
    //     "BOCA DEL ARROYO ",
    //     "BOCA DEL BAO",
    //     "BOCA DEL BOTADO ",
    //     "BOCA DEL CAÑO ",
    //     "BOCA DEL HUMO ",
    //     "BOCA DEL PALMAR ",
    //     "BOCA DEL SOCO ",
    //     "BOCA FERREA ABAJO (AGUACATE)",
    //     "BOCA FERREA ARRIBA (ALGARROBO)",
    //     "BOCA NARANJO",
    //     "BOCA NARANJOS ",
    //     "BOCA NUEVA ",
    //     "BOCA O PLAYA DE CANGREJO",
    //     "BOCA TANJON",
    //     "BOCA YAITA ",
    //     "BOCAMA ",
    //     "BOCHINCHE",
    //     "BOHECHIO (ZONA URBANA)",
    //     "BOHIO VIEJO",
    //     "BOJON",
    //     "BOLO O URBANIZACION SANCHEZ ",
    //     "BOLSILLO ",
    //     "BOMA ",
    //     "BOMBILLO ",
    //     "BOMBITA",
    //     "BONAGUA ARRIBA",
    //     "BONAGUA LOS SIRICES ",
    //     "BONAGUA",
    //     "BONAITO",
    //     "BONAO (ZONA URBANA) ",
    //     "BONETE ",
    //     "BONILLA",
    //     "BONITO ",
    //     "BONITO VALLE",
    //     "BOQUERON ",
    //     "BOQUERÓN ",
    //     "BORINQUEN",
    //     "BOROJOL",
    //     "BORRACHON",
    //     "BORT ",
    //     "BORUCO ",
    //     "BORUGA ",
    //     "BOTIJA DE CABIRMOTA ",
    //     "BOTIJA DE JIMAYACO",
    //     "BOTIN",
    //     "BOTONCILLO ",
    //     "BOTONCILLOS",
    //     "BOULEVARD DEL FARO",
    //     "BOYA ",
    //     "BRACITOS ",
    //     "BRAZO CHIQUITO",
    //     "BRAZO GRANDE",
    //     "BRETON ",
    //     "BRETONCITO ",
    //     "BRISA DE LOS PALMARES ",
    //     "BRISA DEL MAR ",
    //     "BRISA DEL NORTE O PONCE ",
    //     "BRISA LINDA",
    //     "BRISA ORIENTAL",
    //     "BRISAS DE GUAZUMA ",
    //     "BRISAS DE LA CHARLES",
    //     "BRISAS DE MENDOZA ",
    //     "BRISAS DE PEDRO BRAND ",
    //     "BRISAS DEL CANAL",
    //     "BRISAS DEL DUEY ",
    //     "BRISAS DEL ESTE ",
    //     "BRISAS DEL LAGO ",
    //     "BRISAS DEL LLANO",
    //     "BRISAS DEL MAR O LA LOMA O INVI-CEA PARTE ATRAS ",
    //     "BRISAS DEL NORTE",
    //     "BRISAS DEL OZAMA",
    //     "BRISAS DEL RIO",
    //     "BRISAS DEL SUR",
    //     "BRISAS DEL YAQUE",
    //     "BRISAS DEL YUNA ",
    //     "BRISAS SUAVES ",
    //     "BROKLIN",
    //     "BROOKLYN ",
    //     "BRUGAL ",
    //     "BRUJUELAS (ASIENTO ZAPATA BOTIN)",
    //     "BRUNO",
    //     "BUEN AMANECER ",
    //     "BUEN GUSTO ",
    //     "BUEN HOMBRE",
    //     "BUEN PAN ",
    //     "BUEN PASTOR",
    //     "BUENA AGUA ",
    //     "BUENA FORTUNA ",
    //     "BUENA VISTA (ZONA URBANA) ",
    //     "BUENA VISTA ARRIBA",
    //     "BUENA VISTA O EL BOLSILLO ",
    //     "BUENA VISTA",
    //     "BUENAS NOCHES ",
    //     "BUENAS NUEVAS ",
    //     "BUENAVENTURA",
    //     "BUENOS AIRES DE HERRERA ",
    //     "BUENOS AIRES DEL YESO ",
    //     "BUENOS AIRES MIRADOR",
    //     "BUENOS AIRES",
    //     "BUENOS DÍAS",
    //     "BUEYERO",
    //     "BULLA",
    //     "BURENDE",
    //     "BURENES",
    //     "BUSU ",
    //     "BUZON",
    //     "CABA ",
    //     "CABALLERO",
    //     "CABALLO VIEJO ",
    //     "CABALLONA",
    //     "CABARETE ",
    //     "CABARETE (ZONA URBANA)",
    //     "CABEZA DE AGUA",
    //     "CABEZA DE BESTIA",
    //     "CABEZA DE RIO ",
    //     "CABEZA DE RIO GRANDE",
    //     "CABEZA DE TORO (ZONA URBANA)",
    //     "CABEZA DE TORO",
    //     "CABEZA DE VACA",
    //     "CABEZA DEL MUERTO ",
    //     "CABEZA DEL RODEO",
    //     "CABEZADA ",
    //     "CABEZADA DEL CAIMITO",
    //     "CABEZÚ ",
    //     "CABIA",
    //     "CABIRMA CLARA ",
    //     "CABIRMA DEL ESTE",
    //     "CABIRMA",
    //     "CABIRMAL ",
    //     "CABIRMOTA",
    //     "CABISMAL ",
    //     "CABO DUARTE",
    //     "CABO ENGAÑO",
    //     "CABO MUELLE (LOS ALTAGRACIANOS) ",
    //     "CABO MUELLE",
    //     "CABO ROJO",
    //     "CABO SAN RAFAEL ",
    //     "CABOLANA ",
    //     "CABON",
    //     "CABRAL (ZONA URBANA)",
    //     "CABREJA",
    //     "CABRERA (ZONA URBANA) ",
    //     "CABRIA ABAJO",
    //     "CABUYA ",
    //     "CACAO BEACH",
    //     "CACAO",
    //     "CACAVELI I ",
    //     "CACAVELI II",
    //     "CACHAZA",
    //     "CACHEO ",
    //     "CACHIMAN ",
    //     "CACHIMBA ",
    //     "CACHIMBITO ",
    //     "CACHON ",
    //     "CACHON GRANDE ",
    //     "CACHON SECO",
    //     "CACHON VIEJO",
    //     "CACIQUE ARRIBA",
    //     "CACIQUE SOLEDAD ",
    //     "CACIQUE",
    //     "CACIQUILLO ",
    //     "CADILLAR ",
    //     "CAFE I, II, III Y IV",
    //     "CAFE LAS MUJERES",
    //     "CAFE V Y VI",
    //     "CAFEMBA",
    //     "CAGÜEY ",
    //     "CAGÜEYES ",
    //     "CAIMANI",
    //     "CAIMITAL ABAJO",
    //     "CAIMITO",
    //     "CAIMONAL ",
    //     "CAIMONI",
    //     "CAIMONÍ",
    //     "CAJERO ",
    //     "CAJUIL BLANCO ",
    //     "CAJUIL PRIETO ",
    //     "CAJUILITO NORTE ",
    //     "CAJUILITO SUR ",
    //     "CAJUILITO",
    //     "CAL DE PIEDRA ",
    //     "CALABACITO ",
    //     "CALABACITOS",
    //     "CALABAZAS",
    //     "CALABOZO ",
    //     "CALCUTA",
    //     "CALDERON ",
    //     "CALDERON ARRIBA ",
    //     "CALERO ",
    //     "CALETA ",
    //     "CALETA (ZONA URBANA)",
    //     "CALETON O URBANIZACION BUENA VISTA SUR",
    //     "CALETON",
    //     "CALICHAL ",
    //     "CALIENTE ",
    //     "CALIMETAL",
    //     "CALIMETE ",
    //     "CALLE 8",
    //     "CALLE ANCHA",
    //     "CALLE BONITA",
    //     "CALLE DEL RIO ",
    //     "CALLE EN MEDIO",
    //     "CALLE LA PIEDRA ",
    //     "CALLEJON A ",
    //     "CALLEJON CHINO",
    //     "CALLEJON DE LA ALEGRIA",
    //     "CALLEJON DE LOS MEJIA ",
    //     "CALLEJON DE LOS MOTA",
    //     "CALLEJON DE LOS SANCHEZ ",
    //     "CALLEJON DE MERAN ",
    //     "CALLEJON DE TILO",
    //     "CALLEJON JULIO BLANCO ",
    //     "CALLEJON LOS LUNA ",
    //     "CALLEJON LOS TORRES ",
    //     "CALLEJON POLITO 01",
    //     "CALLEJÓN SUR",
    //     "CALOLIN",
    //     "CAMAGÜEY ",
    //     "CAMARON DE LOS GUINEOS",
    //     "CAMARON",
    //     "CAMARONES ABAJO ",
    //     "CAMARONES ARRIBA",
    //     "CAMBALACHE ",
    //     "CAMBELEN ",
    //     "CAMBIASO ",
    //     "CAMBITA EL PUEBLECITO ",
    //     "CAMBITA GARABITOS (ZONA URBANA) ",
    //     "CAMBITA STERLING",
    //     "CAMBITA URIBE ",
    //     "CAMBOYA",
    //     "CAMBUTERA",
    //     "CAMILO RODRIGUEZ",
    //     "CAMINERO ",
    //     "CAMINO DE BARRAQUITO",
    //     "CAMINO REAL (ALTO DE CASIANO) ",
    //     "CAMINO REAL",
    //     "CAMPAMENTO CIMARRON ",
    //     "CAMPAMENTO MILITAR 10 ",
    //     "CAMPECHE ",
    //     "CAMPECHE ABAJO",
    //     "CAMPECHE ARRIBA ",
    //     "CAMPECHITO II ",
    //     "CAMPIÑA",
    //     "CAMPO ALEGRE",
    //     "CAMPO BELLO",
    //     "CAMPO DE AVIACION ",
    //     "CAMPO DE AVIACION 02",
    //     "CAMPO DE AVIACION NUEVO ",
    //     "CAMPO DE AVIACION VIEJO ",
    //     "CAMPO DE CAÑA DEL CEA ",
    //     "CAMPO DE TIRO ",
    //     "CAMPO DE TIRO-LA GALLERA",
    //     "CAMPO LINDO",
    //     "CAMPO NUEVO",
    //     "CAMPO VERDE",
    //     "CAMPOCHO ",
    //     "CAMU ",
    //     "CAMU ARRIBA",
    //     "CAMU-PROYECTO CANAAN",
    //     "CAMUNGUI ",
    //     "CANA ABAJO O SAN PEDRO",
    //     "CANA AL MEDIO ",
    //     "CANA ARRIBA",
    //     "CANA CHAPETON (ZONA URBANA) ",
    //     "CANAAN ",
    //     "CANAAN I ",
    //     "CANAAN II",
    //     "CANABACOA (ZONA URBANA) ",
    //     "CANABACOA ABAJO ",
    //     "CANABACOA",
    //     "CANAL CAÑEO",
    //     "CANARIOS ",
    //     "CANAS ABAJO",
    //     "CANAS AL MEDIO",
    //     "CANAS ARRIBA",
    //     "CANASTA",
    //     "CANASTICA O PARAISO ",
    //     "CANCA ABAJO",
    //     "CANCA ARRIBA LA NUEVA ",
    //     "CANCA ARRIBA",
    //     "CANCA LA PIEDRA (ZONA URBANA) ",
    //     "CANCA LA REYNA (ZONA URBANA)",
    //     "CANCA LA REYNA",
    //     "CANCA LAS AROMAS",
    //     "CANCA REPARACION U ONESIMO POLANCO",
    //     "CANCINO ADENTRO ",
    //     "CANCINO ADENTRO 10",
    //     "CANCINO AFUERA",
    //     "CANCINO I",
    //     "CANCINO II ",
    //     "CANCINO",
    //     "CANDELARIA ",
    //     "CANDELON ",
    //     "CANDELONES ",
    //     "CANDOY ",
    //     "CANECO ",
    //     "CANELA ",
    //     "CANELA ABAJO",
    //     "CANELA ARRIBA O CENTRO DEL PUEBLO ",
    //     "CANELILLA",
    //     "CANEPA VERDE",
    //     "CANETE ",
    //     "CANETE ARRIBA ",
    //     "CANFOR ",
    //     "CANGREJO ",
    //     "CANGREJOS",
    //     "CANOA (ZONA URBANA) ",
    //     "CANOA",
    //     "CANSA MANCEBO ",
    //     "CANTA LA RANA ",
    //     "CANTA LA RANA O BARRIOLANDIA",
    //     "CANTA LA RANA O SANTO TOMAS DE AQUINO ",
    //     "CANTA LOS MACOS ",
    //     "CANTA MACO ",
    //     "CANTA RANA ",
    //     "CANTA RANA 09 ",
    //     "CANTABRIA ABAJO ",
    //     "CANTABRIA ARRIBA",
    //     "CANTAN LOS MACOS",
    //     "CANTURRIA ABAJO ",
    //     "CAOBA",
    //     "CAOBAL ",
    //     "CAOBANICO",
    //     "CAOBANITAS ",
    //     "CAOBETE ARRIBA",
    //     "CAOBETE",
    //     "CAONABO (BATEY SIRIA) ",
    //     "CAONABO II ",
    //     "CAONAO ",
    //     "CAPA ",
    //     "CAPACHO",
    //     "CAPACITO ",
    //     "CAPILLA",
    //     "CAPITA ",
    //     "CAPITÁN",
    //     "CAPOTE ",
    //     "CAPOTE ARRIBA ",
    //     "CAPOTILLO (ZONA URBANA) ",
    //     "CAPOTILLO",
    //     "CAPULIN",
    //     "CARA LINDA ",
    //     "CARABALLO",
    //     "CARABELA ARRIBA ",
    //     "CARACOL",
    //     "CARACOLES",
    //     "CARACOLITO ",
    //     "CARAMANA ",
    //     "CARATA ",
    //     "CARBONERA",
    //     "CARDO PRIETO",
    //     "CARDON ",
    //     "CARENERO ",
    //     "CARIBE ",
    //     "CARLOS ALVAREZ",
    //     "CARLOS DIAZ",
    //     "CARLOS EL PINO",
    //     "CARLOS PINTO",
    //     "CARMEN MARIA",
    //     "CARMONA",
    //     "CARNERO",
    //     "CAROLINA ",
    //     "CAROLINA NORTE",
    //     "CARPINTERO ",
    //     "CARPINTEROS",
    //     "CARRASCO ",
    //     "CARRERA BONITA",
    //     "CARRERA CONUCO",
    //     "CARRERA DE BURRO",
    //     "CARRERA DE HIGÜERO",
    //     "CARRERA DE LIMON",
    //     "CARRERA DE MARCOS ",
    //     "CARRERA DE NARANJO",
    //     "CARRERA DE PALMA",
    //     "CARRERA DE PALMAS ",
    //     "CARRERA DE PUERTA ",
    //     "CARRERA DE SIERRA ",
    //     "CARRERA DE YEGUAS ",
    //     "CARRERA DEL PINO",
    //     "CARRERA VERDE ",
    //     "CARRETA PODRIDA ",
    //     "CARRETALINA",
    //     "CARRETERA DE NARANJO",
    //     "CARRETON ",
    //     "CARRIZAL ",
    //     "CARRUCHO ",
    //     "CARTUJO",
    //     "CARVAJAL ",
    //     "CASA DE ALTO",
    //     "CASA VIEJA ",
    //     "CASABE ",
    //     "CASABITO ",
    //     "CASANDRA ",
    //     "CASAS DE CANAAN ",
    //     "CASCAJAL ",
    //     "CASCAJAL",
    //     "CASCAJAR ",
    //     "CASCAJAR (CASCAJAL) ",
    //     "CASCAJITO",
    //     "CASCARA JIBARA 09 ",
    //     "CASCARA JIBARA",
    //     "CASERÍO TÍA SOSA",
    //     "CASILDA",
    //     "CASILLA",
    //     "CASIMIRO ",
    //     "CASITAS DE MADERA ",
    //     "CASTAÑO",
    //     "CASTAÑUELAS (ZONA URBANA) ",
    //     "CASTAÑUELAS",
    //     "CASTELLALITO",
    //     "CASTELLANOS",
    //     "CASTELLAR",
    //     "CASTILLO ",
    //     "CASTILLO (ZONA URBANA)",
    //     "CASTILLO ABAJO",
    //     "CASTILLO ARRIBA ",
    //     "CASUI",
    //     "CATALINA ",
    //     "CATALINA (ZONA URBANA)",
    //     "CATALINA ABAJO",
    //     "CATALINA ARRIBA ",
    //     "CATAMBU",
    //     "CATANAMATIAS",
    //     "CATANGA",
    //     "CATAREY",
    //     "CATEY ABAJO",
    //     "CATEY ADENTRO ",
    //     "CATEY ARRIBA",
    //     "CATEY",
    //     "CATIVO ",
    //     "CATUANO",
    //     "CAYA CLARA ",
    //     "CAYACOA DEL GUANO ",
    //     "CAYACOA O NUEVO CAYACOA ",
    //     "CAYACOA",
    //     "CAYAO ABAJO (CALLAO ABAJO)",
    //     "CAYAO ARRIBA (CALLAO ARRIBA)",
    //     "CAYAS QUEMADAS",
    //     "CAYETANO GERMOSEN O GUANABANO (ZONA URBANA) ",
    //     "CAYITO ",
    //     "CAYO LEVANTADO",
    //     "CAYOTA ",
    //     "CAYUCAL (EL TUNAL)",
    //     "CAYUCAL ABAJO ",
    //     "CAYUCAL",
    //     "CAYUCO ",
    //     "CAZABITO ",
    //     "CAZUELA",
    //     "CAZUELITA",
    //     "CAZUEZA",
    //     "CAÑA AMARGA",
    //     "CAÑA BRAVA ",
    //     "CAÑA FELES ",
    //     "CAÑA GRANDE",
    //     "CAÑA HONDA ",
    //     "CAÑA LLANA ",
    //     "CAÑA RAFE",
    //     "CAÑA SEGURA",
    //     "CAÑABON (KILOMETRO 103) ",
    //     "CAÑABON",
    //     "CAÑADA ",
    //     "CAÑADA ABAJO",
    //     "CAÑADA AMARGA ",
    //     "CAÑADA ANDRES ",
    //     "CAÑADA ARENOSA",
    //     "CAÑADA ARRIBA ",
    //     "CAÑADA BARROSA",
    //     "CAÑADA BEJUCO ",
    //     "CAÑADA BLANCA ",
    //     "CAÑADA BONITA ",
    //     "CAÑADA C.",
    //     "CAÑADA CASAO",
    //     "CAÑADA CIMARRONA",
    //     "CAÑADA CLARA (EL PUENTE)",
    //     "CAÑADA CLARA",
    //     "CAÑADA DE AGUA",
    //     "CAÑADA DE ANTONIO ",
    //     "CAÑADA DE CACAO ",
    //     "CAÑADA DE CILANTRO",
    //     "CAÑADA DE JENGIBRE",
    //     "CAÑADA DE LA JINA ",
    //     "CAÑADA DE LA PALMA",
    //     "CAÑADA DE LA TABLA",
    //     "CAÑADA DE LA VACA ",
    //     "CAÑADA DE LOS PUERCOS ",
    //     "CAÑADA DE LOS VALLEJO (RICHI) ",
    //     "CAÑADA DE LUIS",
    //     "CAÑADA DE MANACLA ",
    //     "CAÑADA DE MANACLAS",
    //     "CAÑADA DE MIGUEL",
    //     "CAÑADA DE PALMA ",
    //     "CAÑADA DE PAPOY ",
    //     "CAÑADA DE PIEDRA",
    //     "CAÑADA DEL AGUA ",
    //     "CAÑADA DEL BARRERO",
    //     "CAÑADA DEL CAFE ",
    //     "CAÑADA DEL CAIMITO",
    //     "CAÑADA DEL CONCON O ALTOS DEL CACHEO",
    //     "CAÑADA DEL HORNO",
    //     "CAÑADA DEL NEGRO 09 ",
    //     "CAÑADA DEL RANCHO ",
    //     "CAÑADA EL VERRACO ",
    //     "CAÑADA FRANCISCA",
    //     "CAÑADA GRANDE ",
    //     "CAÑADA HIGÜERO",
    //     "CAÑADA HONDA",
    //     "CAÑADA LINDA",
    //     "CAÑADA LLANA",
    //     "CAÑADA MAJAGUA",
    //     "CAÑADA MALA",
    //     "CAÑADA NEGRA",
    //     "CAÑADA NUEVA",
    //     "CAÑADA O LAGUNA DE CASTILLO ",
    //     "CAÑADA PRIETA ",
    //     "CAÑADA SECA",
    //     "CAÑADA SUCIA",
    //     "CAÑADA TE HUNDES",
    //     "CAÑADA VERDE",
    //     "CAÑADA VIEJA",
    //     "CAÑADA VILLA PROGRESO ",
    //     "CAÑAFISTOL ",
    //     "CAÑAFISTOLA",
    //     "CAÑAVERAL",
    //     "CAÑEO",
    //     "CAÑETE ",
    //     "CAÑETIN",
    //     "CAÑITA ",
    //     "CAÑO ABAJO ",
    //     "CAÑO ANDRES",
    //     "CAÑO AZUL DE COLORADO ",
    //     "CAÑO AZUL DE SALOMON",
    //     "CAÑO BEJUCO",
    //     "CAÑO BLANCO",
    //     "CAÑO CLARO ",
    //     "CAÑO DE LA VACA ",
    //     "CAÑO DE LOS NARANJOS",
    //     "CAÑO DE LOS NEGROS",
    //     "CAÑO DE MADRID (MADERA) ",
    //     "CAÑO DULCE ",
    //     "CAÑO EL NARANJO ",
    //     "CAÑO GRANDE",
    //     "CAÑO HONDO ",
    //     "CAÑO MIGUEL",
    //     "CAÑO PIEDRA I ",
    //     "CAÑO PRIETO O LA JARDITA",
    //     "CAÑO SALADO",
    //     "CAÑO SECO",
    //     "CAÑO TELOSO ABAJO ",
    //     "CAÑO TELOSO ARRIBA",
    //     "CAÑONGO (ZONA URBANA) ",
    //     "CAÑONGO",
    //     "CAÑUELO (LAS ACEITUNAS) ",
    //     "CA�ADA CASAO",
    //     "CA�ADA DE MANACLAS",
    //     "CA�ADA DEL AGUA",
    //     "CEAGANA",
    //     "CEBU ",
    //     "CECADAL",
    //     "CECARA ",
    //     "CEDRO SABINA",
    //     "CEIBA BONITA",
    //     "CEIBA DE LA POCILGA ",
    //     "CEIBA DE LOS PAJAROS",
    //     "CEIBA DEL AGUA (CAÑADA HONDA) ",
    //     "CEIBA GORDA",
    //     "CEIBA SECA ",
    //     "CEIBA TABLONUA",
    //     "CEIBITA (LA CUEVITA)",
    //     "CEIBITA O CUEVITA ",
    //     "CEIBITA",
    //     "CEJA DE HIGÜERO ",
    //     "CEJA DE LA GUAMITA",
    //     "CEJA DE LOS CASTAÑOS",
    //     "CEJA DEL JOBO ",
    //     "CEJA LARGA ",
    //     "CELESTINA",
    //     "CEMENTERIO ",
    //     "CEMENTERIO METROPOLIS DE SAN PEDRO",
    //     "CEMENTERIO MUNICIPAL DE MOCA",
    //     "CEMENTERIO TAMARINDO",
    //     "CENACI ",
    //     "CENCERES ",
    //     "CENOVI ",
    //     "CENOVI (ZONA URBANA)",
    //     "CENTRAL ROMANA",
    //     "CENTRAL",
    //     "CENTRO ",
    //     "CENTRO 2 ",
    //     "CENTRO DE LA CIUDAD ",
    //     "CENTRO DE LA CIUDAD",
    //     "CENTRO DE LOS HEROES",
    //     "CENTRO DEL PUEBLO ",
    //     "CENTRO DEL PUEBLO (INGENIO MONTELLANO)",
    //     "CENTRO DEL PUEBLO (LA HIGUERA)",
    //     "CENTRO DEL PUEBLO 02",
    //     "CENTRO DEL PUEBLO BAYAHIBE",
    //     "CENTRO DEL PUEBLO O ALTO DE LA FELICIDAD",
    //     "CENTRO DEL PUEBLO O EL LIMON",
    //     "CENTRO DEL PUEBLO O EL MAMEY",
    //     "CENTRO DEL PUEBLO O EL MEDIO",
    //     "CENTRO DEL PUEBLO O LA CARRETERA",
    //     "CENTRO DEL PUEBLO O LA GINA ",
    //     "CENTRO DEL PUEBLO O LA PLACETA",
    //     "CENTRO DEL PUEBLO O LA Q",
    //     "CENTRO DEL PUEBLO O SECTOR A",
    //     "CENTRO HERMOSO",
    //     "CENTRO HISTORICO DE PUERTO PLATA",
    //     "CENTRO MADRE VIEJA SUR",
    //     "CENTRO OLIMPICO JUAN PABLO DUARTE ",
    //     "CENTRO PENZO",
    //     "CENTRO SANTANA",
    //     "CENTRO VIEJO",
    //     "CEPITO ",
    //     "CERCA DE LA PIÑA",
    //     "CERCADILLO ",
    //     "CERCADO ABAJO ",
    //     "CERCADO ALTO",
    //     "CERINCA",
    //     "CERREJON ",
    //     "CERRITO LIMON ",
    //     "CERRITO PELADO",
    //     "CERRO ADENTRO ",
    //     "CERRO AL MEDIO",
    //     "CERRO ALTO ",
    //     "CERRO ALTO II ",
    //     "CERRO ANTON",
    //     "CERRO BOHÍO",
    //     "CERRO BONITO",
    //     "CERRO CABRA",
    //     "CERRO CAIMONIES ",
    //     "CERRO CHINO",
    //     "CERRO DE DAJAO",
    //     "CERRO DE LA CANA",
    //     "CERRO DE LA ESTANCIA",
    //     "CERRO DE LOS CACHEOS",
    //     "CERRO DE NAVAS",
    //     "CERRO DE PAPATIN",
    //     "CERRO DE PIEDRA ",
    //     "CERRO DE RICHIEZ",
    //     "CERRO DE SALADILLOS O RIO CHIR",
    //     "CERRO DEL CASTILLO",
    //     "CERRO DEL MONTE ",
    //     "CERRO DULCE",
    //     "CERRO EL DAJAO",
    //     "CERRO GORDO ABAJO ",
    //     "CERRO GORDO ARRIBA",
    //     "CERRO GORDO",
    //     "CERRO GUAMO",
    //     "CERRO HERMOSO ",
    //     "CERRO LARGO",
    //     "CERRO LINDO",
    //     "CERRO MALO ",
    //     "CERRO MARINO",
    //     "CERRO MELON",
    //     "CERRO MICO ",
    //     "CERRO MONTE",
    //     "CERRO MONTOSO ",
    //     "CERRO NARANJO ",
    //     "CERRO NEGRO",
    //     "CERRO PRIETO",
    //     "CERRO REDONDO ",
    //     "CERRO SAN FRANCISCO ",
    //     "CERRO YALJU",
    //     "CERROMAR ",
    //     "CERROS DE ARROYO HONDO",
    //     "CERROS DE BELLA VISTA ",
    //     "CERROS DE BUENA VISTA I ",
    //     "CERROS DE BUENA VISTA II",
    //     "CERROS DE CHAVON",
    //     "CERROS DE GURABO I",
    //     "CERROS DE GURABO II ",
    //     "CERROS DE GURABO III",
    //     "CERROS DE LA BAHIA",
    //     "CERROS DE SABANA PERDIDA 10 ",
    //     "CERROS DE SANTA LUCIA ",
    //     "CERROS DEL EDEN ",
    //     "CERROS DEL NORTE",
    //     "CERROS DEL OZAMA",
    //     "CERROS DON ANTONIO",
    //     "CERROS LOS TRATES ",
    //     "CESTEADORO ",
    //     "CEUTA",
    //     "CEVICOS (ZONA URBANA) ",
    //     "CEVICOS ARRIBA",
    //     "CHACUEY MALDONADO ARRIBA",
    //     "CHACUEY",
    //     "CHALONA ABAJO ",
    //     "CHARABISCAL",
    //     "CHARAMICO",
    //     "CHARCA O LAS BAITOAS",
    //     "CHARCO AZUL",
    //     "CHARCO BLANCO ",
    //     "CHARCO COLORADO ",
    //     "CHARCO DE PANCHO",
    //     "CHARCO DEL CAIMAN ",
    //     "CHARCO DEL HIGO ",
    //     "CHARCO DEL TORO ",
    //     "CHARCO LARGO",
    //     "CHARCO NARANJO",
    //     "CHARCO PRIETO ",
    //     "CHARCO PRIETO",
    //     "CHAVISCAL",
    //     "CHAVON ",
    //     "CHAVON (BATEY CABO HAITIANO)",
    //     "CHAVON ABAJO",
    //     "CHAVON ARRIBA ",
    //     "CHAVONCITO ",
    //     "CHENE",
    //     "CHICAGO",
    //     "CHICHI GUARO",
    //     "CHICHIGUAO ",
    //     "CHILLO POUERIET ",
    //     "CHINCHIN ",
    //     "CHINGUELO",
    //     "CHINO",
    //     "CHIRINGO ",
    //     "CHIRINO O HIMIRO",
    //     "CHIRINO",
    //     "CHOLONGO O LOS COCOS",
    //     "CHORRO BONITO ",
    //     "CHORRO DE ORO ",
    //     "CHORRO DE ORO",
    //     "CHUCHO DE CHICHI",
    //     "CHUCHO SALAS",
    //     "CHUCHO VASQUEZ",
    //     "CHUCHU JORGE",
    //     "CHURCHILL",
    //     "CHURUMBUNES",
    //     "CIBAHUETE",
    //     "CIEN TAREAS",
    //     "CIENAGA VIEJA ",
    //     "CIENAGA",
    //     "CIENAGATUAMO",
    //     "CIENAGOTE",
    //     "CIENAGUITA ",
    //     "CIENEGUITA ABAJO",
    //     "CIENEGUITA ARRIBA ",
    //     "CIENFUEGOS ",
    //     "CIGUA",
    //     "CIGÜELILLO ",
    //     "CILINDRON",
    //     "CINTA NEGRA",
    //     "CIRCUNVALACION",
    //     "CIUDAD AGRARIA",
    //     "CIUDAD CODIANA",
    //     "CIUDAD COLONIAL ",
    //     "CIUDAD COLONIAL",
    //     "CIUDAD CONSUELO ",
    //     "CIUDAD DE LOS TRABAJADORES",
    //     "CIUDAD DEL ALMIRANTE",
    //     "CIUDAD DEPORTIVA",
    //     "CIUDAD MODELO ",
    //     "CIUDAD MODELO O SATELITE",
    //     "CIUDAD MODERNA",
    //     "CIUDAD NUEVA",
    //     "CIUDAD PARTE ALTA (ZONA ESCOLAR)",
    //     "CIUDAD REAL II",
    //     "CIUDAD REAL",
    //     "CIUDAD SATELITE ",
    //     "CIUDAD UNIVERSITARIA",
    //     "CLAVELLINA ",
    //     "CLAVELLINA",
    //     "CLAVIJO ABAJO ",
    //     "CLAVIJO",
    //     "CLAVO TORCIO",
    //     "CLUB ",
    //     "COCA BARRERA",
    //     "COCINERA ",
    //     "COCINERO ",
    //     "COCO ",
    //     "COCO (CACO)",
    //     "COCUYO ",
    //     "CODAL",
    //     "CODETEL",
    //     "COJOBAL",
    //     "COLA DE PATO",
    //     "COLINA DEL ESTE ",
    //     "COLINA FESCA (ANTIGUA WENDY GIL)",
    //     "COLINA I ",
    //     "COLINA II",
    //     "COLINA III ",
    //     "COLINAS DE ARROYO HONDO ",
    //     "COLINAS DE ENGOMBE",
    //     "COLINAS DE LOS RIOS ",
    //     "COLINAS DEL ARROYO II ",
    //     "COLINAS DEL ARROYO",
    //     "COLINAS DEL EDEN III",
    //     "COLINAS DEL EDEN",
    //     "COLINAS DEL SUR ",
    //     "COLINAS DEL SUR (EL AVISPERO) ",
    //     "COLOMBIA (PEKIN)",
    //     "COLON SALVALEON ",
    //     "COLON",
    //     "COLONIA 30 DE MAYO",
    //     "COLONIA CATALINA",
    //     "COLONIA DE LA FE",
    //     "COLONIA DE LOS POMOS O TOÑITO BATISTA ",
    //     "COLONIA EL NARANJITO",
    //     "COLONIA ESPAÑOLA",
    //     "COLONIA KENNEDY ",
    //     "COLONIA LOS ARROYOS ",
    //     "COLONIA LOS LIMONES ",
    //     "COLONIA MENCIA",
    //     "COLONIA MIXTA ",
    //     "COLONIA RANCHO ESPAÑOL",
    //     "COLONIA SAN RAFAEL",
    //     "COLONIA VILLA ESPERANZA ",
    //     "COLORADO ",
    //     "COLORAO",
    //     "COLUMNA ABAJO ",
    //     "COLUMNA ARRIBA",
    //     "COMADREJA",
    //     "COMATILLO",
    //     "COME HOMBRE",
    //     "COME PAN ",
    //     "COMEDERO ",
    //     "COMEDERO ABAJO",
    //     "COMEDERO ARRIBA ",
    //     "COMEDERO BAYO ",
    //     "COMPADRE PASCUAL 02 ",
    //     "COMPUERTA DE LICO ",
    //     "COMUNIDAD SAN VICENTE ",
    //     "CONANI ",
    //     "CONCEPCION DE LA VEGA (ZONA URBANA) ",
    //     "CONCHO PRIMO",
    //     "CONCORDIA",
    //     "CONDOMINIO CENTRAL ROMANA ",
    //     "CONDOMINIO SANTO DOMINGO",
    //     "CONDOMINIO TRADY",
    //     "CONFITERO",
    //     "CONGO",
    //     "CONOJO (DORMIDERO AL MEDIO) ",
    //     "CONSTANZA (ZONA URBANA) ",
    //     "CONSTELACION",
    //     "CONSTITUCION",
    //     "CONSUELO ",
    //     "CONSUELO (ZONA URBANA)",
    //     "CONSUMIDERO",
    //     "CONTRAEMBALSE ",
    //     "CONTRERAS",
    //     "CONTROBA O BORINQUEN",
    //     "CONUCO ",
    //     "CONUCO DEL RIO",
    //     "CONUCO LEJOS",
    //     "CONUCO VIEJO",
    //     "COPEY SANO ",
    //     "COPEY",
    //     "COPEYAL",
    //     "COQUI",
    //     "CORALES DEL SUR ",
    //     "CORAZA O CENTRO DEL PUEBLO",
    //     "CORBANAL ",
    //     "CORBANITO (CALLAO ARRIBA) ",
    //     "CORBANO SUR",
    //     "CORBINATO",
    //     "CORDERO",
    //     "COREA",
    //     "COROCITO ",
    //     "COROCITO ABAJO",
    //     "COROCITOS",
    //     "CORONEL FRANCISCO ALBERTO CAAMAÑO ",
    //     "CORONEL FRANCISCO ALBERTO CAAMAÑO DEÑO",
    //     "COROZAL",
    //     "COROZO ABAJO",
    //     "COROZO ARRIBA ",
    //     "COROZO ARRIBA",
    //     "CORRAL DE LOS INDIOS",
    //     "CORRAL DE MARCOS",
    //     "CORRAL FALSO",
    //     "CORRAL GRANDE ",
    //     "CORRALITO",
    //     "CORTE NUEVO",
    //     "CORTECITO",
    //     "CORTICO",
    //     "CORTO BOLO I Y II ",
    //     "COSTA AZUL ",
    //     "COSTA BRAVA",
    //     "COSTA CARIBE",
    //     "COSTA LINDA",
    //     "COSTA VERDE",
    //     "COSTAMBAR",
    //     "COTO ABAJO ",
    //     "COTO AL MEDIO (RINCON DE COTO)",
    //     "COTO ARRIBA",
    //     "COTUI (ZONA URBANA) ",
    //     "COUNTRY CLUB",
    //     "CQ 2 ",
    //     "CQ 3 ",
    //     "CQ I ",
    //     "CRESTELIANDO",
    //     "CRISTAL",
    //     "CRISTINITA ",
    //     "CRISTO REY ",
    //     "CRISTO REY DE GUARAGUAO (ZONA URBANA) ",
    //     "CRISTO REY O JARRO SUCIO",
    //     "CRISTO REY O LA CACHAZA ",
    //     "CRISTO SALVADOR ",
    //     "CRISTOBAL (ZONA URBANA) ",
    //     "CRISTOBAL COLON ",
    //     "CRUCE DE ANGELINA O GUACHUPITA",
    //     "CRUCE DE ARROYO AL MEDIO",
    //     "CRUCE DE BARRERO",
    //     "CRUCE DE BOCA CHICA ",
    //     "CRUCE DE BOCA CHICA 09",
    //     "CRUCE DE CABRAL (NORTE) ",
    //     "CRUCE DE CABRAL (SUR) ",
    //     "CRUCE DE CAYACOA",
    //     "CRUCE DE CHON ",
    //     "CRUCE DE COPEYITO ",
    //     "CRUCE DE DOÑA MARIA ",
    //     "CRUCE DE DURAN",
    //     "CRUCE DE ESPERANZA",
    //     "CRUCE DE GASPAR ",
    //     "CRUCE DE GINA ",
    //     "CRUCE DE GRANADA",
    //     "CRUCE DE GUAYACANES ",
    //     "CRUCE DE GUERRA ",
    //     "CRUCE DE GUZMAN ",
    //     "CRUCE DE ISLEÑO (ANTIGUO CRUZ DE ISLEÑO)",
    //     "CRUCE DE JAGUA",
    //     "CRUCE DE JICOME-KILOMETRO 7 ",
    //     "CRUCE DE LA CEIBA ",
    //     "CRUCE DE LA ELMURSHT (DE PAYABO)",
    //     "CRUCE DE LA FELICIANA ",
    //     "CRUCE DE LA JAGUA ",
    //     "CRUCE DE LA JAGUA",
    //     "CRUCE DE LA LANA",
    //     "CRUCE DE LA PIÑITA",
    //     "CRUCE DE LAS CABIRMAS (ANTIGUA ATRONCA PERROS)",
    //     "CRUCE DE LAS TERRENAS ",
    //     "CRUCE DE LAS YAYAS",
    //     "CRUCE DE LORA ",
    //     "CRUCE DE LOS BACILIOS ",
    //     "CRUCE DE LOS BASILIOS ",
    //     "CRUCE DE LOS BETANCES ",
    //     "CRUCE DE LOS JAVIELES ",
    //     "CRUCE DE LOS LANOS",
    //     "CRUCE DE MAGUA",
    //     "CRUCE DE MAGUANA",
    //     "CRUCE DE MALENA ",
    //     "CRUCE DE MIRABEL",
    //     "CRUCE DE MORALES",
    //     "CRUCE DE MUNDITO",
    //     "CRUCE DE NIZAO",
    //     "CRUCE DE NOE",
    //     "CRUCE DE PALO ALTO",
    //     "CRUCE DE PAVON",
    //     "CRUCE DE PESCADERO",
    //     "CRUCE DE QUINIGUA ",
    //     "CRUCE DE RINCON ",
    //     "CRUCE DE RIO VERDE",
    //     "CRUCE DE SABANETA ",
    //     "CRUCE DE TOÑE ",
    //     "CRUCE DE VELAZQUEZ O LA MINA 09 ",
    //     "CRUCE DEL 15",
    //     "CRUCE DEL CAÑO",
    //     "CRUCE DEL LIMON ",
    //     "CRUCE JICOME",
    //     "CRUCE JOVINA",
    //     "CRUCE MAGUACA ",
    //     "CRUCE",
    //     "CRUCERO",
    //     "CRUZ DE CABRERA ",
    //     "CRUZ DE CABRERA ABAJO ",
    //     "CRUZ DE CABRERA ARRIBA",
    //     "CRUZ DE CENOVI",
    //     "CRUZ DE CUABA ",
    //     "CRUZ DE GEN (SALTADERO) ",
    //     "CRUZ DE GEN",
    //     "CRUZ DE ISLEÑO (ANTIGUO LOS DAJAOS) ",
    //     "CRUZ DE ISLEÑO",
    //     "CRUZ DE MANACLAS",
    //     "CRUZ DE MARCOS",
    //     "CRUZ DE MORILLO ",
    //     "CRUZ GRANDE",
    //     "CRUZ VERDE ",
    //     "CUABA ABAJO",
    //     "CUABA ARRIBA O LA REPRESA ",
    //     "CUABA",
    //     "CUANCE ",
    //     "CUANCITA ",
    //     "CUARCE (CUANCE) ",
    //     "CUARENTA ",
    //     "CUARON ",
    //     "CUATRO ESQUINAS ",
    //     "CUATRO OJOS",
    //     "CUBA ",
    //     "CUBA LIBRE ",
    //     "CUCA ",
    //     "CUCAMA ",
    //     "CUCARACHA",
    //     "CUCARITA ",
    //     "CUCHARETA",
    //     "CUCHILLITA ",
    //     "CUENCA ",
    //     "CUENDA ABAJO",
    //     "CUENDA ARRIBA ",
    //     "CUERECITO",
    //     "CUERNO DE BUEY",
    //     "CUERO DE GENTE",
    //     "CUERO DE PUERCO ",
    //     "CUERO DURO ",
    //     "CUESTA ABAJO",
    //     "CUESTA AMARILLA ",
    //     "CUESTA ARENA",
    //     "CUESTA ARRIBA ",
    //     "CUESTA BARROSA",
    //     "CUESTA BLANCA ",
    //     "CUESTA BRAVA",
    //     "CUESTA COLORADA ",
    //     "CUESTA CORVADA",
    //     "CUESTA DE PIEDRA",
    //     "CUESTA DE QUINIGUA",
    //     "CUESTA DEL JOBO ",
    //     "CUESTA DEL MATE ",
    //     "CUESTA HERMOSA I",
    //     "CUESTA HERMOSA II ",
    //     "CUESTA HERMOSA III",
    //     "CUESTA LA PIÑA",
    //     "CUETO",
    //     "CUEVA DE VALERIO",
    //     "CUEVA DEL AGUA",
    //     "CUEVAS ",
    //     "CUFI ",
    //     "CUMAJON",
    //     "CUMAYASA (ZONA URBANA)",
    //     "CUMBA",
    //     "CUMIA ABAJO",
    //     "CUMIA ADENTRO ",
    //     "CUMIA ARRIBA",
    //     "CURAZAO",
    //     "CURETE ",
    //     "CURVA DEL TURCO ",
    //     "CUTUPU ",
    //     "CUTUPU (ZONA URBANA)",
    //     "DAJAI",
    //     "DAJAO ABAJO",
    //     "DAJAO",
    //     "DAMAJAGUA ADENTRO ",
    //     "DAMAJAGUA",
    //     "DAMAYAGUAS ",
    //     "DAMIAN ",
    //     "DASA I ",
    //     "DASA II",
    //     "DAVID",
    //     "DE CHIVO ",
    //     "DE FORO",
    //     "DE LUZ ",
    //     "DE PERICLE ",
    //     "DEMAJAGUAL ",
    //     "DEMAJAGUAL ABAJO",
    //     "DEMAJAGUAL ARRIBA ",
    //     "DERRICO BLANCO",
    //     "DERRUMBADERO DE MAHOMA",
    //     "DERRUMBADERO",
    //     "DERRUMBADO ",
    //     "DESECHO LARGO ",
    //     "DESIDERIO ARIAS ",
    //     "DESTILERIA BRUGAL ",
    //     "DETRAS DE LA AVENA O LA ISABELA ",
    //     "DETRAS DE PUERTO RICO O PUERTO RICO II",
    //     "DIBUA",
    //     "DICAYAGUA ABAJO ",
    //     "DICAYAGUA ARRIBA",
    //     "DICHOSO ABAJO ",
    //     "DICHOSO ARRIBA",
    //     "DIEGO DE OCAMPO O LOS JARDINES DEL NORTE",
    //     "DIEGUITO ",
    //     "DIFERENCIA ",
    //     "DIONICIO ",
    //     "DIONICIO ABAJO",
    //     "DIONICIO ARRIBA ",
    //     "DIONICIO ARRIBA",
    //     "DIONICIO",
    //     "DIOS DIRA",
    //     "DOCTOR ELIAS SANTANA",
    //     "DOJIMA ",
    //     "DOMINGO CABRERA (ANTIGUO VIETNAM) ",
    //     "DOMINGO FRIO",
    //     "DOMINGO JIMENEZ ",
    //     "DOMINGO MIGUEL",
    //     "DOMINGO SAVIO ",
    //     "DOMINGO SAVIO",
    //     "DOMINGO",
    //     "DOMINICA ",
    //     "DOMINICANOS AUSENTES",
    //     "DOMINICUS",
    //     "DON ANTONIO GUZMAN FERNANDEZ",
    //     "DON ANTONIO",
    //     "DON BOSCO",
    //     "DON DOMINGO",
    //     "DON FAUSTO ",
    //     "DON FERNANDO",
    //     "DON FRANCISCO ",
    //     "DON GREGORIO",
    //     "DON HONORIO",
    //     "DON JUAN ",
    //     "DON JUAN I ",
    //     "DON JUAN II",
    //     "DON JUAN O CENTRO DEL PUEBLO",
    //     "DON JUAN V ",
    //     "DON LOPEZ",
    //     "DON LUIS ",
    //     "DON MANUEL ",
    //     "DON MIGUEL ",
    //     "DON PANCHITO",
    //     "DON PEDRO ABAJO ",
    //     "DON PEDRO ARRIBA (MONTE PEÑA) ",
    //     "DON PEDRO ARRIBA LICEY",
    //     "DONAJA ",
    //     "DONCEL ",
    //     "DORAL",
    //     "DORMIDERO",
    //     "DOS BOCAS",
    //     "DOS BRAZOS ",
    //     "DOS RIOS ",
    //     "DOÑA AGUEDA",
    //     "DOÑA ANA ",
    //     "DOÑA ANA ADENTRO",
    //     "DOÑA ANA AFUERA ",
    //     "DOÑA ANA O CUEVA DE DOÑA ANA",
    //     "DOÑA ANTONIA",
    //     "DOÑA CHUCHA",
    //     "DOÑA EMMA BALAGUER VIUDA VALLEJO",
    //     "DOÑA FEMA",
    //     "DOÑA ISABEL",
    //     "DOÑA LUISA ",
    //     "DOÑA MARIA ",
    //     "DOÑA TOÑA",
    //     "DRIMBOL",
    //     "DUARTE ",
    //     "DUARTE A ",
    //     "DUARTE ARRIBA O DUARTE ATRAS",
    //     "DUEY GRANDE",
    //     "DUEY PEQUEÑO",
    //     "DUQUESA",
    //     "DURAN",
    //     "DUVEAUX (MAMEY MACHO) ",
    //     "DUVERGE (ZONA URBANA) ",
    //     "DUVERGE",
    //     "DUYEY",
    //     "E. LEON JIMENES ",
    //     "EDUARDO BRITO ",
    //     "EL 10 DE HACIENDA ESTRELLA",
    //     "EL 10",
    //     "EL 11 DE CUTUPU ",
    //     "EL 11 DE HACIENDA ESTRELLA",
    //     "EL 14",
    //     "EL 15",
    //     "EL 16",
    //     "EL 2 ",
    //     "EL 25 (EL QUEMADO)",
    //     "EL 3 ",
    //     "EL 31",
    //     "EL 35",
    //     "EL 4 ",
    //     "EL 40 (LA CUARENTA) ",
    //     "EL 42 DE LOS MAPOLOS",
    //     "EL 5 ",
    //     "EL 50",
    //     "EL 77",
    //     "EL 8 ",
    //     "EL 84",
    //     "EL 9 ",
    //     "EL 90",
    //     "EL 91 O BATEY LA GINA ",
    //     "EL ABANICO ",
    //     "EL ABANICO DE CATAMEY ",
    //     "EL ABANICO DE LA CEIBA",
    //     "EL ABEJON",
    //     "EL ABEY",
    //     "EL ABITA ",
    //     "EL ABRA ARRIBA",
    //     "EL ABRA",
    //     "EL ACUEDUCTO",
    //     "EL AGUA DEL LIMON ",
    //     "EL AGUACATE (ZONA URBANA) ",
    //     "EL AGUACATE ABAJO ",
    //     "EL AGUACATE ADENTRO ",
    //     "EL AGUACATE AFUERA",
    //     "EL AGUACATE DE JACAGUA",
    //     "EL AGUACATE DE VIETNAM",
    //     "EL AGUACATE",
    //     "EL AGUACATICO ",
    //     "EL AGUACERO",
    //     "EL AHOGADO ",
    //     "EL ALEMAN",
    //     "EL ALFA",
    //     "EL ALGARROBAL ",
    //     "EL ALGARROBITO",
    //     "EL ALGARROBO O ACAPULCO ",
    //     "EL ALGARROBO",
    //     "EL ALGODON ",
    //     "EL ALJIBE",
    //     "EL ALMACEN ",
    //     "EL ALMACIGO",
    //     "EL ALMENDRO",
    //     "EL ALMIRANTE",
    //     "EL ALTO (VILLA FLORES)",
    //     "EL ALTO DE CHINA",
    //     "EL ALTO DE LA PASTILLA",
    //     "EL ALTO DE LOS GABRIELA ",
    //     "EL ALTO DE LOS PAPITA ",
    //     "EL ALTO DE MAYO ",
    //     "EL ALTO DE PALOMA ",
    //     "EL ALTO DEL CEMENTERIO",
    //     "EL ALTO DEL GALLO 02",
    //     "EL ALTO DEL JAMO",
    //     "EL ALTO DEL POLVO 02",
    //     "EL ALTO",
    //     "EL ANGELITO",
    //     "EL ANICETAL",
    //     "EL ANILLO O EL BRISAL ",
    //     "EL ANISAL",
    //     "EL ANISETAL",
    //     "EL ANON ABAJO ",
    //     "EL ANON ARRIBA",
    //     "EL ANON",
    //     "EL ARADO ",
    //     "EL ARCA",
    //     "EL ARENASO ",
    //     "EL ARENAZO ",
    //     "EL ARENOSO ",
    //     "EL AROMAL",
    //     "EL ARRAIGAN",
    //     "EL ARRAIJAN",
    //     "EL ARROYAZO (ARROYO DEL TORO) ",
    //     "EL ARROYO ARRIBA",
    //     "EL ARROYO GRANDE",
    //     "EL ARROYO",
    //     "EL ARROYON ",
    //     "EL ARROZAL ",
    //     "EL ASERRADERO ",
    //     "EL ASERRADERO DEL CHOCO (PARTE) ",
    //     "EL ASERRIN ",
    //     "EL ATACADOR",
    //     "EL ATRAVESADO ",
    //     "EL AVION ",
    //     "EL AZUCEY",
    //     "EL AÑIL",
    //     "EL BABOR ",
    //     "EL BACHATEO",
    //     "EL BADEN ",
    //     "EL BAGAZO O EL BALAZO ",
    //     "EL BAJIO (LOS PUENTES)",
    //     "EL BAJONAZO",
    //     "EL BALATA O LOS BALATACES ",
    //     "EL BAMBU ",
    //     "EL BARCO ",
    //     "EL BARRACO ",
    //     "EL BARRANQUITO",
    //     "EL BARRERITO (KM 4) ",
    //     "EL BARRERITO",
    //     "EL BARRERO ",
    //     "EL BARRILLAR",
    //     "EL BARRIO O LOS PARCELEROS",
    //     "EL BARRIO",
    //     "EL BARRITO (S.D.) ",
    //     "EL BARRO ",
    //     "EL BATEY ",
    //     "EL BATEY ISABELITA",
    //     "EL BATEY O LA PALOMA",
    //     "EL BATEY",
    //     "EL BAÑADERO",
    //     "EL BAÜICHO ",
    //     "EL BEBEDERO",
    //     "EL BEJUCAL ",
    //     "EL BEJUCAL",
    //     "EL BEJUCO",
    //     "EL BEMBE ",
    //     "EL BEYUGAL ",
    //     "EL BLANCO",
    //     "EL BLOCK ",
    //     "EL BOBO",
    //     "EL BOLO O LA PELUA",
    //     "EL BOLSILLO (LA BOMBA)",
    //     "EL BOLSILLO O LA SABANA DEL MANDO ",
    //     "EL BOLSILLO",
    //     "EL BOLSILLO, LA CURVITA O EL ABANICO",
    //     "EL BOMBILLO (BOMBILLO ADENTRO)",
    //     "EL BOMBON",
    //     "EL BONAO ",
    //     "EL BONITO",
    //     "EL BOQUERON",
    //     "EL BOSQUE ARRIBA",
    //     "EL BOTADO",
    //     "EL BOTAO ",
    //     "EL BOTE",
    //     "EL BRAZO ",
    //     "EL BRETON",
    //     "EL BRINCO",
    //     "EL BRISAL O EL PLAY ",
    //     "EL BRISAL",
    //     "EL BRISON",
    //     "EL BROCAL",
    //     "EL BRONCE",
    //     "EL BRONX ",
    //     "EL BROQUE",
    //     "EL BRUJO ",
    //     "EL BRUJO (YAQUE ABAJO)",
    //     "EL BUCARAL ",
    //     "EL BUEN PAN",
    //     "EL BUEN PASTOR",
    //     "EL BUEN SAMARITANO",
    //     "EL BUEY",
    //     "EL BUREN DE TRES PIEZAS ",
    //     "EL BURRO ",
    //     "EL BUZO",
    //     "EL CABAO ",
    //     "EL CABIRMAL",
    //     "EL CABLE O PESO UNO ",
    //     "EL CABO",
    //     "EL CABREJITO",
    //     "EL CABRETO ",
    //     "EL CACAO ",
    //     "EL CACHEO",
    //     "EL CACHIMBO (SAN ANDRES)",
    //     "EL CACHIMBO",
    //     "EL CACHIPERO O VILLA PROGRESO ",
    //     "EL CACHON (LOS CACHONES)",
    //     "EL CACHON (ZONA URBANA) ",
    //     "EL CACHON DE LA RUBIA ",
    //     "EL CACHON",
    //     "EL CACHOTE ",
    //     "EL CACIQUE ",
    //     "EL CACIQUE (YAGURIZO) ",
    //     "EL CACIQUE O CANTA LA RANA",
    //     "EL CADILLAR",
    //     "EL CAFE (PALMA SOLA)",
    //     "EL CAFE CENTRAL ",
    //     "EL CAFE",
    //     "EL CAFECITO",
    //     "EL CAFETAL ",
    //     "EL CAIMAN",
    //     "EL CAIMITAL ARRIBA",
    //     "EL CAIMITAL",
    //     "EL CAIMITO ",
    //     "EL CAIMITO (ZONA URBANA)",
    //     "EL CAIMITO ABAJO",
    //     "EL CAIMITO ADENTRO",
    //     "EL CAIMITO AFUERA ",
    //     "EL CAIMITO DE LA ROSARIO",
    //     "EL CAIMITO DEL HOSPITAL ",
    //     "EL CAIMONIAL",
    //     "EL CAJON ",
    //     "EL CAJUIL BLANCO",
    //     "EL CAJUIL PRIETO",
    //     "EL CAJUIL",
    //     "EL CAJUILITO",
    //     "EL CALABACITO ",
    //     "EL CALABAZO",
    //     "EL CALABOZO",
    //     "EL CALICHE ",
    //     "EL CALIENTISIMO ",
    //     "EL CALLEJON DE LA LOMA",
    //     "EL CALLEJON",
    //     "EL CALLITO ",
    //     "EL CALVARIO",
    //     "EL CAMBRON ",
    //     "EL CAMINO LA JOBERA ",
    //     "EL CAMPAMENTO ",
    //     "EL CAMPECHE",
    //     "EL CAMPITO ",
    //     "EL CAMU",
    //     "EL CAN ",
    //     "EL CANAL ",
    //     "EL CANAL DE LA MISERIA 02 ",
    //     "EL CANDEJON",
    //     "EL CANDELON",
    //     "EL CANDONGO",
    //     "EL CANEY ",
    //     "EL CANTON",
    //     "EL CAO ",
    //     "EL CAOBAL",
    //     "EL CAPA",
    //     "EL CAPACITO",
    //     "EL CAPAZ ",
    //     "EL CARACOL ",
    //     "EL CARAO ",
    //     "EL CARAQUEÑO",
    //     "EL CARMEN",
    //     "EL CARRAO",
    //     "EL CARRETON (ZONA URBANA) ",
    //     "EL CARRETON",
    //     "EL CARRIL (ZONA URBANA) ",
    //     "EL CARRIL ABAJO ",
    //     "EL CARRIL ARRIBA",
    //     "EL CARRIL",
    //     "EL CARRIZAL",
    //     "EL CASCAJAL",
    //     "EL CASERIO ",
    //     "EL CASERIO ABAJO O LOS VARGAS ",
    //     "EL CASERIO ABAJO O LOS VARGAS",
    //     "EL CASERIO O HERNANDO ALONZO",
    //     "EL CASERIO SANTA CLARA",
    //     "EL CASERIO",
    //     "EL CASTILLO O EL CAMPO",
    //     "EL CASTILLO O MANRESA ORIENTAL",
    //     "EL CATALAN ",
    //     "EL CATEY ",
    //     "EL CATUAN",
    //     "EL CAUCHO",
    //     "EL CAYAL ",
    //     "EL CAYITO",
    //     "EL CAYO",
    //     "EL CAYUCO",
    //     "EL CAÑAFISTOL ",
    //     "EL CAÑAVERAL",
    //     "EL CAÑO",
    //     "EL CEA ",
    //     "EL CEDRITO ",
    //     "EL CEDRO ",
    //     "EL CEDRO (ZONA URBANA)",
    //     "EL CEMENTERIO ",
    //     "EL CEMENTERIO O LA MILAGROSA",
    //     "EL CEMENTERIO",
    //     "EL CENTRAL ",
    //     "EL CENTRO DEL PUEBLO",
    //     "EL CENTRO",
    //     "EL CEPILLO ",
    //     "EL CERCADILLO ",
    //     "EL CERCADITO",
    //     "EL CERCADO ",
    //     "EL CERCADO (LA LILA)",
    //     "EL CERCADO (ZONA URBANA)",
    //     "EL CERRAZO ",
    //     "EL CERRITO ",
    //     "EL CERRO ",
    //     "EL CERRO (GUAYACANAL) ",
    //     "EL CERRO (GUAYACANAL)",
    //     "EL CHACARO ",
    //     "EL CHAMPAN ",
    //     "EL CHARCAZO",
    //     "EL CHARCO BONITO",
    //     "EL CHARCO",
    //     "EL CHARCON ",
    //     "EL CHARCOS ",
    //     "EL CHAVON",
    //     "EL CHEPE ",
    //     "EL CHICHARRON ",
    //     "EL CHIFLE",
    //     "EL CHIVO ",
    //     "EL CHOCHO JUAN LUCIANO",
    //     "EL CHOCO ",
    //     "EL CHORRERON",
    //     "EL CHORRO",
    //     "EL CHUCHO DE PEY",
    //     "EL CHUCHO O LA YUCA ",
    //     "EL CHUCHO",
    //     "EL CIDRAL (LA REPRESA)",
    //     "EL CIDRAL",
    //     "EL CIGUAL (LA CONCHA) ",
    //     "EL CIGUAL",
    //     "EL CIGUAR-(RAÑE)",
    //     "EL CIGUELILLO ",
    //     "EL CINCO ",
    //     "EL CINCO (EL 5) ",
    //     "EL CIRUELILLO ",
    //     "EL CIRUELITO O EL CIRUELILLO",
    //     "EL CIRUELITO",
    //     "EL CIRUELO ",
    //     "EL CLUB",
    //     "EL CO",
    //     "EL COAMO ",
    //     "EL COBRE ",
    //     "EL COCAL ",
    //     "EL COCHO ",
    //     "EL COCO 1",
    //     "EL COCO 2",
    //     "EL COCO",
    //     "EL COGOTE",
    //     "EL COIL O COL ",
    //     "EL COLORADO",
    //     "EL COLORAO ",
    //     "EL COLUMPIO",
    //     "EL COMEDERO",
    //     "EL CONCRETO (LOS HIDALGOS)",
    //     "EL CONDE ",
    //     "EL CONGO ",
    //     "EL CONGO (LOS MULTI)",
    //     "EL CONTROL ",
    //     "EL CONUCO",
    //     "EL CONVENTO NIZAO-LA NEVERA ",
    //     "EL CONVENTO",
    //     "EL COPEY ",
    //     "EL COPEY (ARROYO SALADO)",
    //     "EL COPEY O RANCHO COPEY ",
    //     "EL COPEYITO",
    //     "EL COQUITAL",
    //     "EL COQUITO ",
    //     "EL CORAL ",
    //     "EL CORAZAL ",
    //     "EL CORAZAL ABAJO (EL GAJO)",
    //     "EL CORBANAL",
    //     "EL CORBANITO",
    //     "EL CORBANO ",
    //     "EL CORBANO (EL CORVANO) ",
    //     "EL CORBANO NORTE",
    //     "EL COROZAL ",
    //     "EL COROZO ABAJO ",
    //     "EL COROZO ARRIBA",
    //     "EL COROZO",
    //     "EL CORRAL",
    //     "EL CORRALITO",
    //     "EL CORREO",
    //     "EL CORTE ",
    //     "EL CORTE NUEVO",
    //     "EL COSON ",
    //     "EL COSTE ",
    //     "EL CRUCE ",
    //     "EL CRUCE DE ANGELINA",
    //     "EL CRUCE DE ESTEBANIA ",
    //     "EL CRUCE DE ESTEBANIA",
    //     "EL CRUCE DE GUAYABO (EL CRUCE)",
    //     "EL CRUCE DE LA ESPERANZA",
    //     "EL CRUCE DE LA PALMA",
    //     "EL CRUCE DE LAS YAYAS ",
    //     "EL CRUCE DE LOS BOTADOS ",
    //     "EL CRUCE DE MARTIN ALONZO ",
    //     "EL CRUCE DE OCOA 05 ",
    //     "EL CRUCE DEL PAJON 09 ",
    //     "EL CRUCE DEL QUINCE ",
    //     "EL CRUCE DEL QUINCE",
    //     "EL CRUCERO ",
    //     "EL CUADRO",
    //     "EL CUARTEL ",
    //     "EL CUATRO",
    //     "EL CUERNO",
    //     "EL CUERVO",
    //     "EL CUEY",
    //     "EL CUMBI ",
    //     "EL CUPEY ",
    //     "EL CURRO ",
    //     "EL CUYA",
    //     "EL DAJAO ",
    //     "EL DAJAO DE LAS PIEDRAS ",
    //     "EL DALMAO",
    //     "EL DEPORTIVO",
    //     "EL DERRUMBADERO ",
    //     "EL DERRUMBADO ",
    //     "EL DESECHO ",
    //     "EL DESPEGAO",
    //     "EL DESPERTAR",
    //     "EL DESVIO",
    //     "EL DIAMANTE",
    //     "EL DIAN",
    //     "EL DIEZ",
    //     "EL DIQUE ",
    //     "EL DISTRITO",
    //     "EL DIVISO",
    //     "EL DOCE (12)",
    //     "EL DONAO ",
    //     "EL DORADO I",
    //     "EL DORADO II",
    //     "EL DORADO",
    //     "EL DOS (EL 2) ",
    //     "EL DOS (EL 2) O LA MINA ",
    //     "EL DRAGO ",
    //     "EL DUAN",
    //     "EL DUCADO",
    //     "EL DUEY",
    //     "EL DULCE O ARROYO DULCE ",
    //     "EL DURO",
    //     "EL EDEN",
    //     "EL EJIDO ",
    //     "EL EMBALSADERO O SABANA ROBLE ",
    //     "EL EMBRUJO III PRIMERA ETAPA",
    //     "EL ENCANTO ",
    //     "EL ENSANCHITO ",
    //     "EL ENSUEÑO ",
    //     "EL ESCARBADERO",
    //     "EL ESPINO",
    //     "EL ESTABLO ",
    //     "EL ESTADO",
    //     "EL ESTERO",
    //     "EL ESTILADERO ",
    //     "EL ESTRECHO ABAJO ",
    //     "EL ESTRECHO DE LUPERON OMAR BROSS ",
    //     "EL ESTRECHO DE LUPERON OMAR BROSS (ZONA URBANA) ",
    //     "EL ESTRECHO",
    //     "EL ESTRIBO ",
    //     "EL FACTOR (ZONA URBANA) ",
    //     "EL FANGO ",
    //     "EL FAO ",
    //     "EL FARO",
    //     "EL FERROCARRIL",
    //     "EL FIRME ",
    //     "EL FIRME DE LOS CAFESES ",
    //     "EL FLACO ",
    //     "EL FLORON",
    //     "EL FLUMER",
    //     "EL FOGONAZO",
    //     "EL FONDO ",
    //     "EL FONDO DE SABANA CRUZ ",
    //     "EL FRAILE",
    //     "EL FRANCES ",
    //     "EL FRANCES",
    //     "EL FRENITO ",
    //     "EL FRIO",
    //     "EL FRONTINO",
    //     "EL FRONTON ",
    //     "EL FUERTE",
    //     "EL FUNDO ",
    //     "EL FUNDO (MIRADOR NORTE)",
    //     "EL FUNDO O CASA VIEJA ",
    //     "EL FUNDO O SAN PEDRO 02 ",
    //     "EL FUNDO O SAN PEDRO",
    //     "EL FUNDO",
    //     "EL GAJO DE SABANA ",
    //     "EL GAJO DEL AMACEY",
    //     "EL GAJO O MIRADOR NORTE ",
    //     "EL GAJO",
    //     "EL GALLO ",
    //     "EL GANADERO",
    //     "EL GATO",
    //     "EL GAUCHO",
    //     "EL GENARE",
    //     "EL GOLFO ",
    //     "EL GOMEZ ",
    //     "EL GORRO ",
    //     "EL GRAMASO ",
    //     "EL GRAMOSO ",
    //     "EL GRAMOSO",
    //     "EL GRAN LLANO ",
    //     "EL GRAN PEÑON ",
    //     "EL GRANADO ",
    //     "EL GRANADO",
    //     "EL GRI GRI ",
    //     "EL GRUMO ",
    //     "EL GUAJABO ",
    //     "EL GUAMALITO",
    //     "EL GUANABANO",
    //     "EL GUANAL O LA MESETA ",
    //     "EL GUANAL",
    //     "EL GUANITO ",
    //     "EL GUANITO (EL CENTRO) 09 ",
    //     "EL GUANO ",
    //     "EL GUANO (LOS YAGRUMOS) ",
    //     "EL GUANO O LOS GUANOS ",
    //     "EL GUANO O LOS GUANOS",
    //     "EL GUAO",
    //     "EL GUARAGUAO",
    //     "EL GUARANAL O ALTO DE LA PIRAGUA",
    //     "EL GUARANAL",
    //     "EL GUARICO ",
    //     "EL GUATEQUE",
    //     "EL GUAYABAL",
    //     "EL GUAYABITO",
    //     "EL GUAYABO ",
    //     "EL GUAYACAL",
    //     "EL GUAYACAN",
    //     "EL GUAYO ",
    //     "EL GUAYUYAL",
    //     "EL GUAYUYO ",
    //     "EL GUAZARAL",
    //     "EL GUAZARO ",
    //     "EL GUINEAL ",
    //     "EL HABRA ",
    //     "EL HAITI ",
    //     "EL HATICO",
    //     "EL HATILLO ",
    //     "EL HATILLO (SAN JUAN DE BUENA VISTA)",
    //     "EL HATO DE SANGUINEO",
    //     "EL HATO O CENTRO DEL PUEBLO ",
    //     "EL HATO O EL JATO ",
    //     "EL HATO",
    //     "EL HELECHAL (EL ALTO) ",
    //     "EL HICOTEO ",
    //     "EL HIGO CLARO ",
    //     "EL HIGO O BRISAS",
    //     "EL HIGO",
    //     "EL HIGUERO ",
    //     "EL HIGUITO ",
    //     "EL HIGÜERITO (ZONA URBANA)",
    //     "EL HIGÜERITO ARRIBA ",
    //     "EL HIGÜERITO",
    //     "EL HIGÜERO ",
    //     "EL HIGÜERO (PARTE)",
    //     "EL HIGÜEROTE",
    //     "EL HIG�ERO",
    //     "EL HILO",
    //     "EL HORMIGUERO ",
    //     "EL HORNO ",
    //     "EL HOSPITAL O LAS MERCEDES",
    //     "EL HOSPITAL",
    //     "EL HOYAZO",
    //     "EL HOYITO",
    //     "EL HOYO DE LA CACATA",
    //     "EL HOYO DE LOS TOROS",
    //     "EL HOYO DE PEREZ",
    //     "EL HOYO DEL CAN ",
    //     "EL HOYO DEL CERCADO ",
    //     "EL HOYO O LOMA BLANCA ",
    //     "EL HOYO SANJUANERO",
    //     "EL HOYO U HOYO BELLO",
    //     "EL HOYO",
    //     "EL HUESO ",
    //     "EL HUMEN ",
    //     "EL HUNDIDERO",
    //     "EL INDIO ",
    //     "EL INDRHI",
    //     "EL INFINITO",
    //     "EL INGENIO ",
    //     "EL INGENIO ABAJO",
    //     "EL INGENIO ARRIBA ",
    //     "EL INGENIO",
    //     "EL INVI O CIUDAD UNIVERSITARIA",
    //     "EL INVI",
    //     "EL JABILLAR",
    //     "EL JABILLON",
    //     "EL JAMITO",
    //     "EL JAMO",
    //     "EL JAPON ",
    //     "EL JAROL ",
    //     "EL JARQUI",
    //     "EL JAZMIN",
    //     "EL JENGIBRAL",
    //     "EL JENGIBRE",
    //     "EL JIGÜERO (HIGÜERO)",
    //     "EL JOBILLO ",
    //     "EL JOBITO",
    //     "EL JOBO O VILLA PARAISO ",
    //     "EL JOBO",
    //     "EL JON O CUMAJON",
    //     "EL JOVAL ",
    //     "EL JOVERO",
    //     "EL JUNCAL",
    //     "EL JUNCO ",
    //     "EL KILOMBO ",
    //     "EL KILOMETRO 2",
    //     "EL KILOMETRO 9",
    //     "EL LAUREL",
    //     "EL LIAL",
    //     "EL LIBERTADOR ",
    //     "EL LIBRO ",
    //     "EL LICEO ",
    //     "EL LIMON ",
    //     "EL LIMON (ZONA URBANA)",
    //     "EL LIMONAL ",
    //     "EL LIMONAL (ZONA URBANA)",
    //     "EL LIMONCILLAR",
    //     "EL LIMONCITO",
    //     "EL LIMPIO O LA CIGUA",
    //     "EL LIMPIO",
    //     "EL LLANITO ",
    //     "EL LLANO ",
    //     "EL LLANO (ZONA URBANA)",
    //     "EL LLANO DE GUABATICO ",
    //     "EL LLANO DE LAS PIEDRAS ",
    //     "EL LOASA ",
    //     "EL LOBO",
    //     "EL LORO",
    //     "EL MACAO ",
    //     "EL MACO",
    //     "EL MAGANTILLO ",
    //     "EL MAICILLO",
    //     "EL MAIZAL",
    //     "EL MAJAGUAL",
    //     "EL MALECON ",
    //     "EL MAMEY ",
    //     "EL MAMEY",
    //     "EL MAMEYITO",
    //     "EL MAMON ",
    //     "EL MAMONAL ",
    //     "EL MAMONCITO",
    //     "EL MAMÓN ",
    //     "EL MANACLAR",
    //     "EL MANANTIAL",
    //     "EL MANGAL",
    //     "EL MANGLAR ",
    //     "EL MANGO ",
    //     "EL MANGO O EL MAGO",
    //     "EL MANGUITO O ZUMBADOR",
    //     "EL MANGUITO",
    //     "EL MANI",
    //     "EL MANIEL",
    //     "EL MANIELITO",
    //     "EL MANIERCITO ",
    //     "EL MARICAO ",
    //     "EL MARTILLO",
    //     "EL MATADERO",
    //     "EL MATE (EL MARTE)",
    //     "EL MATE (LOMA EL MATE)",
    //     "EL MATE",
    //     "EL MECHE ",
    //     "EL MECHERITO",
    //     "EL MEMBRILLO",
    //     "EL MEMISAL ",
    //     "EL MEMISO O EL MIMERO ",
    //     "EL MEMISO",
    //     "EL MENEO ",
    //     "EL MERCADO ",
    //     "EL MESO",
    //     "EL MILLO ",
    //     "EL MILLON",
    //     "EL MILLONCITO I ",
    //     "EL MILLONCITO II 10 ",
    //     "EL MOCHITO ",
    //     "EL MOCHO ",
    //     "EL MOGOTE",
    //     "EL MOLINO (ANTIGUO JARRO SUCIO) ",
    //     "EL MOLINO",
    //     "EL MONTAZO ",
    //     "EL MONTEADERO ",
    //     "EL MORRITO ",
    //     "EL MORRO ",
    //     "EL MUELLE",
    //     "EL MUERTO BORRACHO CERVANTES",
    //     "EL MUERTO",
    //     "EL MUEY",
    //     "EL MULO",
    //     "EL MURAZO",
    //     "EL MURO (PUEBLO NUEVO)",
    //     "EL MURO",
    //     "EL NACO",
    //     "EL NARANJAL (ZONA URBANA) ",
    //     "EL NARANJAL ADENTRO ",
    //     "EL NARANJAL",
    //     "EL NARANJITO",
    //     "EL NARANJO ",
    //     "EL NARANJO (NARANJAL) ",
    //     "EL NARANJO O NARANJAL ",
    //     "EL NEGRO ",
    //     "EL NISPERO ",
    //     "EL NOVILLO ",
    //     "EL NUEVE ",
    //     "EL NUEVO CAMINO O LOS COME SOLOS",
    //     "EL NUEVO PLAY ",
    //     "EL NUMERO",
    //     "EL OBISPADO",
    //     "EL OCHO (EL 8)",
    //     "EL OCHO",
    //     "EL OJO DE AGUA",
    //     "EL OREGANO ",
    //     "EL ORO ",
    //     "EL ORÉGANO ",
    //     "EL OTRO LADO DEL RIO",
    //     "EL OTRO LADO",
    //     "EL PABELLON",
    //     "EL PADRE ",
    //     "EL PAJON ",
    //     "EL PALERO BELLOSO ",
    //     "EL PALERO",
    //     "EL PALISTAL",
    //     "EL PALITO",
    //     "EL PALMAR (D.M.)",
    //     "EL PALMAR (ZONA URBANA) ",
    //     "EL PALMAR DE LOS SANCHEZ",
    //     "EL PALMAR",
    //     "EL PALMARITO",
    //     "EL PALMITO ",
    //     "EL PALO 30 ",
    //     "EL PALO",
    //     "EL PANDO ",
    //     "EL PAPAYO",
    //     "EL PARADERO",
    //     "EL PARAISO ",
    //     "EL PARQUE",
    //     "EL PARQUECITO ",
    //     "EL PARQUESITO O EL PARQUE ",
    //     "EL PARRAL",
    //     "EL PASO DE LA MAJAGÜITA ",
    //     "EL PATIO ",
    //     "EL PATO",
    //     "EL PEDREGAL",
    //     "EL PEDRERO ",
    //     "EL PEJE",
    //     "EL PELIGRO ",
    //     "EL PELU",
    //     "EL PERGANO ",
    //     "EL PERICO",
    //     "EL PERRO ",
    //     "EL PERU",
    //     "EL PESCADERO",
    //     "EL PESCOZON (SECTOR PADRE FANTINO)",
    //     "EL PETAQUERO",
    //     "EL PEÑA",
    //     "EL PEÑON ",
    //     "EL PEÑON (ZONA URBANA)",
    //     "EL PEÑON DE LOS REYES ",
    //     "EL PE�ON",
    //     "EL PICACHO ",
    //     "EL PICADO",
    //     "EL PICAO ",
    //     "EL PICAO DE LOS TORITOS ",
    //     "EL PICAO DE LUIS O PICADO DE LUIS ",
    //     "EL PICAPIEDRA ",
    //     "EL PICHON",
    //     "EL PICO DEL AJI ",
    //     "EL PICO",
    //     "EL PIE DE LA LOMA ",
    //     "EL PIE DE LOS PILONES ",
    //     "EL PILON ",
    //     "EL PINAL ",
    //     "EL PINAR ",
    //     "EL PINAR (ZONA URBANA)",
    //     "EL PINAZO",
    //     "EL PINITO DE LOS JIMENEZ",
    //     "EL PINITO SABANETA",
    //     "EL PINITO",
    //     "EL PINO (LOS MELLIZOS)",
    //     "EL PINO (ZONA URBANA) ",
    //     "EL PINO DE LAS SIETE HOJAS",
    //     "EL PINO",
    //     "EL PINTADO ",
    //     "EL PINTO ",
    //     "EL PIRAGUAL",
    //     "EL PISTOLAR",
    //     "EL PIÑON ",
    //     "EL PLACER",
    //     "EL PLAN",
    //     "EL PLATANAL",
    //     "EL PLATANO ",
    //     "EL PLATON",
    //     "EL PLAY DE DUARTE ",
    //     "EL PLAY O SAN JOSE",
    //     "EL PLAY",
    //     "EL PLAYON",
    //     "EL PLD ",
    //     "EL POBLADO ",
    //     "EL POCITO",
    //     "EL PODRIDO ",
    //     "EL POLVAZO ",
    //     "EL POMIER",
    //     "EL POMITO",
    //     "EL POMO",
    //     "EL PON ",
    //     "EL PORRITO O POMITO ",
    //     "EL PORTAL",
    //     "EL PORTILLO",
    //     "EL PORTON",
    //     "EL POZO (ZONA URBANA) ",
    //     "EL POZO DE COLI ",
    //     "EL POZO DE LA CEIBA ",
    //     "EL POZO DE LIMON",
    //     "EL POZO DE RENE ",
    //     "EL POZO",
    //     "EL PRADO ",
    //     "EL PRADO",
    //     "EL PRD ",
    //     "EL PRESENTADO ",
    //     "EL PRIETO",
    //     "EL PROGRESO (LOS CAJUILES)",
    //     "EL PROGRESO",
    //     "EL PROYECTO MANUEL TAVAREZ",
    //     "EL PROYECTO O HATO ARRIBA 09",
    //     "EL PROYECTO",
    //     "EL PUEBLECITO ",
    //     "EL PUEBLECITO",
    //     "EL PUENTE DE CAMU ",
    //     "EL PUENTE DE LAGUNA SALADA",
    //     "EL PUENTE",
    //     "EL PUENTECITO ",
    //     "EL PUENTECITO O CUMAJON ",
    //     "EL PUERTECITO ",
    //     "EL PUERTO O EL CENTRO ",
    //     "EL PUERTO",
    //     "EL PUERTON ",
    //     "EL PUJADOR O JAGÜITA",
    //     "EL QUEMADO ",
    //     "EL QUEMAO (LOMA DEL QUEMAO) ",
    //     "EL QUEMAO O EL QUEMAO DE SANTIAGO ",
    //     "EL QUEMAO",
    //     "EL QUILOMBO",
    //     "EL RAMON ",
    //     "EL RAMONAL ",
    //     "EL RANCHITO (ZONA URBANA) ",
    //     "EL RANCHITO",
    //     "EL RANCHO LOS POMOS O RANCHO",
    //     "EL RANCHO",
    //     "EL RASTRILLO",
    //     "EL RAYO",
    //     "EL REBO",
    //     "EL RECO",
    //     "EL RECODO",
    //     "EL REFUGIO ",
    //     "EL REFUGIO ALPHA 4",
    //     "EL REJON ",
    //     "EL REMATE",
    //     "EL REMOLINO",
    //     "EL RESBALON",
    //     "EL RESBALOSO",
    //     "EL RETIRO",
    //     "EL RIBON ",
    //     "EL RIFLE ",
    //     "EL RIITO ",
    //     "EL RINCON",
    //     "EL RINCONAZO",
    //     "EL RIO ",
    //     "EL RIO ABAJO",
    //     "EL RIO ARRIBA ",
    //     "EL ROBLEGAR",
    //     "EL ROBLITO ",
    //     "EL RODADERO O ZODADERO",
    //     "EL RODEO ",
    //     "EL RODEO (MAJAGUAL) ",
    //     "EL RODEO (MAJAGUAL)",
    //     "EL RODEO ADENTRO",
    //     "EL ROMERILLO",
    //     "EL RONDON",
    //     "EL ROSAL ",
    //     "EL ROSALITO",
    //     "EL ROSARIO ",
    //     "EL ROSARIO (ZONA URBANA)",
    //     "EL ROSARIO AL MEDIO ",
    //     "EL ROSARIO ARRIBA ",
    //     "EL RUBIO ",
    //     "EL RUBIO (ZONA URBANA)",
    //     "EL RUCIO ABAJO",
    //     "EL RUCIO DE LOS CACHONES",
    //     "EL RUCIO DE LOS LANOS ",
    //     "EL SACO",
    //     "EL SALADO (ZONA URBANA) ",
    //     "EL SALADO DE LOS CUCUSES",
    //     "EL SALADO",
    //     "EL SALAO ",
    //     "EL SALAO O EL SALADO",
    //     "EL SALDO ",
    //     "EL SALITRE ",
    //     "EL SALTADERO",
    //     "EL SALTO ",
    //     "EL SALTO DE JIMENOA ",
    //     "EL SAMAN ",
    //     "EL SAMAN (FACIL)",
    //     "EL SAMARITANO ",
    //     "EL SAMARITANO II",
    //     "EL SAMO",
    //     "EL SANJON",
    //     "EL SANO",
    //     "EL SAYO",
    //     "EL SEMILLERO O LA CAOBA ",
    //     "EL SEMILLERO",
    //     "EL SERENO",
    //     "EL SESENTA Y UNO (61) ",
    //     "EL SIETE ",
    //     "EL SIFONCITO",
    //     "EL SILENCIO",
    //     "EL SILLON",
    //     "EL SISAL ",
    //     "EL SITIO ",
    //     "EL SOCO",
    //     "EL SOMBRERO",
    //     "EL SORRIBO ",
    //     "EL SUERO ",
    //     "EL SUIZO ",
    //     "EL TABACAL ",
    //     "EL TABLAZO ",
    //     "EL TABLON ADENTRO ",
    //     "EL TABLON AFUERA",
    //     "EL TABLON",
    //     "EL TALADO",
    //     "EL TALLADO ",
    //     "EL TAMARINDO",
    //     "EL TANQUE O QUIJA QUIETA",
    //     "EL TANQUE",
    //     "EL TAPION",
    //     "EL TARANAL-CAIMITO",
    //     "EL TEJAR ",
    //     "EL TELANZA ",
    //     "EL TETERO",
    //     "EL TINTERO ",
    //     "EL TIZON ",
    //     "EL TOCINO DE JOCA ",
    //     "EL TOCON ",
    //     "EL TOCON O FOGON DE LOS PERROS",
    //     "EL TOPE O SABANA ARRIBA ",
    //     "EL TOPE",
    //     "EL TORITO",
    //     "EL TORNADO ",
    //     "EL TORO LADO",
    //     "EL TORO",
    //     "EL TRANCHE ",
    //     "EL TRES",
    //     "EL TUERTO",
    //     "EL TUNEL ",
    //     "EL TURCO ",
    //     "EL UNO ",
    //     "EL VACACIONAL ",
    //     "EL VALEDOR ",
    //     "EL VALIENTE",
    //     "EL VALLE ",
    //     "EL VALLE (ZONA URBANA)",
    //     "EL VALLE FRANCES",
    //     "EL VALLECITO",
    //     "EL VATICANO",
    //     "EL VEINTE",
    //     "EL VENAO ",
    //     "EL VERDE ",
    //     "EL VERGEL",
    //     "EL VIGIADOR",
    //     "EL VIOLON (LOS MAMEYES) ",
    //     "EL VISO",
    //     "EL VOLADERO",
    //     "EL YAGAL ",
    //     "EL YAGUAL O EL JAGUAL ",
    //     "EL YAGUARIZO",
    //     "EL YAQUE ",
    //     "EL YAQUITO ",
    //     "EL YAREY ",
    //     "EL YAYAL ",
    //     "EL YAYAL (CAMPO AMOR) ",
    //     "EL YUGAL (EL PALMARITO) ",
    //     "EL YUJO",
    //     "EL ZANJON",
    //     "EL ZAPOTE",
    //     "EL ZINC ABAJO ",
    //     "EL ZINC",
    //     "EL ZOOLOGICO",
    //     "EL ZUMBADOR",
    //     "EL ZUMBI MANTECA",
    //     "EL ZUMBIO",
    //     "EL ZUMBON",
    //     "ELEGIDO",
    //     "ELUPINA CORDERO DE LAS CAÑITAS (ZONA URBANA)",
    //     "ELVIRA ",
    //     "EMILIO GARCIA ",
    //     "ENEA ",
    //     "ENEMENCIO DIAZ",
    //     "ENGOMBE",
    //     "ENRIQUILLO ",
    //     "ENRIQUILLO (ZONA URBANA)",
    //     "ENRIQUILLO III",
    //     "ENRIQUILLO O LA GALLERA ",
    //     "ENRIQUILLO O RESIDENCIAL SANTANA",
    //     "ENSANCHE ABREU",
    //     "ENSANCHE AGUILA ",
    //     "ENSANCHE ALMEIDA",
    //     "ENSANCHE ANACAONA ",
    //     "ENSANCHE BERMUDEZ ",
    //     "ENSANCHE BOLIVAR",
    //     "ENSANCHE CAONABO (LOS PLATANITOS) ",
    //     "ENSANCHE CAPOTILLO",
    //     "ENSANCHE CRISTAL 10 ",
    //     "ENSANCHE DOLORES",
    //     "ENSANCHE DUBEAU ",
    //     "ENSANCHE ESPAILLAT",
    //     "ENSANCHE FELICIDAD",
    //     "ENSANCHE GETSEMANI",
    //     "ENSANCHE HERMANAS MIRABAL ",
    //     "ENSANCHE INDEPENDENCIA",
    //     "ENSANCHE ISABELITA II ",
    //     "ENSANCHE JOSE MANUEL",
    //     "ENSANCHE JOSE RAMIREZ ",
    //     "ENSANCHE JUAN PABLO DUARTE",
    //     "ENSANCHE JULIA 01 ",
    //     "ENSANCHE KENNEDY",
    //     "ENSANCHE LA CAOBA ",
    //     "ENSANCHE LA FE 02 ",
    //     "ENSANCHE LA FE",
    //     "ENSANCHE LA HOZ ",
    //     "ENSANCHE LA PAZ ",
    //     "ENSANCHE LA ROTONDA ",
    //     "ENSANCHE LA RUBIA ",
    //     "ENSANCHE LAS CAOBAS ",
    //     "ENSANCHE LAS PALMAS ",
    //     "ENSANCHE LIBERTAD ",
    //     "ENSANCHE LIBERTAD 02",
    //     "ENSANCHE LOS JARDINES ",
    //     "ENSANCHE LUGO ",
    //     "ENSANCHE LUPERON",
    //     "ENSANCHE LUZ Y VIDA ",
    //     "ENSANCHE MADRIGAL ",
    //     "ENSANCHE NACO ",
    //     "ENSANCHE OLIMPICO ",
    //     "ENSANCHE ORTEGA 01",
    //     "ENSANCHE OZAMA",
    //     "ENSANCHE PALO HINCADO O BLANCO",
    //     "ENSANCHE PEREIRA",
    //     "ENSANCHE QUISQUEYA NUEVA",
    //     "ENSANCHE QUISQUEYA VIEJA",
    //     "ENSANCHE QUISQUEYA",
    //     "ENSANCHE RAMOS",
    //     "ENSANCHE ROMAN",
    //     "ENSANCHE SAN MARTIN DE PORRES ",
    //     "ENSANCHE SERRALLES",
    //     "ENSUEÑO I",
    //     "ENSUEÑO II ",
    //     "ENTRADA DE JINOVA O LA CABIRMA",
    //     "ENTRADA DE LA FALCONBRIDGE",
    //     "ENTRADA DE LA ZANJA ",
    //     "ENTRADA DE LEMBA",
    //     "ENTRADA DE MAO",
    //     "ENTRADA DE PAULINO",
    //     "ENTRADA DE POZO PRIETO",
    //     "ENTRADA LA CAYA ",
    //     "ERCILIA PEPIN ",
    //     "ERMITAÑO ",
    //     "ESCALERA ABAJO",
    //     "ESCALERA ARRIBA ",
    //     "ESCOBAR",
    //     "ESCOBOSO ",
    //     "ESCONDIDITO",
    //     "ESCONDIDO",
    //     "ESCUELA NUEVA ",
    //     "ESLABON O ISLABON ",
    //     "ESLABONES",
    //     "ESPAILLAT",
    //     "ESPARTILLO ",
    //     "ESPERANZA (ZONA URBANA) ",
    //     "ESPERANZA",
    //     "ESPERON",
    //     "ESPINILLA",
    //     "ESPINOSA ",
    //     "ESPIRITU SANTO",
    //     "ESQUINA CALIENTE",
    //     "ESTABLO",
    //     "ESTANCIA DEL YAQUE",
    //     "ESTANCIA NUEVA ABAJO",
    //     "ESTANCIA NUEVA ARRIBA ",
    //     "ESTANCIA NUEVA",
    //     "ESTANCIA VIEJA",
    //     "ESTANCITA",
    //     "ESTANZUELA ABAJO",
    //     "ESTANZUELA ARRIBA ",
    //     "ESTEBANIA (ZONA URBANA) ",
    //     "ESTEBANIA (ZONA URBANA)",
    //     "ESTEBANIA",
    //     "ESTERO BALSA",
    //     "ESTERO HONDO (ZONA URBANA)",
    //     "ESTERO HONDO",
    //     "ESTORGA (ZONA URBANA) ",
    //     "ESTORGA",
    //     "EUGENIO MARIA DE HOSTOS ",
    //     "EUGENIO MARIA DE HOSTOS (ZONA URBANA) ",
    //     "EUGENIO PERDOMO ",
    //     "EURIPIDES",
    //     "EVARISTO MORALES",
    //     "EXTENSION PADRE LAS CASAS ",
    //     "FACTOR ",
    //     "FACTOR VIEJO",
    //     "FALLETE",
    //     "FAMIER ",
    //     "FANTINO (ZONA URBANA) ",
    //     "FARO A COLON",
    //     "FARO DEL CERRO",
    //     "FATIMA O LOS CACHIMBOS",
    //     "FATIMA-LA BASCUA",
    //     "FAVIDRIO ",
    //     "FE Y ALEGRIA",
    //     "FE Y AMOR",
    //     "FELICIANA",
    //     "FELIPA PEREZ",
    //     "FELITO BUENO",
    //     "FELIX NUÑEZ O EL MURO ",
    //     "FELIX TAVERAS ",
    //     "FERREGUS ",
    //     "FIGUEROA ",
    //     "FILIPINAS",
    //     "FINCA DE ACIBA",
    //     "FINCA DE ENGOMBE",
    //     "FINCA DE FRANCISCO MATOS",
    //     "FINCA DE JAIME FELIZ",
    //     "FINCA MAULE",
    //     "FINCA TONY RIVERA (ARROYO SONADOR)",
    //     "FINQUITA ",
    //     "FIO-FIO",
    //     "FIRME DE JINA CLARA ",
    //     "FIRME DE LA BRISA ",
    //     "FIRME DE LAS TARANAS",
    //     "FIRME DE LOS CHIVOS ",
    //     "FIRME DE LOS ORTEGA ",
    //     "FIRME DE MONROE ",
    //     "FIRME DE SUAREZ ",
    //     "FIRME DEL CARRAO",
    //     "FIRME EN MEDIO",
    //     "FLOR DE BAYAHIBE",
    //     "FLOR DE CAFE",
    //     "FLOR DE LIZ O SAL SI PUEDES ",
    //     "FLORA",
    //     "FLORENCIO",
    //     "FOGON APAGADO ",
    //     "FONDO ABAJO",
    //     "FONDO ARRIBA",
    //     "FONDO DE AGUSTIN",
    //     "FONDO DE ARISTEO",
    //     "FONDO DE BENITO ",
    //     "FONDO DE BENITO",
    //     "FONDO DE BOTELLA",
    //     "FONDO GRANDE",
    //     "FONDO NEGRO (ZONA URBANA) ",
    //     "FONDO VIEJO",
    //     "FORTALEZA 2 DE MAYO ",
    //     "FRAMBOYAN",
    //     "FRANCES",
    //     "FRANCISCO A. CAAMAÑO",
    //     "FRANCISCO BUENO ZAPATA",
    //     "FRANCISCO DEL ROSARIO SANCHEZ ",
    //     "FRANCISCO JOSE",
    //     "FRANCISCO MATEO ",
    //     "FRANCISQUITO ABAJO",
    //     "FRANCISQUITO ARRIBA ",
    //     "FRANCISQUITO",
    //     "FRANCO BIDO",
    //     "FRASQUITO GOMEZ ",
    //     "FRIAS",
    //     "FRUTA DE LA PALOMA",
    //     "FRUTA DE PALOMA ",
    //     "FRUTA DE PALOMA",
    //     "FUDECO ",
    //     "FUERTE RESOLI ",
    //     "FULA ",
    //     "FUNDACION (ZONA URBANA) ",
    //     "FUNDACION DE PERAVIA",
    //     "FUNDACION PANAL ",
    //     "FUNDACION",
    //     "FUNDO VIEJO",
    //     "FUQUETE",
    //     "GACELA ",
    //     "GACHITO",
    //     "GAJO ALTO",
    //     "GAJO DE LA CRUZ ",
    //     "GAJO DE LAS FLORES",
    //     "GAJO DE LOS CABALLOS",
    //     "GAJO DE LOS CAYUCOS ",
    //     "GAJO DE LOS CAYUCOS",
    //     "GAJO DE MAJAGUA ",
    //     "GAJO DE PEDRO ",
    //     "GAJO DE TORO",
    //     "GAJO DEL BOHIO",
    //     "GAJO DEL GACHO",
    //     "GAJO DEL LOCO ",
    //     "GAJO DEL MONTE",
    //     "GAJO DEL MULO ",
    //     "GAJO DEL MULO O VILLA DE LA MONTAÑA ",
    //     "GAJO DEL RANCHO ",
    //     "GAJO DEL TORO ",
    //     "GAJO IRABON",
    //     "GAJO LA YUCA",
    //     "GAJO LARGO ",
    //     "GAJO LIMON ",
    //     "GAJO LIMON",
    //     "GAJO MALO",
    //     "GALA ",
    //     "GALIFETE ",
    //     "GALINDO",
    //     "GALLABON ",
    //     "GALLINERO",
    //     "GALVAN ",
    //     "GALVAN (ZONA URBANA)",
    //     "GALVAN",
    //     "GAMAGÜEY ",
    //     "GAMUNDI",
    //     "GANADERO (ZONA URBANA)",
    //     "GANADERO NUEVO",
    //     "GANADERO VIEJO",
    //     "GANCHA ",
    //     "GANCHO AL MEDIO ",
    //     "GANCHO DE JAYA",
    //     "GANCHO DE JOBO",
    //     "GANZU",
    //     "GARANTIA ",
    //     "GARCIA ",
    //     "GARGAGUAR",
    //     "GARO ",
    //     "GASCUE ",
    //     "GASPAR HERNANDEZ (ZONA URBANA)",
    //     "GAUTIER (ZONA URBANA) ",
    //     "GAUTIER RURAL ",
    //     "GAUTIER",
    //     "GAVILAN ABAJO ",
    //     "GAVILAN",
    //     "GAVIOTA",
    //     "GAZCUE ",
    //     "GENAO",
    //     "GENARO ",
    //     "GENERAL ANTONIO DUVERGE ",
    //     "GENESIS",
    //     "GENIMILLO",
    //     "GENIMO ",
    //     "GEORGE ",
    //     "GEORGIA",
    //     "GERMANIA ",
    //     "GERONIMO LOPEZ",
    //     "GETSEMANI",
    //     "GIBRALTAR",
    //     "GILBRALTAR ",
    //     "GILDAMAR ",
    //     "GIMIO EL BUEY ",
    //     "GINA CLARA (JAGUA CLARA)",
    //     "GINANDIANA ",
    //     "GLITERIA ",
    //     "GOMEZ",
    //     "GONZALO (ZONA URBANA) ",
    //     "GONZALO",
    //     "GORRETA",
    //     "GOYO VIEJO ",
    //     "GOZUELA",
    //     "GRAFIS ",
    //     "GRAGEA ",
    //     "GRAN DIABLO",
    //     "GRAN PARADA ABAJO ",
    //     "GRAN PARADA AFUERA",
    //     "GRAN PARADA ARRIBA",
    //     "GRAN PARADA",
    //     "GRAN PODER DE DIOS",
    //     "GRANADA",
    //     "GREGORIO ",
    //     "GREGORIO (PARTE)",
    //     "GREGORIO LUPERON 01 ",
    //     "GREGORIO LUPERON I",
    //     "GREGORIO LUPERON II ETAPA ",
    //     "GREGORIO LUPERON O LA GALLERA ",
    //     "GREGORIO LUPERON",
    //     "GROMA",
    //     "GRULLON PRIMERA ETAPA ",
    //     "GUABINA",
    //     "GUACARITAS ",
    //     "GUACAYA",
    //     "GUACHIMÁN",
    //     "GUACHUPITA ",
    //     "GUACHUPITA-LOSCALLEJONES 04 ",
    //     "GUACO (LA PISTA)",
    //     "GUACO (LA PIÑITA) ",
    //     "GUACO (LA PI�ITA)",
    //     "GUACO LOS FRIAS ",
    //     "GUACO",
    //     "GUACONEJAL ",
    //     "GUACONEJO",
    //     "GUAGÜI ",
    //     "GUAITABON",
    //     "GUAJACA",
    //     "GUAJIMIA ",
    //     "GUALETE (ZONA URBANA) ",
    //     "GUALETE ABAJO ",
    //     "GUALETE AL MEDIO",
    //     "GUALETE ARRIBA",
    //     "GUALETE",
    //     "GUALETICO",
    //     "GUALEY ",
    //     "GUAMA ABAJO",
    //     "GUAMA ARRIBA O LA GUAMA ",
    //     "GUAMACAGE (PAPAYO)",
    //     "GUAMACHA ",
    //     "GUAMANAL O GUAMACHAL",
    //     "GUAMAR ",
    //     "GUAMIRA",
    //     "GUAMITA O GUAMA ABAJO ",
    //     "GUANABANITO",
    //     "GUANABANO DEL LIMON ",
    //     "GUANABANO",
    //     "GUANABANOS ",
    //     "GUANAJUMA",
    //     "GUANAL ",
    //     "GUANANICO (ZONA URBANA) ",
    //     "GUANANITO",
    //     "GUANARATE",
    //     "GUANCHI",
    //     "GUANCHO (CUACHO)",
    //     "GUANIABANO ",
    //     "GUANIABANO ARRIBA (LA CEIBA)",
    //     "GUANICHITA O GUAMIRITA",
    //     "GUANITO (ZONA URBANA) ",
    //     "GUANITO O CENTRO DEL PUEBLO ",
    //     "GUANITO",
    //     "GUANO O LOS MUERTOS ",
    //     "GUANUMA",
    //     "GUANUMITA",
    //     "GUAO ABAJO ",
    //     "GUARAGUAO",
    //     "GUARAGURITO",
    //     "GUARALBANA O GUANALBANA ",
    //     "GUARANAL ",
    //     "GUARAPITO",
    //     "GUARAPO",
    //     "GUARDA RAYA",
    //     "GUARDARRAYA DE BAITOA ",
    //     "GUARDARRAYA DE NAIBOA ",
    //     "GUARDARRAYA",
    //     "GUARDIA DEL CAFE",
    //     "GUARDIA VIEJA ",
    //     "GUARDIANON ",
    //     "GUAREY ",
    //     "GUAREY ARRIBA ",
    //     "GUARICANO CENTRAL ",
    //     "GUARICANO O JARRO SUCIO ",
    //     "GUARICANO",
    //     "GUARIONEX",
    //     "GUAROA ",
    //     "GUASOSA",
    //     "GUATAPANA",
    //     "GUATAPANAL ",
    //     "GUATAPANAL O GUAYACANAL (ANT. LA PUERCA)",
    //     "GUATAPANAL O GUAYACANAL (LA PUERCA) ",
    //     "GUATEMALA",
    //     "GUATINIQUIN",
    //     "GUAUCI ",
    //     "GUAUCI ABAJO",
    //     "GUAUCI ARRIBA ",
    //     "GUAYABAL ",
    //     "GUAYABAL (ZONA URBANA)",
    //     "GUAYABAL AFUERA ",
    //     "GUAYABAL AL MEDIO O CENTRO",
    //     "GUAYABAL ARRIBA ",
    //     "GUAYABAL",
    //     "GUAYABALES ",
    //     "GUAYABILLO ",
    //     "GUAYABITO",
    //     "GUAYABO (ZONA URBANA) ",
    //     "GUAYABO DULCE ",
    //     "GUAYABO DULCE (ZONA URBANA) ",
    //     "GUAYABO",
    //     "GUAYACAN ",
    //     "GUAYACANAL ",
    //     "GUAYACANES ",
    //     "GUAYACANESADENTRO ",
    //     "GUAYAJAYUCO",
    //     "GUAYAYAL ",
    //     "GUAYMATE (ZONA URBANA)",
    //     "GUAYMOROTE ",
    //     "GUAYUBIN (ZONA URBANA)",
    //     "GUAYUBINCITO",
    //     "GUAYUYAL ",
    //     "GUAYUYAL DEL AGUACATE ",
    //     "GUAYUYAL DEL AGUACATE",
    //     "GUAYUYAL",
    //     "GUAYUYO ADENTRO ",
    //     "GUAYUYO AFUERA",
    //     "GUAYUYO",
    //     "GUAZABARA",
    //     "GUAZARA",
    //     "GUAZARAL ",
    //     "GUAZARAL ADENTRO 09 ",
    //     "GUAZUMA",
    //     "GUAZUMAL ",
    //     "GUAZUMAL ABAJO",
    //     "GUAZUMAL ARRIBA ",
    //     "GUAZUMAL LICEY (GUAZUMAL ABAJO) ",
    //     "GUAZUMAL-EL CHIVO ",
    //     "GUAZUMILLA ",
    //     "GUAZUMITA",
    //     "GUERRA CENTRO ",
    //     "GUILLO ",
    //     "GUINDADERO ",
    //     "GUINEO PERDIDO",
    //     "GUIRE (AGUIRRE) ",
    //     "GUIRI GUIRI",
    //     "GURABITO ",
    //     "GURABITO DE YAROA ",
    //     "GURABO ",
    //     "GURABO ABAJO",
    //     "GURABO ADENTRO",
    //     "GURABO AFUERA ",
    //     "GURABO AL MEDIO ",
    //     "GURABO ARRIBA ",
    //     "GURABO DULCE",
    //     "GURABO O FLOR DE GURABO ",
    //     "GUSTAVO O EL HOSPITAL ",
    //     "GUZMAN ",
    //     "GUZMANCITO ",
    //     "GÜIZA",
    //     "GÜIZARA",
    //     "G�IZA",
    //     "HABANERO ",
    //     "HABITACION LOS CACERES",
    //     "HABITACIONAL CONSUELO (GEORGE)",
    //     "HACIENDA ESTRELLA ",
    //     "HACIENDA PALMERAL ",
    //     "HAINA",
    //     "HAINAMOSA",
    //     "HAITI BONITO",
    //     "HAITI CHIQUITO",
    //     "HAITI LA CUEVA",
    //     "HAITI",
    //     "HARAS NACIONALES",
    //     "HATICO ",
    //     "HATICO DE JEREMIAS",
    //     "HATICO DE PLATANAL",
    //     "HATICO VIEJO",
    //     "HATILLO (JATILLO) ",
    //     "HATILLO DE AZUA ",
    //     "HATILLO PALMA ",
    //     "HATILLO PALMA (ZONA URBANA) ",
    //     "HATILLO PALMA ADENTRO ",
    //     "HATILLO SAN LORENZO ",
    //     "HATILLO",
    //     "HATILLO-LAS HOJAS ANCHAS",
    //     "HATO ABAJO ",
    //     "HATO ARRIBA",
    //     "HATO BONITO",
    //     "HATO DAMAS ",
    //     "HATO DE MANA",
    //     "HATO DE SAN PEDRO ",
    //     "HATO DEL MEDIO ABAJO",
    //     "HATO DEL MEDIO ADENTRO",
    //     "HATO DEL MEDIO ARRIBA ",
    //     "HATO DEL PADRE",
    //     "HATO DEL YAQUE (ZONA URBANA)",
    //     "HATO DEL YAQUE ABAJO",
    //     "HATO FINO",
    //     "HATO MAIZ",
    //     "HATO MAYOR ",
    //     "HATO MAYOR DEL REY (ZONA URBANA)",
    //     "HATO MAYOR O LA LAJA",
    //     "HATO NUEVO ",
    //     "HATO NUEVO CORTES ",
    //     "HATO NUEVO CORTES (ZONA URBANA) ",
    //     "HATO NUEVO CORTES",
    //     "HATO ROSARIO",
    //     "HATO SAN PEDRO",
    //     "HATO SANTIAGO ",
    //     "HATO VIEJO ",
    //     "HATO VIEJO (AZUCEY) ",
    //     "HATO VIEJO ARRIBA ",
    //     "HATO VIEJO O SANTOME",
    //     "HENEQUEN ",
    //     "HERMANAS MIRABAL O LAS YAGÜITAS DEL EJIDO 01",
    //     "HERMANAS MIRABAL",
    //     "HERMANAS MIRABAL, CAMPO DE AVIACION O ANACAONA",
    //     "HERMANOS MEDINA ",
    //     "HERMANOS SERRET ",
    //     "HERMITA DEL BLANCO-ERMITA ",
    //     "HERNANDO ALONZO (ZONA URBANA) ",
    //     "HERRERA DE CUABA",
    //     "HERRERA",
    //     "HERVIDOR ",
    //     "HICACAL",
    //     "HICACO O EL ALTO DE LA BATATA ",
    //     "HICO MARTINEZ ",
    //     "HICOTEA",
    //     "HIDALGO",
    //     "HIGO BARBU ",
    //     "HIGO BONITO",
    //     "HIGO CLARO ",
    //     "HIGO DE AGUA",
    //     "HIGO DE LA CRUZ ",
    //     "HIGO DE LAS TRES PIERNAS",
    //     "HIGO GORDO ",
    //     "HIGOS CLAROS",
    //     "HIGUA",
    //     "HIGUAMO O BATEY HIGUAMO ",
    //     "HIGUAMO",
    //     "HIGUERA ABAJO ",
    //     "HIGUERETA",
    //     "HIGUERITO",
    //     "HIGUERO ABAJO ",
    //     "HIGÜERITO (CASA COLORADA) ",
    //     "HIGÜERITO (LOS PEREZ) ",
    //     "HIGÜERITO ABAJO ",
    //     "HIGÜERITO ARRIBA",
    //     "HIGÜERITO O LUCERO",
    //     "HIGÜERITO",
    //     "HIGÜERITO-LA FACTORIA ",
    //     "HIGÜERITO-PEÑUELA ",
    //     "HIGÜERO ABAJO ",
    //     "HIGÜERO",
    //     "HILARIO MARTINEZ 09 ",
    //     "HIPOLITO BILLINI",
    //     "HIPOLITO PERALTA",
    //     "HOJA ANCHA ",
    //     "HOJAS ANCHAS",
    //     "HOLGUIN MARTE ",
    //     "HOLGUIN",
    //     "HOLLYWOOD",
    //     "HONDO VALLE (ZONA URBANA) ",
    //     "HONDO VALLE",
    //     "HONDURAS ",
    //     "HONDURAS DEL NORTE",
    //     "HONDURAS DEL OESTE",
    //     "HORIZONTE DEL ATLANTICO (VILLA SANCHEZ) ",
    //     "HORIZONTE",
    //     "HORMIGO",
    //     "HORMIGUERO ",
    //     "HOSPEDAJE YAQUE ",
    //     "HOTEL MONTAÑA (EL PUERTO) 02",
    //     "HOTEL Y CASINO COSTA DORADA ",
    //     "HOYA BELLACA",
    //     "HOYA CAUTIVA",
    //     "HOYA DEL CAIMITO",
    //     "HOYA FRESCA",
    //     "HOYA GRANDE O LAS TABLITAS",
    //     "HOYA GRANDE",
    //     "HOYA REDONDA",
    //     "HOYO BONITO",
    //     "HOYO CAMPO ",
    //     "HOYO CLARO ",
    //     "HOYO DE BAO",
    //     "HOYO DE BARTOLA ",
    //     "HOYO DE CHULIN",
    //     "HOYO DE HIGÜERO ",
    //     "HOYO DE JAYA",
    //     "HOYO DE JULIAN",
    //     "HOYO DE LA CIGUA",
    //     "HOYO DE LOLA",
    //     "HOYO DE LOS COROZOS ",
    //     "HOYO DE LUIS",
    //     "HOYO DE MEREGILDO ",
    //     "HOYO DE ORO",
    //     "HOYO DE RAMON ",
    //     "HOYO DEL BARRO",
    //     "HOYO DEL CACAO",
    //     "HOYO DEL TORO ",
    //     "HOYO FRIO",
    //     "HOYO GRANDE",
    //     "HOYO HONDO ",
    //     "HOYO JAYA (ZONA URBANA) ",
    //     "HOYO LIBRE ",
    //     "HOYO NUEVO ",
    //     "HOYO OSCURO",
    //     "HOYO PRIETO",
    //     "HOYO SANCHEZ",
    //     "HOYO SIN FIN",
    //     "HOYO VIEJO ",
    //     "HOYONCITO",
    //     "HOYOS OSCUROS ",
    //     "HOZARO ",
    //     "HUECO-HOYO DE LA PIEDRA ",
    //     "HUEVITO",
    //     "HUGAMBA DE GUACHUPITA ",
    //     "HUGAMBA",
    //     "HUMACHON ",
    //     "HUNDIDERA",
    //     "HUNDIDEROS ",
    //     "IGUANA ABAJO",
    //     "IGUANA ARRIBA ",
    //     "IGUANIONA (MUELLE DE QUISQUEYA) ",
    //     "IMBERT BARRERAS ",
    //     "INAJE",
    //     "INCA ",
    //     "INDEPENDENCIA ",
    //     "INDIO VIEJO",
    //     "INDRHI ",
    //     "INDUSTRIA DE ALIMENTO ",
    //     "INDUVECA ",
    //     "INES ",
    //     "INESPRE",
    //     "INGCO",
    //     "INGENGE",
    //     "INGENIO ABAJO ",
    //     "INGENIO AMISTAD ",
    //     "INGENIO ANGELINA",
    //     "INGENIO ARRIBA",
    //     "INGENIO CAEI",
    //     "INGENIO CRISTOBAL COLON ",
    //     "INGENIO NUEVO ",
    //     "INGENIO PORVENIR",
    //     "INGENIO RIO HAINA ",
    //     "INGENIO SANTA FE",
    //     "INGENIO",
    //     "INOA ",
    //     "INOA ABAJO ",
    //     "INOA ARRIBA",
    //     "INVI ",
    //     "INVI I ",
    //     "INVI II",
    //     "INVI PARTE ATRAS",
    //     "INVI SUR ",
    //     "INVI-CEA ",
    //     "INVI-MOSA",
    //     "INVI-VILLA PROGRESO ",
    //     "INVI-VILLA PROGRESO O EL PLAY ",
    //     "INVI-VILLA PROGRESO-ARENOSO ",
    //     "INVIVIENDA ",
    //     "ISABEL DE TORRES",
    //     "ISABEL VILAS",
    //     "ISABELA",
    //     "ISABELITA I",
    //     "ISABELITA",
    //     "ISIDRO MARTINEZ ",
    //     "ISLA BEATA ",
    //     "ISLA CATALINA ",
    //     "ISLA DE ADON",
    //     "ISLABON",
    //     "ISLETA ",
    //     "ISMAEL JIMENEZ O LAS GARZAS ",
    //     "ISSFAPOL ",
    //     "ITABO O URBANIZACION ANTERA MOTA",
    //     "ITABO",
    //     "JABABA ",
    //     "JABABA AL MEDIO ",
    //     "JABABA ARRIBA ",
    //     "JABILLA GORDA I ",
    //     "JABILLA GORDA II 09 ",
    //     "JACAGUA ABAJO ",
    //     "JACAGUA ADENTRO ",
    //     "JACAGUA AL MEDIO",
    //     "JACAGUA ARRIBA",
    //     "JACAGUA",
    //     "JACKSON",
    //     "JAGUA ABAJO",
    //     "JAGUA ARRIBA",
    //     "JAGUA CAÍDA",
    //     "JAGUA DULCE",
    //     "JAGUA GORDA",
    //     "JAGUA MACHO",
    //     "JAGUA MOCHA O LAS ESPINAS ",
    //     "JAGUA MOCHA",
    //     "JAGUAL ",
    //     "JAGÜERA",
    //     "JAGÜEY ",
    //     "JAGÜITA",
    //     "JAIBON ",
    //     "JAIBON ARRIBA O LA LOMERA ",
    //     "JAIBON O PUEBLO NUEVO (ZONA URBANA) ",
    //     "JAIQUI ",
    //     "JAIQUI PICAO ABAJO (AJI PICAO ABAJO)",
    //     "JAIQUI PICAO ARRIBA (AJI PICAO ARRIBA)",
    //     "JAIQUI PICAO",
    //     "JALISCO",
    //     "JALONGA",
    //     "JAMAMU ",
    //     "JAMAMUCITO ",
    //     "JAMAO ADENTRO ",
    //     "JAMAO AFUERA (ZONA URBANA)",
    //     "JAMAO AFUERA O EL PUENTE",
    //     "JAMAO AL NORTE (ZONA URBANA)",
    //     "JAMEY",
    //     "JAMO ARRIBA O JAMO AFUERA ",
    //     "JAMO JARDETA",
    //     "JAMO LA BARRANQUITA ",
    //     "JANABITO ",
    //     "JANABO ",
    //     "JANEY",
    //     "JANICO (ZONA URBANA)",
    //     "JAPON",
    //     "JAQUEY ",
    //     "JAQUIME",
    //     "JAQUIMEYES ",
    //     "JAQUIMEYES (ZONA URBANA)",
    //     "JARABACOA (ZONA URBANA) ",
    //     "JARAGUA",
    //     "JARAMILLO",
    //     "JARDIN BOTANICO ",
    //     "JARDIN ZOOLOGICO",
    //     "JARDINES DE ALMA ROSA ",
    //     "JARDINES DE BOCA CHICA 10 ",
    //     "JARDINES DE ENGOMBE ",
    //     "JARDINES DEL ATLANTICO (G)",
    //     "JARDINES DEL CARIBE ",
    //     "JARDINES DEL ESTE ",
    //     "JARDINES DEL OESTE",
    //     "JARDINES DEL OZAMA I",
    //     "JARDINES DEL OZAMA II ",
    //     "JARDINES DEL SUR",
    //     "JARDINES UNIVERSITARIOS ",
    //     "JARDINES VERDES ",
    //     "JARRO SUCIO",
    //     "JATUBEY",
    //     "JAYA ",
    //     "JAYABITO ",
    //     "JAYABO ADENTRO",
    //     "JAYABO AFUERA ",
    //     "JAYABO AL MEDIO ",
    //     "JAYACO ",
    //     "JAYACO (ZONA URBANA)",
    //     "JAYACO ABAJO",
    //     "JAYACO ARRIBA ",
    //     "JAYAN",
    //     "JAYAQUITO",
    //     "JENGIBRE ",
    //     "JEREMIAS ",
    //     "JEREMIAS O NUEVO",
    //     "JERINGA",
    //     "JERONIMO LOPEZ",
    //     "JERUSALEM",
    //     "JEÑO ",
    //     "JIBE ",
    //     "JICOME ",
    //     "JICOME ABAJO",
    //     "JICOME ARRIBA (RURAL) ",
    //     "JIGÜEY ",
    //     "JIMA ",
    //     "JIMA (CRISTO REY) ",
    //     "JIMA ABAJO (ZONA URBANA)",
    //     "JIMANI (ZONA URBANA)",
    //     "JIMANI NUEVO O CENTRO DEL PUEBLO",
    //     "JIMANI VIEJO",
    //     "JIMAYACO ",
    //     "JIMAYACO ABAJO",
    //     "JIMAYACO ARRIBA ",
    //     "JIMENEZ ABAJO ",
    //     "JIMENEZ",
    //     "JIMINILLO",
    //     "JINA CLARA ",
    //     "JINA COPIOSA",
    //     "JINA JARAGUA",
    //     "JINAMAGAO ABAJO ",
    //     "JINAMAGAO ARRIBA",
    //     "JINOVA ABAJO",
    //     "JINOVA AL MEDIO ",
    //     "JINOVA ARRIBA ",
    //     "JOA",
    //     "JOBA ARRIBA (D.M.)",
    //     "JOBA ARRIBA (ZONA URBANA) ",
    //     "JOBA ARRIBA",
    //     "JOBITO ",
    //     "JOBITOS",
    //     "JOBO BONITO",
    //     "JOBO CLARO ",
    //     "JOBO CORCOVADO",
    //     "JOBO DULCE ",
    //     "JOBO DULCE ADENTRO",
    //     "JOBO DULCE AFUERA ",
    //     "JOBO DULCE O LA PEONIA",
    //     "JOBO GRANDE",
    //     "JOBO JAGÜEY",
    //     "JOBO LARGO ",
    //     "JOBOBAN",
    //     "JOCO VIEJO ",
    //     "JOHN F. KENNEDY ",
    //     "JOLIU",
    //     "JOLUPO ",
    //     "JORJILLO (ZONA URBANA)",
    //     "JORUNGO",
    //     "JOSAFA ",
    //     "JOSE CONTRERAS (ZONA URBANA)",
    //     "JOSE CONTRERAS",
    //     "JOSE FRANCISCO PEÑA GOMEZ ",
    //     "JOSE HORACIO RODRIGUEZ",
    //     "JOSE JOAQUIN PUELLO ",
    //     "JOSE JOAQUIN",
    //     "JOSE LEON",
    //     "JOSE LETA",
    //     "JOSE LUCAS ",
    //     "JOSE OLIVARES ",
    //     "JOSE PAULINO",
    //     "JOSESITO ",
    //     "JOSUE",
    //     "JOVAYAL",
    //     "JOYA DE RAMON ",
    //     "JOZADEROS (HOZADEROS) ",
    //     "JUAN ADRIAN (ZONA URBANA) ",
    //     "JUAN ADRIAN",
    //     "JUAN ALVAREZ",
    //     "JUAN ANTONIO ALIX ",
    //     "JUAN BARON ",
    //     "JUAN BECERRO",
    //     "JUAN BROWN ",
    //     "JUAN CANO",
    //     "JUAN DE DIOS",
    //     "JUAN DE HERRERA ",
    //     "JUAN DE HERRERA (ZONA URBANA) ",
    //     "JUAN DE NINA",
    //     "JUAN DINGA ",
    //     "JUAN DOLIO ",
    //     "JUAN ESTEBAN",
    //     "JUAN FELIPE",
    //     "JUAN FINO",
    //     "JUAN GARCIA",
    //     "JUAN GOMEZ ",
    //     "JUAN GORIS ",
    //     "JUAN GRANDE",
    //     "JUAN ISIDRO",
    //     "JUAN JIMENEZ",
    //     "JUAN LOCKWARD O NUEVO MONTELLANO",
    //     "JUAN LOPEZ ",
    //     "JUAN LOPEZ (ZONA URBANA)",
    //     "JUAN LOPEZ ABAJO",
    //     "JUAN LOPEZ ARRIBA ",
    //     "JUAN LOPITO",
    //     "JUAN LUCIANO",
    //     "JUAN LUIS",
    //     "JUAN MANUEL VALDEZ",
    //     "JUAN PABLO DUARTE ",
    //     "JUAN PABLO DUARTE 10",
    //     "JUAN PABLO DUARTE O KILOMETRO 6 ",
    //     "JUAN PABLO DUARTE O KILOMETRO SEIS",
    //     "JUAN PABLO DUARTE O LA JAGUA",
    //     "JUAN PABLO DUARTE O NUEVO ",
    //     "JUAN PEDRO ",
    //     "JUAN PIO ",
    //     "JUAN REYES ",
    //     "JUAN ROMAN ",
    //     "JUAN SANCHEZ",
    //     "JUAN SANTIAGO ",
    //     "JUAN SANTIAGO (ZONA URBA",
    //     "JUAN TOMAS ",
    //     "JUANA ALEJO",
    //     "JUANA ALVAREZ ",
    //     "JUANA COTES",
    //     "JUANA DIAZ ABAJO",
    //     "JUANA DIAZ ARRIBA ",
    //     "JUANA JICO ",
    //     "JUANA LORENZA ",
    //     "JUANA LORENZA (BUENA VISTA) ",
    //     "JUANA RODRIGUEZ (JUANA RODRIGUEZ ARRIBA)",
    //     "JUANA SALTITOPA ",
    //     "JUANA VICENTA ",
    //     "JUANCHO (ZONA URBANA) ",
    //     "JUANILLO ",
    //     "JUBERO ",
    //     "JUBILEO",
    //     "JUGADERO ",
    //     "JULIAN SUARDI ",
    //     "JULIETA MORALES ",
    //     "JULIO GÜILLAMO",
    //     "JULUPE ",
    //     "JUMA ADENTRO",
    //     "JUMA BEJUCAL (ZONA URBANA)",
    //     "JUMUNUCO ",
    //     "JUNCALITO (ZONA URBANA) ",
    //     "JUNCALITO ABAJO ",
    //     "JUNCALITO ARRIBA",
    //     "JUNCO VERDE",
    //     "JUNDA JUNDA",
    //     "JUNQUITO ",
    //     "JUNUMUCU ",
    //     "JURA ",
    //     "JURUNGO",
    //     "KATANGA",
    //     "KG ",
    //     "KILOMETRO 1",
    //     "KILOMETRO 10 DE CUMAYASA",
    //     "KILOMETRO 10",
    //     "KILOMETRO 100 ",
    //     "KILOMETRO 101 ",
    //     "KILOMETRO 11",
    //     "KILOMETRO 12 NORTE (LA HURCA) ",
    //     "KILOMETRO 12 SUR",
    //     "KILOMETRO 12",
    //     "KILOMETRO 14",
    //     "KILOMETRO 14½ ",
    //     "KILOMETRO 16",
    //     "KILOMETRO 17",
    //     "KILOMETRO 18",
    //     "KILOMETRO 2 Y MEDIO ",
    //     "KILOMETRO 2",
    //     "KILOMETRO 22",
    //     "KILOMETRO 26",
    //     "KILOMETRO 28",
    //     "KILOMETRO 3",
    //     "KILOMETRO 30",
    //     "KILOMETRO 36, CARRETERA MELLA ",
    //     "KILOMETRO 36B ",
    //     "KILOMETRO 3½",
    //     "KILOMETRO 4",
    //     "KILOMETRO 40",
    //     "KILOMETRO 45",
    //     "KILOMETRO 48",
    //     "KILOMETRO 4½(ANTIGUO KILOMETRO 6) ",
    //     "KILOMETRO 5",
    //     "KILOMETRO 56",
    //     "KILOMETRO 59",
    //     "KILOMETRO 5½ (ANTIGUO KILOMETRO 6½) ",
    //     "KILOMETRO 6",
    //     "KILOMETRO 6½ (ANTIGUO KILOMETRO 7)",
    //     "KILOMETRO 7",
    //     "KILOMETRO 8 1/2 DE LA INDEPENDENCIA",
    //     "KILOMETRO 8",
    //     "KILOMETRO 9",
    //     "KILOMETRO CINCO (5) ",
    //     "KILOMETRO CUATRO (4)",
    //     "KILOMETRO XI",
    //     "KILOMETRO",
    //     "KILOMETROS 11 AL 15 ",
    //     "KILOMETROS 11, 12 Y 13",
    //     "KILOMETROY MEDIO",
    //     "KILÓMETRO 20",
    //     "KILÓMETRO 23",
    //     "KILÓMETRO 25 Y 26 ",
    //     "KM 3 ",
    //     "KM 4 ",
    //     "KM. 12 ",
    //     "KM. 13 ",
    //     "KOREA",
    //     "LA 24",
    //     "LA 40 (LA CUARENTA) ",
    //     "LA 40",
    //     "LA 42",
    //     "LA ACEQUIA ",
    //     "LA AGUADA",
    //     "LA AGUAITA ",
    //     "LA AGUJETA ",
    //     "LA AGUSTINA",
    //     "LA AGUSTINITA ",
    //     "LA AGÜITA",
    //     "LA AGÜITAS ",
    //     "LA AHUMADA ",
    //     "LA ALBINA",
    //     "LA ALCANTARILLA ",
    //     "LA ALMENDRA",
    //     "LA ALTAGRACIA ",
    //     "LA ALTAGRACIA (RAMONCITO) ",
    //     "LA ALTAGRACIA (ZONA URBANA) ",
    //     "LA ALTAGRACIA AL NORTE",
    //     "LA ALTAGRACIA IL",
    //     "LA ALTAGRACIA LL",
    //     "LA ALTAGRACIA O CENTRO DEL PUEBLO ",
    //     "LA ALTAMISA",
    //     "LA AMAPOLA ",
    //     "LA AMARGA",
    //     "LA AMARGURA",
    //     "LA AMERICANA",
    //     "LA ANACAGÜITA ",
    //     "LA ANACAHUITA ",
    //     "LA ANGOLA",
    //     "LA ANGOSTURA",
    //     "LA ANTENA MILITAR ",
    //     "LA ANTENA O LA TORRE",
    //     "LA ANTENA",
    //     "LA ANTONA",
    //     "LA ARBIÑA",
    //     "LA ARBIÑITA",
    //     "LA ARCILLA ",
    //     "LA ARENA ",
    //     "LA ARENA (EL PLAY)",
    //     "LA ARTEMISA O LA ALTAMISA ",
    //     "LA ASOCIACION ",
    //     "LA ATARAZANA",
    //     "LA ATOLLADERA ",
    //     "LA ATRAVESADA ",
    //     "LA AUYAMA",
    //     "LA AVANZADA",
    //     "LA AVIACION",
    //     "LA BABOSA",
    //     "LA BAHIA ",
    //     "LA BAHIA DE MAIMON (S.D.) ",
    //     "LA BAITOA",
    //     "LA BAITOITA ARRIBA",
    //     "LA BAJADA DEL BLANCO",
    //     "LA BAJADA",
    //     "LA BALLENA ",
    //     "LA BALSA ",
    //     "LA BANANERA",
    //     "LA BARBACOA",
    //     "LA BARCA ",
    //     "LA BARITA",
    //     "LA BARQUITA",
    //     "LA BARRA ",
    //     "LA BARRANCA",
    //     "LA BARRANQUITA",
    //     "LA BARRERA ",
    //     "LA BASE",
    //     "LA BASILICA",
    //     "LA BASTIDA ",
    //     "LA BASURA",
    //     "LA BATATA",
    //     "LA BATEA ",
    //     "LA BECERRERA",
    //     "LA BEJUCURA",
    //     "LA BEJUQUERA",
    //     "LA BELLACA ",
    //     "LA BELLEZA ",
    //     "LA BERENGENA (BERENJENA)",
    //     "LA BERENJENA O LOS TABITA ",
    //     "LA BERENJENA",
    //     "LA BERLETA (LAS PLACETAS) ",
    //     "LA BERMA ",
    //     "LA BERMA (EL GUANAL)",
    //     "LA BERMA DEL CANAL",
    //     "LA BERRAZA ",
    //     "LA BERRAZA (LA BERRASA) ",
    //     "LA BESTIA DE ATABALERO",
    //     "LA BESTIA DE LA MALENA",
    //     "LA BESTIA",
    //     "LA BIJA (ZONA URBANA) ",
    //     "LA BIJA",
    //     "LA BLANCA",
    //     "LA BOBINA",
    //     "LA BOCA DE ESTANCIA ",
    //     "LA BOCA DE JIMA ",
    //     "LA BOCA DE LA TOMA",
    //     "LA BOCA DE UNIJICA",
    //     "LA BOCA DEL ARROYO",
    //     "LA BOCA DEL SONADOR ",
    //     "LA BOCA",
    //     "LA BOCAINA ",
    //     "LA BOLITA",
    //     "LA BOMBA ",
    //     "LA BOMBA DE YAIBA ",
    //     "LA BOMBITA ",
    //     "LA BOMBITA",
    //     "LA BONITA",
    //     "LA BOQUITA ",
    //     "LA BOQUITA",
    //     "LA BORDA ",
    //     "LA BOTELLA ",
    //     "LA BOTIJA",
    //     "LA BOTIJUELA",
    //     "LA BOYA",
    //     "LA BOZUA ",
    //     "LA BREÑA ",
    //     "LA BREÑA ABAJO",
    //     "LA BRIGIDA ",
    //     "LA BRUCA ",
    //     "LA BRUJA ",
    //     "LA BRUJA",
    //     "LA BRUSCA",
    //     "LA BUCARA",
    //     "LA BURRA ",
    //     "LA CABALLERIZA",
    //     "LA CABEZA",
    //     "LA CABIRMA ",
    //     "LA CABIRMITA",
    //     "LA CABIRMOTA",
    //     "LA CABRA ",
    //     "LA CABRA-EL CERRO ",
    //     "LA CABRERA ",
    //     "LA CABRIA",
    //     "LA CABUYA",
    //     "LA CACATA O LA UNION",
    //     "LA CACATA",
    //     "LA CACHAZA ",
    //     "LA CACHIMBA",
    //     "LA CACIQUE ",
    //     "LA CAGUAZA ",
    //     "LA CAIDA ",
    //     "LA CALABACITA ",
    //     "LA CALABAZA",
    //     "LA CALABERNA",
    //     "LA CALETA (ZONA URBANA) ",
    //     "LA CALETA",
    //     "LA CALLE ",
    //     "LA CAMPANA ",
    //     "LA CAMPAÑA ",
    //     "LA CANA DE HATO NUEVO 07",
    //     "LA CANA",
    //     "LA CANAS ",
    //     "LA CANASTA ",
    //     "LA CANASTICA O CANASTILLA ",
    //     "LA CANCHA",
    //     "LA CANDELA ",
    //     "LA CANDELARIA ",
    //     "LA CANELA (ZONA URBANA) ",
    //     "LA CANELA",
    //     "LA CANELILLA",
    //     "LA CANGREJERA ",
    //     "LA CANOA ",
    //     "LA CANTERA ",
    //     "LA CAOBA ",
    //     "LA CAOBA O CAOBETA",
    //     "LA CAOBANA ",
    //     "LA CAOBANA O LA CAOBA ",
    //     "LA CAOBANITA",
    //     "LA CAOBITA ",
    //     "LA CAPILLA ",
    //     "LA CAPITALISTA",
    //     "LA CAPITALITA ",
    //     "LA CARABELA",
    //     "LA CARIBE",
    //     "LA CARIDAD ",
    //     "LA CARITA",
    //     "LA CARIÑOSA",
    //     "LA CARMELITA",
    //     "LA CARMONA ",
    //     "LA CARRETERA",
    //     "LA CASITA",
    //     "LA CASTELLANA ",
    //     "LA CASTILLA",
    //     "LA CATALINA",
    //     "LA CAYA",
    //     "LA CAYENA",
    //     "LA CAYOTA",
    //     "LA CAÑA",
    //     "LA CAÑADA DEL CAFE",
    //     "LA CAÑADA DEL RIO ",
    //     "LA CAÑADA O LA LOMITA ",
    //     "LA CAÑAITA ",
    //     "LA CAÑITA (EL ESCARBADO)",
    //     "LA CAÑITA",
    //     "LA CEBOLLA ",
    //     "LA CEIBA ",
    //     "LA CEIBA ABAJO",
    //     "LA CEIBA ADENTRO",
    //     "LA CEIBA ARRIBA ",
    //     "LA CEIBA DE BONET ",
    //     "LA CEIBA DE MADERA",
    //     "LA CEIBA GORDA",
    //     "LA CEIBA NUEVA",
    //     "LA CEIBA VIEJA",
    //     "LA CEIBITA ",
    //     "LA CEIBITA ABAJO-HIGO ",
    //     "LA CEIBITA ARRIBA ",
    //     "LA CEITA ",
    //     "LA CEJA (BATEY LA MAYA) ",
    //     "LA CEJA (MATA SANTIAGO DE MENA) ",
    //     "LA CEJA",
    //     "LA CEJITA",
    //     "LA CELESTINA",
    //     "LA CEMENTERA",
    //     "LA CENIZA",
    //     "LA CENTRAL (ARROYO SALADO)",
    //     "LA CERA",
    //     "LA CERCA ",
    //     "LA CERCA",
    //     "LA CERVECERIA ",
    //     "LA CHAMUSCADA ",
    //     "LA CHANCLETA",
    //     "LA CHANGÜELA",
    //     "LA CHAPITA ",
    //     "LA CHARCA",
    //     "LA CHICHARRA",
    //     "LA CHICHIGUA",
    //     "LA CHINA ",
    //     "LA CHINA O VILLA NAVARRO",
    //     "LA CHINA",
    //     "LA CHINOLA ",
    //     "LA CHIVERA ",
    //     "LA CHORRERA",
    //     "LA CIDRA ",
    //     "LA CIDRA-LA GINITA",
    //     "LA CIDRITA ",
    //     "LA CIEN MIL-LA PIEDRA ",
    //     "LA CIENAGA ",
    //     "LA CIENAGA (ZONA URBANA)",
    //     "LA CIENAGA AL MEDIO ",
    //     "LA CIENAGA DE LOS POCITOS ",
    //     "LA CIENAGA VIEJA",
    //     "LA CIENAGUITA ",
    //     "LA CIENAGUITA O YUNA",
    //     "LA CIGUA ",
    //     "LA CIGUAPA ",
    //     "LA CIMARRA ",
    //     "LA CINCUENTA",
    //     "LA CIRUELA ",
    //     "LA CLINICA ",
    //     "LA COLA DE LOS ROLONES",
    //     "LA COLA",
    //     "LA COLECITA ARRIBA",
    //     "LA COLINA ARRIBA",
    //     "LA COLINA DE LOS POMOS",
    //     "LA COLINA I",
    //     "LA COLINA II",
    //     "LA COLINA III ",
    //     "LA COLINA",
    //     "LA COLMENA ",
    //     "LA COLMENAS",
    //     "LA COLONIA ",
    //     "LA COLONIA (ZONA URBANA)",
    //     "LA COLONIA AGRARIA",
    //     "LA COLONIA ESPAÑOLA ",
    //     "LA COLONIA ESPA�OLA",
    //     "LA COLONIA HUNGARA O EL DISTRITO",
    //     "LA COLONIA JAPONESA ",
    //     "LA COLONIA LIBERTADOR ",
    //     "LA COLONIA O EL JOBITO",
    //     "LA COLONIA O LINDO",
    //     "LA COLONIAL",
    //     "LA COLORADA",
    //     "LA COMPUERTA",
    //     "LA CONCE ",
    //     "LA CONCHA",
    //     "LA CONCORDIA",
    //     "LA CONGA ",
    //     "LA CONSTITUCION ",
    //     "LA CONSTRUCCION ",
    //     "LA CONSTRUCCION",
    //     "LA COPLA ",
    //     "LA COQUERA ",
    //     "LA CORAZA",
    //     "LA CORCOBADA (CORCOVADA)",
    //     "LA CORCOVADA",
    //     "LA CORPORACION",
    //     "LA CORPORANEA ",
    //     "LA CORTADERA",
    //     "LA CORTINA ",
    //     "LA COSTA ",
    //     "LA COTORRA ",
    //     "LA COYERA",
    //     "LA CRUZ (LA CRUZ DE YASICA) ",
    //     "LA CRUZ DE ANGELINA ",
    //     "LA CRUZ DE ESCALERA ABAJO ",
    //     "LA CRUZ DE LOS CALABOZOS",
    //     "LA CRUZ DE LOS RONDONES ",
    //     "LA CRUZ DE PALO VERDE ",
    //     "LA CRUZ DE SANTIAGO ",
    //     "LA CRUZ DE VICENTE O EL 5 ",
    //     "LA CRUZ DE VICENTE",
    //     "LA CRUZ DEL NARANJAL",
    //     "LA CRUZ",
    //     "LA CU",
    //     "LA CUABA ",
    //     "LA CUABA (BARRIO SAN JOSE)",
    //     "LA CUABA (ZONA URBANA)",
    //     "LA CUABA ABAJO",
    //     "LA CUABA ARRIBA 09",
    //     "LA CUABA O CUBANA ",
    //     "LA CUABITA ",
    //     "LA CUADRA",
    //     "LA CUARENTA (LA 40) ",
    //     "LA CUARENTA",
    //     "LA CUBA",
    //     "LA CUBANA",
    //     "LA CUCAMA",
    //     "LA CUCARACHA",
    //     "LA CUCARITA",
    //     "LA CUCHARA ",
    //     "LA CUCHARETA",
    //     "LA CUCHILLA DE LA GUARDIA ",
    //     "LA CUCHILLA",
    //     "LA CUCURUCHA",
    //     "LA CUENDA",
    //     "LA CUESTA (ZONA URBANA) ",
    //     "LA CUESTA DE LA VACA",
    //     "LA CUESTA",
    //     "LA CUEVA ",
    //     "LA CUEVA (ZONA URBANA)",
    //     "LA CUEVA DE LUIS",
    //     "LA CUEVA DEL DUEY ",
    //     "LA CUEVA",
    //     "LA CULATA AL MEDIO",
    //     "LA CULATA ARRIBA",
    //     "LA CULATA",
    //     "LA CULATICA",
    //     "LA CULEBRA ",
    //     "LA CUMBA ",
    //     "LA CUMBRE (GURABITO LA CUMBRE)",
    //     "LA CUMBRE 2",
    //     "LA CUMBRE ABAJO ",
    //     "LA CUMBRE",
    //     "LA CUNA",
    //     "LA CUNETA",
    //     "LA CURTIEMBRE ",
    //     "LA CURVA ",
    //     "LA CURVA (EL AGUACATE)",
    //     "LA CURVA O LA CULATA",
    //     "LA CURVA O LA PLANTA DE GAS ",
    //     "LA DAMAJAGUA 05 ",
    //     "LA DAMAJAGUA O FORTUNA",
    //     "LA DAMAJAGUA",
    //     "LA DAMAJUANA O LA DAMAJAGUA ",
    //     "LA DAMAYA-LA DAMAIJA",
    //     "LA DELGADA ",
    //     "LA DELGADA ARRIBA ",
    //     "LA DELICIA ",
    //     "LA DESCUBIERTA (ZONA URBANA)",
    //     "LA DESCUBIERTA",
    //     "LA DESEADA ",
    //     "LA DESTILADERA 02 ",
    //     "LA DIVISORIA",
    //     "LA DUARTE",
    //     "LA E ",
    //     "LA ELBA",
    //     "LA EMBAJADA",
    //     "LA EMBOSCADA",
    //     "LA EMISORA ",
    //     "LA EMPANADA",
    //     "LA ENCANTADA",
    //     "LA ENEA",
    //     "LA ENRAMADA",
    //     "LA ENSENADA ABAJO-ALTO DEL NARANJO",
    //     "LA ENSENADA",
    //     "LA ENTRADA ",
    //     "LA ENTRADA (ZONA URBANA)",
    //     "LA ENTRADA DE LAS CABIRMAS",
    //     "LA ERMITA DE SANTA ANA",
    //     "LA ERMITA DE TAMBORIL ",
    //     "LA ERMITA O NAJAYO EN MEDIO ",
    //     "LA ERMITA",
    //     "LA ERMITA-LA HERMIDA",
    //     "LA ESCALERETA ",
    //     "LA ESCUCHADERA",
    //     "LA ESCUELA ",
    //     "LA ESCUELA O EL CALLEJON DE LA TOMA ",
    //     "LA ESCUELA O ENSANCHE ESCOLAR ",
    //     "LA ESMERALDA (HOYO DE MACHUCA)",
    //     "LA ESMERALDA",
    //     "LA ESPARGATA",
    //     "LA ESPENSA ",
    //     "LA ESPERANZA II ",
    //     "LA ESPERANZA O EL HOYO",
    //     "LA ESPERANZA O MOSCU",
    //     "LA ESPERANZA O VILLA ESPERANZA",
    //     "LA ESPERANZA",
    //     "LA ESPERILLA",
    //     "LA ESPINOLA I ",
    //     "LA ESPINOLA II",
    //     "LA ESPINOLA III ",
    //     "LA ESQUINA ",
    //     "LA ESTACA",
    //     "LA ESTACION",
    //     "LA ESTANCIA O ANSONIA ",
    //     "LA ESTANCIA O ANSONIA",
    //     "LA ESTANCIA",
    //     "LA ESTRECHURA ",
    //     "LA ESTRECHURA DE LA NEGRA ",
    //     "LA ESTRELLA VIEJA 09",
    //     "LA ESTRELLADORA ",
    //     "LA ESTRELLETA ",
    //     "LA EXCAVACION ",
    //     "LA EXPLANACION",
    //     "LA FACILIDAD",
    //     "LA FACTORIA",
    //     "LA FACUNDA ",
    //     "LA FALDIQUERA ",
    //     "LA FARDIQUERA ",
    //     "LA FE (ANTIGUO LA TETA) ",
    //     "LA FE",
    //     "LA FELICIANA",
    //     "LA FELICITA",
    //     "LA FERIA ",
    //     "LA FILIPINA",
    //     "LA FINCA ",
    //     "LA FLACA ",
    //     "LA FLECHA",
    //     "LA FLOR",
    //     "LA FLORIDA ",
    //     "LA FORTALEZA VIEJA",
    //     "LA FORTALEZA",
    //     "LA FORTUNA ",
    //     "LA FRANCIA ",
    //     "LA FRANJA",
    //     "LA FREIDURIA O FARDIQUERA ",
    //     "LA FRISA ",
    //     "LA FRONTERA",
    //     "LA FRUTA ",
    //     "LA FUENTE ARRIBA",
    //     "LA FUENTE",
    //     "LA FURNIA (LA BOCA) ",
    //     "LA FURNIA (RINCON DE LOS JIMENEZ) ",
    //     "LA FURNIA (RINCON DE LOS JIMENEZ)",
    //     "LA FURNIA",
    //     "LA GALANA",
    //     "LA GALETA O LA GOLETA ",
    //     "LA GALLERA ",
    //     "LA GALLERA O EL MULTIUSO",
    //     "LA GALLERA O ENTRE REYES",
    //     "LA GALLERA O LOS REDIMIDOS",
    //     "LA GALLERA VIEJA",
    //     "LA GALLINA ",
    //     "LA GARATA",
    //     "LA GARITA",
    //     "LA GARRAPATA",
    //     "LA GARZA ",
    //     "LA GATA",
    //     "LA GINA (LA GINITA) ",
    //     "LA GINA (LA TITA) ",
    //     "LA GINA (ZONA URBANA) ",
    //     "LA GINA MARCADA ",
    //     "LA GINA",
    //     "LA GINITA",
    //     "LA GIRONDA ",
    //     "LA GLORIA",
    //     "LA GOBERNACION O LAS FLORES ",
    //     "LA GOLETA 1",
    //     "LA GOLETA 2",
    //     "LA GOLONDRINA ",
    //     "LA GOMA",
    //     "LA GORRA ",
    //     "LA GORRETA ",
    //     "LA GOTERA",
    //     "LA GOYA",
    //     "LA GRAMITA ",
    //     "LA GRAN CHORRA",
    //     "LA GRAN PARADA O PUEBLO ABAJO ",
    //     "LA GRAN PARADA",
    //     "LA GRANA ",
    //     "LA GRANCERA",
    //     "LA GRANJA",
    //     "LA GRIEGA",
    //     "LA GRIMOSA ",
    //     "LA GRITONA ",
    //     "LA GRUA",
    //     "LA GUA ( LA AGUADA) ",
    //     "LA GUABINA ",
    //     "LA GUACARA ",
    //     "LA GUACIMA ",
    //     "LA GUACIMA (LA GUAZUMA) ",
    //     "LA GUAITA (LA AGUADITA) ",
    //     "LA GUAJABA ",
    //     "LA GUAJACA ",
    //     "LA GUAMA ",
    //     "LA GUAMA (DE GUANABANO) ",
    //     "LA GUAMA ABAJO",
    //     "LA GUAMA ARRIBA ",
    //     "LA GUAMA DE JUNUMUCU",
    //     "LA GUAMA O LA GUANIA",
    //     "LA GUAMITA ",
    //     "LA GUAMITA PRESA DE YEGUA ",
    //     "LA GUAMITA",
    //     "LA GUANABANA",
    //     "LA GUANDULERA ",
    //     "LA GUANITA ",
    //     "LA GUARANA ",
    //     "LA GUARANITA",
    //     "LA GUARAPA ",
    //     "LA GUARDARRAYA",
    //     "LA GUARDIA ",
    //     "LA GUARDIA ABAJO 09 ",
    //     "LA GUARDIA ABAJO 09",
    //     "LA GUARDIA ARRIBA 09",
    //     "LA GUARDIA O CARLOS DANIEL",
    //     "LA GUARIDA ",
    //     "LA GUASIMA ",
    //     "LA GUASUMA ",
    //     "LA GUAYIGA ",
    //     "LA GUAYIGA (ZONA URBANA)",
    //     "LA GUAZABARA",
    //     "LA GUAZARA ",
    //     "LA GUAZARA (ZONA URBANA)",
    //     "LA GUAZARA ABAJO",
    //     "LA GUAZARA O CENTRO DEL PUEBLO",
    //     "LA GUAZARITA (CAMPECHE ARRIBA DE CASTILLO)",
    //     "LA GUAZARITA",
    //     "LA GUAZUMA ",
    //     "LA GUAZUMA",
    //     "LA GUAZUMITA",
    //     "LA GUIA",
    //     "LA GUINEA",
    //     "LA HABANA",
    //     "LA HABITACION ",
    //     "LA HACIENDA MARIA ",
    //     "LA HEBRA ",
    //     "LA HERRADURA ABAJO",
    //     "LA HERRADURA ARRIBA ",
    //     "LA HERRADURA",
    //     "LA HICOTEA ",
    //     "LA HIGUERA ",
    //     "LA HIGUERETA",
    //     "LA HIGUERITA (LA HIGUERETA) ",
    //     "LA HIGÜERA ",
    //     "LA HONDONADA",
    //     "LA HONDURA ",
    //     "LA HORA DE DIOS ",
    //     "LA HORCA ",
    //     "LA HORMA ",
    //     "LA HORMIGA ",
    //     "LA HORQUETA",
    //     "LA HORTENSIA O RABO DURO",
    //     "LA HOYA",
    //     "LA HUAZUMITA (GUAZUMITA)",
    //     "LA IGLESIA ",
    //     "LA IGUANA",
    //     "LA IMAGEN",
    //     "LA INFINITA",
    //     "LA ISABELA ",
    //     "LA ISABELA (ZONA URBANA)",
    //     "LA ISABELA ARRIBA ",
    //     "LA ISABELITA",
    //     "LA ISLA",
    //     "LA ISLETA",
    //     "LA ISLETA-CAÑO ARENOSO",
    //     "LA ISLITA",
    //     "LA JABILLA ",
    //     "LA JABILLA O LA OTRA BANDA",
    //     "LA JACAGUA ",
    //     "LA JAGUA ",
    //     "LA JAGUA ABAJO",
    //     "LA JAGUA ARRIBA ",
    //     "LA JAGUA MOCHA",
    //     "LA JAGUA O LA VAGUA ",
    //     "LA JAGÜITA ",
    //     "LA JAIBA ",
    //     "LA JAIBA (ZONA URBANA)",
    //     "LA JAIBA O LA JAMBA ",
    //     "LA JAINERA (HAINERA)",
    //     "LA JAQUETA ",
    //     "LA JARDA ",
    //     "LA JARDA DE HOYO CLARO",
    //     "LA JARDA DE LOS LIRIOS",
    //     "LA JARDA U HOYO CLARO ",
    //     "LA JARDETA ",
    //     "LA JARDITA ",
    //     "LA JAVILLA ",
    //     "LA JIBARA",
    //     "LA JICOTEA ",
    //     "LA JINA HUECA ",
    //     "LA JINA HUECA (ZONA URBANA) ",
    //     "LA JINA O JANA",
    //     "LA JINA",
    //     "LA JIQUIMA ",
    //     "LA JO",
    //     "LA JOBITA O LA JUBITA ",
    //     "LA JOTA",
    //     "LA JOYA (RINCON)",
    //     "LA JOYA ABAJO ",
    //     "LA JOYA ARRIBA",
    //     "LA JOYA DE PAULINO",
    //     "LA JOYA DEL MANGO ",
    //     "LA JOYA I",
    //     "LA JOYA II ",
    //     "LA JOYA III",
    //     "LA JOYA O LA JOYA DEL TETERO",
    //     "LA JOYA O LOS GOYA",
    //     "LA JOYA",
    //     "LA JOYA-LA JAGUA",
    //     "LA JOYITA",
    //     "LA JUDEA ",
    //     "LA JULIA ",
    //     "LA JULIANA ABAJO",
    //     "LA JULIANA ARRIBA ",
    //     "LA JUNTA ",
    //     "LA JUSTICIA",
    //     "LA LADRILLADA ",
    //     "LA LAGAÑOSA",
    //     "LA LAGUNA DE SABANA ",
    //     "LA LAGUNA O PEÑA BELLO",
    //     "LA LAGUNA",
    //     "LA LAGUNETA",
    //     "LA LAGUNITA DEL QUEMAO",
    //     "LA LAGUNITA",
    //     "LA LAJA",
    //     "LA LAJITA DE ANTONIO MORETA ",
    //     "LA LAJITA O ALTO VELO ",
    //     "LA LAJITA",
    //     "LA LAMBEDERA",
    //     "LA LAMEDERA",
    //     "LA LANA O LA CALLE DE LA BEBIDA ",
    //     "LA LANA",
    //     "LA LANZA ABAJO",
    //     "LA LANZA ARRIBA ",
    //     "LA LATA",
    //     "LA LECHOSA ",
    //     "LA LECHUGA ",
    //     "LA LECHUZA ",
    //     "LA LECHUZA O EL CUAYO ",
    //     "LA LEGAMOSA",
    //     "LA LEONA ",
    //     "LA LEONOR",
    //     "LA LEONORA ",
    //     "LA LETI",
    //     "LA LEÑA",
    //     "LA LIBERTAD",
    //     "LA LICA",
    //     "LA LILA",
    //     "LA LIMA",
    //     "LA LIMONERA",
    //     "LA LISITA (LA LUISITA)",
    //     "LA LISSA ",
    //     "LA LISTA ",
    //     "LA LISTA",
    //     "LA LLANADA ",
    //     "LA LLANADA GRANDE O CAÑADA GRANDE ",
    //     "LA LLANADITA",
    //     "LA LLOVEDERA",
    //     "LA LOGIA ",
    //     "LA LOMA ARENITA ",
    //     "LA LOMA DE COMEDERO ",
    //     "LA LOMA DE LAS CAOBAS ",
    //     "LA LOMA DEL CHIVO ",
    //     "LA LOMA",
    //     "LA LOMETA",
    //     "LA LOMETICA",
    //     "LA LOMITA DE GUACO",
    //     "LA LOMITA DE LA YAGÜIZA ",
    //     "LA LOMITA DE LOS SALAZAR",
    //     "LA LOMITA DEL PALMAR ABAJO",
    //     "LA LOMITA O EL CORRAL ",
    //     "LA LOMITA O MELENDEZ",
    //     "LA LOMITA",
    //     "LA LOMOTA",
    //     "LA LORETA",
    //     "LA LOTERIA ",
    //     "LA LUISA ",
    //     "LA LUISA BLANCA ",
    //     "LA LUISA PRIETA ",
    //     "LA LUPERONA",
    //     "LA LUZ ",
    //     "LA MADAMA",
    //     "LA MADEJA",
    //     "LA MADERA",
    //     "LA MADRE ",
    //     "LA MADRECITA",
    //     "LA MAGDALENA",
    //     "LA MAGUANA ",
    //     "LA MAGUANITA",
    //     "LA MAJAGUA ",
    //     "LA MAJAGUA (GUACHUPITA) ",
    //     "LA MAJAGUA ABAJO",
    //     "LA MAJAGUA ARRIBA ",
    //     "LA MAJAGUA ARRIBA",
    //     "LA MAJAGUA",
    //     "LA MAJAGUITA",
    //     "LA MAJAGÜITA",
    //     "LA MAJUANA ",
    //     "LA MALA PASADA",
    //     "LA MALAGUETA",
    //     "LA MALANGA ",
    //     "LA MALENA DE JAYA ",
    //     "LA MALENA O CRUCE DE LA MALENA",
    //     "LA MALENA",
    //     "LA MALENITA O LA LOMASA ",
    //     "LA MALENITA",
    //     "LA MALEZA",
    //     "LA MALLITA ",
    //     "LA MANACLA ",
    //     "LA MANACLAS",
    //     "LA MANACLITA",
    //     "LA MANCHA",
    //     "LA MANGA ",
    //     "LA MANGA ARRIBA ",
    //     "LA MANICERA",
    //     "LA MANIGUA ",
    //     "LA MANIGÜITA",
    //     "LA MANSION ",
    //     "LA MANTECA ",
    //     "LA MARA",
    //     "LA MARAVILLA",
    //     "LA MARCA ",
    //     "LA MARGA ",
    //     "LA MARGARITA",
    //     "LA MARIHUANA",
    //     "LA MARINA",
    //     "LA MARINUELA",
    //     "LA MARIPOSA",
    //     "LA MARIQUITA",
    //     "LA MATA (BOBA)",
    //     "LA MATA (ZONA URBANA) ",
    //     "LA MATA CIMARRONA ",
    //     "LA MATA DE LIMON",
    //     "LA MATA DE PLATANO",
    //     "LA MATA PUERCOS ",
    //     "LA MATA",
    //     "LA MATICA",
    //     "LA MATILLA ",
    //     "LA MAYA",
    //     "LA MAYITA",
    //     "LA MEDIA LUNA ",
    //     "LA MEDITERRANEA ",
    //     "LA MELLA ",
    //     "LA MESA",
    //     "LA MESETA ABAJO ",
    //     "LA MESETA ARRIBA",
    //     "LA MESETA",
    //     "LA MESOPOTAMIA",
    //     "LA MEZCLA",
    //     "LA MIGAJA",
    //     "LA MILAGROSA O PROYECTO SAN MIGUEL",
    //     "LA MILAGROSA",
    //     "LA MINA ARRIBA",
    //     "LA MINA DE LOS PEYNADO (MINA VIEJA) ",
    //     "LA MINA",
    //     "LA MINITA",
    //     "LA MIREYA",
    //     "LA MISERICORDIA DE DIOS O LOS MANANTIALES ",
    //     "LA MITAD ",
    //     "LA MOCHA ",
    //     "LA MOLEDORA",
    //     "LA MONJA ",
    //     "LA MONTAÑITA",
    //     "LA MONTEADA",
    //     "LA MONTEADITA ",
    //     "LA MONTERIA",
    //     "LA MONTOSA ",
    //     "LA MORA O NIGUA ABAJO ",
    //     "LA MORA",
    //     "LA MORALEJA",
    //     "LA MOSCA ",
    //     "LA MOZADERA O LA HOZADERA ",
    //     "LA MUDA",
    //     "LA MUJARRA (MOJARRA)",
    //     "LA MULA",
    //     "LA MULATA (PARTE) ",
    //     "LA MULATA",
    //     "LA MULITA DE GUAYABAL ",
    //     "LA MUNICION",
    //     "LA NASA",
    //     "LA NAVAJA",
    //     "LA NEVERA",
    //     "LA NORIA ",
    //     "LA NORIEGA ",
    //     "LA NORITA",
    //     "LA NOVILLA ",
    //     "LA NOVILLA O VILLA ESPERANZA",
    //     "LA NUEVA ESPERANZA",
    //     "LA NUEZ",
    //     "LA NUNUTA",
    //     "LA OCTAVA",
    //     "LA ORQUETA ",
    //     "LA ORTEGA (ZONA URBANA) ",
    //     "LA ORTEGA ABAJO ",
    //     "LA OSUA",
    //     "LA OTRA BANDA ",
    //     "LA OTRA BANDA (ZONA URBANA) ",
    //     "LA OTRA VERA O LOS CRUCES 02",
    //     "LA OTRA VERA",
    //     "LA OZUA",
    //     "LA PAILITA ",
    //     "LA PALMA ",
    //     "LA PALMA HERRADA",
    //     "LA PALMERA ",
    //     "LA PALMILLA O VILLA BALAGUER",
    //     "LA PALMILLA",
    //     "LA PALMITA ",
    //     "LA PALMITA ABAJO",
    //     "LA PALMITA ARRIBA ",
    //     "LA PALMITA II ",
    //     "LA PALOMA",
    //     "LA PANGOLA ",
    //     "LA PARCELA ",
    //     "LA PARED ",
    //     "LA PARIA ",
    //     "LA PASCUALA O LA PASCUAZA ",
    //     "LA PASCUALA",
    //     "LA PASTILLA",
    //     "LA PATANA",
    //     "LA PATILLA ",
    //     "LA PATILLA",
    //     "LA PATIYA (LA PATILLA)",
    //     "LA PAZ ",
    //     "LA PAZ O LA CHINA ",
    //     "LA PAZ O LA GARATA",
    //     "LA PAZ",
    //     "LA PEGAJOSA",
    //     "LA PEGUERA ",
    //     "LA PEGUERA",
    //     "LA PEGUERO ",
    //     "LA PEGUERO",
    //     "LA PELADA",
    //     "LA PELOTA",
    //     "LA PELUA ",
    //     "LA PENCA ",
    //     "LA PENCA (KILOMETRO 20 DE LA AUTOPISTA DUARTE)",
    //     "LA PENDA ",
    //     "LA PENDULA ",
    //     "LA PEONIA",
    //     "LA PERDIZ",
    //     "LA PERONIA ",
    //     "LA PERONILA",
    //     "LA PERRITA ",
    //     "LA PEÑA (LA PEÑA ARRIBA)",
    //     "LA PEÑA (ZONA URBANA) ",
    //     "LA PEÑA ABAJO ",
    //     "LA PEÑA",
    //     "LA PEÑITA ABAJO ",
    //     "LA PEÑITA",
    //     "LA PEÑUELA ",
    //     "LA PICADORA",
    //     "LA PICANTINA O JOSE FRANCISCO PEÑA GOMEZ",
    //     "LA PICHINGA",
    //     "LA PIEDRA",
    //     "LA PIEZA ",
    //     "LA PILETA",
    //     "LA PINTA ",
    //     "LA PIONIA",
    //     "LA PIRAGUA ",
    //     "LA PIRAGUA AL MEDIO ",
    //     "LA PISCINA ",
    //     "LA PISTA ",
    //     "LA PIÑA I",
    //     "LA PIÑA II ",
    //     "LA PIÑA",
    //     "LA PIÑITA (S.D.)",
    //     "LA PIÑITA",
    //     "LA PLACETA ",
    //     "LA PLACETA (EL PALMAR)",
    //     "LA PLACETA (LAS TRES CASITAS) ",
    //     "LA PLACETA DE YUNA",
    //     "LA PLACETA",
    //     "LA PLANTA O EL GAJO ",
    //     "LA PLANTA",
    //     "LA PLATA ",
    //     "LA PLAYA ",
    //     "LA PLAYA DEL MUERTO ",
    //     "LA PLAYA DEL VALLE",
    //     "LA PLAYITA ",
    //     "LA PLAZA ",
    //     "LA PLAZA (BATEY LA PLAZA) ",
    //     "LA PLAZOLETA",
    //     "LA PLENA ",
    //     "LA PLUMA ",
    //     "LA PLUMITA ",
    //     "LA POCILGA ",
    //     "LA POCILGA (DURALIZA ULLOA) ",
    //     "LA POCILGA",
    //     "LA POCILGUITA ",
    //     "LA POLICIA ",
    //     "LA POLICIA O URBANIZACION PALMA REAL",
    //     "LA POLICLINICA",
    //     "LA POLONIA ",
    //     "LA POTRANCA",
    //     "LA POTRICA ",
    //     "LA POZA PRIETA",
    //     "LA POZA",
    //     "LA PRESA ",
    //     "LA PRESA (S.D.) ",
    //     "LA PRIMAVERA",
    //     "LA PRIMER AGUA",
    //     "LA PRINGAMOSA (PRINGAMOZA)",
    //     "LA PRIVADA ",
    //     "LA PUENTECITA ",
    //     "LA PUERTA BLANCA",
    //     "LA PUERTA DE SANTA FE ",
    //     "LA PUERTA DEL MULO",
    //     "LA PUERTA",
    //     "LA PULGA ",
    //     "LA PULLA ",
    //     "LA PUNTA ",
    //     "LA PUNTA DEL CERRO",
    //     "LA PUNTA PESCADORA",
    //     "LA PUYA",
    //     "LA Q ",
    //     "LA QUEBRADA",
    //     "LA QUEBRADITA ",
    //     "LA RACIMERA",
    //     "LA RAFAELA ",
    //     "LA RAIZ DE LA PALMA ",
    //     "LA RAIZ",
    //     "LA RANCHA",
    //     "LA RAPADURA",
    //     "LA RAQUETA ",
    //     "LA RAYA O EL MANGO",
    //     "LA RECTA ",
    //     "LA RECTA DE SANITA",
    //     "LA REDENCION",
    //     "LA REDONDA ",
    //     "LA REDONDA (TIERRA COLORADA, EL ABANICO)",
    //     "LA REFORMA ",
    //     "LA REGADERA",
    //     "LA REGOLA O ENSANCHE EDUARDO BRITO",
    //     "LA REGOLA",
    //     "LA REJOLLA ",
    //     "LA REPRESA ",
    //     "LA RESBALOSA",
    //     "LA RESTAURACION 10",
    //     "LA RIGOLITA",
    //     "LA RINCONADA",
    //     "LA RIVERA DEL ESTE",
    //     "LA RIVERA DEL NORTE ",
    //     "LA RIVERA DEL OESTE ",
    //     "LA RIVERA",
    //     "LA ROCETA",
    //     "LA RODA",
    //     "LA ROMANA (ZONA URBANA) ",
    //     "LA ROMANA",
    //     "LA ROMERA",
    //     "LA ROSA DE MOCA ",
    //     "LA ROSA O GRAN PLENA",
    //     "LA ROSA",
    //     "LA ROSA-LA COLONIA",
    //     "LA ROSALEDA",
    //     "LA ROTONDA ",
    //     "LA RUFINA",
    //     "LA RUSIA ",
    //     "LA SABANA (S.D.)",
    //     "LA SABANA ABAJO ",
    //     "LA SABANA DE COMEDERO (ZONA URBANA) ",
    //     "LA SABANA DE LOS DOMINGUEZ",
    //     "LA SABANA DE MANIEL ",
    //     "LA SABANA DE RIO VERDE 02 ",
    //     "LA SABANA DEL HATO",
    //     "LA SABANA DEL SUR ",
    //     "LA SABANA O LAS SABANAS ",
    //     "LA SABANA O PUEBLO ABAJO",
    //     "LA SABANA O SAN MIGUEL",
    //     "LA SABANA",
    //     "LA SABANETA",
    //     "LA SABANITA REDONDA ",
    //     "LA SABANITA",
    //     "LA SABILA",
    //     "LA SABINA (ZONA URBANA) ",
    //     "LA SABINA",
    //     "LA SAFRA ",
    //     "LA SAHONADA ARRIBA",
    //     "LA SAHONADA",
    //     "LA SAL ",
    //     "LA SALADA",
    //     "LA SALADILLA",
    //     "LA SALINA",
    //     "LA SALSA O LA ZARZA ",
    //     "LA SALVADORA",
    //     "LA SALVIA",
    //     "LA SANGRE",
    //     "LA SANGRIA ",
    //     "LA SAONA ",
    //     "LA SAVITA O CRUCE DE MELO 09",
    //     "LA SAVITA",
    //     "LA SECADORA",
    //     "LA SEIBA (LA CEIBA) ",
    //     "LA SELVA ",
    //     "LA SENDA ",
    //     "LA SEQUIA",
    //     "LA SIDRA ",
    //     "LA SIEMBRA ",
    //     "LA SIEMBRA (ZONA URBANA)",
    //     "LA SIEMBRA O LA SIEMBRITA ",
    //     "LA SIEMBRITA",
    //     "LA SIERRA (ALTO DE LAS FLORES)",
    //     "LA SIERRA",
    //     "LA SIERRECITA ",
    //     "LA SIERRITA",
    //     "LA SILVERIO",
    //     "LA SILVERITA",
    //     "LA SIRENA O LA PENDA",
    //     "LA SOLAO ",
    //     "LA SOLEDAD ",
    //     "LA SOMBRA",
    //     "LA SORIA (KILOMETRO 6)",
    //     "LA SOSA",
    //     "LA SOYA (SOYO)",
    //     "LA SUBIDA DE LOS MUERTOS",
    //     "LA SUCESION",
    //     "LA SUFRIDERA",
    //     "LA SUIZA ",
    //     "LA TABLITA ",
    //     "LA TACHUELA",
    //     "LA TAINA ",
    //     "LA TALA DE SANCHEZ",
    //     "LA TALA",
    //     "LA TARANA",
    //     "LA TASAJERA",
    //     "LA TAYOTA (S.D.)",
    //     "LA TAYOTA",
    //     "LA TEJA",
    //     "LA TELANZA ",
    //     "LA TERRAZA ",
    //     "LA TIERRA",
    //     "LA TINA",
    //     "LA TINAJA O TINAJITA",
    //     "LA TINAJA",
    //     "LA TINAJITA",
    //     "LA TOMA ARRIBA",
    //     "LA TOMA",
    //     "LA TORMENTA",
    //     "LA TORONJA ",
    //     "LA TORRE ",
    //     "LA TORRE O IMBERT ",
    //     "LA TOTUMA",
    //     "LA TOZA",
    //     "LA TRANCA",
    //     "LA TRANQUERA",
    //     "LA TRAVESIA DEL MULO",
    //     "LA TRAVESIA",
    //     "LA TREPADA ",
    //     "LA TRINCHERA",
    //     "LA TRINITARIA ",
    //     "LA TRINITARIA 01",
    //     "LA TROCHA (LA TOCHA)",
    //     "LA TROCHA DE LAGUNA CLARA ",
    //     "LA TROCHA",
    //     "LA TRONCHA ",
    //     "LA TUATUA",
    //     "LA TUMBA ",
    //     "LA TUNA",
    //     "LA TUNITA",
    //     "LA TUSA",
    //     "LA U ",
    //     "LA UNIDAD",
    //     "LA UNION ",
    //     "LA URCA",
    //     "LA UREÑA ",
    //     "LA UVA ",
    //     "LA UVITA ",
    //     "LA VACA",
    //     "LA VECINA",
    //     "LA VEGANA",
    //     "LA VENTA ",
    //     "LA VERA DEL RIO ",
    //     "LA VEREDA ATRAVESADA",
    //     "LA VEREDA DE DICHOSO",
    //     "LA VEREDA DEL DEMAJAGUAL",
    //     "LA VEREDA NUEVA ",
    //     "LA VEREDA",
    //     "LA VIAJACA ",
    //     "LA VIARA ",
    //     "LA VIBORA",
    //     "LA VICTORIA (ZONA URBANA) ",
    //     "LA VICTORIA (ZONA URBANA)",
    //     "LA VICTORIA",
    //     "LA VIGIA ",
    //     "LA VIGIA (CAJAREQUE)",
    //     "LA VILLA ",
    //     "LA VILLA NUEVA",
    //     "LA VILLITA ",
    //     "LA VIOLETA ",
    //     "LA VIRGEN DE LA PIEDRA",
    //     "LA VIRGEN",
    //     "LA VIUDA ",
    //     "LA VUELTA DE GABINO ",
    //     "LA VUELTA DE LA BARRANCA",
    //     "LA VUELTA DEL CHIVO ",
    //     "LA VUELTA",
    //     "LA YABACOA ",
    //     "LA YABACOA O BATEY YABACOA",
    //     "LA YAGUA ",
    //     "LA YAGUA (LA JAGUA) ",
    //     "LA YAGUA O LA CAYA",
    //     "LA YAGUAZA ",
    //     "LA YAGÜITA ",
    //     "LA YAGÜITA DE PASTOR",
    //     "LA YAGÜIZA ABAJO (LA PIRAGUA) ",
    //     "LA YAGÜIZA AFUERA ",
    //     "LA YAGÜIZA CENTRAL",
    //     "LA YALLITA ",
    //     "LA YAMAYAS ",
    //     "LA YAUTIA ABAJO ",
    //     "LA YAUTIA ARRIBA",
    //     "LA YAUTIA",
    //     "LA YAYA",
    //     "LA YAYAS ",
    //     "LA YAYITA",
    //     "LA YEGUA ",
    //     "LA YEGUADA ",
    //     "LA YERBA ",
    //     "LA YUCA O ATRONCA PERRO ",
    //     "LA YUCA",
    //     "LA ZAFRA ",
    //     "LA ZANJA ",
    //     "LA ZAPA ARRIBA",
    //     "LA ZAPA",
    //     "LA ZARZA ",
    //     "LA ZOLAPA (SOLAPA)",
    //     "LA ZONA",
    //     "LA ZUMBADORA (LA COLECITA)",
    //     "LA ZUMBADORA",
    //     "LA ZURZA ",
    //     "LA ZURZA I ",
    //     "LA ZURZA II",
    //     "LA ZURZA III",
    //     "LADINO ",
    //     "LAGUNA ABAJO",
    //     "LAGUNA AL MEDIO (LAGUNA DE COTO)",
    //     "LAGUNA ARRIBA ",
    //     "LAGUNA CASTILLA ",
    //     "LAGUNA CLARA",
    //     "LAGUNA COLORADA ",
    //     "LAGUNA COLORADA 09",
    //     "LAGUNA DE LA CEIBA",
    //     "LAGUNA DE MADRE VIEJA ",
    //     "LAGUNA DE YERBA O JOSADERA",
    //     "LAGUNA DEL CAIMAN ",
    //     "LAGUNA DEL DAJAO",
    //     "LAGUNA DEL DIABLO ",
    //     "LAGUNA DEL REMBLAZO ",
    //     "LAGUNA GRANDE ",
    //     "LAGUNA HONDA",
    //     "LAGUNA PRIETA ",
    //     "LAGUNA PRIETA ABAJO ",
    //     "LAGUNA PRIETA AL CENTRO ",
    //     "LAGUNA PRIETA ARRIBA",
    //     "LAGUNA RINCON (PARTE) ",
    //     "LAGUNA SALADA ",
    //     "LAGUNA SALADA (ZONA URBANA) ",
    //     "LAGUNA SALADILLO",
    //     "LAGUNA SECA",
    //     "LAGUNA VERDE",
    //     "LAGUNETA ",
    //     "LAGUNITA ",
    //     "LAJA ARRIBA",
    //     "LAJAS CAMPECHE",
    //     "LAJAS DE YAROA",
    //     "LAJAS",
    //     "LAMBADA",
    //     "LAMBEDERA",
    //     "LAMBEDEROS ",
    //     "LAMEDERO ",
    //     "LANNA GAUTIER ",
    //     "LANZA DEL NORTE ",
    //     "LAS 10 CASITAS",
    //     "LAS 12 CASITAS",
    //     "LAS 13 ",
    //     "LAS 20 CASITAS",
    //     "LAS 204",
    //     "LAS 5 CASAS",
    //     "LAS 6 CASITAS ",
    //     "LAS 80 CASITAS",
    //     "LAS ABEJAS ",
    //     "LAS ABRAS",
    //     "LAS ACACIAS",
    //     "LAS AGUAS",
    //     "LAS AGUSTINAS ",
    //     "LAS ALBAHACAS ",
    //     "LAS ALFORJAS",
    //     "LAS ALMENDRAS ",
    //     "LAS ALTAMISAS ",
    //     "LAS AMERICAS",
    //     "LAS AMÉRICAS",
    //     "LAS ANIMAS ",
    //     "LAS ANTILLAS (LOTES Y SERVICIOS II) ",
    //     "LAS ANTILLAS",
    //     "LAS ARENAS ",
    //     "LAS AREPAS ",
    //     "LAS AROMAS ",
    //     "LAS AURORAS",
    //     "LAS AUYAMAS",
    //     "LAS AVENIDAS",
    //     "LAS AVISPAS",
    //     "LAS BAITOAS",
    //     "LAS BARIAS ",
    //     "LAS BARIAS (ZONA URBANA)",
    //     "LAS BARIAS-LA ESTANCIA",
    //     "LAS BATEAS ",
    //     "LAS BAYONAS",
    //     "LAS BERBENAS",
    //     "LAS BERENJENAS",
    //     "LAS BLANCAS",
    //     "LAS BRUJAS ",
    //     "LAS BRUJAS",
    //     "LAS CABIRMAS",
    //     "LAS CABUYAS",
    //     "LAS CACATAS",
    //     "LAS CALABAZAS ",
    //     "LAS CALABAZAS",
    //     "LAS CALDERAS",
    //     "LAS CALLAS ",
    //     "LAS CANAS ABAJO ",
    //     "LAS CANAS ARRIBA",
    //     "LAS CANAS",
    //     "LAS CANAS-EL ESTRECHO ",
    //     "LAS CANELAS",
    //     "LAS CANITAS",
    //     "LAS CANOAS ",
    //     "LAS CAOBAS ",
    //     "LAS CAOBAS ABAJO",
    //     "LAS CAOBAS ADENTRO",
    //     "LAS CAOBAS ARRIBA ",
    //     "LAS CAOBAS O JARRO SUCIO",
    //     "LAS CAOBITAS",
    //     "LAS CARITAS",
    //     "LAS CARMELITAS",
    //     "LAS CARRERAS DE CEIBA ",
    //     "LAS CARRERAS",
    //     "LAS CASITAS PARTE ATRAS O CALLEJON DE TAGA",
    //     "LAS CASITAS",
    //     "LAS CAYAS",
    //     "LAS CAÑAS DE LOS UVEROS ",
    //     "LAS CAÑAS",
    //     "LAS CAÑITAS",
    //     "LAS CA�AS",
    //     "LAS CEIBAS ",
    //     "LAS CEJAS",
    //     "LAS CEJITAS",
    //     "LAS CHAMUSCADAS ",
    //     "LAS CHARCAS (D.M.)",
    //     "LAS CHARCAS (ZONA URBANA) ",
    //     "LAS CHARCAS (ZONA URBANA)",
    //     "LAS CHARCAS ABAJO ",
    //     "LAS CHARCAS DE GARABITO ",
    //     "LAS CHARCAS DE MARIA NOVA ",
    //     "LAS CHARCAS DE MARIA NOVA O LAS CHARCAS NUEVAS",
    //     "LAS CHARCAS VIEJAS",
    //     "LAS CHARCAS",
    //     "LAS CHICHARRAS",
    //     "LAS CHORRERAS ",
    //     "LAS CHUPADERAS",
    //     "LAS CIDRA",
    //     "LAS CIENAGAS",
    //     "LAS CIENES (LAS SIENES) ",
    //     "LAS CINCO CASAS ",
    //     "LAS CINCO CASAS",
    //     "LAS CINCO CASITAS ",
    //     "LAS CINCO ESQUINAS",
    //     "LAS CLARAS ",
    //     "LAS CLAVELLINAS ",
    //     "LAS CLAVELLINAS (ZONA URBANA) ",
    //     "LAS CLAVELLINAS",
    //     "LAS COJAS",
    //     "LAS COLES (ZONA URBANA) ",
    //     "LAS COLES",
    //     "LAS COLINAS DE CIENFUEGOS ",
    //     "LAS COLINAS DE DON GUILLERMO",
    //     "LAS COLINAS DEL OZAMA ",
    //     "LAS COLINAS DEL SEMINARIO I ",
    //     "LAS COLINAS O LOS COCOS ",
    //     "LAS COLINAS",
    //     "LAS COLONIAS",
    //     "LAS CORCOBAS",
    //     "LAS CORTADERAS",
    //     "LAS CRUCES ",
    //     "LAS CRUCES O LA CANTERA ",
    //     "LAS CUARENTA (LAS 40) ",
    //     "LAS CUATRO BOCAS",
    //     "LAS CUATRO CUCHARAS ",
    //     "LAS CUATRO ESQUINAS ",
    //     "LAS CUCHILLAS ",
    //     "LAS CUEVAS ",
    //     "LAS DAMAS",
    //     "LAS DELICIAS",
    //     "LAS DIANAS ",
    //     "LAS DOS BOCAS ",
    //     "LAS DOS JARDAS",
    //     "LAS DOS LOMAS ",
    //     "LAS DOS LOMAS",
    //     "LAS DOS MATAS ",
    //     "LAS DOS PALMAS",
    //     "LAS DOS ZANJAS",
    //     "LAS ENEAS",
    //     "LAS ENFERMERAS",
    //     "LAS ESCOBAS",
    //     "LAS ESPINAS",
    //     "LAS ESTANCIAS ",
    //     "LAS ESTRELLAS ",
    //     "LAS FILIPINAS ",
    //     "LAS FLORES ",
    //     "LAS FLORES O CARRERA DE YEGUAS",
    //     "LAS FLORES O EL PASAR ",
    //     "LAS FLORES O LOS CARTONES ",
    //     "LAS FRUTAS ",
    //     "LAS FUENTES DE GUAJABO",
    //     "LAS GALAXIAS",
    //     "LAS GALERAS (ZONA URBANA) ",
    //     "LAS GALERAS",
    //     "LAS GALLARDAS ",
    //     "LAS GALLARDAS (LOS BRUJANES)",
    //     "LAS GARITAS",
    //     "LAS GARZAS ",
    //     "LAS GOLONDRINAS ",
    //     "LAS GORDAS (ZONA URBANA)",
    //     "LAS GUAJACAS",
    //     "LAS GUAMAS ",
    //     "LAS GUANABANAS",
    //     "LAS GUARANAS (ZONA URBAN",
    //     "LAS GUARANAS",
    //     "LAS GUARANITAS",
    //     "LAS GUAYIGAS",
    //     "LAS GUAZARAS",
    //     "LAS GUAZUMAS",
    //     "LAS GUINEAS",
    //     "LAS GUÁRANAS (KILÓMETRO 4)",
    //     "LAS HICOTEAS",
    //     "LAS HORMIGAS",
    //     "LAS HORTENSIAS",
    //     "LAS HOYAS",
    //     "LAS HOYITAS",
    //     "LAS IGLESIAS",
    //     "LAS ISLETAS",
    //     "LAS JARDAS ",
    //     "LAS JARDETAS",
    //     "LAS JOYAS",
    //     "LAS LAGUNAS (ZONA URBANA) ",
    //     "LAS LAGUNAS ABAJO ",
    //     "LAS LAGUNAS ARRIBA",
    //     "LAS LAGUNAS DE NISIBON (ZONA URBANA)",
    //     "LAS LAGUNAS",
    //     "LAS LAGUNITAS ",
    //     "LAS LAGUNITAS",
    //     "LAS LAJAS (MANAGUA) ",
    //     "LAS LAJAS ABAJO ",
    //     "LAS LAJAS ARRIBA",
    //     "LAS LAJAS",
    //     "LAS LAJITAS",
    //     "LAS LAMBEDERAS",
    //     "LAS LANDRAS",
    //     "LAS LAVAS",
    //     "LAS LECHUZAS O LOS MORALES",
    //     "LAS LILAS",
    //     "LAS LIMAS",
    //     "LAS LISAS",
    //     "LAS LOMAS ABREU ",
    //     "LAS LOMAS",
    //     "LAS LOMETAS",
    //     "LAS MAGUANAS-HATO NUEVO (ZONA URBANA) ",
    //     "LAS MALAGUETAS",
    //     "LAS MALLITAS (LAS BOCAINAS) 05",
    //     "LAS MALVINAS",
    //     "LAS MANACLAS",
    //     "LAS MANACLITAS",
    //     "LAS MANGAS ",
    //     "LAS MANUELAS",
    //     "LAS MARAS I",
    //     "LAS MARAS",
    //     "LAS MARGARITAS",
    //     "LAS MARIAS ",
    //     "LAS MARITAS",
    //     "LAS MARTINEZ",
    //     "LAS MATAS ABAJO O PEDRO TOMAS ",
    //     "LAS MATAS DE FARFAN (ZONA URBANA) ",
    //     "LAS MATAS DE GUABATICO 09 ",
    //     "LAS MATAS DE SANTA CRUZ (ZONA URBANA) ",
    //     "LAS MATAS",
    //     "LAS MELLIZAS",
    //     "LAS MERCEDES 10 ",
    //     "LAS MERCEDES I",
    //     "LAS MERCEDES II ",
    //     "LAS MERCEDES O LOS MELLA",
    //     "LAS MERCEDES",
    //     "LAS MERCEDITAS",
    //     "LAS MESAS",
    //     "LAS MESETAS",
    //     "LAS MINAS",
    //     "LAS MONJAS ",
    //     "LAS NUECES ",
    //     "LAS OCHOCIENTAS ",
    //     "LAS OVEJAS ",
    //     "LAS PAJAS",
    //     "LAS PALERIAS",
    //     "LAS PALMAS ",
    //     "LAS PALMAS ARRIBA ",
    //     "LAS PALMAS DE ALMA ROSA ",
    //     "LAS PALMAS DE HERRERA ",
    //     "LAS PALMAS O LAS PALOMAS",
    //     "LAS PALMERAS",
    //     "LAS PALMILLAS ",
    //     "LAS PALMITAS",
    //     "LAS PALOMAS (ZONA URBANA) ",
    //     "LAS PALOMAS ABAJO ",
    //     "LAS PALOMAS ARRIBA 01 ",
    //     "LAS PALOMAS ARRIBA",
    //     "LAS PALOMAS O CENTRO DEL PUEBLO ",
    //     "LAS PALOMITAS ",
    //     "LAS PAPITAS",
    //     "LAS PAREDES O LOS PAREDONES ",
    //     "LAS PAREDES",
    //     "LAS PARRAS ",
    //     "LAS PATILLAS",
    //     "LAS PETACAS",
    //     "LAS PEÑAS",
    //     "LAS PIEDRAS",
    //     "LAS PIEDRITAS ",
    //     "LAS PIRAGUAS ABAJO",
    //     "LAS PIRAGUAS AL MEDIO ",
    //     "LAS PIRAGUAS ARRIBA ",
    //     "LAS PIRAGUAS",
    //     "LAS PIÑAS",
    //     "LAS PIÑITAS",
    //     "LAS PLACETAS (ZONA URBANA)",
    //     "LAS PLACETAS AL MEDIO ",
    //     "LAS PLACETAS ARRIBA ",
    //     "LAS PLACETAS",
    //     "LAS PLAYAS ",
    //     "LAS PLAYITAS",
    //     "LAS POCILGAS",
    //     "LAS PRADERAS DEL RIO",
    //     "LAS PRADERAS",
    //     "LAS QUINCE MIL",
    //     "LAS QUINIENTAS",
    //     "LAS RAICES ",
    //     "LAS REJOYAS",
    //     "LAS ROCAS",
    //     "LAS ROSAS",
    //     "LAS SABILAS",
    //     "LAS SABINAS",
    //     "LAS SALINAS (ZONA URBANA) ",
    //     "LAS SALINAS",
    //     "LAS SARDINAS",
    //     "LAS SARNAS ",
    //     "LAS SIETE LAGUNAS ",
    //     "LAS TARANAS (ZONA URBANA) ",
    //     "LAS TARANAS",
    //     "LAS TEJAS",
    //     "LAS TELAS",
    //     "LAS TEMBLADERAS ",
    //     "LAS TERRENAS (ZONA URBANA)",
    //     "LAS TERRERAS",
    //     "LAS TORONJAS",
    //     "LAS TOTUMAS ABAJO ",
    //     "LAS TOTUMAS O LOS TOCONES ",
    //     "LAS TRES BOCAS II ",
    //     "LAS TRES BOCAS",
    //     "LAS TRES CANAS",
    //     "LAS TRES CASITAS",
    //     "LAS TRES CEIBAS ",
    //     "LAS TRES CRUCES ",
    //     "LAS TRES PALMAS ",
    //     "LAS TRES VEREDAS",
    //     "LAS TRESCIENTAS (LAS 300) ",
    //     "LAS TUNAS",
    //     "LAS TUNITAS",
    //     "LAS UVAS ",
    //     "LAS UVITAS ",
    //     "LAS VACAMAS",
    //     "LAS VERAS",
    //     "LAS VERITAS",
    //     "LAS VIRGINIAS O EL AVISPERO ",
    //     "LAS YAGUAS ",
    //     "LAS YAYAS ABAJO ",
    //     "LAS YAYAS ABAJO",
    //     "LAS YAYAS ADENTRO ",
    //     "LAS YAYAS AFUERA",
    //     "LAS YAYAS ARRIBA - VIET-NAM ",
    //     "LAS YAYAS ARRIBA - VIET-NAM",
    //     "LAS YAYAS ARRIBA",
    //     "LAS YAYAS DE VIAJAMA (ZONA URBANA)",
    //     "LAS YAYAS DE VIAJAMA",
    //     "LAS YAYAS",
    //     "LAS YAYITAS",
    //     "LAS YERBAS ",
    //     "LAS ZANJAS ",
    //     "LAS ZONAS (MEJIA) ",
    //     "LASMERCEDES-FINCA ",
    //     "LAUREL ",
    //     "LAVADOR",
    //     "LAVAPIE",
    //     "LAVAPIES ",
    //     "LAZARO ",
    //     "LEANDRO",
    //     "LEBRON ",
    //     "LEBRONCITO ",
    //     "LECHERIA ",
    //     "LECHOSO",
    //     "LEDESMA",
    //     "LEGIA",
    //     "LEGION ",
    //     "LEMBA",
    //     "LENGUA AZUL",
    //     "LENGUA DE VACA",
    //     "LEONARDO ",
    //     "LEONARDO (EL BAÑADERO)",
    //     "LEONARDO GONZALEZ O LOS MULOS ",
    //     "LEONARDO GONZALEZ O LOS MULOS",
    //     "LEONOR I Y II ",
    //     "LEONORITA",
    //     "LIBERTAD ",
    //     "LIBERTAD (EL GUAYO) ",
    //     "LIBERTAD O JARRO SUCIO",
    //     "LIBERTAD O JUAN CASTAÑO ",
    //     "LIBERTADOR ",
    //     "LIBONAO",
    //     "LIBORIO",
    //     "LICEY AL MEDIO (ZONA URBANA)",
    //     "LICEY AL MEDIO",
    //     "LICEY",
    //     "LIMBAO ",
    //     "LIMON DULCE",
    //     "LIMONAL ABAJO ",
    //     "LIMONAL ARRIBA",
    //     "LIMONAL",
    //     "LIMONCILLO ",
    //     "LINCOLN",
    //     "LINDO O QUIJÁ QUIETA",
    //     "LINDO",
    //     "LINEA 15 ",
    //     "LINEA A",
    //     "LINEA ABAJO",
    //     "LINEA NUEVA",
    //     "LINO ABREU ",
    //     "LLANADA AL MEDIO",
    //     "LLANADA DE LOS JENGIBRES (S.D.) ",
    //     "LLANADA GRANDE",
    //     "LLANADA PARROQUIA (S.D.)",
    //     "LLANADA",
    //     "LLANO DE JAGUA",
    //     "LLANO DE JUMUNUCO 02",
    //     "LLANO DE LA CANA",
    //     "LLANO DE LA MESETA (LA MESETA ARRIBA) ",
    //     "LLANO DE LA PIONIA",
    //     "LLANO DE LA TALA",
    //     "LLANO DEL HIGO",
    //     "LLANO DEL JOBO",
    //     "LLANO GRANDE",
    //     "LLANOS DE GURABO II ",
    //     "LLANOS DEL INGENIO",
    //     "LLAVE",
    //     "LLENAS-HINCHAS",
    //     "LO MENSO ",
    //     "LO ROTO O LA PLAYA",
    //     "LODO BLANDITO ",
    //     "LOLA ",
    //     "LOLO ",
    //     "LOMA ABAJO ",
    //     "LOMA AGUA FRIA",
    //     "LOMA AL MEDIO ",
    //     "LOMA ALBANITA ",
    //     "LOMA ALTA",
    //     "LOMA AMARILLA ",
    //     "LOMA ARENITA",
    //     "LOMA ARRIBA",
    //     "LOMA ARROYO GUAYABO ",
    //     "LOMA ATRAVESADA ",
    //     "LOMA AZUL",
    //     "LOMA BAJITA",
    //     "LOMA BLANCA O LA PEONIA ",
    //     "LOMA BLANCA",
    //     "LOMA CABALLO",
    //     "LOMA CAMBELEN ",
    //     "LOMA CENOVI",
    //     "LOMA CLARA ",
    //     "LOMA COLON ",
    //     "LOMA COLORADA ",
    //     "LOMA COLORADA (EL POLVASO)",
    //     "LOMA COMEJEN (EL COMEJEN) ",
    //     "LOMA COPLIN",
    //     "LOMA DE AGRIPINO",
    //     "LOMA DE AGUA HONDA",
    //     "LOMA DE AGUA",
    //     "LOMA DE AGUACATE",
    //     "LOMA DE ALMACEY ",
    //     "LOMA DE BABOR ",
    //     "LOMA DE BABOR O ALTO DE LAS FLORES",
    //     "LOMA DE CABRERA (ZONA URBANA) ",
    //     "LOMA DE CANA",
    //     "LOMA DE CAOBAZO ",
    //     "LOMA DE CASTAÑUELAS ",
    //     "LOMA DE CAÑA",
    //     "LOMA DE COCHERO ",
    //     "LOMA DE CONSUELO",
    //     "LOMA DE COPEY ",
    //     "LOMA DE DAMAJAGUA 04",
    //     "LOMA DE FEBRILLET ",
    //     "LOMA DE FELITO",
    //     "LOMA DE GALAN ",
    //     "LOMA DE GUANANICO ",
    //     "LOMA DE GUAYABO ",
    //     "LOMA DE GUAYACANES",
    //     "LOMA DE JANICO",
    //     "LOMA DE JAYA",
    //     "LOMA DE JICOME",
    //     "LOMA DE JUANICO ",
    //     "LOMA DE JUANICO",
    //     "LOMA DE LA CAYA ",
    //     "LOMA DE LA CEIBA (LA CEIBITA) ",
    //     "LOMA DE LA CIENAGA",
    //     "LOMA DE LA CRUZ ",
    //     "LOMA DE LA GALLINA 02 ",
    //     "LOMA DE LA JAGUA",
    //     "LOMA DE LA JAIBA",
    //     "LOMA DE LA JOYA (LOMA DE LOS PAULINO) ",
    //     "LOMA DE LA LLANADA",
    //     "LOMA DE LA PALMA",
    //     "LOMA DE LA PIÑA ",
    //     "LOMA DE LA SAL",
    //     "LOMA DE LA VACA ",
    //     "LOMA DE LA YEGUA",
    //     "LOMA DE LAS BESTIAS ",
    //     "LOMA DE LAS CANAS ",
    //     "LOMA DE LAS CAOBAS",
    //     "LOMA DE LAS CIGUAS",
    //     "LOMA DE LIMÓN ",
    //     "LOMA DE LOS ANGELES ",
    //     "LOMA DE LOS BONILLA ",
    //     "LOMA DE LOS CAMACHO ",
    //     "LOMA DE LOS CHIVOS",
    //     "LOMA DE LOS GURABO",
    //     "LOMA DE LOS JOBOS ",
    //     "LOMA DE LOS MAJAGUALES",
    //     "LOMA DE LOS PALOS ",
    //     "LOMA DE LOS RIOS",
    //     "LOMA DE LOS SELECTOS",
    //     "LOMA DE MAIMON O POZO DEL MAIZ",
    //     "LOMA DE MAIMON",
    //     "LOMA DE MARA",
    //     "LOMA DE MARCELO ",
    //     "LOMA DE MATEO ",
    //     "LOMA DE NOVILLERO ",
    //     "LOMA DE PALMA PICADA",
    //     "LOMA DE PALO BONITO ",
    //     "LOMA DE PERRO ",
    //     "LOMA DE PIEDRA",
    //     "LOMA DE PINTO ",
    //     "LOMA DE PORQUERO",
    //     "LOMA DE POZO PRIETO ",
    //     "LOMA DE SABANA",
    //     "LOMA DE SARANTE ",
    //     "LOMA DE SOLIMAN ",
    //     "LOMA DE TANQUE (BOTONCILLO) ",
    //     "LOMA DE TOMAS ",
    //     "LOMA DE YERBA ",
    //     "LOMA DEL AGUACATE 04",
    //     "LOMA DEL BURRO",
    //     "LOMA DEL CABALLO",
    //     "LOMA DEL CAJON",
    //     "LOMA DEL CHIVO",
    //     "LOMA DEL COCO ",
    //     "LOMA DEL CORRAL ",
    //     "LOMA DEL CURRO",
    //     "LOMA DEL DAJAO",
    //     "LOMA DEL GALLO",
    //     "LOMA DEL GUANO (LOS JOBOS)",
    //     "LOMA DEL GUANO",
    //     "LOMA DEL HICACAL",
    //     "LOMA DEL LLANO",
    //     "LOMA DEL LORO ",
    //     "LOMA DEL MEDIO",
    //     "LOMA DEL MOGOTE ",
    //     "LOMA DEL MUERTO ",
    //     "LOMA DEL PERICO ",
    //     "LOMA DEL PINAL",
    //     "LOMA DEL RANCHO ",
    //     "LOMA DEL TORO ",
    //     "LOMA DEL VIENTO ",
    //     "LOMA EL ALTO DE LA PIÑA ",
    //     "LOMA EL CAFE",
    //     "LOMA EL COLORADO",
    //     "LOMA EL GUANO ",
    //     "LOMA EL GUAZUMAL",
    //     "LOMA EL MEDIO ",
    //     "LOMA EL PEÑON ",
    //     "LOMA ESCONDIDA",
    //     "LOMA FIRME ",
    //     "LOMA HOYO SIN FIN ",
    //     "LOMA ISABEL DE TORRES ",
    //     "LOMA LA CANOA ",
    //     "LOMA LA CRUZ",
    //     "LOMA LA HERRADURA ",
    //     "LOMA LA MAJAGUA ",
    //     "LOMA LA PALOMA",
    //     "LOMA LA TASAJERA",
    //     "LOMA LECHOSO",
    //     "LOMA LINDA ",
    //     "LOMA LLANA ",
    //     "LOMA LOS ANONES ",
    //     "LOMA LOS BRAZOS ",
    //     "LOMA LOS PALOS DE ESCOBA",
    //     "LOMA LOS PINOS",
    //     "LOMA LOS RIOS ",
    //     "LOMA MATA PUERCOS ",
    //     "LOMA MIGUEL MARTIN",
    //     "LOMA MONTEADA (TORITO DEL YUNA) ",
    //     "LOMA NEGRA ",
    //     "LOMA PICADA",
    //     "LOMA PRIETA",
    //     "LOMA QUEMADA",
    //     "LOMA REGINA",
    //     "LOMA SABANA DE LA SIERRA",
    //     "LOMA SANTA MARIA",
    //     "LOMA SUCIA ",
    //     "LOMA TABACO",
    //     "LOMA VERDE ",
    //     "LOMA VERDE-MARICAO",
    //     "LOMA VIEJA ",
    //     "LOMAS DE ARROYO HONDO ",
    //     "LOMAS DE LIMON",
    //     "LOMAS FRIAS",
    //     "LOMITA DE PIEDRAS ",
    //     "LOMITA LARGA",
    //     "LOMITA PRIETA ",
    //     "LOMITA SUCIA",
    //     "LOPEZ",
    //     "LORA DE LOS AUQUEYES",
    //     "LORAN",
    //     "LORENZO",
    //     "LOS ABEYES ",
    //     "LOS ABREU",
    //     "LOS ACEVEDOS",
    //     "LOS ACOSTADOS ",
    //     "LOS AGRONOMOS ",
    //     "LOS AGUACATES ",
    //     "LOS AGUACATICOS ",
    //     "LOS AGUACATICOS 04",
    //     "LOS AJICITOS SECTOR ARRIBA",
    //     "LOS ALAMOS ",
    //     "LOS ALBERTO",
    //     "LOS ALBINOS",
    //     "LOS ALCARRIZOS (SABANETA) ",
    //     "LOS ALCARRIZOS (ZONA URBANA)",
    //     "LOS ALEJO",
    //     "LOS ALEMANES",
    //     "LOS ALGARROBOS",
    //     "LOS ALGODONES ",
    //     "LOS ALMACIGOS ",
    //     "LOS ALMENDRALES ",
    //     "LOS ALMENDROS ",
    //     "LOS ALPARGATALES",
    //     "LOS ALPES",
    //     "LOS ALTOS DE BLAQUIZALES",
    //     "LOS ALTOS DE BUENOS AIRES ",
    //     "LOS ALTOS DE MARMOLEJOS ",
    //     "LOS ALTOS GRANDES ",
    //     "LOS ALTOS",
    //     "LOS ALVINOS (ALBINOS) ",
    //     "LOS ALZAFRAZ",
    //     "LOS AMACEYES ARRIBA ",
    //     "LOS AMACEYES",
    //     "LOS AMAPOLOLOS O LAS AMAPOLAS ",
    //     "LOS AMAPOLOS",
    //     "LOS AMERICANOS (LOS ANGELES)",
    //     "LOS AMERICANOS II ",
    //     "LOS AMERICANOS",
    //     "LOS ANCONES",
    //     "LOS ANEGADIZOS",
    //     "LOS ANGELES",
    //     "LOS ANGELITOS ",
    //     "LOS ANGELITOS",
    //     "LOS ANONES ",
    //     "LOS ANONES (LAS CRUCES) 09",
    //     "LOS ANQUELLES ",
    //     "LOS APOSENTOS ",
    //     "LOS AQUINO ",
    //     "LOS ARACENA",
    //     "LOS ARADOS ",
    //     "LOS ARENOSOS",
    //     "LOS ARITAS ",
    //     "LOS ARQUEANOS ",
    //     "LOS ARQUIES",
    //     "LOS ARRAIJANES",
    //     "LOS ARROCES ADENTRO ",
    //     "LOS ARROCES AFUERA",
    //     "LOS ARROYITOS ",
    //     "LOS ARROYONES ",
    //     "LOS ARROYOS (ARROYO BUENO)",
    //     "LOS ARROYOS ARRIBA",
    //     "LOS ARROYOS DE SALAMANCA",
    //     "LOS ARROYOS",
    //     "LOS ASERRADEROS DEL CHOCO (PARTE) ",
    //     "LOS ASICIS ",
    //     "LOS ASIENTOS",
    //     "LOS AUQUELLES ",
    //     "LOS AUQUEYES",
    //     "LOS AUYENES",
    //     "LOS AVELLES",
    //     "LOS AZUFRES",
    //     "LOS AZULES ",
    //     "LOS BACILIOS",
    //     "LOS BAEZ ",
    //     "LOS BAJOS DE MAIMON ",
    //     "LOS BAJOS DEL RIO ",
    //     "LOS BAJOS",
    //     "LOS BALATACES ",
    //     "LOS BALLETEROS",
    //     "LOS BAMBUES",
    //     "LOS BANCOS ",
    //     "LOS BANCOS ABAJO",
    //     "LOS BANCOS DE ARENA ",
    //     "LOS BANCOS VIEJOS ",
    //     "LOS BAOS ",
    //     "LOS BARRABCONES ",
    //     "LOS BARRANCONES ",
    //     "LOS BARRANCONES DE CAMBOYA",
    //     "LOS BARRANCONES DE PALMARITO",
    //     "LOS BARRANCONES LOS FRIAS ",
    //     "LOS BARRANCONES NUEVOS O LOS ALEMANES ",
    //     "LOS BARRANCONES O CONANI",
    //     "LOS BARRANCOS ",
    //     "LOS BARREROS",
    //     "LOS BARROS ",
    //     "LOS BASORA ",
    //     "LOS BATONES",
    //     "LOS BAÑADEROS ",
    //     "LOS BEATOS ",
    //     "LOS BEJUCOS",
    //     "LOS BELLOSOS",
    //     "LOS BERIGÜETE ",
    //     "LOS BERRENDOS ",
    //     "LOS BERROA ",
    //     "LOS BERROS ",
    //     "LOS BILLETEROS",
    //     "LOS BLANCOS",
    //     "LOS BLEOS",
    //     "LOS BLOCKS ",
    //     "LOS BLOCKS DE MENA",
    //     "LOS BOBOSES",
    //     "LOS BOLOS",
    //     "LOS BOMBONES",
    //     "LOS BONILLA (S.D.)",
    //     "LOS BONILLA",
    //     "LOS BOQUERONES",
    //     "LOS BORBOLLONES ",
    //     "LOS BORDAS ",
    //     "LOS BORNO O LA VIEJA MEA",
    //     "LOS BOTADITOS ",
    //     "LOS BOTADOS (ZONA URBANA) ",
    //     "LOS BOTADOS DE LA CAÑA",
    //     "LOS BOTADOS DE LA RESERVA ",
    //     "LOS BOTADOS DE VICTORIA ",
    //     "LOS BOTADOS",
    //     "LOS BOTAOS ",
    //     "LOS BRACHE O LOS BELLACOS ",
    //     "LOS BRACITOS",
    //     "LOS BRAZOS ",
    //     "LOS BRETONES",
    //     "LOS BRITO",
    //     "LOS BUEYES ",
    //     "LOS BURGOS ",
    //     "LOS BURROS ",
    //     "LOS CABALLOS",
    //     "LOS CABORIES",
    //     "LOS CABRAL ",
    //     "LOS CABRERA O LA LOMETA ",
    //     "LOS CACAITOS",
    //     "LOS CACAOS ",
    //     "LOS CACAOS O SAN ISIDRO ",
    //     "LOS CACAOS RURAL",
    //     "LOS CACAÍTOS",
    //     "LOS CACERES",
    //     "LOS CACHIMBOS ",
    //     "LOS CACHIMBOS O VILLA ESPERANZA ",
    //     "LOS CACHONES ARRIBA (CACHONES ADENTRO)",
    //     "LOS CACHONES",
    //     "LOS CACICAZGOS",
    //     "LOS CADILLOS",
    //     "LOS CAFECITOS ",
    //     "LOS CAFES",
    //     "LOS CAFESES",
    //     "LOS CAGÜEYES",
    //     "LOS CAIMITICOS",
    //     "LOS CAIMITOS",
    //     "LOS CAIMONICES",
    //     "LOS CAIMONIES ",
    //     "LOS CAJONES",
    //     "LOS CAJUILES",
    //     "LOS CAJUILITOS",
    //     "LOS CALABAZOS ",
    //     "LOS CALABOZOS ",
    //     "LOS CALABOZOS (LA ESTRELLETA) ",
    //     "LOS CALABOZOS O LA CALABAZA ",
    //     "LOS CALDEROS",
    //     "LOS CALIESES",
    //     "LOS CALIMETES ",
    //     "LOS CALLEJONES (NORTE)",
    //     "LOS CALLEJONES (SUR)",
    //     "LOS CALLEJONES DE PEÑUELA ",
    //     "LOS CALLEJONES",
    //     "LOS CAMACHO",
    //     "LOS CAMARONES ",
    //     "LOS CAMBEROS",
    //     "LOS CAMBRONES ",
    //     "LOS CAMBRONES O SAN JOSE",
    //     "LOS CAMIONEROS",
    //     "LOS CAMPECHES ",
    //     "LOS CAMPECHITOS ",
    //     "LOS CANDELARIOS ",
    //     "LOS CANDELONES",
    //     "LOS CANDONGUITOS",
    //     "LOS CANES",
    //     "LOS CANGREJITOS ",
    //     "LOS CANJILONES",
    //     "LOS CANTINES O LOS ALGARROBOS ",
    //     "LOS CAPACES",
    //     "LOS CAPACITOS ",
    //     "LOS CAPELLAN",
    //     "LOS CAPOS O MAJAGUAL ADENTRO",
    //     "LOS CARABALLO ",
    //     "LOS CARACOLES ",
    //     "LOS CARDEREJOS",
    //     "LOS CARLOS ",
    //     "LOS CARMONIES ",
    //     "LOS CARPINTEROS ",
    //     "LOS CARRAOS",
    //     "LOS CARTONES O BARRIO NUEVO ",
    //     "LOS CARTONES O MARIA CARLITA",
    //     "LOS CARTONES O SAN PABLO II ",
    //     "LOS CARTONES",
    //     "LOS CASCAJALES DE SANCHEZ ",
    //     "LOS CASCAJALES DE SANCHEZ",
    //     "LOS CASCARONES",
    //     "LOS CASTELLANOS ",
    //     "LOS CASTILLO",
    //     "LOS CASTILLOS ",
    //     "LOS CATEYES O LOS CATORCE ",
    //     "LOS CATEYES",
    //     "LOS CATUANES",
    //     "LOS CAUCHOS",
    //     "LOS CAVORI ",
    //     "LOS CAYETANOS ",
    //     "LOS CAYUCOS I ",
    //     "LOS CAYUCOS II",
    //     "LOS CAYUCOS",
    //     "LOS CAYUQUITOS",
    //     "LOS CAZABES",
    //     "LOS CAÑAFISTOL",
    //     "LOS CAÑITOS",
    //     "LOS CAÑOS ADENTRO ",
    //     "LOS CAÑOS",
    //     "LOS CEDROS ",
    //     "LOS CEDROS O MENDOZA",
    //     "LOS CERCADILLOS ",
    //     "LOS CERCADILLOS ABAJO ",
    //     "LOS CERCADILLOS AL MEDIO",
    //     "LOS CERCADILLOS ARRIBA",
    //     "LOS CERCADOS",
    //     "LOS CEREZOS",
    //     "LOS CERRITOS",
    //     "LOS CERROS ",
    //     "LOS CERROS DE AMINILLA",
    //     "LOS CERROS DE DUEY",
    //     "LOS CERROS DE GURABO",
    //     "LOS CERROS DE HATO NUEVO 07 ",
    //     "LOS CERROS DE NAVAS ",
    //     "LOS CERROS DE TAMBORIL",
    //     "LOS CERROS DEL YUCA 10",
    //     "LOS CHACHASES ",
    //     "LOS CHALESES O LOS ALMACENES",
    //     "LOS CHAPARRALES ",
    //     "LOS CHARAMICOS",
    //     "LOS CHARCOS",
    //     "LOS CHARLESES ",
    //     "LOS CHARQUITOS",
    //     "LOS CHEPITOS",
    //     "LOS CHICHARRONES",
    //     "LOS CHICHIGUAOS ",
    //     "LOS CHICHONES ",
    //     "LOS CHICONES",
    //     "LOS CHIFLES",
    //     "LOS CHIJOS ",
    //     "LOS CHIRIPOS",
    //     "LOS CHIRIVICOS",
    //     "LOS CHIVOS ",
    //     "LOS CHIVOS O LOS CHINOS ",
    //     "LOS CHOFERES",
    //     "LOS CHUPADEROS",
    //     "LOS CIMARRONES",
    //     "LOS CINCO (5) PUERCOS ",
    //     "LOS CINCO CAMINOS ",
    //     "LOS CINCO",
    //     "LOS CIRISES",
    //     "LOS CIRUELITOS",
    //     "LOS CIRUELOS",
    //     "LOS CLAVELES",
    //     "LOS COCOS (KILOMETRO 28)",
    //     "LOS COCOS O EL COCO ",
    //     "LOS COCOS O ENSANCHE MIRAMAR",
    //     "LOS COCOS O LA ARBOLERA ",
    //     "LOS COCOS O SAN FRANCISCO ABAJO ",
    //     "LOS COCOS",
    //     "LOS COCUYOS",
    //     "LOS COLEGIOS",
    //     "LOS COLELOS",
    //     "LOS COLES",
    //     "LOS COLINFRE",
    //     "LOS COLONOS",
    //     "LOS COLORADOS ",
    //     "LOS COMPE",
    //     "LOS COMPOS ",
    //     "LOS CONTRERAS ",
    //     "LOS CONUCONES ",
    //     "LOS CONUCOS O LOS CACIQUES",
    //     "LOS CONUCOS",
    //     "LOS CONUQUITOS",
    //     "LOS COORDINADORES ",
    //     "LOS COPEYES O LA CABEZADA ",
    //     "LOS COQUITOS 2",
    //     "LOS COQUITOS 3",
    //     "LOS COQUITOS ARRIBA 09",
    //     "LOS COQUITOS",
    //     "LOS CORAZONES ",
    //     "LOS CORBANITOS (CAOBITA)",
    //     "LOS CORBANITOS",
    //     "LOS CORBANOS",
    //     "LOS CORCINO",
    //     "LOS COROCITOS ",
    //     "LOS COROZOS (CARA SUCIA)",
    //     "LOS COROZOS",
    //     "LOS CORRALES DEL CEA",
    //     "LOS CORRALES",
    //     "LOS CORRALITOS",
    //     "LOS CORSOS ",
    //     "LOS CRESPO ",
    //     "LOS CRUCES ",
    //     "LOS CUACOS ",
    //     "LOS CUAOS",
    //     "LOS CUATRO CAMINOS",
    //     "LOS CUCUSES",
    //     "LOS CUEROS ",
    //     "LOS CUERVOS",
    //     "LOS CUETO O LAS CAOBAS",
    //     "LOS CUMANI ",
    //     "LOS CURINES",
    //     "LOS DAJAITOS",
    //     "LOS DAJAOS ",
    //     "LOS DELGADILLOS ",
    //     "LOS DERRAMADEROS",
    //     "LOS DESAMPARADOS",
    //     "LOS DIEGUILLOS",
    //     "LOS DOMINGUEZ ",
    //     "LOS DOS HERMANOS",
    //     "LOS DOS PINOS ",
    //     "LOS DOS RIOS",
    //     "LOS DRAGONES",
    //     "LOS DURAN",
    //     "LOS EBARITOS",
    //     "LOS ENVASADORES ",
    //     "LOS ESPATILES ",
    //     "LOS ESPAÑOLES ",
    //     "LOS ESPINOS",
    //     "LOS ESTAMOS",
    //     "LOS ESTRELLA",
    //     "LOS ESTUDIANTES ",
    //     "LOS FACTORES O CARLOS DIAZ",
    //     "LOS FARALLONES",
    //     "LOS FEFINOS",
    //     "LOS FELIU",
    //     "LOS FERMIN ",
    //     "LOS FIRMES O LOMA LOS TITISES ",
    //     "LOS FOGONCITOS",
    //     "LOS FOGONES",
    //     "LOS FONDITOS",
    //     "LOS FONDOS DE JIGÜEY",
    //     "LOS FRAILES I ",
    //     "LOS FRAILES II",
    //     "LOS FRAILES",
    //     "LOS FRANCESES ",
    //     "LOS FRANCO ",
    //     "LOS FRIAS",
    //     "LOS FRIOS (ZONA URBANA) ",
    //     "LOS FRIOS AL MEDIO",
    //     "LOS FRIOS",
    //     "LOS FRUCTUOSOS",
    //     "LOS FULGENES",
    //     "LOS FUNDOS ",
    //     "LOS FUNDOS DE OLIVERO ",
    //     "LOS FUNDOS VIEJOS ",
    //     "LOS GAJITOS",
    //     "LOS GAJOS LARGOS",
    //     "LOS GAJOS",
    //     "LOS GALANOS",
    //     "LOS GALINDEZ",
    //     "LOS GALLARDOS ",
    //     "LOS GANCHOS",
    //     "LOS GARCIA ",
    //     "LOS GATOS",
    //     "LOS GENAO",
    //     "LOS GENARO ",
    //     "LOS GERMANES",
    //     "LOS GERVACIO",
    //     "LOS GEÑOS",
    //     "LOS GINEBRA ARCENO",
    //     "LOS GIRASOLES ",
    //     "LOS GIRASOLES I ",
    //     "LOS GIRASOLES II",
    //     "LOS GIRASOLES III ",
    //     "LOS GOMEZ",
    //     "LOS GONZALEZ",
    //     "LOS GORILAS",
    //     "LOS GOYOS",
    //     "LOS GRACILIANOS ",
    //     "LOS GRANADILLOS ",
    //     "LOS GRANADILLOS",
    //     "LOS GRANIZOS",
    //     "LOS GRATINI",
    //     "LOS GRAYUMBOS ",
    //     "LOS GREEN",
    //     "LOS GRILLOS",
    //     "LOS GRINGOS",
    //     "LOS GRITOS ",
    //     "LOS GRULLON II",
    //     "LOS GRULLON",
    //     "LOS GUAMACHOS ",
    //     "LOS GUANABANOS",
    //     "LOS GUANDULES ",
    //     "LOS GUANDULES O LAS MERCEDES",
    //     "LOS GUANOS ",
    //     "LOS GUANOS O LOMA EL GUANO",
    //     "LOS GUAOS",
    //     "LOS GUARAGUAOS",
    //     "LOS GUATAPANALES",
    //     "LOS GUAYABOS 09 ",
    //     "LOS GUAYABOS",
    //     "LOS GUAYACANES",
    //     "LOS GUAYOS ",
    //     "LOS GUAYUBINES",
    //     "LOS GUAYUYOS",
    //     "LOS GUAZARALES",
    //     "LOS GUAZAROS",
    //     "LOS GUINEOS ADENTRO ",
    //     "LOS GUINEOS AFUERA",
    //     "LOS GUINEOS",
    //     "LOS GUIROS ",
    //     "LOS GUZMAN ",
    //     "LOS GÜIROS ",
    //     "LOS HAITILES",
    //     "LOS HAITISES",
    //     "LOS HATILLOS",
    //     "LOS HELECHOS",
    //     "LOS HEROES ",
    //     "LOS HICACOS BLANCOS ",
    //     "LOS HICACOS",
    //     "LOS HIDALGOS (ZONA URBANA)",
    //     "LOS HIDALGOS",
    //     "LOS HIERROS",
    //     "LOS HIGOS GORDOS",
    //     "LOS HIGOS O EL HIGO ",
    //     "LOS HIGOS O LA YAGÜITA",
    //     "LOS HIGOS",
    //     "LOS HIGÜEROS",
    //     "LOS HILARIO",
    //     "LOS HINOJOS",
    //     "LOS HOJANCHOS ",
    //     "LOS HORCONES",
    //     "LOS HORNILLOS ",
    //     "LOS HORNOS ",
    //     "LOS HOYITOS",
    //     "LOS HOYOS (EL PLACER ABAJO) ",
    //     "LOS HOYOS DE JIMENEZ",
    //     "LOS HOYOS DEL HARA",
    //     "LOS HOYOS O EL GUANO",
    //     "LOS HOYOS",
    //     "LOS HOZADEROS ",
    //     "LOS HUMANICES O LOS ANEGADIZOS",
    //     "LOS HUMILDES",
    //     "LOS HUNDIDEROS",
    //     "LOS HUSOS O JUSOS ",
    //     "LOS HÉROES ",
    //     "LOS INAGITOS (LOS INAJITOS) ",
    //     "LOS INAJITOS O LOS NAJITOS",
    //     "LOS INDIOS ",
    //     "LOS INFANTES",
    //     "LOS INGENITOS ",
    //     "LOS INNOVADORES ",
    //     "LOS INVASORES ",
    //     "LOS JABILLONES",
    //     "LOS JABOSOS",
    //     "LOS JAGUALES",
    //     "LOS JAGUEROS",
    //     "LOS JAIMINES",
    //     "LOS JAIQUICES ",
    //     "LOS JAPONESES ",
    //     "LOS JAQUELLES ",
    //     "LOS JARDINES DE MADRE VIEJA ",
    //     "LOS JARDINES DEL EMBAJADOR",
    //     "LOS JARDINES METROPOLITANOS ",
    //     "LOS JARDINES METROPOLITANOS 01",
    //     "LOS JARDINES",
    //     "LOS JARICOS",
    //     "LOS JAVIELES",
    //     "LOS JAZMINES",
    //     "LOS JENGIBRES ",
    //     "LOS JENGIBRES ABAJO ",
    //     "LOS JENGIBRES ABAJO",
    //     "LOS JENGIBRES ARRIBA",
    //     "LOS JESUS",
    //     "LOS JIBAROS DE MANCHADO ",
    //     "LOS JIBAROS DE SANTANA",
    //     "LOS JIBAROS",
    //     "LOS JICACOS",
    //     "LOS JIMENEZ",
    //     "LOS JINCO",
    //     "LOS JOBAZOS",
    //     "LOS JOBILLOS",
    //     "LOS JOBITOS",
    //     "LOS JOBOS DE MATUA",
    //     "LOS JOBOS",
    //     "LOS JOSADEROS ",
    //     "LOS JOVILLOS",
    //     "LOS JUGADEROS ",
    //     "LOS JULINES",
    //     "LOS JUNCOS ",
    //     "LOS JUNQUITOS ",
    //     "LOS JURUNGOS",
    //     "LOS LADRILLOS ",
    //     "LOS LAMEDEROS ",
    //     "LOS LANOS",
    //     "LOS LAURELES",
    //     "LOS LAVADEROS ",
    //     "LOS LAZOS",
    //     "LOS LEBRILLOS (LA 14) ",
    //     "LOS LECHOSOS",
    //     "LOS LEJOS",
    //     "LOS LEONES ",
    //     "LOS LERENES",
    //     "LOS LETREROS",
    //     "LOS LIBERTADORES",
    //     "LOS LICEYES",
    //     "LOS LIMONCILLOS ",
    //     "LOS LIMONCITOS",
    //     "LOS LIMONES AFUERA",
    //     "LOS LIMONES AL MEDIO",
    //     "LOS LIMONES ARRIBA",
    //     "LOS LIMONES O LAS AMAPOLAS",
    //     "LOS LIMONES",
    //     "LOS LINDANAS",
    //     "LOS LIONES ",
    //     "LOS LIRIOS ",
    //     "LOS LLABONES",
    //     "LOS LLANOS ",
    //     "LOS LLANOS DE GURABO",
    //     "LOS LLANOS DE PEREZ ",
    //     "LOS LOPEZ I",
    //     "LOS LOPEZ II",
    //     "LOS LOPEZ III ",
    //     "LOS LOPEZ",
    //     "LOS LORA ",
    //     "LOS LORA O LOS LARA ",
    //     "LOS LOROS",
    //     "LOS LUCIANO",
    //     "LOS MACOS O ERNESTO RODRIGUEZ ",
    //     "LOS MACOS",
    //     "LOS MAESTROS O LOS PROFESORES ",
    //     "LOS MAESTROS",
    //     "LOS MAGALENOS ",
    //     "LOS MAGALEÑOS ",
    //     "LOS MAGINO ",
    //     "LOS MAGUAQUITOS ",
    //     "LOS MAGUELLES ",
    //     "LOS MAGUEYES",
    //     "LOS MAJAOS ",
    //     "LOS MALANGOS",
    //     "LOS MALCOTES",
    //     "LOS MAMBRUSES ",
    //     "LOS MAMBRUSES",
    //     "LOS MAMEYEJOS ",
    //     "LOS MAMEYES ABAJO ",
    //     "LOS MAMEYES ARRIBA",
    //     "LOS MAMEYES",
    //     "LOS MAMONEROS ",
    //     "LOS MAMPURRIOS",
    //     "LOS MANACLARES",
    //     "LOS MANANTIALES ",
    //     "LOS MANANTIALES 09",
    //     "LOS MANATIES",
    //     "LOS MANCORNADOS ",
    //     "LOS MANGITOS",
    //     "LOS MANGOS ",
    //     "LOS MANGOS O COYOTE ",
    //     "LOS MANGUITOS ",
    //     "LOS MANIADEROS",
    //     "LOS MAOS ",
    //     "LOS MAPOLOS",
    //     "LOS MAQUITOS",
    //     "LOS MARCANO",
    //     "LOS MARENOS",
    //     "LOS MARINGÜISES ",
    //     "LOS MARMOLEJOS",
    //     "LOS MARRANITOS",
    //     "LOS MARTES ",
    //     "LOS MARTINEZ O LA CANCHA",
    //     "LOS MARTINEZ",
    //     "LOS MATAS",
    //     "LOS MATEO",
    //     "LOS MATES",
    //     "LOS MATOS (LOS MATEOS) 05 ",
    //     "LOS MAYABOS",
    //     "LOS MAYALES",
    //     "LOS MAÑESES",
    //     "LOS MAÑONES",
    //     "LOS MEDICOS",
    //     "LOS MEDINA ",
    //     "LOS MEJIA",
    //     "LOS MELAOS (LOS MELADOS)",
    //     "LOS MELMONTO",
    //     "LOS MELONES",
    //     "LOS MEMISOS",
    //     "LOS MEMIZOS",
    //     "LOS MENDEZ ",
    //     "LOS MENISEROS ",
    //     "LOS MENISEROS",
    //     "LOS MERA ",
    //     "LOS MERCADOS",
    //     "LOS MERCEDES",
    //     "LOS MIESES ",
    //     "LOS MILITARES ",
    //     "LOS MILITARES",
    //     "LOS MILLONES",
    //     "LOS MINA ",
    //     "LOS MINA CENTRO ",
    //     "LOS MINA NORTE",
    //     "LOS MINA SUR",
    //     "LOS MINA VIEJO",
    //     "LOS MINAYA ",
    //     "LOS MINEROS",
    //     "LOS MIRANDAS",
    //     "LOS MOCHOS ",
    //     "LOS MOGOTES",
    //     "LOS MOJADOS",
    //     "LOS MOLINA ",
    //     "LOS MOLINOS O LOS HILOS ",
    //     "LOS MOLINOS",
    //     "LOS MOLONDRONES ",
    //     "LOS MOLUSES O LOS MELUSES ",
    //     "LOS MONOS",
    //     "LOS MONTASITOS",
    //     "LOS MONTAZOS",
    //     "LOS MONTE",
    //     "LOS MONTES ",
    //     "LOS MONTES FRESCOS",
    //     "LOS MONTES FRIOS",
    //     "LOS MONTONES ABAJO",
    //     "LOS MONTONES ARRIBA ",
    //     "LOS MONTONES",
    //     "LOS MORAN",
    //     "LOS MORENOS",
    //     "LOS MORONES",
    //     "LOS MOSQUITOS ",
    //     "LOS MOTA ",
    //     "LOS MOZOS",
    //     "LOS MULOS",
    //     "LOS MULTI DE GALVAN ",
    //     "LOS MULTI DE SAVICA ",
    //     "LOS MULTI O EL CEMENTERIO ",
    //     "LOS MULTI",
    //     "LOS MULTIFAMILIARES ",
    //     "LOS MULTIS ",
    //     "LOS MUÑOZ",
    //     "LOS NARANJALES",
    //     "LOS NARANJITOS",
    //     "LOS NARANJOS (POZO DEL NARANJO) ",
    //     "LOS NARANJOS ABAJO",
    //     "LOS NARANJOS ARRIBA ",
    //     "LOS NARANJOS O COLORADOS",
    //     "LOS NARANJOS",
    //     "LOS NEGRITOS",
    //     "LOS NEGROS ",
    //     "LOS NEGROS VIEJOS ",
    //     "LOS NINA ",
    //     "LOS NINJAS ",
    //     "LOS NONAS",
    //     "LOS NOVA ",
    //     "LOS NOVILLOS O LAS ABEJAS ",
    //     "LOS NOVILLOS",
    //     "LOS NUÑEZ",
    //     "LOS OCTAVIOS",
    //     "LOS OFICIALES ",
    //     "LOS OLIVOS ",
    //     "LOS OLMOS",
    //     "LOS OREGANOS",
    //     "LOS ORNES O REFORMA ",
    //     "LOS OROZCOS",
    //     "LOS ORTEGAS",
    //     "LOS OSORIAS",
    //     "LOS OZORIO (OSORIO) ",
    //     "LOS PABELLONES",
    //     "LOS PACHECO",
    //     "LOS PADROS ",
    //     "LOS PAJARITOS ",
    //     "LOS PAJAROS",
    //     "LOS PAJONES",
    //     "LOS PAJUILES",
    //     "LOS PALEROS",
    //     "LOS PALITOS",
    //     "LOS PALITOS-LOS NARANJOS",
    //     "LOS PALMARES I",
    //     "LOS PALMARES II ",
    //     "LOS PALMARES",
    //     "LOS PALMARITOS",
    //     "LOS PALOS DE BURRO",
    //     "LOS PALOS DEL BURRO ",
    //     "LOS PALOS GRANDES ",
    //     "LOS PALOS",
    //     "LOS PANCHOS",
    //     "LOS PANIAGUA",
    //     "LOS PAPAYOS",
    //     "LOS PAPITEROS ",
    //     "LOS PARCELEROS (LOS PAREDONES)",
    //     "LOS PARCELEROS O NUEVO",
    //     "LOS PARCELEROS",
    //     "LOS PAREDONES ",
    //     "LOS PAREDONES DE ANDRES ",
    //     "LOS PASITOS",
    //     "LOS PASOS DE MELLA",
    //     "LOS PASOS",
    //     "LOS PATIOS ",
    //     "LOS PATITOS O MARIA AUXILIADORA ",
    //     "LOS PATOS (ZONA URBANA) ",
    //     "LOS PATOS",
    //     "LOS PAULINO",
    //     "LOS PAYASOS O LOS PARAYASES ",
    //     "LOS PEDREGONES",
    //     "LOS PEGUERO",
    //     "LOS PELADEROS ",
    //     "LOS PELAO",
    //     "LOS PEPINES",
    //     "LOS PERALEJOS ",
    //     "LOS PERALTA",
    //     "LOS PEREZ",
    //     "LOS PERICOS",
    //     "LOS PERIQUITOS",
    //     "LOS PESCADORES",
    //     "LOS PEYNADO",
    //     "LOS PEÑA ",
    //     "LOS PEÑASCOS",
    //     "LOS PEÑONES",
    //     "LOS PIANTINI",
    //     "LOS PICHARDO",
    //     "LOS PICOS ABAJO ",
    //     "LOS PICOS ARRIBA",
    //     "LOS PICOS",
    //     "LOS PILONES O LOS PILARES ",
    //     "LOS PILONES",
    //     "LOS PINALITOS ",
    //     "LOS PINEDA ",
    //     "LOS PINITOS",
    //     "LOS PINOS DE JUAN TAVERAS ",
    //     "LOS PINOS DEL EDEN",
    //     "LOS PINOS",
    //     "LOS PIRINDINES",
    //     "LOS PIÑONES",
    //     "LOS PLACENCIO O LOS HORACIO ",
    //     "LOS PLACERES",
    //     "LOS PLANES ABAJO",
    //     "LOS PLANES ARRIBA ",
    //     "LOS PLATANITOS 09 ",
    //     "LOS PLATANITOS",
    //     "LOS PLATANOS",
    //     "LOS PLATONES",
    //     "LOS PLÁTANOS",
    //     "LOS POCHESES",
    //     "LOS POCITOS",
    //     "LOS POLANCO (LOS POLANCOS)",
    //     "LOS POLANCO",
    //     "LOS POLOS",
    //     "LOS POMOROSOS ",
    //     "LOS POMOS O LOS POMOLOS ",
    //     "LOS POMOS",
    //     "LOS PONTONES ABAJO",
    //     "LOS PONTONES ARRIBA ",
    //     "LOS PONTONES",
    //     "LOS PORTES ",
    //     "LOS PORTESUELOS ",
    //     "LOS PORTUGUESES ",
    //     "LOS POSITOS",
    //     "LOS POTRAZOS",
    //     "LOS POTROCARRERAS ",
    //     "LOS POZOS AMARILLOS ",
    //     "LOS POZOS BLANCOS ",
    //     "LOS POZOS",
    //     "LOS POZUELOS",
    //     "LOS PRADITOS",
    //     "LOS PRADOS ",
    //     "LOS PRAVIELES ",
    //     "LOS PRIETOS",
    //     "LOS PROCERES",
    //     "LOS PRODUCTORES ",
    //     "LOS PROFESIONALES ",
    //     "LOS PROFESIONALES",
    //     "LOS PROFESORES O LOS MAESTROS ",
    //     "LOS PROFESORES",
    //     "LOS PUCHEOS",
    //     "LOS PUELLO ",
    //     "LOS PUENTECITOS ",
    //     "LOS PUENTES DE TOMINES",
    //     "LOS PUENTES",
    //     "LOS PUJOLS ",
    //     "LOS PUYONES",
    //     "LOS QUEMADOS (ZONA URBANA)",
    //     "LOS QUEMADOS",
    //     "LOS QUEMAITOS ",
    //     "LOS QUEZADA",
    //     "LOS QUIMICOS",
    //     "LOS RAMIREZ",
    //     "LOS RAMONES O BULLA ",
    //     "LOS RAMONES",
    //     "LOS RANCHEROS ",
    //     "LOS RANCHITOS ",
    //     "LOS RANCHITOS (ARENA GORDA) ",
    //     "LOS RANCHOS DE BABOSICO ABAJO ",
    //     "LOS RANCHOS DE BABOSICO ARRIBA",
    //     "LOS RANCHOS DE TAVERAS",
    //     "LOS RANCHOS",
    //     "LOS RAPADEROS ",
    //     "LOS RECIO",
    //     "LOS REDIMIDOS ",
    //     "LOS REINOSO",
    //     "LOS REMOLINOS ",
    //     "LOS RESTAURADORES ",
    //     "LOS REYES NUEVO ",
    //     "LOS REYES O MATA DE LOS REYES 09",
    //     "LOS REYES",
    //     "LOS RICELI (LOS BREA) ",
    //     "LOS RIELES ",
    //     "LOS RIELES ABAJO",
    //     "LOS RIELES DE MOLINILLO ",
    //     "LOS RINCONCITOS ",
    //     "LOS RINCONES DE BOBA",
    //     "LOS RINCONES",
    //     "LOS RIOS ",
    //     "LOS RIOS (D.M.) ",
    //     "LOS RIOS (ZONA URBANA)",
    //     "LOS RIVERA O ALTAGRACIA ",
    //     "LOS ROAS ",
    //     "LOS ROAS",
    //     "LOS ROBALOS",
    //     "LOS ROBLES ",
    //     "LOS ROBLES DE JAYABO (LA CARIÑOSA)",
    //     "LOS ROBLES DE OJO DE AGUA ",
    //     "LOS ROCHE",
    //     "LOS RODRIGUEZ ",
    //     "LOS ROJAS",
    //     "LOS ROMEDILLOS",
    //     "LOS ROSALES",
    //     "LOS ROSARIO",
    //     "LOS RUALES ",
    //     "LOS SABINO ",
    //     "LOS SAJONES O EL SAJON",
    //     "LOS SAJONES",
    //     "LOS SALADILLOS",
    //     "LOS SALADITOS ",
    //     "LOS SALADOS VIEJOS",
    //     "LOS SALADOS",
    //     "LOS SALTADEROS 02 ",
    //     "LOS SAMANES",
    //     "LOS SANCHEZ",
    //     "LOS SANTANA",
    //     "LOS SANTILES",
    //     "LOS SANTOS ",
    //     "LOS SANTOS O LOS MACOS",
    //     "LOS SAUCES ",
    //     "LOS SAUCOS ",
    //     "LOS SEGUNDOS",
    //     "LOS SERRANOS",
    //     "LOS SEVERINOS ",
    //     "LOS SILLONES",
    //     "LOS SITIOS DE JUAN DECENA ",
    //     "LOS SOCIAS ",
    //     "LOS SOLANO ",
    //     "LOS SOLANOS",
    //     "LOS SOLARES (ANT. JUAN PEDRO) ",
    //     "LOS SOLARES I (ANT. JUAN EUGENIO-LA JAJA) ",
    //     "LOS SOLARES O LA CAÑA ",
    //     "LOS SOLARES U ORLANDO MARTINEZ 02 ",
    //     "LOS SOLARES",
    //     "LOS SOPAIPOS",
    //     "LOS SORIANO",
    //     "LOS SOSA ",
    //     "LOS SOTO ",
    //     "LOS SOTO ABAJO",
    //     "LOS SOTO AL MEDIO ",
    //     "LOS SOTO ARRIBA ",
    //     "LOS SUAREZ ",
    //     "LOS SUBURBIOS ",
    //     "LOS SUFRIDOS",
    //     "LOS SUMIDEROS ",
    //     "LOS SUÁREZ ",
    //     "LOS TABLONES",
    //     "LOS TABUCOS",
    //     "LOS TAINOS ",
    //     "LOS TAMARINDOS",
    //     "LOS TANQUECITOS 10",
    //     "LOS TAPIA (EL OCHO) ",
    //     "LOS TAVAREZ",
    //     "LOS TAVERAS",
    //     "LOS TEJADA ",
    //     "LOS TIBURONES ",
    //     "LOS TINAJONES ",
    //     "LOS TOCONES",
    //     "LOS TOMATES",
    //     "LOS TOMINES ABAJO ",
    //     "LOS TOMINES",
    //     "LOS TOROS (ZONA URBANA) ",
    //     "LOS TOROS",
    //     "LOS TORRES ",
    //     "LOS TORRES",
    //     "LOS TOTUMOS",
    //     "LOS TRACTORISTAS",
    //     "LOS TRAMOJOS",
    //     "LOS TRANSFORMADORES ",
    //     "LOS TRATRACES ",
    //     "LOS TREJOS ",
    //     "LOS TRES BRAZOS-JARDINES DEL OZAMA",
    //     "LOS TRES CAÑOS",
    //     "LOS TRES CHARCOS",
    //     "LOS TRES OJOS ",
    //     "LOS TRES PASOS DE CHACUEY 02",
    //     "LOS TRES PASOS",
    //     "LOS TRES PIES ",
    //     "LOS TRES PIES",
    //     "LOS TRES PUENTES",
    //     "LOS TRINITARIOS ",
    //     "LOS TRINITARIOS 10",
    //     "LOS TRINITARIOS II",
    //     "LOS TROZOS ",
    //     "LOS TUPAMAROS ",
    //     "LOS TURCOS ",
    //     "LOS URABOS ",
    //     "LOS URBANOS",
    //     "LOS UREÑA",
    //     "LOS UVEROS ",
    //     "LOS VALDEZ ",
    //     "LOS VALERIO",
    //     "LOS VALERIOS",
    //     "LOS VALLAONDITO (LOS BAYAHONDITO) ",
    //     "LOS VALLECITOS",
    //     "LOS VALLES ",
    //     "LOS VARGAS ",
    //     "LOS VASQUEZ ABAJO ",
    //     "LOS VASQUEZ ARRIBA",
    //     "LOS VECINOS",
    //     "LOS VEINTIUNO ",
    //     "LOS VERRACOS",
    //     "LOS VICINI ",
    //     "LOS VIDAL",
    //     "LOS VINELES",
    //     "LOS VIZCAINO",
    //     "LOS VOTAO (LOS BOTADOS) ",
    //     "LOS VÁSQUEZ",
    //     "LOS YAGRUMOS",
    //     "LOS YAGUARIZOS",
    //     "LOS YAREYES",
    //     "LOS YAURUMOS",
    //     "LOS YAYALES",
    //     "LOS YESOS",
    //     "LOS YUGOS",
    //     "LOS ZANCONES",
    //     "LOS ZANJONES",
    //     "LOS ZUMBADORES",
    //     "LOS ÑOCOS",
    //     "LOSTRANSFORMADORES",
    //     "LOTES Y SERVICIOS 10",
    //     "LOTIFICACION CAÑA LINDA ",
    //     "LOTIFICACION DEL ESTE ",
    //     "LOTIFICACION DON AMADO",
    //     "LOTIFICACION DON SERGIO ",
    //     "LOTIFICACION FERMIN ",
    //     "LOTIFICACION LOS RIOS ",
    //     "LOTIFICACION VERON II ",
    //     "LOTIFICACION VERON",
    //     "LOTIFICACION VICTORIANA ",
    //     "LOVATON",
    //     "LOZANO ",
    //     "LUCAS DIAZ ",
    //     "LUCAS",
    //     "LUCAZADA ",
    //     "LUCERO O VILLA CHAVEZ ",
    //     "LUCINDA",
    //     "LUIS GOMEZ ",
    //     "LUIS MANUEL CARABALLO 10",
    //     "LUIS MARIA MARTINEZ ",
    //     "LUIS MARTIN HILARIO ",
    //     "LUIS SIMON ",
    //     "LUPA ",
    //     "LUPERON (ZONA URBANA) ",
    //     "LUPERON O CENTRO DEL PUEBLO ",
    //     "LUPERON",
    //     "LUZ CELESTE LARA",
    //     "LUZ CONSUELO NORTE",
    //     "LUZ CONSUELO SUR",
    //     "LUZ DE LUNA",
    //     "LUZ DIVINA ",
    //     "M.O I",
    //     "M.O IL ",
    //     "MABRIGIDA",
    //     "MACANATILLO",
    //     "MACANDELA",
    //     "MACASÍA",
    //     "MACHEMBE (CHEMBE) ",
    //     "MACHETE",
    //     "MACHIN ",
    //     "MACO VERDE ",
    //     "MACORIS",
    //     "MACOTE ",
    //     "MACUMAS",
    //     "MADAMA ",
    //     "MADERA ",
    //     "MADRE DEL AGUA",
    //     "MADRE GIL O MADREGIL",
    //     "MADRE VIEJA DEL NORTE ",
    //     "MADRE VIEJA DEL SUR ",
    //     "MADRE VIEJA",
    //     "MADRID ",
    //     "MADRIGAL ",
    //     "MAGANTE",
    //     "MAGARIN ABAJO ",
    //     "MAGARIN",
    //     "MAGGIOLO ADENTRO",
    //     "MAGUA ABAJO",
    //     "MAGUA AL MEDIO",
    //     "MAGUA ARRIBA",
    //     "MAGUA O MAJAGUA ",
    //     "MAGUACA",
    //     "MAGUANA ABAJO ",
    //     "MAGUANA AL MEDIO",
    //     "MAGUANA ARRIBA",
    //     "MAGUANA",
    //     "MAGUANAS ABAJO",
    //     "MAGUANITA",
    //     "MAGUEY ",
    //     "MAGUEYAL ",
    //     "MAGUEYAL O EL CAOBAL",
    //     "MAGUEYAL",
    //     "MAGUEYAR NORTE",
    //     "MAGUÁ",
    //     "MAGÜEYAL ",
    //     "MAHABHARATA",
    //     "MAHOMA ",
    //     "MAHOMITA LOS ARROYITOS",
    //     "MAIMON ",
    //     "MAIMON (ZONA URBANA)",
    //     "MAIMORO",
    //     "MAIROSA",
    //     "MAIZAL ",
    //     "MAIZAL (ZONA URBANA)",
    //     "MAJAGUA",
    //     "MAJAGUAL ",
    //     "MAJAGUAL (ZONA URBANA)",
    //     "MAJAGUAL ABAJO",
    //     "MAJAGUAL CENIZO ",
    //     "MAJAGUALITO",
    //     "MAL NOMBRE ",
    //     "MAL PASO ",
    //     "MAL PECAO",
    //     "MALA MUERTE",
    //     "MALA VUELTA",
    //     "MALAGA ",
    //     "MALANGA",
    //     "MALENO ",
    //     "MALENO LA MINA",
    //     "MALENO",
    //     "MALMELI (MAIMELY) ",
    //     "MALPAEZ",
    //     "MALTA MORENA",
    //     "MALTOMACINA",
    //     "MALUCO ",
    //     "MALULANI ",
    //     "MAMA GINA",
    //     "MAMA TINGO ",
    //     "MAMBI",
    //     "MAMEICITO (MAMEYCITO) ",
    //     "MAMEY MACHO",
    //     "MAMEY",
    //     "MANA ABAJO ",
    //     "MANA DE HAINA ",
    //     "MANA DE MAIZAL O MAIZAL ARRIBA",
    //     "MANA DE YAGUATE ",
    //     "MANA LA VIEJA ",
    //     "MANABAO",
    //     "MANACLA",
    //     "MANACLAR ",
    //     "MANACLAS ",
    //     "MANACLITAS ",
    //     "MANAGUA ABAJO ",
    //     "MANAGUA",
    //     "MANANTIAL",
    //     "MANAO PILON",
    //     "MANCEBO",
    //     "MANCHADO ",
    //     "MANCORNA ",
    //     "MANCORNETA ",
    //     "MANDINGA ",
    //     "MANDINGA",
    //     "MANGA LARGA ABAJO ",
    //     "MANGA LARGA ARRIBA",
    //     "MANGA MOCHA O YAGUARIZO ",
    //     "MANGA",
    //     "MANGANAGUA ",
    //     "MANGIL ",
    //     "MANGIL ABAJO",
    //     "MANGO FRESCO (PARTE)",
    //     "MANGO FRESCO",
    //     "MANGO LIMPIO",
    //     "MANGRUNO ",
    //     "MANHATTAN",
    //     "MANI BLANCO",
    //     "MANIEL VIEJO",
    //     "MANIGUA ARRIBA",
    //     "MANO MATUEY ABAJO ",
    //     "MANO MATUEY ARRIBA",
    //     "MANO MATUEY",
    //     "MANOGUAYABO O LOS CAÑOS ",
    //     "MANOGUAYABO",
    //     "MANOJUAN-ADAMANAY ",
    //     "MANOLO DAJER",
    //     "MANOLO TAVAREZ JUSTO",
    //     "MANOMAN",
    //     "MANRESA O ALTAGRACIA",
    //     "MANTANZAS AFUERA",
    //     "MANUEL ",
    //     "MANUEL BUENO (ZONA URBANA)",
    //     "MANUEL BUENO",
    //     "MANUEL DIAZ",
    //     "MANUEL GOYA",
    //     "MANUEL LORENZO",
    //     "MANUEL MINA",
    //     "MANUEL QUIQUITO ",
    //     "MANUEL RODRIGUEZ",
    //     "MANYAYA",
    //     "MANZANA DE ORO",
    //     "MANZANILLO RURAL",
    //     "MAO (ZONA URBANA) ",
    //     "MAO ADENTRO",
    //     "MAPIORO",
    //     "MAPOLO ABAJO",
    //     "MAPOLO ARRIBA ",
    //     "MAQUITERIA ",
    //     "MAR AZUL ",
    //     "MARANATHA",
    //     "MARAPICA O COCA COLA",
    //     "MARAPICADA ",
    //     "MARAÑON I",
    //     "MARAÑON II ",
    //     "MARAÑON",
    //     "MARBELLA II",
    //     "MARCIAL PEÑA",
    //     "MARCOS DEL ROSARIO",
    //     "MARGARA",
    //     "MARGINAL OESTE",
    //     "MARIA AUXILIADORA ",
    //     "MARIA AUXILIADORA 02",
    //     "MARIA AUXILIADORA I ",
    //     "MARIA AUXILIADORA II",
    //     "MARIA AUXILIADORA O LA MESETA ",
    //     "MARIA BONITA",
    //     "MARIA COLORADA",
    //     "MARIA CONSUELO",
    //     "MARIA DIONICIA",
    //     "MARIA ESTELA",
    //     "MARIA FERNANDEZ ",
    //     "MARIA GARCIA",
    //     "MARIA ISABEL",
    //     "MARIA JOSEFINA",
    //     "MARIA LORENZA ",
    //     "MARIA LUISA",
    //     "MARIA MONTES",
    //     "MARIA MONTEZ O LOS CUABA",
    //     "MARIA RUIZ ",
    //     "MARIA TERESA",
    //     "MARIA TRINIDAD SANCHEZ O EL SEMILLERO ",
    //     "MARIA TRINIDAD SANCHEZ",
    //     "MARIA VIDAL",
    //     "MARIANA",
    //     "MARIANO CESTERO ",
    //     "MARICAO (EL JOBOVAN)",
    //     "MARICAO",
    //     "MARIEN ",
    //     "MARIEN GARCIA ",
    //     "MARILOPE ",
    //     "MARILOPEZ",
    //     "MARINERO ",
    //     "MARINO TIO ",
    //     "MARIOLA",
    //     "MARIPILI ",
    //     "MARISCAO ",
    //     "MARISOL",
    //     "MARIZAN",
    //     "MARMOLEJOS ",
    //     "MARMOLEJOS ABAJO",
    //     "MAROTA ",
    //     "MARTEL ",
    //     "MARTICINIO (MARTINICINIO) ",
    //     "MARTIN ",
    //     "MARTIN ALONZO ARRIBA",
    //     "MARTIN BRUNITO",
    //     "MARTIN GARCIA ",
    //     "MARTIN POLANCO",
    //     "MARTIN SANTANA (FIDEL MARIA ZAMBRANO) ",
    //     "MARTINEZ ",
    //     "MARTINICA",
    //     "MASACO ",
    //     "MASACRE",
    //     "MASAQUITOS ",
    //     "MASCOTILLO ",
    //     "MASIPEDRO",
    //     "MATA AJI ",
    //     "MATA AROMA ",
    //     "MATA BARRACO",
    //     "MATA BONITA",
    //     "MATA CABRITO",
    //     "MATA CADILLO",
    //     "MATA CALICHE",
    //     "MATA CHALUPE",
    //     "MATA CLARA ",
    //     "MATA DE CAFE O LOMA DEL CAFE",
    //     "MATA DE CAFE",
    //     "MATA DE CANA",
    //     "MATA DE CONUCO",
    //     "MATA DE FELIPITO 09 ",
    //     "MATA DE GUANABANO ",
    //     "MATA DE IGLESIA ",
    //     "MATA DE JOBO",
    //     "MATA DE LIMON ",
    //     "MATA DE LIMON (VAMOS ENTRANDO)",
    //     "MATA DE LOS CABALLEROS",
    //     "MATA DE LOS CAOS",
    //     "MATA DE MAIZ",
    //     "MATA DE NARANJA ",
    //     "MATA DE PALMA ",
    //     "MATA DE PLATANO 02",
    //     "MATA DE PLATANO 09",
    //     "MATA DE TUNA",
    //     "MATA DEL AGUA ",
    //     "MATA DEL DAJAO",
    //     "MATA DEL TORO ",
    //     "MATA GALLINA",
    //     "MATA GORDA ",
    //     "MATA GRANDE",
    //     "MATA GUINEO",
    //     "MATA HAMBRE",
    //     "MATA HOMBRE",
    //     "MATA LA PIEDRA",
    //     "MATA LARGA ",
    //     "MATA LOS INDIOS ",
    //     "MATA MACEY ",
    //     "MATA MAMON ",
    //     "MATA NARANJO O NARANJAL ",
    //     "MATA NARANJO",
    //     "MATA PALACIO (ZONA URBANA)",
    //     "MATA PALOMA",
    //     "MATA PUERCO ABAJO ",
    //     "MATA PUERCO ARRIBA",
    //     "MATA PUERCO",
    //     "MATA PUERCOS",
    //     "MATA PUERTO (MATA PUERCO) ",
    //     "MATA REDONDA",
    //     "MATA SAN JUAN ",
    //     "MATA SANTIAGO ",
    //     "MATA VACA",
    //     "MATA VERDE (MATA GORDA) 09",
    //     "MATA VIEJA ",
    //     "MATADERO ",
    //     "MATAGUAYABO",
    //     "MATANCITA",
    //     "MATANZAS ",
    //     "MATANZAS (ZONA URBANA)",
    //     "MATANZAS ABAJO",
    //     "MATANZAS ADENTRO",
    //     "MATANZAS ARRIBA ",
    //     "MATANZAS RURAL",
    //     "MATARRATON ",
    //     "MATASECO ",
    //     "MATAYAYA ",
    //     "MATAYAYA (ZONA URBANA)",
    //     "MATAYAYA O EL BATEY ",
    //     "MATENCIO ",
    //     "MATEO PELON",
    //     "MATEO PICO ",
    //     "MATEO PICO",
    //     "MATERNIDAD ",
    //     "MATIAS ",
    //     "MATICA SECA",
    //     "MATUAN ABAJO",
    //     "MAXIMO GOMEZ",
    //     "MAY ISABEL ",
    //     "MAYIGA ARRIBA ",
    //     "MECERON",
    //     "MEDIA BLANCA",
    //     "MEDIA CARA ",
    //     "MEDIA CARA ARRIBA ",
    //     "MEDIA CHINA",
    //     "MEDIA GORRA",
    //     "MEDIA LUNA ",
    //     "MEDINA ",
    //     "MEDIO O CENTRO 1",
    //     "MEJIA ABAJO",
    //     "MEJIA ARRIBA",
    //     "MEJIA",
    //     "MEJORAMIENTO SOCIAL ",
    //     "MEJORAMIENTO SOCIAL (BAMESO)",
    //     "MEJORAMIENTO SOCIAL 01",
    //     "MEJORAMIENTO SOCIAL O LOS MULTI ",
    //     "MEJORAMIENTO SOCIAL",
    //     "MEJOREMIENTO SOCIAL ",
    //     "MELEN",
    //     "MELITON",
    //     "MELLA (ZONA URBANA) ",
    //     "MELLA I",
    //     "MELLA II ",
    //     "MENA ",
    //     "MENA (ZONA URBANA)",
    //     "MENA ABAJO ",
    //     "MENA ARRIBA",
    //     "MENCIA ",
    //     "MENDEZ ",
    //     "MENDIETA ",
    //     "MENDOZA",
    //     "MERCEDES ALTA ",
    //     "MEREGILDO",
    //     "MESA ",
    //     "MESA DE DOMINGO O NEON DE DOMINGO ",
    //     "MESETA DEL PINO ",
    //     "MESOPOTAMIA",
    //     "MEXICO ",
    //     "MEZQUINO ",
    //     "MI HOGAR ",
    //     "MI HOGAR DEL ESTE ",
    //     "MI LOLA",
    //     "MI SUEÑO ",
    //     "MICHES (ZONA URBANA)",
    //     "MICHES O HIGÜEY ",
    //     "MIGUEL ",
    //     "MIGUEL A. MICHEL",
    //     "MIGUEL MARTIN ",
    //     "MIGUEL MARTIN",
    //     "MIGUEL MARTINEZ ",
    //     "MIGUEL SANCHEZ",
    //     "MIGUEL YANGÜELA ",
    //     "MIGUELUCHO ",
    //     "MIJO ABAJO ",
    //     "MIJO ABAJO",
    //     "MIJO O KILOMETRO 13 ",
    //     "MIL FLORES ",
    //     "MIL TAREAS DE ATABALERO ",
    //     "MILITAR",
    //     "MILITO ",
    //     "MILLONCITO ",
    //     "MINA CENTRAL ROMANA ",
    //     "MINA VIEJA ",
    //     "MINAYA ",
    //     "MINERVA O SIMON BOLIVAR ",
    //     "MINGO BARTOLO O LA PRIVADA",
    //     "MIRACIELO",
    //     "MIRADOR ARRIBA",
    //     "MIRADOR DE GIRASOLES",
    //     "MIRADOR DEL ESTE",
    //     "MIRADOR DEL JIMENOA ",
    //     "MIRADOR DEL OESTE ",
    //     "MIRADOR DEL OZAMA ",
    //     "MIRADOR DEL OZAMA",
    //     "MIRADOR DEL YAQUE ",
    //     "MIRADOR ISABELA O EL DORADO ",
    //     "MIRADOR NORTE ",
    //     "MIRADOR SUR",
    //     "MIRADOR",
    //     "MIRAFLORES ",
    //     "MIRAMAR U HOYO FRIO ",
    //     "MIRAMAR",
    //     "MIRANDA",
    //     "MIRAPATO ",
    //     "MOCA (ZONA URBANA)",
    //     "MOCAN CAMPANA ",
    //     "MOCAN DE SAN JOSE ",
    //     "MOCAN",
    //     "MOCHITO",
    //     "MOGEA",
    //     "MOGOLLON ",
    //     "MOGOTE O EL CERRO ",
    //     "MOHOSO ",
    //     "MOISES ",
    //     "MOJA CASABE",
    //     "MOJIN",
    //     "MOLINO SUCIO",
    //     "MOLINUEVO",
    //     "MOMPOQUE ",
    //     "MONCADA",
    //     "MONCION (ZONA URBANA) ",
    //     "MONIER ",
    //     "MONO MOJAO ",
    //     "MONSERRAT",
    //     "MONSERRATE O MONTSERRAT (ZONA URBANA) ",
    //     "MONSEÑOR ELISEO PEREZ ",
    //     "MONSEÑOR MOYA ",
    //     "MONTADA O MONTE ARA ",
    //     "MONTAZO",
    //     "MONTAZOS DE ARROYO BONITO ",
    //     "MONTAÑO",
    //     "MONTE ABAJO",
    //     "MONTE ADENTRO ",
    //     "MONTE ADENTRO ABAJO O LAS AROMAS",
    //     "MONTE ADENTRO ARRIBA",
    //     "MONTE AGUILAR ",
    //     "MONTE ARRIBA",
    //     "MONTE BONITO (ZONA URBANA)",
    //     "MONTE BONITO",
    //     "MONTE BRAVO",
    //     "MONTE CARMELO ",
    //     "MONTE CLARO",
    //     "MONTE COCA ",
    //     "MONTE DE LA GALLINA ",
    //     "MONTE DE LA GALLINA",
    //     "MONTE DE LA JAGUA ",
    //     "MONTE DE LA JAGUA (ZONA URBANA) ",
    //     "MONTE DE LA JAGUA ABAJO ",
    //     "MONTE DE LA JAGUA ARRIBA",
    //     "MONTE DE LOS GATOS",
    //     "MONTE DE LOS NEGROS ",
    //     "MONTE DEL MANIEL",
    //     "MONTE FIRME",
    //     "MONTE GORDO",
    //     "MONTE GRANDE",
    //     "MONTE HIGO ",
    //     "MONTE HIGÜERO ",
    //     "MONTE LA GUARDIA",
    //     "MONTE LA JAGUA",
    //     "MONTE LARGO",
    //     "MONTE LLANO",
    //     "MONTE MAMON",
    //     "MONTE MAYOR O CERRO MICO",
    //     "MONTE NEGRO I ",
    //     "MONTE NEGRO II",
    //     "MONTE NEGRO",
    //     "MONTE PALMA",
    //     "MONTE PLATA (ZONA URBANA) ",
    //     "MONTE PLATA",
    //     "MONTE PRIETO",
    //     "MONTE QUEMADO ",
    //     "MONTE RECIO",
    //     "MONTE RICO ",
    //     "MONTE RICO 1",
    //     "MONTE RIO",
    //     "MONTE ROJO ",
    //     "MONTE VERDE",
    //     "MONTEADA DE JAVIER",
    //     "MONTEADA NUEVA",
    //     "MONTELLANO ",
    //     "MONTEMAR O LOS MULTI",
    //     "MONTEREY ",
    //     "MONTEREY (NUEVO) 10 ",
    //     "MONTERIAS",
    //     "MONTERICO II",
    //     "MONTERICO",
    //     "MONTERO",
    //     "MONTES DE OCA ",
    //     "MONTES DEL ESTADO ",
    //     "MONTIA DEL COCO ",
    //     "MONTREAL ",
    //     "MONTREAL",
    //     "MONTSERRAT ",
    //     "MONUMENTO A LA CAÑA ",
    //     "MOQUITA",
    //     "MORA ",
    //     "MORALES",
    //     "MORDAN ",
    //     "MOREY",
    //     "MORILLO",
    //     "MORO SUCIO ",
    //     "MORON",
    //     "MORONTE",
    //     "MORQUECHO",
    //     "MORRO SUCIO",
    //     "MORUNO ",
    //     "MORUNO DEL GUANO",
    //     "MOSCOSO",
    //     "MOSCU",
    //     "MOTO CROSS ",
    //     "MOTOLON",
    //     "MOZAVI ABAJO",
    //     "MOZAVI ARRIBA ",
    //     "MOÑA GORRA ",
    //     "MUCHA AGUA ",
    //     "MUELLE DE HAINA ",
    //     "MUERTO SENTADO",
    //     "MULATA I ",
    //     "MULTIFAMILIARES TABACALERA",
    //     "MULTIFAMILIARES ZONA FRANCA ",
    //     "MUNDITO",
    //     "MUNDO NUEVO",
    //     "MUNENE ",
    //     "MUSU ",
    //     "MUÑOZ",
    //     "NACO ",
    //     "NAGUA (ZONA URBANA) ",
    //     "NAJAYO ",
    //     "NAJAYO ABAJO O CRUCE DE NAJAYO",
    //     "NAJAYO ARRIBA ",
    //     "NAJAYO EN MEDIO ",
    //     "NANDITA",
    //     "NAPOLES",
    //     "NARANJAL ARRIBA ",
    //     "NARANJITO",
    //     "NARANJO ABAJO ",
    //     "NARANJO BOJON ",
    //     "NARANJO CHINO ",
    //     "NARANJO DE CHINA",
    //     "NARANJO DULCE ",
    //     "NARANJO DULCE ABAJO ",
    //     "NARANJO DULCE ARRIBA",
    //     "NARANJO",
    //     "NARANJOS ",
    //     "NARCISA",
    //     "NAVA ",
    //     "NAVARRETE",
    //     "NAVAS (ZONA URBANA) ",
    //     "NAVAS",
    //     "NAZARENO O MANZANERO",
    //     "NAZARET",
    //     "NAZARIO",
    //     "NEGRO MELO ",
    //     "NEGRO",
    //     "NEIBA (ZONA URBANA) ",
    //     "NEITA ABAJO",
    //     "NEITA",
    //     "NEW YORK ",
    //     "NIBAJE ",
    //     "NICARAGUA",
    //     "NICOLAS FELIZ ",
    //     "NICOLAS O JOCA",
    //     "NIGUA ABAJO",
    //     "NIGUA NORTE I ",
    //     "NIGUA SUR I",
    //     "NIGUA SUR II",
    //     "NIGUA",
    //     "NIZA ABAJO ",
    //     "NIZA ARRIBA",
    //     "NIZAO (ZONA URBANA) ",
    //     "NIZAO",
    //     "NIZAY",
    //     "NIÑO DE ANTORCHA",
    //     "NONA ",
    //     "NORDESA I",
    //     "NORDESA III",
    //     "NOROESTE ",
    //     "NORTE O ENSANCHE QUISQUEYA",
    //     "NORTE O RINCON",
    //     "NORTE",
    //     "NOVILLERO",
    //     "NUESTRA SEÑORA DE LA ALTAGRACIA ",
    //     "NUESTRA SEÑORA DE LA PAZ",
    //     "NUEVA AMERICA ",
    //     "NUEVA ESPERANZA ",
    //     "NUEVA ESPERANZA O PROYECTO 3",
    //     "NUEVA ESTANCIA",
    //     "NUEVA ISABELA ",
    //     "NUEVA JUDEA",
    //     "NUEVA ROSA ",
    //     "NUEVA SUIZA",
    //     "NUEVA UVILLA",
    //     "NUEVA VILLA GUERRERO",
    //     "NUEVA YORK ",
    //     "NUEVA YORK CHIQUITO ",
    //     "NUEVA YORK",
    //     "NUEVO (N)",
    //     "NUEVO AMANECER",
    //     "NUEVO AMBIENTE",
    //     "NUEVO AMPARO",
    //     "NUEVO ARROYO HONDO III",
    //     "NUEVO ARROYO HONDO",
    //     "NUEVO CEMENTERIO",
    //     "NUEVO CONCENTRACION ",
    //     "NUEVO CURRO",
    //     "NUEVO ESFUERZO",
    //     "NUEVO ESPLENDOR O LOS MAESTROS",
    //     "NUEVO MEXICO",
    //     "NUEVO MILENIUM",
    //     "NUEVO O DETRAS DEL CEMENTERIO ",
    //     "NUEVO O SAN VICENTE ",
    //     "NUEVO PUERTO RICO ",
    //     "NUEVO",
    //     "NUEVOS HORIZONTES ",
    //     "NUÑEZ ABAJO",
    //     "NUÑEZ ARRIBA",
    //     "OBDULIA O EL PUEBLECITO ",
    //     "OBRAS PUBLICAS",
    //     "OBRERO ",
    //     "OCHOA",
    //     "OCOA ",
    //     "OCOEÑO ",
    //     "OFASA",
    //     "OFELIA ",
    //     "OJEDA",
    //     "OJO DE AGUA",
    //     "OJOS DE AGUA",
    //     "OLIMPICO ",
    //     "OLIVAR ",
    //     "ONDINA ",
    //     "OREGANO CHIQUITO",
    //     "OREGANO GRANDE",
    //     "ORGANIZACION",
    //     "ORQUIDEA PRIMERA ETAPA",
    //     "ORTEGA ",
    //     "ORTEGA AFUERA ",
    //     "ORTIZ",
    //     "OSCAR",
    //     "OTAÑA",
    //     "OTILIA GUZMAN ",
    //     "OTRA BANDA ",
    //     "OTRO LADO",
    //     "OVENDO ",
    //     "OVIEDO (ZONA URBANA)",
    //     "OXIGENO DOMINICANO",
    //     "OXIGENO",
    //     "OZAMA ARRIBA",
    //     "P.R.D. ",
    //     "PACHO PEGAO",
    //     "PACHUTICO",
    //     "PADRE BILLINI ",
    //     "PADRE FANTINO ",
    //     "PADRE GRANERO ",
    //     "PADRE LAS CASAS ",
    //     "PADRE LAS CASAS (ZONA URBANA) ",
    //     "PADRE LAS CASAS (ZONA URBANA)",
    //     "PADRE LAS CASAS",
    //     "PADRE NUESTRO ",
    //     "PADRE SEGURA O EL FUNDO ",
    //     "PAIMATIA ",
    //     "PAJARITO ",
    //     "PAJARITO",
    //     "PAJONAL",
    //     "PALACIO",
    //     "PALAVE ",
    //     "PALENQUE ",
    //     "PALENQUE",
    //     "PALERITO ",
    //     "PALERMO",
    //     "PALERO ",
    //     "PALERO ABAJO",
    //     "PALERO ALMONTE",
    //     "PALERO ARRIBA ",
    //     "PALERO O LOS HIGOS",
    //     "PALIZA BUENA",
    //     "PALMA ARRIBA",
    //     "PALMA CANA ",
    //     "PALMA CANA",
    //     "PALMA CAÑA ",
    //     "PALMA CLARA",
    //     "PALMA DE LOS HIERROS",
    //     "PALMA DE LOS SANTOS ",
    //     "PALMA EL GALLO",
    //     "PALMA ESPINO",
    //     "PALMA HERRADA ",
    //     "PALMA LARGA",
    //     "PALMA LIMPIA",
    //     "PALMA LISA ",
    //     "PALMA PANDA",
    //     "PALMA PICADA DE CARLOS DIAZ ",
    //     "PALMA PICADA DE LOS AMACEYES",
    //     "PALMA PICADA",
    //     "PALMA REAL ",
    //     "PALMA SECA ",
    //     "PALMA SOLA ",
    //     "PALMA SOLA DE LA CAÑITA ",
    //     "PALMAR ",
    //     "PALMAR ABAJO",
    //     "PALMAR ARRIBA ",
    //     "PALMAR ARRIBA (ZONA URBANA) ",
    //     "PALMAR BONITO ",
    //     "PALMAR DE BUENA VISTA ",
    //     "PALMAR DE LOS NIDOS ",
    //     "PALMAR DE OCOA (D.M.) ",
    //     "PALMAR DE OCOA",
    //     "PALMAR DULCE",
    //     "PALMAR GRANDE ",
    //     "PALMAR NUEVO",
    //     "PALMAR VIEJO (EL BONO)",
    //     "PALMAR VIEJO",
    //     "PALMAREJITO",
    //     "PALMAREJO VILLA LINDA (ZONA URBANA) ",
    //     "PALMAREJO",
    //     "PALMARITO ABAJO ",
    //     "PALMARITO DE LA HOYA",
    //     "PALMARITO",
    //     "PALMILLA ",
    //     "PALMINGO ",
    //     "PALO ABOQUETEADO",
    //     "PALO ALTO (ZONA URBANA) ",
    //     "PALO ALTO",
    //     "PALO AMARGO",
    //     "PALO AMARILLO ",
    //     "PALO BLANCO",
    //     "PALO BONITO",
    //     "PALO COLORADO ",
    //     "PALO DE BURRO ",
    //     "PALO DE CAJA",
    //     "PALO DE COA",
    //     "PALO DE CUABA ",
    //     "PALO DE GUERRA",
    //     "PALO DE LA CRUZ ",
    //     "PALO DE LA HIGÜERA",
    //     "PALO DE LA JAIBA",
    //     "PALO DE LECHE ",
    //     "PALO DE SABINA",
    //     "PALO DEL VIENTO ",
    //     "PALO EL NUMERO",
    //     "PALO GRANDE",
    //     "PALO HINCADO",
    //     "PALO INDIO ",
    //     "PALO PRIETO",
    //     "PALO QUEMADO",
    //     "PALO QUEMAO",
    //     "PALO ROTO",
    //     "PALO SECO",
    //     "PALO VEINTE",
    //     "PALO VERDE ",
    //     "PALO VERDE (ZONA URBANA)",
    //     "PALO VIEJO ",
    //     "PALOMINO ",
    //     "PALOMINO",
    //     "PALOS AMARGOS ",
    //     "PALOS DE BURRO",
    //     "PAN DE AZUCAR ",
    //     "PANANAO ABAJO ",
    //     "PANANAO AL MEDIO",
    //     "PANANAO ARRIBA",
    //     "PANANAO",
    //     "PANCHITA ",
    //     "PANCHITO ",
    //     "PANCHO MATEO",
    //     "PANCHOLO ",
    //     "PANDIE ",
    //     "PANGOLA",
    //     "PANORAMA ",
    //     "PANTANAL ",
    //     "PANTOITA ",
    //     "PANTOJA (ZONA URBANA) ",
    //     "PANTOJA I",
    //     "PANTOJA",
    //     "PAPAGAYO ",
    //     "PAPATINO (VILLA LUZ)",
    //     "PARADERO ",
    //     "PARADERO EN MEDIO ",
    //     "PARAGUA",
    //     "PARAGUAY ",
    //     "PARAISO (ZONA URBANA) ",
    //     "PARAISO DE LAS MATAS",
    //     "PARAISO ORIENTAL",
    //     "PARAISO",
    //     "PARALIMON",
    //     "PARAVEL",
    //     "PARAÍSO",
    //     "PARCELA I",
    //     "PARCELA II ",
    //     "PARCELEROS ",
    //     "PARED LIMPIA",
    //     "PAREDES PRIETAS ",
    //     "PARQUE DEL ESTE I ",
    //     "PARQUE DEL ESTE IL",
    //     "PARQUE DEL ESTE ILL ",
    //     "PARQUE HOSTOS ",
    //     "PARQUE INDUSTRIAL ",
    //     "PARQUE INDUSTRIAL ZONAS FRANCAS ",
    //     "PARQUE METROPOLITANO DE SANTIAGO",
    //     "PARQUE MIRADOR NORTE",
    //     "PARQUE NACIONAL ",
    //     "PARQUE NACIONAL DEL ESTE",
    //     "PARQUE NACIONAL JOSE DEL CARMEN RAMIREZ ",
    //     "PARRA",
    //     "PARTE ALTA DE LA JOYA ",
    //     "PARTE BELLACA ",
    //     "PARTIDO (ZONA URBANA) ",
    //     "PARTIDO ARRIBA",
    //     "PARTIDO O CENTRO DEL PUEBLO ",
    //     "PARTIDO",
    //     "PASATIEMPO ",
    //     "PASATIEMPO ABAJO",
    //     "PASATIEMPO ARRIBA ",
    //     "PASCUAL",
    //     "PASEO DE LOS CACIQUES I ",
    //     "PASEO DE LOS CACIQUES II",
    //     "PASEO DE LOS INDIOS O PARQUE MIRADOR SUR",
    //     "PASEO DEL PARQUE O VILLA MARIA",
    //     "PASO AFUERA",
    //     "PASO AL MEDIO ",
    //     "PASO ASTACIO",
    //     "PASO BAJITO",
    //     "PASO CABRERA",
    //     "PASO CARIBE",
    //     "PASO CIBAO ",
    //     "PASO COLORADO ",
    //     "PASO DE JACINTO ",
    //     "PASO DE LA JAGUA",
    //     "PASO DE LA MAJAGÜITA O LA MARGARITA ",
    //     "PASO DE LA PALMA",
    //     "PASO DE LA PERRA",
    //     "PASO DE LOS BURROS",
    //     "PASO DE LOS NOVILLOS",
    //     "PASO DE MOCA",
    //     "PASO DE SANTA ",
    //     "PASO DE SENA",
    //     "PASO DEL CAPA ",
    //     "PASO DEL GANADO ",
    //     "PASO DEL JAMO ",
    //     "PASO FUERTE",
    //     "PASO HONDO ",
    //     "PASO LARGO ",
    //     "PASO REAL",
    //     "PASO SECO (ARROYO SECO) ",
    //     "PASO SECO",
    //     "PASO TAPAO ",
    //     "PASO VIEJO ",
    //     "PASTOR ",
    //     "PASTOR ARRIBA ",
    //     "PATA DE GALLINA ",
    //     "PATA DE VACA",
    //     "PATAO",
    //     "PATILLA",
    //     "PATRIA NUEVA",
    //     "PATRICIO ",
    //     "PAULINA PEÑA",
    //     "PAVIN",
    //     "PAVON",
    //     "PAYA (ZONA URBANA)",
    //     "PAYA ABAJO ",
    //     "PAYA ARRIBA",
    //     "PAYA EN MEDIO ",
    //     "PAYA RURAL ",
    //     "PAYABO ",
    //     "PAYANO ",
    //     "PAYITA ",
    //     "PAYITA O CENTRO DEL PUEBLO",
    //     "PAZ Y AMOR ",
    //     "PAÑAPAÑA ",
    //     "PEDERNALES (ZONA URBANA)",
    //     "PEDREGAL ",
    //     "PEDRO ACOSTA",
    //     "PEDRO ALEJANDRO ",
    //     "PEDRO BRAND (ZONA URBANA) ",
    //     "PEDRO BRAND",
    //     "PEDRO CABALLERO ",
    //     "PEDRO CORTO",
    //     "PEDRO CUEVAS",
    //     "PEDRO DISLA",
    //     "PEDRO FRANCISCO BONO",
    //     "PEDRO GARCIA (ZONA URBANA)",
    //     "PEDRO GARCIA",
    //     "PEDRO JUSTO CARRION ",
    //     "PEDRO MARTIN",
    //     "PEDRO MOTA ",
    //     "PEDRO PABLO",
    //     "PEDRO RAMON",
    //     "PEDRO SANCHEZ ",
    //     "PEDRO SANCHEZ (ZONA URBANA) ",
    //     "PEDRO SANCHEZ O CENTRO DEL PUEBLO ",
    //     "PEDRO SANTANA (ZONA URBANA) ",
    //     "PEDRO",
    //     "PEJE DE PEÑA",
    //     "PEKIN",
    //     "PELADEROS",
    //     "PELAGIO",
    //     "PELIGRO",
    //     "PENDA",
    //     "PEPE PEREZ ",
    //     "PEPE PEREZ-CUCHILLA ",
    //     "PEPE ROSARIO",
    //     "PEPILLO SALCEDO ",
    //     "PEPILLO SALCEDO O MANZANILLO (ZONA URBANA)",
    //     "PEPILLO",
    //     "PERALTA (ZONA URBANA) ",
    //     "PERALTA MANGUITO",
    //     "PERALTA",
    //     "PERALVILLO (ZONA URBANA)",
    //     "PERANTUEN",
    //     "PERAVIA",
    //     "PEREZ DE LOS MATES",
    //     "PERIQUITO",
    //     "PERLA ANTILLANA ",
    //     "PERPETUO SOCORRO",
    //     "PESCADERIA (ZONA URBANA)",
    //     "PESCADERO",
    //     "PESCADO BOBO ABAJO",
    //     "PESCADO BOBO ARRIBA ",
    //     "PESO AL MEDIO ",
    //     "PESQUERO ",
    //     "PETRONICA",
    //     "PETROPOLIS ",
    //     "PEÑA ALTA",
    //     "PEÑA BELLO ",
    //     "PEÑA BLANCA ADENTRO ",
    //     "PEÑA BLANCA AFUERA",
    //     "PEÑA DE RANCHADEROS ",
    //     "PEÑALO ",
    //     "PEÑALVA",
    //     "PEÑON",
    //     "PEÑONCITO",
    //     "PEÑOSO ",
    //     "PEÑUELA ABAJO ",
    //     "PEÑUELA ADENTRO 04",
    //     "PEÑUELA AFUERA 04 ",
    //     "PEÑUELA",
    //     "PIANTINI ",
    //     "PICA PIEDRA (EL CANAL)",
    //     "PICADO CIDOR",
    //     "PICHE",
    //     "PICO ALTO",
    //     "PICO BLANCO",
    //     "PICO DE LA COTORRA",
    //     "PIDOCA ",
    //     "PIE CADENCIA",
    //     "PIE CANO ",
    //     "PIE DE LOMA",
    //     "PIE DE PLATA",
    //     "PIEDRA ",
    //     "PIEDRA AZUL",
    //     "PIEDRA BLANCA ",
    //     "PIEDRA BLANCA (ZONA URBANA) ",
    //     "PIEDRA BLANCA 1 ",
    //     "PIEDRA BLANCA NORTE ",
    //     "PIEDRA BLANCA O SOBACON ",
    //     "PIEDRA BLANCA SUR ",
    //     "PIEDRA CHIQUITA 09",
    //     "PIEDRA DE AMOLAR",
    //     "PIEDRA DE BOHIO ",
    //     "PIEDRA DE CANDELA ",
    //     "PIEDRA DE LOS VEGANOS ",
    //     "PIEDRA DEL GRILLO O GRILLO",
    //     "PIEDRA GORDA",
    //     "PIEDRA GRANDE ",
    //     "PIEDRA GRANDE O GORDA ",
    //     "PIEDRA HINCADA",
    //     "PIEDRA IMAN",
    //     "PIEDRA LINDA",
    //     "PIEDRA LLANA",
    //     "PIEDRA MALA",
    //     "PIEDRA PARTIDA",
    //     "PIEDRA PEGADA ",
    //     "PIEDRA QUEMADA",
    //     "PIEDRAS AZULES ABAJO",
    //     "PIEDRAS AZULES ARRIBA ",
    //     "PIEDROSITO (PEDROSITO)",
    //     "PIEDROSO (PEDROSO)",
    //     "PIES JAGUA ",
    //     "PILANCON ",
    //     "PILANCONCITO",
    //     "PILETA HONDA",
    //     "PILETA VERDE",
    //     "PILON",
    //     "PILOTO ",
    //     "PIMENTEL (ZONA URBANA)",
    //     "PINAL CLARO",
    //     "PINAL REDONDO ",
    //     "PINALITO ",
    //     "PINALITO (LOS PICHONES) ",
    //     "PINAR BONITO",
    //     "PINAR CLARO",
    //     "PINAR DE LA CANA",
    //     "PINAR DEL CUELLO",
    //     "PINAR DEL YAQUE (LA PIÑA) 02",
    //     "PINAR GRANDE",
    //     "PINAR PAREJO",
    //     "PINAR QUEMADO ",
    //     "PINAR SUCIO",
    //     "PINO DEL RAYO ",
    //     "PINO DEL YUNA ",
    //     "PINO FRESCO",
    //     "PINO MOCHO (PINO MONCHO)",
    //     "PINOS DE VILLA OLGA ",
    //     "PINOS NORTE",
    //     "PINTA PICO ",
    //     "PINZÓN ",
    //     "PIO",
    //     "PIRAGUA",
    //     "PISA COSTURA",
    //     "PISAÑA ",
    //     "PIYOYO ",
    //     "PIZARRETE (ZONA URBANA) ",
    //     "PIZARRETE ARRIBA",
    //     "PIÑA AL MEDIO ",
    //     "PIÑA DE ORO",
    //     "PIÑA VIEJA ",
    //     "PLACER BONITO ",
    //     "PLACER BONITO DE PEDRO",
    //     "PLAN CAFE O EL CALICHE",
    //     "PLAN CAFE",
    //     "PLAN GRANDE",
    //     "PLAN I ",
    //     "PLAN PILOTO",
    //     "PLAN PORVENIR O LOS CAJONES ",
    //     "PLAN SIERRA",
    //     "PLANTA GENERADORA ELECTRICA ",
    //     "PLATANAL ",
    //     "PLATANAL ABAJO",
    //     "PLATANAL ADENTRO",
    //     "PLATANAL AFUERA O ARRIBA",
    //     "PLATANAL LA JOYA",
    //     "PLATANILLO ",
    //     "PLAY VIEJO O TERCERA BASE ",
    //     "PLAYA CHIQUITA",
    //     "PLAYA COLORADA",
    //     "PLAYA DE MAIMON ",
    //     "PLAYA DORADA",
    //     "PLAYA NAVIO",
    //     "PLAYA OESTE",
    //     "PLAYA PRIETA",
    //     "PLAZA CACIQUE ",
    //     "PLAZA",
    //     "PLUMITA REGAJO",
    //     "PLUMITA",
    //     "POBLADO DE JUMA ",
    //     "POBLADO DE TAVERAS",
    //     "POCO AGUA",
    //     "POLANCO",
    //     "POLO ",
    //     "POLO ARRIBA",
    //     "POLONIA",
    //     "POLVORIN O LAS FLORES ",
    //     "PONCE",
    //     "PONTEZUELA ",
    //     "PONTEZUELA ABAJO",
    //     "PONTEZUELA AL MEDIO ",
    //     "PONTEZUELA ARRIBA ",
    //     "PONTEZUELO ",
    //     "PONTON ",
    //     "PONTON (VILLA HENEQUEN) ",
    //     "PONTON ABAJO",
    //     "PONTONCITO ",
    //     "POPULAR",
    //     "PORQUERO ABAJO",
    //     "PORQUERO ARRIBA ",
    //     "PORTA MONEDA",
    //     "PORTEZUELO ",
    //     "PORTO",
    //     "PORVENIR ",
    //     "POSTRER RIO (ZONA URBANA) ",
    //     "POTRANQUITA",
    //     "POTRERO CENTRAL ROMANA",
    //     "POTRERO",
    //     "POTRO BLANCO",
    //     "POTRO RABON",
    //     "POTROSO",
    //     "POZA DE BOJOLO",
    //     "POZO AMARILLO ",
    //     "POZO ARENOSO",
    //     "POZO BONITO",
    //     "POZO COLORADO ",
    //     "POZO COLORADO (HOYITO SAN LORENZO)",
    //     "POZO DE LA PALMA",
    //     "POZO DEL BEJUCO ",
    //     "POZO DEL HIGO ",
    //     "POZO DEL JOBO ",
    //     "POZO HONDO ",
    //     "POZO PRIETO O POZO LARGO",
    //     "POZO PRIETO",
    //     "PRADERA DEL CERRO ",
    //     "PRADERA HERMOSA ",
    //     "PRADERAS DEL YAQUE",
    //     "PRADO DEL NORTE ",
    //     "PRADO ORIENTAL I",
    //     "PRADO ORIENTAL II ",
    //     "PRADO ORIENTAL III",
    //     "PRADO ORIENTAL",
    //     "PRADOS DE CUMAYASA",
    //     "PRADOS DEL CACHON ",
    //     "PRECIOSA DE MORA",
    //     "PRECONCA ",
    //     "PREPARO",
    //     "PRESA DE RINCON ",
    //     "PRESIDENTE DON ANTONIO GUZMAN FERNANDEZ (ZONA URBANA) ",
    //     "PRESTILES",
    //     "PRIMAVERA",
    //     "PRIMER ALTO",
    //     "PRIMER RANCHO ARRIBA",
    //     "PRIMER SABANA ",
    //     "PRIMERA BOCA",
    //     "PRINGAMOSA ",
    //     "PROGRESO ",
    //     "PROLONGACION 30 DE ABRIL",
    //     "PROLONGACION PADRE LAS CASAS",
    //     "PROSPERIDAD",
    //     "PROYECTO ",
    //     "PROYECTO 1 O MAXIMILIANO PERDOMO",
    //     "PROYECTO 2-C (ZONA URBANA)",
    //     "PROYECTO 2-C",
    //     "PROYECTO 4 ",
    //     "PROYECTO 4 (ZONA URBANA)",
    //     "PROYECTO AGRARIO A-C 151",
    //     "PROYECTO AGRARIO",
    //     "PROYECTO ARROCERO ",
    //     "PROYECTO BISONO ",
    //     "PROYECTO CABRETO",
    //     "PROYECTO CELESTE I",
    //     "PROYECTO D-1 GANADERO ",
    //     "PROYECTO DON ANTONIO GUZMAN FERNANDEZ ",
    //     "PROYECTO DON ANTONIO GUZMAN FERNANDEZ-",
    //     "PROYECTO DOÑA NELLY ",
    //     "PROYECTO ESMERALDA",
    //     "PROYECTO HABITACIONAL LA ZURZA",
    //     "PROYECTO HABITACIONAL SANCHEZ ",
    //     "PROYECTO HACIENDA ROSA MARIA",
    //     "PROYECTO INVI ",
    //     "PROYECTO INVI O NUEVO ",
    //     "PROYECTO INVI VILLA PROGRESO",
    //     "PROYECTO INVI-CEA I ",
    //     "PROYECTO INVI-VILLA PROGRESO RECUPERACION EL CUEY ",
    //     "PROYECTO JAVIER ",
    //     "PROYECTO JOSE CONTRERAS ",
    //     "PROYECTO JOSE FRANCISCO PEÑA GOMEZ I",
    //     "PROYECTO JOSE FRANCISCO PEÑA GOMEZ II ",
    //     "PROYECTO JOSE FRANCISCO PEÑA GOMEZ",
    //     "PROYECTO LA CIENAGUITA",
    //     "PROYECTO LOS GUARDIAS ",
    //     "PROYECTO LOS HAITISES O CATEY ADENTRO ",
    //     "PROYECTO LOS NUÑEZ",
    //     "PROYECTO MINGOYE",
    //     "PROYECTO MONCION",
    //     "PROYECTO NUEVA NAGUA",
    //     "PROYECTO NUEVO",
    //     "PROYECTO O CENTRO DEL PUEBLO",
    //     "PROYECTO PERLA DORADA ",
    //     "PROYECTO PORVENIR ",
    //     "PROYECTO PRADERA VERDE",
    //     "PROYECTO S/N",
    //     "PROYECTO SIN NOMBRE ",
    //     "PROYECTO UNO",
    //     "PROYECTO URBANIZACION LOS CIRUELOS",
    //     "PROYECTO VILLA BLANCA ",
    //     "PROYECTO YONU ",
    //     "PROYECTO YUNA ",
    //     "PRUDENCIO",
    //     "PUEBLO ABAJO",
    //     "PUEBLO ARRIBA ",
    //     "PUEBLO BAVARO ",
    //     "PUEBLO CHICO",
    //     "PUEBLO DE DIOS",
    //     "PUEBLO NUEVO ABAJO",
    //     "PUEBLO NUEVO O EL MECHON",
    //     "PUEBLO NUEVO O LA ARENA ",
    //     "PUEBLO NUEVO O SANTA CLARA",
    //     "PUEBLO NUEVO",
    //     "PUEBLO VIEJO (ZONA URBANA)",
    //     "PUEBLO VIEJO",
    //     "PUELLO ",
    //     "PUENTE ANAMUYA",
    //     "PUENTE DE CAMU",
    //     "PUENTE DE YAMI",
    //     "PUENTE MIJO",
    //     "PUENTE SAN RAFAEL ",
    //     "PUERCA GORDA DEL FIRME",
    //     "PUERCA GORDA",
    //     "PUERTA BLANCA ",
    //     "PUERTA DE HIERRO",
    //     "PUERTA DE SANTA FE",
    //     "PUERTA VIEJA",
    //     "PUERTO ",
    //     "PUERTO ALEJANDRO",
    //     "PUERTO ALTO",
    //     "PUERTO ARTURO ",
    //     "PUERTO BLANCO MARINA",
    //     "PUERTO CABALLO",
    //     "PUERTO ESCONDIDO",
    //     "PUERTO GRANDE ",
    //     "PUERTO ISABELA",
    //     "PUERTO JUANITA",
    //     "PUERTO PALENQUE ",
    //     "PUERTO PLATA (INVI) ",
    //     "PUERTO PLATA I",
    //     "PUERTO PLATA II ",
    //     "PUERTO PRINCIPE ",
    //     "PUERTO PRINCIPE 09",
    //     "PUERTO RICO A PIE ",
    //     "PUERTO RICO VIEJO ",
    //     "PUERTO RICO",
    //     "PUERTO VIEJO",
    //     "PUERTON ROJO",
    //     "PUESTO GRANDE ",
    //     "PUJABANTE",
    //     "PULGARIN ",
    //     "PULIDO ",
    //     "PULIO",
    //     "PUN PUN",
    //     "PUNCHA MAQUITO",
    //     "PUNTA AFUERA",
    //     "PUNTA BALANDRA",
    //     "PUNTA BONITA",
    //     "PUNTA BRAVA",
    //     "PUNTA CANA ",
    //     "PUNTA CAÑA ",
    //     "PUNTA CAÑA O LOS CERROS ",
    //     "PUNTA DE COCO ",
    //     "PUNTA DE GARZA",
    //     "PUNTA DE PINO ",
    //     "PUNTA GARZA",
    //     "PUNTA GORDA",
    //     "PUNTA LARGA",
    //     "PUNTA PALMA",
    //     "PUNTA RUSIA",
    //     "PUNTA",
    //     "PUNTO ARTURO",
    //     "PUNTO BOTADO",
    //     "PUNTO FIJO ",
    //     "PUÑAL (ZONA URBANA) ",
    //     "PUÑAL ADENTRO ",
    //     "PUÑAL AFUERA",
    //     "PUÑAL",
    //     "Q DE ABAJO ",
    //     "Q DE ARRIBA",
    //     "QUAIQUIA ",
    //     "QUEBRADA ",
    //     "QUEBRADA AMARILLA ",
    //     "QUEBRADA DE LA JAGUA O DE LA YAGUA",
    //     "QUEBRADA DE LOS PATOS ",
    //     "QUEBRADA DE PABLO ",
    //     "QUEBRADA FRIA ",
    //     "QUEBRADA HONDA",
    //     "QUEBRADA LLANA",
    //     "QUEBRADITA ",
    //     "QUEMA CRETA (6 DE NOVIEMBRE)",
    //     "QUEZADA",
    //     "QUIJA QUIETA",
    //     "QUILOMBO ",
    //     "QUIMBAMBA",
    //     "QUINIGUA ",
    //     "QUINIGUA DE LA YUCA (LA YUCA) ",
    //     "QUINTANA ",
    //     "QUINTAS DE PONTEZUELA ",
    //     "QUINTAS DE RINCON LARGO ",
    //     "QUINTO CENTENARIO 01",
    //     "QUINTO PATIO (5.º PATIO)",
    //     "QUINTO PATIO",
    //     "QUISIBANI",
    //     "QUISQUEYA (ZONA URBANA) ",
    //     "QUISQUEYA",
    //     "QUISQUEYANO",
    //     "QUITA CORAZA (ZONA URBANA)",
    //     "QUITA CORAZA",
    //     "QUITA PENA ",
    //     "QUITA SUEÑO (ZONA URBANA) ",
    //     "QUITA SUEÑO NORTE ",
    //     "QUITA SUEÑO SUR ",
    //     "QUITA SUEÑO",
    //     "RABO DE CHIVO ",
    //     "RABO DURO",
    //     "RABO LA PUERCA",
    //     "RACHO DE LAS CANAS",
    //     "RADIANTE ",
    //     "RAFAEL CRUCETA",
    //     "RAFEY",
    //     "RAIZ PICADA",
    //     "RALMA",
    //     "RALO ",
    //     "RAMADA ",
    //     "RAMON CASTILLO",
    //     "RAMON CHALAS",
    //     "RAMON MATIAS MELLA (LENGUA AZUL)",
    //     "RAMON MATIAS MELLA",
    //     "RAMON RAMIREZ ",
    //     "RAMON ROSA ",
    //     "RAMON SANTANA (ZONA URBANA) ",
    //     "RAMONAL ABAJO ",
    //     "RAMONAL ARRIBA",
    //     "RANCHADEROS",
    //     "RANCHERIA",
    //     "RANCHETE ",
    //     "RANCHITO ",
    //     "RANCHITO ABAJO O EL BADEN ",
    //     "RANCHITO ABAJO",
    //     "RANCHITO DE LOS PERALTA ",
    //     "RANCHITO DE LOS VARGAS",
    //     "RANCHITO POSTRERO ",
    //     "RANCHO 2 ",
    //     "RANCHO ABAJO (VUELTA LARGA) ",
    //     "RANCHO ABAJO",
    //     "RANCHO ACEVEDO",
    //     "RANCHO AGUSTIN",
    //     "RANCHO AL MEDIO ",
    //     "RANCHO AMBROSIO ",
    //     "RANCHO ANTONIO",
    //     "RANCHO ARRIBA ",
    //     "RANCHO ARRIBA ABAJO ",
    //     "RANCHO ARRIBA-CABON ",
    //     "RANCHO CHIQUITO ",
    //     "RANCHO COSME",
    //     "RANCHO DE COPEY ",
    //     "RANCHO DE JUANA ",
    //     "RANCHO DE LA GUARDIA (ZONA URBANA)",
    //     "RANCHO DE LA GUARDIA",
    //     "RANCHO DE LAS MUJERES ",
    //     "RANCHO DE LOS PLATANOS",
    //     "RANCHO DE MARCOS",
    //     "RANCHO DE MATOS ",
    //     "RANCHO DE PEDRO ",
    //     "RANCHO DEL COJO ",
    //     "RANCHO DEL NEGRO",
    //     "RANCHO DEL PINO ",
    //     "RANCHO DEL PINO",
    //     "RANCHO DEL RIO GUANAJUMA 02 ",
    //     "RANCHO DEL RIO",
    //     "RANCHO ESPAÑOL",
    //     "RANCHO FRANCISCO",
    //     "RANCHO HIGÜERO",
    //     "RANCHO LA CUMBRE",
    //     "RANCHO LA VACA",
    //     "RANCHO MANUEL ",
    //     "RANCHO MANUEL (PARTE) ",
    //     "RANCHO NUEVO",
    //     "RANCHO O RANCHO 1 ",
    //     "RANCHO O RANCHO VIEJO ",
    //     "RANCHO PEDRO",
    //     "RANCHO TOMAS",
    //     "RANCHO VALDEZ ",
    //     "RANCHO VIEJO",
    //     "RANCHO YAGUA",
    //     "RASTRILLO",
    //     "RAVELO ",
    //     "RAVINZAL ",
    //     "REAL TAMARINDO O LOS ROSALES",
    //     "REBOSO-PONTON DE EL LLANO ",
    //     "RECODO ",
    //     "REDONDO",
    //     "REFUGIO ALPHA 6 ",
    //     "REGADERA ",
    //     "REGADERA",
    //     "REINOSO",
    //     "REMANGAO ",
    //     "RENACIMIENTO",
    //     "REPARADERO ",
    //     "REPARADERO ARRIBA ",
    //     "REPARTO AGUEDITA",
    //     "REPARTO ALMA ROSA ",
    //     "REPARTO CONSUELO",
    //     "REPARTO DEL ESTE",
    //     "REPARTO FRAMBOYAN ",
    //     "REPARTO HACHE ",
    //     "REPARTO IBARRA 10 ",
    //     "REPARTO ILUSION ",
    //     "REPARTO IMPERIAL",
    //     "REPARTO KOKETTE ",
    //     "REPARTO LAS COLINAS ",
    //     "REPARTO LOS ROBLES",
    //     "REPARTO LOS TRES OJOS ",
    //     "REPARTO MANHATTAN 01",
    //     "REPARTO MIGUELINA ",
    //     "REPARTO MONTERO ",
    //     "REPARTO OQUET ",
    //     "REPARTO PATRIA MELLA O EL HOYO",
    //     "REPARTO PERALTA ",
    //     "REPARTO PERELLO ",
    //     "REPARTO PRIMAVERA ",
    //     "REPARTO SAMARIA ",
    //     "REPARTO SAN GREGORIO",
    //     "REPARTO TAVAREZ 01",
    //     "REPARTO TORRES",
    //     "REPARTO UNIVERSITARIO ",
    //     "REPARTO VILLA MARIA ",
    //     "RESCATE 94 ",
    //     "RESELEZUELA",
    //     "RESIDENCIAL 27 DE FEBRERO ",
    //     "RESIDENCIAL 5º CENTENARIO ",
    //     "RESIDENCIAL ACUARIO ",
    //     "RESIDENCIAL ALAMEDA ",
    //     "RESIDENCIAL ALAMEDA OESTE ",
    //     "RESIDENCIAL ALAMO ",
    //     "RESIDENCIAL ALBA",
    //     "RESIDENCIAL ALEXANDRA ",
    //     "RESIDENCIAL ALMA ROSA ",
    //     "RESIDENCIAL ALTAGRACIA I",
    //     "RESIDENCIAL ALTAGRACIA II ",
    //     "RESIDENCIAL AMADO ",
    //     "RESIDENCIAL AMANDA I",
    //     "RESIDENCIAL AMANDA II ",
    //     "RESIDENCIAL AMAPOLA ",
    //     "RESIDENCIAL AMAPOLA 10",
    //     "RESIDENCIAL AMARILIS III",
    //     "RESIDENCIAL AMARILIS IV ",
    //     "RESIDENCIAL ANA MELIA ",
    //     "RESIDENCIAL ANA MIGUELINA ",
    //     "RESIDENCIAL ANACAONA",
    //     "RESIDENCIAL ARCOIRIS",
    //     "RESIDENCIAL ARMIDA",
    //     "RESIDENCIAL ARTURO GIGANTE",
    //     "RESIDENCIAL AURORA",
    //     "RESIDENCIAL BAMBU III ",
    //     "RESIDENCIAL BARBI ",
    //     "RESIDENCIAL BAVARO PUNTA-CANA ",
    //     "RESIDENCIAL BELLA COLINA",
    //     "RESIDENCIAL BELLO CAMPO 10",
    //     "RESIDENCIAL BENJAMIN",
    //     "RESIDENCIAL BOCA DE MOCA",
    //     "RESIDENCIAL BRISA ORIENTAL I",
    //     "RESIDENCIAL BRISA ORIENTAL II ",
    //     "RESIDENCIAL BRISA ORIENTAL III",
    //     "RESIDENCIAL BRISA ORIENTAL IV ",
    //     "RESIDENCIAL BRISA ORIENTAL V",
    //     "RESIDENCIAL BRISA ORIENTAL VI ",
    //     "RESIDENCIAL BRISA ORIENTAL VII",
    //     "RESIDENCIAL BRISAS DE CUMAYASA",
    //     "RESIDENCIAL BRISAS DEL ATLANTICO",
    //     "RESIDENCIAL BRISAS DEL MAR",
    //     "RESIDENCIAL BRISAS DEL NORTE",
    //     "RESIDENCIAL BRISMAR O BRISAS DEL MAR",
    //     "RESIDENCIAL BRISOL",
    //     "RESIDENCIAL CALAF I ",
    //     "RESIDENCIAL CALAF II",
    //     "RESIDENCIAL CANO",
    //     "RESIDENCIAL CARIBE",
    //     "RESIDENCIAL CARMELA ",
    //     "RESIDENCIAL CAROL GISSEL",
    //     "RESIDENCIAL CHARLES DE GAULLE 10",
    //     "RESIDENCIAL CIUDAD DE LOS JARDINES",
    //     "RESIDENCIAL CIUDAD OLIMPICA ",
    //     "RESIDENCIAL CLARIBEL",
    //     "RESIDENCIAL CLARINEL",
    //     "RESIDENCIAL CLAUDIA ",
    //     "RESIDENCIAL COLINA BELLA",
    //     "RESIDENCIAL COLINAS DEL SEMINARIO ",
    //     "RESIDENCIAL COLONIA DE LOS DOCTORES ",
    //     "RESIDENCIAL CONDADO ",
    //     "RESIDENCIAL CORONA PLAZA",
    //     "RESIDENCIAL CORONA",
    //     "RESIDENCIAL COSTA DEL MAR ",
    //     "RESIDENCIAL COSTA VERDE ",
    //     "RESIDENCIAL DEL ESTE 10 ",
    //     "RESIDENCIAL DIEGO II",
    //     "RESIDENCIAL DIOMEDES",
    //     "RESIDENCIAL DON BOLIVAR ",
    //     "RESIDENCIAL DON FAUSTO",
    //     "RESIDENCIAL DON GREGORIO",
    //     "RESIDENCIAL DON JUAN",
    //     "RESIDENCIAL DON LUIS",
    //     "RESIDENCIAL DON MARIO ",
    //     "RESIDENCIAL DON MIGUEL",
    //     "RESIDENCIAL DON NIETO CORDERO ",
    //     "RESIDENCIAL DON OSCAR ",
    //     "RESIDENCIAL DON PEDRO ",
    //     "RESIDENCIAL DON ROGELIO ",
    //     "RESIDENCIAL DON ZOILO ",
    //     "RESIDENCIAL DOÑA ANGELA ",
    //     "RESIDENCIAL DOÑA CHEA ",
    //     "RESIDENCIAL DOÑA ELSA ",
    //     "RESIDENCIAL DOÑA EMMA BALAGUER",
    //     "RESIDENCIAL DOÑA GLORIA ",
    //     "RESIDENCIAL DOÑA MIMI ",
    //     "RESIDENCIAL DOÑA OLGA I ",
    //     "RESIDENCIAL DOÑA OLGA II",
    //     "RESIDENCIAL DOÑA OLGA III ",
    //     "RESIDENCIAL DOÑA ROSA ",
    //     "RESIDENCIAL EL CAMPITO",
    //     "RESIDENCIAL EL CRISTO ",
    //     "RESIDENCIAL EL DORAL 01 ",
    //     "RESIDENCIAL EL EMBRUJO II ",
    //     "RESIDENCIAL EL EMBRUJO III",
    //     "RESIDENCIAL EL MANANTIAL",
    //     "RESIDENCIAL EL PASO ",
    //     "RESIDENCIAL EL PORTAL ",
    //     "RESIDENCIAL ELIO FRANCO 10",
    //     "RESIDENCIAL ELSA PATRICIA ",
    //     "RESIDENCIAL ENSUEÑO ",
    //     "RESIDENCIAL EVANS LUIS",
    //     "RESIDENCIAL FABIO FIALLO",
    //     "RESIDENCIAL FEDERICO LINARES",
    //     "RESIDENCIAL FIALLO",
    //     "RESIDENCIAL FLOR DE LIZ ",
    //     "RESIDENCIAL FLOR DE LOTO",
    //     "RESIDENCIAL FLOR DEL FARO ",
    //     "RESIDENCIAL GILGAR",
    //     "RESIDENCIAL GRAN VEREDA ",
    //     "RESIDENCIAL GRANADO ",
    //     "RESIDENCIAL HERRERA ",
    //     "RESIDENCIAL IDALIA",
    //     "RESIDENCIAL INES O VILLA FARO 10",
    //     "RESIDENCIAL INVI-DOREX",
    //     "RESIDENCIAL IRENE ",
    //     "RESIDENCIAL IRIS",
    //     "RESIDENCIAL IRKA",
    //     "RESIDENCIAL IVAN GUZMAN ",
    //     "RESIDENCIAL JACARANDA ",
    //     "RESIDENCIAL JARDINES DE BUENA VISTA 10",
    //     "RESIDENCIAL JARDINES DE GENOVEVA",
    //     "RESIDENCIAL JARDINES DE LICEY ",
    //     "RESIDENCIAL JOSUE ",
    //     "RESIDENCIAL JUAN PABLO I O LAS MERCEDES ",
    //     "RESIDENCIAL JUAN YILDA",
    //     "RESIDENCIAL KARINA",
    //     "RESIDENCIAL KARLA ",
    //     "RESIDENCIAL KG",
    //     "RESIDENCIAL LA ENCANTADA",
    //     "RESIDENCIAL LA ESPAÑOLA ",
    //     "RESIDENCIAL LA GLORIA ",
    //     "RESIDENCIAL LA JABILLA",
    //     "RESIDENCIAL LA MONEDA ",
    //     "RESIDENCIAL LA RAMA ",
    //     "RESIDENCIAL LANTIGUA",
    //     "RESIDENCIAL LAS AMERICAS",
    //     "RESIDENCIAL LAS AURORAS ",
    //     "RESIDENCIAL LAS CHARCAS ",
    //     "RESIDENCIAL LAS DELICIAS",
    //     "RESIDENCIAL LAS PALMAS",
    //     "RESIDENCIAL LAS PALMERAS",
    //     "RESIDENCIAL LAS PRADERAS",
    //     "RESIDENCIAL LOMISA",
    //     "RESIDENCIAL LOS AGRONOMOS ",
    //     "RESIDENCIAL LOS ANGELES ",
    //     "RESIDENCIAL LOS CASTILLOS ",
    //     "RESIDENCIAL LOS CERROS 10 ",
    //     "RESIDENCIAL LOS CERROS DE DOÑA JULIA",
    //     "RESIDENCIAL LOS CERROS",
    //     "RESIDENCIAL LOS CORALES ",
    //     "RESIDENCIAL LOS DOCTORES",
    //     "RESIDENCIAL LOS HIDALGOS",
    //     "RESIDENCIAL LOS JARDINES DE PANTOJA ",
    //     "RESIDENCIAL LOS LEONES",
    //     "RESIDENCIAL LOS MAESTROS O BRISAS DE LA HERRADURA ",
    //     "RESIDENCIAL LOS MAESTROS",
    //     "RESIDENCIAL LOS PRADOS",
    //     "RESIDENCIAL LOS ROSALES 01",
    //     "RESIDENCIAL LOS SOCIAS",
    //     "RESIDENCIAL LOS TRES OJOS ",
    //     "RESIDENCIAL LOS TRIUNFADORES",
    //     "RESIDENCIAL LOS WILAMO",
    //     "RESIDENCIAL LOYOLA",
    //     "RESIDENCIAL LUISA PERLA ",
    //     "RESIDENCIAL LUZ MARIA ",
    //     "RESIDENCIAL MADELAINE ",
    //     "RESIDENCIAL MADELYN I ",
    //     "RESIDENCIAL MAINARDI REINA",
    //     "RESIDENCIAL MAINARDI",
    //     "RESIDENCIAL MAMA NELSI",
    //     "RESIDENCIAL MAR AZUL",
    //     "RESIDENCIAL MARAÑON ",
    //     "RESIDENCIAL MARGARITA ",
    //     "RESIDENCIAL MARIA ",
    //     "RESIDENCIAL MARIA 2000",
    //     "RESIDENCIAL MARIA DEL CARMEN",
    //     "RESIDENCIAL MARIA SALOME",
    //     "RESIDENCIAL MARIBEL ",
    //     "RESIDENCIAL MARIBEL I ",
    //     "RESIDENCIAL MARIEN",
    //     "RESIDENCIAL MAXIMO GOMEZ",
    //     "RESIDENCIAL MAYAGUI ",
    //     "RESIDENCIAL MELISSA ",
    //     "RESIDENCIAL MENDOZA II",
    //     "RESIDENCIAL MICHELL ",
    //     "RESIDENCIAL MICON ",
    //     "RESIDENCIAL MIGUEL ABUD ",
    //     "RESIDENCIAL MILENIUM V-IX ",
    //     "RESIDENCIAL MILENIUM",
    //     "RESIDENCIAL MIRA VALLE",
    //     "RESIDENCIAL MIRADOR DEL ESTE",
    //     "RESIDENCIAL MOCA (MACO TORIBIO O MACO TIBIO)",
    //     "RESIDENCIAL MONICA",
    //     "RESIDENCIAL MONTI I ",
    //     "RESIDENCIAL MORONTA ",
    //     "RESIDENCIAL MORONTA",
    //     "RESIDENCIAL NAIME ",
    //     "RESIDENCIAL NANCY NADESHA ",
    //     "RESIDENCIAL NICOLE",
    //     "RESIDENCIAL NOELIA",
    //     "RESIDENCIAL NONO",
    //     "RESIDENCIAL NORTE ",
    //     "RESIDENCIAL NUEVA TERRAZA ",
    //     "RESIDENCIAL NUEVO AMANECER",
    //     "RESIDENCIAL NUEVO SOL NACIENTE",
    //     "RESIDENCIAL OASIS ",
    //     "RESIDENCIAL ORIENTE ",
    //     "RESIDENCIAL ORQUIDEA II ETAPA ",
    //     "RESIDENCIAL ORTEGA Y GASSET ",
    //     "RESIDENCIAL OVIDIO L. HENDERSON ",
    //     "RESIDENCIAL PALMA DE LA COSTA ",
    //     "RESIDENCIAL PALMARES DE HARAS ",
    //     "RESIDENCIAL PALMERA I (EN PROYECTO) ",
    //     "RESIDENCIAL PANAMERICANO",
    //     "RESIDENCIAL PARAISO ",
    //     "RESIDENCIAL PARAISO DE SAN PEDRO",
    //     "RESIDENCIAL PARQUE DEL SOL",
    //     "RESIDENCIAL PASEO DE LAS ROSAS",
    //     "RESIDENCIAL PASEO DEL LLANO ",
    //     "RESIDENCIAL PASEO DEL PRADO ",
    //     "RESIDENCIAL PASEO VERDE ",
    //     "RESIDENCIAL PASEO YORYI MOREL ",
    //     "RESIDENCIAL PERLA BONITA",
    //     "RESIDENCIAL PEÑA BELLO",
    //     "RESIDENCIAL PINAR DEL NORTE ",
    //     "RESIDENCIAL PONTEZUELA",
    //     "RESIDENCIAL PRADERA DEL NORTE ",
    //     "RESIDENCIAL PRADERAS DEL ESTE ",
    //     "RESIDENCIAL PRADERAS ORIENTAL ",
    //     "RESIDENCIAL PRADOS DE PANTOJA ",
    //     "RESIDENCIAL PRADOS DE VERON ",
    //     "RESIDENCIAL QD",
    //     "RESIDENCIAL QUISQUEYA ",
    //     "RESIDENCIAL RADIANTE AMANECER ",
    //     "RESIDENCIAL REGINA",
    //     "RESIDENCIAL REYOLI",
    //     "RESIDENCIAL RIVAS BONILLA ",
    //     "RESIDENCIAL RIVERA DE LA ISABELA",
    //     "RESIDENCIAL RIVERAS DE CUMAYASA ",
    //     "RESIDENCIAL RIVERAS DEL ARROYO",
    //     "RESIDENCIAL ROMANA DEL OESTE",
    //     "RESIDENCIAL ROMANA",
    //     "RESIDENCIAL ROQUE NUÑEZ ",
    //     "RESIDENCIAL ROSA DEL ESTE ",
    //     "RESIDENCIAL ROSA MARIA",
    //     "RESIDENCIAL ROSMIL",
    //     "RESIDENCIAL RUMINA",
    //     "RESIDENCIAL SAN ANTONIO ",
    //     "RESIDENCIAL SAN BENITO",
    //     "RESIDENCIAL SAN FELIPE",
    //     "RESIDENCIAL SAN FRANCISCO DE ASIS ",
    //     "RESIDENCIAL SAN JOSE",
    //     "RESIDENCIAL SAN LATE I",
    //     "RESIDENCIAL SAN LATE IV ",
    //     "RESIDENCIAL SAN LUIS",
    //     "RESIDENCIAL SAN PEDRO ",
    //     "RESIDENCIAL SANTO DOMINGO ",
    //     "RESIDENCIAL SARA GABRIELA 10",
    //     "RESIDENCIAL SEBASTIAN ",
    //     "RESIDENCIAL SEBASTIAN III ",
    //     "RESIDENCIAL SHALOM II ",
    //     "RESIDENCIAL SHALOM III (EN CONSTRUCCION)",
    //     "RESIDENCIAL SHARMAN 02",
    //     "RESIDENCIAL SIN NOMBRE (EN CONSTRUCCION)",
    //     "RESIDENCIAL SUR ",
    //     "RESIDENCIAL TRINITI ",
    //     "RESIDENCIAL UREÑA ",
    //     "RESIDENCIAL VANESSA ",
    //     "RESIDENCIAL VARGAS",
    //     "RESIDENCIAL VIANO AZCONA",
    //     "RESIDENCIAL VICTORIA",
    //     "RESIDENCIAL VILLA CAROLIN ",
    //     "RESIDENCIAL VILLA DE LOS IMPERIOS ",
    //     "RESIDENCIAL VILLA DEL NORTE ",
    //     "RESIDENCIAL VILLA DEL PARQUE II-A ",
    //     "RESIDENCIAL VILLA EL CORAL",
    //     "RESIDENCIAL VILLA ELSA",
    //     "RESIDENCIAL VILLA ESPAÑA",
    //     "RESIDENCIAL VILLA HERMOSA ",
    //     "RESIDENCIAL VILLA MARIA ",
    //     "RESIDENCIAL VILLA PROGRESO",
    //     "RESIDENCIAL VISTA CATALINA",
    //     "RESIDENCIAL VISTA DEL ATLANTICO ",
    //     "RESIDENCIAL VISTA DEL CERRO ",
    //     "RESIDENCIAL WENDY MICHELL ",
    //     "RESIDENCIAL YUCA DE LOS RIOS",
    //     "RESIDENCIALALEXANDRA",
    //     "RESIDENCIALOGANDO ",
    //     "RESOLI ",
    //     "RESOLI",
    //     "RESPALDO 27 DE FEBRERO",
    //     "RESPALDO AMELIA ",
    //     "RESPALDO CARIBE O SAN BARTOLO ",
    //     "RESPALDO EL BRISAL 10 ",
    //     "RESPALDO EL EDEN",
    //     "RESPALDO JUAN PABLO DUARTE",
    //     "RESPALDO LA CANCHA",
    //     "RESPALDO LA ROSA",
    //     "RESPALDO MARIA ESTELA O VILLA ANDRES",
    //     "RESPALDO VILLA CARMEN ",
    //     "RESTAURACION (ZONA URBANA)",
    //     "RESTAURACION",
    //     "RESTAURADOR",
    //     "REVENTAZON ",
    //     "REVOLCADERO",
    //     "REVOLCADEROS",
    //     "RIBERA DEL JAYA ",
    //     "RIBERA DEL OZAMA",
    //     "RINCON ",
    //     "RINCON (ZONA URBANA)",
    //     "RINCON ABAJO",
    //     "RINCON ALTO",
    //     "RINCON BEBEDERO ",
    //     "RINCON BELLACO",
    //     "RINCON CAJUIL ",
    //     "RINCON CALIENTE ",
    //     "RINCON CALIENTE ABAJO ",
    //     "RINCON CALIENTE ARRIBA",
    //     "RINCON CANA",
    //     "RINCON CAYAO",
    //     "RINCON CHAVON ",
    //     "RINCON CLARO",
    //     "RINCON COLLADO",
    //     "RINCON DE AJI ",
    //     "RINCON DE AJI (ARROYO SECO) ",
    //     "RINCON DE HIGÜERO ",
    //     "RINCON DE LA JAGUA",
    //     "RINCON DE LA LOMA ",
    //     "RINCON DE LOS GENAO ",
    //     "RINCON DE LOS JIMENEZ ",
    //     "RINCON DE MAJAGUAL",
    //     "RINCON DE MESA",
    //     "RINCON DE PIEDRAS ",
    //     "RINCON DE VERAGUA O RINCON",
    //     "RINCON DE YUBOA ",
    //     "RINCON DEL HIGÜERO",
    //     "RINCON DEL JUNCO",
    //     "RINCON DEL LLANO",
    //     "RINCON DEL NOVILLO",
    //     "RINCON DEL PINO ",
    //     "RINCON DORADO ",
    //     "RINCON DULCE",
    //     "RINCON ESCONDIDO",
    //     "RINCON FRIO",
    //     "RINCON GRANDE ",
    //     "RINCON HAINERO",
    //     "RINCON HATO",
    //     "RINCON HONDO 09 ",
    //     "RINCON HONDO",
    //     "RINCON LARGO",
    //     "RINCON LLANO",
    //     "RINCON LOS SINDO O ZUMBI LA ARAÑA ",
    //     "RINCON MARTIN ",
    //     "RINCON MORENO ",
    //     "RINCON NARANJO",
    //     "RINCON O DUARTE ",
    //     "RINCON SOLO",
    //     "RINCON YACO",
    //     "RINCONAZO",
    //     "RINCONCITO ",
    //     "RINCÓN BELLACO",
    //     "RINCÓN FOGÓN",
    //     "RINCÓN LARGO",
    //     "RINCÓN SOLO",
    //     "RIO ABAJO DEL MEMISO",
    //     "RIO ABAJO MAGA",
    //     "RIO ABAJO",
    //     "RIO ARRIBA ",
    //     "RIO ARRIBA (RANCHO ARRIBA)",
    //     "RIO ARRIBA DEL SUR",
    //     "RIO BONITO ",
    //     "RIO BOYA ",
    //     "RIO CHIQUITO",
    //     "RIO DEL PADRE ",
    //     "RIO FRIO ",
    //     "RIO GRANDE ",
    //     "RIO GRANDE (ZONA URBANA)",
    //     "RIO GRANDE ABAJO",
    //     "RIO GRANDE ARRIBA ",
    //     "RIO JAGUA ARRIBA",
    //     "RIO JAGUA",
    //     "RIO LIMON",
    //     "RIO LIMPIO ",
    //     "RIO LIMPIO (ZONA URBANA)",
    //     "RIO LLANO",
    //     "RIO LOS COCOS ",
    //     "RIO LOS PALOS ",
    //     "RIO MAR",
    //     "RIO NARANJO ABAJO ",
    //     "RIO NARANJO ARRIBA",
    //     "RIO PIEDRA ",
    //     "RIO PIEDRAS",
    //     "RIO SALADO ",
    //     "RIO SAN JUAN (ZONA URBANA)",
    //     "RIO SAN JUAN",
    //     "RIO SECO ",
    //     "RIO VERDE ABAJO ",
    //     "RIO VERDE ARRIBA",
    //     "RIO VIA",
    //     "RIO VIEJO",
    //     "RIO YUNA ",
    //     "RIOSITO",
    //     "ROBERTO FERMIN",
    //     "ROBERTO SURIEL",
    //     "ROCA DEL MAR",
    //     "ROCHONA",
    //     "RODEO O HERNANDO ALONZO ABAJO ",
    //     "RODEO O RODERO",
    //     "RODEO POLVO",
    //     "RODEO",
    //     "RODOLFO SCHEAFFLER",
    //     "ROMERICO ",
    //     "ROMERO ",
    //     "ROMPE TRAPO",
    //     "RONCADOR ",
    //     "RONELIO LLOYO ",
    //     "RONELIO LLOYO O RANCHO DE GOYO",
    //     "ROQUE DABAS",
    //     "ROSA ",
    //     "ROSA ALTA",
    //     "ROSA BAJA",
    //     "ROSA DE LA PIEDRA ",
    //     "ROSA MISTICA 02 ",
    //     "ROSA MISTICA",
    //     "ROSARIO ABAJO ",
    //     "ROSARIO AL MEDIO",
    //     "ROSARIO DOMINICANA (LOS MINEROS)",
    //     "ROSSO",
    //     "RUBIO ADENTRO ",
    //     "RUISEÑOR ",
    //     "RUMBAMBA ",
    //     "RÍO ARRIBA ",
    //     "RÍO CHIQUITO",
    //     "SABALLO",
    //     "SABANA ",
    //     "SABANA ABAJO",
    //     "SABANA AL MEDIO ",
    //     "SABANA ALTA (ZONA URBANA) ",
    //     "SABANA ALTA",
    //     "SABANA ANGOSTA",
    //     "SABANA ARRIBA ",
    //     "SABANA BARRANCA ",
    //     "SABANA BONITA ",
    //     "SABANA BRUNO",
    //     "SABANA BUEY (ZONA URBANA) ",
    //     "SABANA CALVARIO ",
    //     "SABANA CAMPO",
    //     "SABANA CAOBAL ",
    //     "SABANA CENTRO ",
    //     "SABANA CHIQUITA ",
    //     "SABANA CRANDE DE PALENQUE (ZONA URBANA) ",
    //     "SABANA CRUZ (ZONA URBANA) ",
    //     "SABANA CRUZ",
    //     "SABANA CULEBRA",
    //     "SABANA CUNA",
    //     "SABANA DE AHOGA VACA",
    //     "SABANA DE ARROYO GRANDE ",
    //     "SABANA DE CAMPIÑA ",
    //     "SABANA DE CAÑO HONDO",
    //     "SABANA DE CHEN",
    //     "SABANA DE COMELO O DE COMER ",
    //     "SABANA DE CORRAL FALSO",
    //     "SABANA DE DUEY",
    //     "SABANA DE GRANDE",
    //     "SABANA DE GUANO ",
    //     "SABANA DE INAJE ",
    //     "SABANA DE JENGIBRE",
    //     "SABANA DE JINA",
    //     "SABANA DE LA CEIBA",
    //     "SABANA DE LA CRUZ ",
    //     "SABANA DE LA LOMA ",
    //     "SABANA DE LA MAR (ZONA URBANA)",
    //     "SABANA DE LA RANCHA ",
    //     "SABANA DE LA VACA ",
    //     "SABANA DE LA VIGIA",
    //     "SABANA DE LAS PRIMERAS YERBAS ",
    //     "SABANA DE LOS ALBA",
    //     "SABANA DE LOS JAVIER 09 ",
    //     "SABANA DE LOS JIMENEZ ",
    //     "SABANA DE LOS MARTINEZ",
    //     "SABANA DE LOS MIESES",
    //     "SABANA DE LOS MUERTOS ",
    //     "SABANA DE MAGUANA ",
    //     "SABANA DE MELADITO",
    //     "SABANA DE MIGUEL MARTIN ",
    //     "SABANA DE MIGUEL MARTIN",
    //     "SABANA DE NISIBON ",
    //     "SABANA DE PALMAREJO ",
    //     "SABANA DE PAYABO",
    //     "SABANA DE PEDRO SANCHEZ ",
    //     "SABANA DE PONTON",
    //     "SABANA DE SAN FRANCISCO ",
    //     "SABANA DE TOSA",
    //     "SABANA DE YABACAO (PUEBLO NUEVO)",
    //     "SABANA DE YAJARIMA",
    //     "SABANA DEL CUEY ",
    //     "SABANA DEL ESTADO ",
    //     "SABANA DEL LINO ",
    //     "SABANA DEL MARISCAO ",
    //     "SABANA DEL MEDIO",
    //     "SABANA DEL MONO (LA SABANA) ",
    //     "SABANA DEL PINO ",
    //     "SABANA DEL PUERTO ",
    //     "SABANA DEL PUERTO (ZONA URBANA) ",
    //     "SABANA DEL RANCHO ",
    //     "SABANA DEL RIO",
    //     "SABANA DEL YAYAL (LOS RANCHOS)",
    //     "SABANA EL PIÑAL ",
    //     "SABANA EN MEDIO ",
    //     "SABANA EN MEDIO (CATANAMATIAS)",
    //     "SABANA EN MEDIO (LOS COPEYES) ",
    //     "SABANA ENRIQUE DE COPEY ",
    //     "SABANA GLORIA ",
    //     "SABANA GRANDE ",
    //     "SABANA GRANDE (ZONA URBANA) ",
    //     "SABANA GRANDE ABAJO ",
    //     "SABANA GRANDE DE BATEY I",
    //     "SABANA GRANDE DE BOYA (HOYO DE PUTA)",
    //     "SABANA GRANDE DE BOYA (ZONA URBANA) ",
    //     "SABANA GRANDE DE PALENQUE RURAL ",
    //     "SABANA GRANDE DE SABALLO",
    //     "SABANA GRANDE O EL CASERIO",
    //     "SABANA GURABO ",
    //     "SABANA HIGÜERO (ZONA URBANA)",
    //     "SABANA IGLESIA (ZONA URBANA)",
    //     "SABANA INDIO",
    //     "SABANA JOVERO ",
    //     "SABANA LA PUERTA",
    //     "SABANA LARGA (ZONA URBANA)",
    //     "SABANA LARGA ABAJO O LOS COME DULCE ",
    //     "SABANA LARGA ABAJO",
    //     "SABANA LARGA ARRIBA ",
    //     "SABANA LARGA DE COJOBAL ",
    //     "SABANA LARGA O VILLAS TILIN ",
    //     "SABANA LARGA",
    //     "SABANA MADERA ",
    //     "SABANA MIGUEL MARTIN",
    //     "SABANA MINA",
    //     "SABANA MULA",
    //     "SABANA NOVILLO",
    //     "SABANA PALITO ",
    //     "SABANA PERDIDA",
    //     "SABANA PIEDRA ",
    //     "SABANA POSTRERA ",
    //     "SABANA POTRERO",
    //     "SABANA QUELIZ ",
    //     "SABANA REAL",
    //     "SABANA REY ",
    //     "SABANA REY ABAJO O LAS CABUYAS",
    //     "SABANA REY ARRIBA ",
    //     "SABANA RINCÓN ",
    //     "SABANA RODEO",
    //     "SABANA SAN JUAN ",
    //     "SABANA SANTIAGO ",
    //     "SABANA SIERRA O LAS MULAS ",
    //     "SABANA SIN PROVECHO-ALTO BANDERA",
    //     "SABANA TORO",
    //     "SABANA TOSA",
    //     "SABANA TUNA",
    //     "SABANA VERDE",
    //     "SABANA YEGUA (ZONA URBANA)",
    //     "SABANA YEGUA O PINTAO ",
    //     "SABANA YEGUA",
    //     "SABANETA ",
    //     "SABANETA (ZONA URBANA)",
    //     "SABANETA ABAJO",
    //     "SABANETA ARRIBA ",
    //     "SABANETA DE CANGREJOS ",
    //     "SABANETA DE LAS PALOMAS ",
    //     "SABANETA DE YASICA (ZONA URBANA)",
    //     "SABANETA DE YASICA",
    //     "SABANETA O CENTRO DEL PUEBLO",
    //     "SABANETA O EL PUENTE",
    //     "SABANETA REDONDA",
    //     "SABANETICA ",
    //     "SABANITA AL MEDIO ",
    //     "SABILA ARRIBA ",
    //     "SABILA ARRIBA (ZABILA ARRIBA) ",
    //     "SABILA ARRIBA",
    //     "SABILA O LAS MERCEDES ",
    //     "SABINA ",
    //     "SABO ",
    //     "SACATURRON ",
    //     "SAGUATICO",
    //     "SAINAGUA ",
    //     "SAJANOA",
    //     "SAJONCITO",
    //     "SAL SI PUEDES ",
    //     "SALADILLOS ",
    //     "SALADITO ",
    //     "SALAMANCA",
    //     "SALCEDO (ZONA URBANA) ",
    //     "SALCEDO",
    //     "SALOME UREÑA 10 ",
    //     "SALOME UREÑA",
    //     "SALOMON JORGE ",
    //     "SALSA I",
    //     "SALSA II ",
    //     "SALSAL ",
    //     "SALTADERO",
    //     "SALTO GRANDE",
    //     "SALVADOR THEN Y THEN",
    //     "SALVALEON DE HIGÜEY (ZONA URBANA) ",
    //     "SAMAN",
    //     "SAMANA ",
    //     "SAMANA O SAMANA TRES CUERDAS",
    //     "SAMANGOLA",
    //     "SAMARIA",
    //     "SAN ANDRES ",
    //     "SAN ANTON",
    //     "SAN ANTONIO (EL BOLSILLO) ",
    //     "SAN ANTONIO DE GUERRA (ZONA URBANA) ",
    //     "SAN ANTONIO PARTE ALTA",
    //     "SAN ANTONIO",
    //     "SAN BARTOLO (BARTOLOME",
    //     "SAN BARTOLO",
    //     "SAN CARALAMPIO",
    //     "SAN CARLOS ",
    //     "SAN CARLOS ABAJO",
    //     "SAN CARLOS",
    //     "SAN CRISTOBAL ",
    //     "SAN CRISTOBAL (ZONA URBANA) ",
    //     "SAN DIEGO",
    //     "SAN FELIPE ",
    //     "SAN FELIPE ABAJO",
    //     "SAN FELIPE ARRIBA ",
    //     "SAN FELIPE DE PUERTO PLATA (ZONA URBANA)",
    //     "SAN FERNANDO DE MONTE CRISTI (ZONA URBANA)",
    //     "SAN FERNANDO",
    //     "SAN FRANCISCO ",
    //     "SAN FRANCISCO (ENTRADA) ",
    //     "SAN FRANCISCO ABAJO ",
    //     "SAN FRANCISCO ADENTRO ",
    //     "SAN FRANCISCO ARRIBA",
    //     "SAN FRANCISCO DE JACAGUA (ZONA URBANA)",
    //     "SAN FRANCISCO O SAN FEO ",
    //     "SAN GABRIEL",
    //     "SAN GERALDO",
    //     "SAN GERONIMO",
    //     "SAN GREGORIO DE NIGUA (ZONA URBANA) ",
    //     "SAN GREGORIO O KILOMETRO 18 ",
    //     "SAN IGNACIO DE SABANETA (ZONA URBANA) ",
    //     "SAN ILDEFONSO ",
    //     "SAN ISIDRO ",
    //     "SAN ISIDRO ADENTRO",
    //     "SAN ISIDRO AFUERA ",
    //     "SAN JERONIMO",
    //     "SAN JOAQUIN - LA CEIBA",
    //     "SAN JOAQUIN",
    //     "SAN JOSE ",
    //     "SAN JOSE ADENTRO",
    //     "SAN JOSE AFUERA ",
    //     "SAN JOSE DE CENOVI",
    //     "SAN JOSE DE CONUCO",
    //     "SAN JOSE DE LAS MATAS (ZONA URBANA) ",
    //     "SAN JOSE DE LOS LLANOS (ZONA URBANA)",
    //     "SAN JOSE DE MATANZAS (ZONA URBANA)",
    //     "SAN JOSE DE MENDOZA ",
    //     "SAN JOSE DE OCOA (ZONA URBANA)",
    //     "SAN JOSE DE VILLA (CUMAJON) ",
    //     "SAN JOSE DEL PUERTO (ZONA URBANA) ",
    //     "SAN JOSE LA CUABA ",
    //     "SAN JOSE O RESPALDO EL BRISAL ",
    //     "SAN JOSE PASTRANA ",
    //     "SAN JUAN ",
    //     "SAN JUAN BAUTISTA ",
    //     "SAN JUAN BOSCO",
    //     "SAN JUAN DE LA MAGUANA (ZONA URBANA)",
    //     "SAN JUAN O SAN JOSE ",
    //     "SAN LAZARO ",
    //     "SAN LORENZO O CERROS DE SAN LORENZO ",
    //     "SAN LORENZO",
    //     "SAN LUIS ",
    //     "SAN MARCOS ",
    //     "SAN MARCOS (SOLDADO ARRIBA) ",
    //     "SAN MARCOS ABAJO",
    //     "SAN MARCOS ARRIBA ",
    //     "SAN MARTIN ",
    //     "SAN MARTIN DE PORRES O RINCON CALIENTE",
    //     "SAN MARTIN DE PORRES",
    //     "SAN MARTIN I",
    //     "SAN MARTIN IL ",
    //     "SAN MATEO",
    //     "SAN MIGUEL ",
    //     "SAN MIGUEL ABAJO",
    //     "SAN MIGUEL ARRIBA ",
    //     "SAN MIGUEL O NUEVO SAN LORENZO",
    //     "SAN NICOLAS",
    //     "SAN NICOLÁS",
    //     "SAN PABLO",
    //     "SAN PEDRO DE MACORIS (ZONA URBANA)",
    //     "SAN PEDRO",
    //     "SAN RAFAEL ",
    //     "SAN RAFAEL DEL YUMA (ZONA URBANA) ",
    //     "SAN RAFAEL",
    //     "SAN RAMON",
    //     "SAN ROQUE",
    //     "SAN SAPITO O AGAPITO",
    //     "SAN SIMON",
    //     "SAN TOBAL",
    //     "SAN VALENTIN",
    //     "SAN VALERIO",
    //     "SAN VICENTE DE PAUL ",
    //     "SAN VICENTE",
    //     "SAN VICTOR ",
    //     "SAN VICTOR (ZONA URBANA)",
    //     "SAN VICTOR ABAJO",
    //     "SAN VICTOR ARRIBA ",
    //     "SANABIA",
    //     "SANAGUA",
    //     "SANATE ",
    //     "SANATE ABAJO",
    //     "SANCHEZ (ZONA URBANA) ",
    //     "SANCHEZ",
    //     "SANDINO DIAZ",
    //     "SANDRA I ",
    //     "SANDRA II",
    //     "SANGRE LINDA",
    //     "SANITA ",
    //     "SANJOUL",
    //     "SANS SOUCI ",
    //     "SANTA ANA MADRID",
    //     "SANTA ANA O BARRIO SANTA ANA",
    //     "SANTA ANA",
    //     "SANTA BARBARA ",
    //     "SANTA BARBARA DE SAMANA (ZONA URBANA) ",
    //     "SANTA BARBARA EL 6 (ZONA URBANA)",
    //     "SANTA CAPUZA",
    //     "SANTA CLARA",
    //     "SANTA CRUZ ",
    //     "SANTA CRUZ DE BARAHONA (ZONA URBANA)",
    //     "SANTA CRUZ DE GATO",
    //     "SANTA EDUVIGIS",
    //     "SANTA ELENA",
    //     "SANTA FE ",
    //     "SANTA FE OESTE",
    //     "SANTA LUCIA (ZONA URBANA) ",
    //     "SANTA LUCIA DE CAMBA",
    //     "SANTA LUCIA",
    //     "SANTA MARIA",
    //     "SANTA MONICA",
    //     "SANTA POLA ",
    //     "SANTA RITA ",
    //     "SANTA ROSA ",
    //     "SANTA ROSA O BATEY PAJA ",
    //     "SANTA ROSA",
    //     "SANTA TERESITA",
    //     "SANTANA (ZONA URBANA) ",
    //     "SANTANA ABAJO ",
    //     "SANTANA ARRIBA",
    //     "SANTANA",
    //     "SANTIAGO APOSTOL 01 ",
    //     "SANTIAGO APOSTOL O SAN PEDRO",
    //     "SANTIAGO DE LA CRUZ (ZONA URBANA) ",
    //     "SANTIAGUITO",
    //     "SANTISIMA TRINIDAD",
    //     "SANTO CERRO",
    //     "SANTO CRISTO",
    //     "SANTO DOMINGO ",
    //     "SANTO DOMINGO COUNTRY CLUB",
    //     "SANTO DOMINGO OESTE",
    //     "SANTO DOMINGO SAVIO ",
    //     "SANTO ESPIRITU",
    //     "SANTO LA PANGOLA",
    //     "SANTURCE",
    //     "SAONA",
    //     "SARAMBAMBA ",
    //     "SARITO ",
    //     "SARMIENTO",
    //     "SAVICA ",
    //     "SAVICA LOTERIA I Y II ",
    //     "SAVICA PRINCIPAL",
    //     "SAVIÑON",
    //     "SEBASTIAN",
    //     "SEBORUCO ",
    //     "SECTOR A ",
    //     "SECTOR B ",
    //     "SECTOR CUATRO CAMINOS ",
    //     "SECTOR EVANGELINA RODRIGUEZ ",
    //     "SECTOR I ",
    //     "SECTOR IAD ",
    //     "SECTOR II",
    //     "SECTOR LA IGLESIA ",
    //     "SECTOR MALLEN ",
    //     "SECTOR MELLA",
    //     "SECTOR NUEVO",
    //     "SECTOR OLIMPIA",
    //     "SEGUIDORES DE CRISTO",
    //     "SEGUNDO PASO",
    //     "SEGUNDO RIO",
    //     "SEMANA SANTA",
    //     "SEMILLERO",
    //     "SEMINARIO",
    //     "SERRA O CERRADA ",
    //     "SERRALLES ADENTRO 09",
    //     "SERRALLES",
    //     "SERRANO",
    //     "SEVERE ",
    //     "SEVERINO ",
    //     "SEVICO O LOS RIELES ",
    //     "SIBILA ",
    //     "SIEMBRA VIEJA ",
    //     "SIERRA DE AGUA",
    //     "SIERRA DEL GUANO",
    //     "SIERRA PRIETA ",
    //     "SIERRECITA ",
    //     "SIGAR",
    //     "SILLONCITO ",
    //     "SIMON BOLIVAR ",
    //     "SIMON DIAZ ",
    //     "SIMON STRIDDELS ",
    //     "SIMON STRIDDELS",
    //     "SIMONICO ",
    //     "SINAI O DE LAS AMERICAS 10",
    //     "SINAI",
    //     "SINENCIO ",
    //     "SIRICU ",
    //     "SITIO NUEVO",
    //     "SITO TORO",
    //     "SOBACON ABAJO ",
    //     "SOBACON ARRIBA",
    //     "SOBACON",
    //     "SOCO ARRIBA",
    //     "SOCOA",
    //     "SOL DE LUZ ",
    //     "SOLANITO ",
    //     "SOLARES DE MILTON O MARIA MONTEZ",
    //     "SOLDADO ABAJO ",
    //     "SOLEDAD",
    //     "SOLERA ",
    //     "SOLIMAN",
    //     "SOLIMAR",
    //     "SOLORIN",
    //     "SOMBRERO ",
    //     "SONADOR DE YAROA",
    //     "SONADOR O JUAN DE LA CRUZ ",
    //     "SONADOR",
    //     "SONADORCITO",
    //     "SOSA ",
    //     "SOSUA ABAJO",
    //     "SOTO ",
    //     "SOUFFLE GRANDE",
    //     "SUARDI ",
    //     "SUBIDA GRANDE ",
    //     "SUCIO DE GUACHUPITA ",
    //     "SUDADERO ",
    //     "SUELO DURO ",
    //     "SUI",
    //     "SUIZO",
    //     "SULI ",
    //     "SUMBU",
    //     "SUR",
    //     "SURIEL ",
    //     "TABACAL",
    //     "TABARA ABAJO (ZONA URBANA)",
    //     "TABARA ABAJO",
    //     "TABARA ARRIBA ",
    //     "TABARA ARRIBA (ZONA URBANA) ",
    //     "TABARA ARRIBA",
    //     "TABARDILLO ARRIBA ",
    //     "TABARDILLO ARRIBA",
    //     "TAGÜIQUE ",
    //     "TALA DE SANCHEZ ",
    //     "TALANQUERA ",
    //     "TAMARES",
    //     "TAMARINDO ADENTRO ",
    //     "TAMARINDO",
    //     "TAMAYO ",
    //     "TAMAYO (ZONA URBANA)",
    //     "TAMBORIL (ZONA URBANA)",
    //     "TARTABON ",
    //     "TARTABON ADENTRO",
    //     "TASAJERA ",
    //     "TASAJERA DEL CHIVO",
    //     "TATON",
    //     "TAVERA ",
    //     "TAVITO ",
    //     "TAWIKE ",
    //     "TAZA PEREZ ",
    //     "TEDECHE",
    //     "TELECABLE",
    //     "TENARES (ZONA URBANA) ",
    //     "TENTACION",
    //     "TERESANDON ",
    //     "TERRAPLEN",
    //     "TERRENO DEL ESTADO",
    //     "TERRERO",
    //     "TERREROS ",
    //     "TETERO ",
    //     "TETERO",
    //     "TEXTIL ",
    //     "TIBURCIO ",
    //     "TIBURCIO (PARTE)",
    //     "TIERRA ALTA",
    //     "TIERRA BLANCA ",
    //     "TIERRA COLORADA ",
    //     "TIERRA DURA",
    //     "TIERRA FRIA AFUERA",
    //     "TIERRA FRIA",
    //     "TIERRA HONDA",
    //     "TIERRA HUNDIDA",
    //     "TIERRA LLANA",
    //     "TIERRA MALA",
    //     "TIERRA NUEVA (SUAREZ) ",
    //     "TIERRA NUEVA",
    //     "TIERRA PRIETA ",
    //     "TIERRA SANTA",
    //     "TIERRA SECA",
    //     "TIERRA SUCIA",
    //     "TIERRA VIRGEN ",
    //     "TIERRITA BLANCA ",
    //     "TIESTO DE PLATO O LA COTORRA",
    //     "TIMIA",
    //     "TIO LORENZO",
    //     "TIREO (ZONA URBANA) ",
    //     "TIREO ABAJO",
    //     "TIREO AL MEDIO O LA SECADORA",
    //     "TIREO ARRIBA",
    //     "TITO CABRERA",
    //     "TITO III ",
    //     "TITO MINA",
    //     "TITOMINA ",
    //     "TITOMINA",
    //     "TOCOA",
    //     "TOCONAL",
    //     "TOJIN",
    //     "TOLENTINO",
    //     "TOMA-PINAR SUCIO",
    //     "TOMANINA ",
    //     "TOMINES ARRIBA",
    //     "TORO ARRIBA (SITIO QUEMAO)",
    //     "TORO CENIZO",
    //     "TORO PRIETO",
    //     "TORONJA",
    //     "TORRE B",
    //     "TRABAJO",
    //     "TRAVESIA ",
    //     "TREPADA ALTA",
    //     "TREPADA DE JABILLA",
    //     "TRES CUERDAS O PUERCO GORDO ",
    //     "TRES CUERDAS",
    //     "TRES MANGAS",
    //     "TRES PALMAS",
    //     "TRES PIES",
    //     "TRES PIEZAS (EL CARACOL)",
    //     "TRIFURCACION",
    //     "TRINCHERAS EL FUNDO ",
    //     "TRINIDAD ",
    //     "TRIPLE PLAY",
    //     "TROPICAL DEL ESTE ",
    //     "TROPICAL METALDOM ",
    //     "TUBAGUA",
    //     "TUBO PRIETO",
    //     "TUMBA BURROS (LOMA TURRON)",
    //     "TUMBA BURROS",
    //     "TUMBA COCO ",
    //     "TUMBACA",
    //     "TUNAL",
    //     "TUNINGO",
    //     "TÍO PEPE ",
    //     "UBILLA ",
    //     "UBILLA (D.M.) ",
    //     "UGAMBA ",
    //     "UNIJICA ABAJO ",
    //     "UNIVERSITARIO ",
    //     "URBANIZACION  QUISQUEYA",
    //     "URBANIZACION 6 DE NOVIEMBRE ",
    //     "URBANIZACION ABELARDO GOMEZ ",
    //     "URBANIZACION ABREU REYES",
    //     "URBANIZACION ABREU",
    //     "URBANIZACION ADONIS ",
    //     "URBANIZACION ALBA ",
    //     "URBANIZACION ALBA MARIEN",
    //     "URBANIZACION ALEJO",
    //     "URBANIZACION ALMANZAR ",
    //     "URBANIZACION ALTA VISTA ",
    //     "URBANIZACION ALVAREZ",
    //     "URBANIZACION AMANECER ",
    //     "URBANIZACION AMBAR",
    //     "URBANIZACION AMELIA II",
    //     "URBANIZACION ANABEL ",
    //     "URBANIZACION ANDUJAR",
    //     "URBANIZACION ANTARE ",
    //     "URBANIZACION ARCOIRIS ",
    //     "URBANIZACION ARGENTINA",
    //     "URBANIZACION ARISMAR",
    //     "URBANIZACION AROS CARRAU",
    //     "URBANIZACION ARROYO MANZANO ",
    //     "URBANIZACION ARTURO GRULLON ",
    //     "URBANIZACION ATLANTICA",
    //     "URBANIZACION AURORA ",
    //     "URBANIZACION BELLA VISTA",
    //     "URBANIZACION BELLO ATARDECER",
    //     "URBANIZACION BONILLA",
    //     "URBANIZACION BRISAS DE LA PRADERA II",
    //     "URBANIZACION BRISAS DEL CANAL ",
    //     "URBANIZACION BRISAS DEL CANAL II",
    //     "URBANIZACION BRISAS DEL MAR ",
    //     "URBANIZACION BRISAS DEL MAR II",
    //     "URBANIZACION BRISAS DEL MOGOTE",
    //     "URBANIZACION BRISAS DEL NORTE O LOS BOTADOS ",
    //     "URBANIZACION BRUGAL ",
    //     "URBANIZACION BUENA VISTA NORTE",
    //     "URBANIZACION BUENAVENTURA ",
    //     "URBANIZACION CAAMAÑO",
    //     "URBANIZACION CAMELIA CARABALLO",
    //     "URBANIZACION CAMILO ",
    //     "URBANIZACION CAMINO DEL SOL ",
    //     "URBANIZACION CAMPO FERNANDEZ I Y II ",
    //     "URBANIZACION CAONABO I",
    //     "URBANIZACION CAPOTILLO",
    //     "URBANIZACION CARABALLO 01 ",
    //     "URBANIZACION CARMEN AÑIL BONO ",
    //     "URBANIZACION CAROLINA ",
    //     "URBANIZACION CEMENTO TITAN",
    //     "URBANIZACION CERRO ALTO ",
    //     "URBANIZACION CERRO VERDE",
    //     "URBANIZACION CERROMAR ",
    //     "URBANIZACION CERROS DE SAN CRISTOBAL",
    //     "URBANIZACION CERROS DEL ATLANTICO ",
    //     "URBANIZACION CERROS DEL PARAISO ",
    //     "URBANIZACION COLINA HERMOSA ",
    //     "URBANIZACION COLINAS DEL CARIBE ",
    //     "URBANIZACION COLINAS DEL OESTE",
    //     "URBANIZACION COLINAS I",
    //     "URBANIZACION CORDERO TEJADA ",
    //     "URBANIZACION CORONEL FERNANDEZ DOMINGUEZ",
    //     "URBANIZACION COSTA SUR",
    //     "URBANIZACION CUESTA HERMOSA ",
    //     "URBANIZACION DEL ESTE ",
    //     "URBANIZACION DESPRADEL",
    //     "URBANIZACION DINERO I ",
    //     "URBANIZACION DINERO II",
    //     "URBANIZACION DOMINGO BERMUDEZ ",
    //     "URBANIZACION DON ARMANDO",
    //     "URBANIZACION DON DEPORTE",
    //     "URBANIZACION DON FELIX",
    //     "URBANIZACION DON GREGORIO ",
    //     "URBANIZACION DON JAIME",
    //     "URBANIZACION DON RICHI (VILLA BENDICION)",
    //     "URBANIZACION DOÑA CATALINA",
    //     "URBANIZACION DOÑA MILEDYS ",
    //     "URBANIZACION DOÑA OLGA I",
    //     "URBANIZACION EDUVIL ",
    //     "URBANIZACION EJECUTIVO",
    //     "URBANIZACION EL BRISAL",
    //     "URBANIZACION EL DORADO",
    //     "URBANIZACION EL DORAL ",
    //     "URBANIZACION EL EDEN",
    //     "URBANIZACION EL EMBRUJO I ",
    //     "URBANIZACION EL FRUTAL",
    //     "URBANIZACION EL GRAN JINETE ",
    //     "URBANIZACION EL MAR ",
    //     "URBANIZACION EL REMANSO ",
    //     "URBANIZACION EL ROSAL ",
    //     "URBANIZACION EL SILENCIO II ETAPA ",
    //     "URBANIZACION EL SILENCIO",
    //     "URBANIZACION EL TANQUE",
    //     "URBANIZACION EL TEJAR ",
    //     "URBANIZACION ELFA ",
    //     "URBANIZACION ERCILIA PEPIN",
    //     "URBANIZACION ERNEISA",
    //     "URBANIZACION ESMERALDA",
    //     "URBANIZACION ESTELA ",
    //     "URBANIZACION ESTRELLA ",
    //     "URBANIZACION EUGENIO MARIA DE HOSTOS",
    //     "URBANIZACION EURIPIDES DURAN II ",
    //     "URBANIZACION EUROPA ",
    //     "URBANIZACION FALCONBRIDGE O LOS GRINGOS ",
    //     "URBANIZACION FERNANDEZ",
    //     "URBANIZACION FERNANDO VALERIO ",
    //     "URBANIZACION FLOR DEL TAMARINDO 10",
    //     "URBANIZACION FRAMBOYAN",
    //     "URBANIZACION FRANCIA",
    //     "URBANIZACION FRANCISCO DEL ROSARIO SANCHEZ",
    //     "URBANIZACION FRANCONIA",
    //     "URBANIZACION GARCIA ",
    //     "URBANIZACION GRULLON",
    //     "URBANIZACION GUELO",
    //     "URBANIZACION HAMARAP",
    //     "URBANIZACION HENRIQUEZ",
    //     "URBANIZACION INDEPENDENCIA",
    //     "URBANIZACION INVERMAR ",
    //     "URBANIZACION INVI ",
    //     "URBANIZACION ISABEL 10",
    //     "URBANIZACION ITALIA ",
    //     "URBANIZACION JARDINES DEL MAESTRO II",
    //     "URBANIZACION JARDINES DEL SUR ",
    //     "URBANIZACION JARDINES DORADO",
    //     "URBANIZACION JENNIFER ",
    //     "URBANIZACION JEREZ",
    //     "URBANIZACION JOSE DEL CARMEN",
    //     "URBANIZACION JOSE ELIAS RAMIREZ ",
    //     "URBANIZACION KARINA ",
    //     "URBANIZACION LA CAPERUZA II ",
    //     "URBANIZACION LA CAPERUZA III",
    //     "URBANIZACION LA CAPERUZA",
    //     "URBANIZACION LA CARPA ",
    //     "URBANIZACION LA CASTELLANA",
    //     "URBANIZACION LA ESPAÑOLA",
    //     "URBANIZACION LA ESTANCIA",
    //     "URBANIZACION LA FLORIDA ",
    //     "URBANIZACION LA FLORIDA (VILLA MORALES) ",
    //     "URBANIZACION LA FORTUNA ",
    //     "URBANIZACION LA LOTERIA ",
    //     "URBANIZACION LA PRADERA ",
    //     "URBANIZACION LA ROCA",
    //     "URBANIZACION LA SALVIA",
    //     "URBANIZACION LAIDEN ",
    //     "URBANIZACION LAMA ",
    //     "URBANIZACION LAS ACACIAS",
    //     "URBANIZACION LAS AMERICAS ",
    //     "URBANIZACION LAS ARESCAS",
    //     "URBANIZACION LAS CAYENAS",
    //     "URBANIZACION LAS COLINAS II ",
    //     "URBANIZACION LAS COLINAS",
    //     "URBANIZACION LAS ESMERALDAS ",
    //     "URBANIZACION LAS FLORES ",
    //     "URBANIZACION LAS GAVIOTAS ",
    //     "URBANIZACION LAS MARAS II ",
    //     "URBANIZACION LAS MERCEDES ",
    //     "URBANIZACION LAS PALMAS ",
    //     "URBANIZACION LAS PALMAS I ",
    //     "URBANIZACION LAS PALMAS O VILLA PALMA ",
    //     "URBANIZACION LAS PIEDRAS",
    //     "URBANIZACION LEONELA",
    //     "URBANIZACION LIBERTAD ",
    //     "URBANIZACION LOLITA ",
    //     "URBANIZACION LORA ",
    //     "URBANIZACION LORENA ",
    //     "URBANIZACION LORENA MARIA ",
    //     "URBANIZACION LOS ALPES II ",
    //     "URBANIZACION LOS COROBAT",
    //     "URBANIZACION LOS GINEBRA",
    //     "URBANIZACION LOS JAPONESES",
    //     "URBANIZACION LOS MAESTROS ",
    //     "URBANIZACION LOS MAESTROS I ",
    //     "URBANIZACION LOS MAESTROS II",
    //     "URBANIZACION LOS MAESTROS III ",
    //     "URBANIZACION LOS MANGOS ",
    //     "URBANIZACION LOS MONTERO",
    //     "URBANIZACION LOS PINOS O VILLA MARBON ",
    //     "URBANIZACION LOS PINOS",
    //     "URBANIZACION LOS PRADOS ",
    //     "URBANIZACION LOS QUEZADA",
    //     "URBANIZACION LOS REYES II ",
    //     "URBANIZACION LOS REYES",
    //     "URBANIZACION LOS RODRIGUEZ",
    //     "URBANIZACION LOS ROSARIOS ",
    //     "URBANIZACION LOS UREÑA 01 ",
    //     "URBANIZACION LUCERNA",
    //     "URBANIZACION LUIS GINEBRA ",
    //     "URBANIZACION MAESTRO II ",
    //     "URBANIZACION MARBELLA III ",
    //     "URBANIZACION MARIA DEL CARMEN ",
    //     "URBANIZACION MARIA FERNANDEZ",
    //     "URBANIZACION MARIA RUBIO",
    //     "URBANIZACION MARIA",
    //     "URBANIZACION MARLIN O HIGÜEY",
    //     "URBANIZACION MARRANZINI ",
    //     "URBANIZACION MARTINEZ ",
    //     "URBANIZACION MAXIMO GOMEZ ",
    //     "URBANIZACION MEDINA I ",
    //     "URBANIZACION MEDINA II",
    //     "URBANIZACION MIOSOTIS ",
    //     "URBANIZACION MIRADOR DEL SUR",
    //     "URBANIZACION MIRADOR SUR",
    //     "URBANIZACION MONTALVO LIRANZO ",
    //     "URBANIZACION MONTE VERDE",
    //     "URBANIZACION MONUMENTAL ",
    //     "URBANIZACION MORALES",
    //     "URBANIZACION NEFTALI III",
    //     "URBANIZACION NEFTALI",
    //     "URBANIZACION NICOLE ",
    //     "URBANIZACION NUEVA",
    //     "URBANIZACION NUEVO SAN FRANCISCO",
    //     "URBANIZACION OFELIA ",
    //     "URBANIZACION OLIMPO ",
    //     "URBANIZACION OLIVA",
    //     "URBANIZACION ORIENTAL ",
    //     "URBANIZACION ORTEGA ",
    //     "URBANIZACION PADRE LAS CASAS",
    //     "URBANIZACION PALO ALTO",
    //     "URBANIZACION PALO DE AZUCAR ",
    //     "URBANIZACION PARAISO DEL CARIBE ",
    //     "URBANIZACION PASEO DEL RIO",
    //     "URBANIZACION PATRIA MINERVA ",
    //     "URBANIZACION PERALTA",
    //     "URBANIZACION PEÑA BELLO ",
    //     "URBANIZACION PINAR DORADO ",
    //     "URBANIZACION PORTELA",
    //     "URBANIZACION PRADERAS DE MARAPICA ",
    //     "URBANIZACION PRIMAVERAL ",
    //     "URBANIZACION PROYECTO DILONE",
    //     "URBANIZACION PROYECTO INVI-CEA",
    //     "URBANIZACION PUNTA CANA ",
    //     "URBANIZACION QUISQUEYA II ",
    //     "URBANIZACION QUISQUEYA II",
    //     "URBANIZACION QUISQUEYA",
    //     "URBANIZACION REAL ",
    //     "URBANIZACION REAL CANCINO ",
    //     "URBANIZACION RENEE KLANG VDA. GUZMAN",
    //     "URBANIZACION REPARTO CABRERA",
    //     "URBANIZACION RIBERA DEL JAYA",
    //     "URBANIZACION RIBERA DEL SUR ",
    //     "URBANIZACION RINCON ",
    //     "URBANIZACION RODRIGUEZ",
    //     "URBANIZACION ROSA DELIA ",
    //     "URBANIZACION ROSARIO O ROSADO ",
    //     "URBANIZACION SAN FELIPE ",
    //     "URBANIZACION SAN FRANCISCO I",
    //     "URBANIZACION SAN FRANCISCO II ",
    //     "URBANIZACION SAN GREGORIO ",
    //     "URBANIZACION SAN LORENZO",
    //     "URBANIZACION SAN MIGUEL ",
    //     "URBANIZACION SAN SEBASTIAN",
    //     "URBANIZACION SANTA ANA",
    //     "URBANIZACION SANTA CRUZ ",
    //     "URBANIZACION SANTANA",
    //     "URBANIZACION SAONA",
    //     "URBANIZACION SARA ",
    //     "URBANIZACION SARAH GABRIELA ",
    //     "URBANIZACION SFARON I ",
    //     "URBANIZACION SIGFRIDO DOMINGUEZ ",
    //     "URBANIZACION SIN NOMBRE ",
    //     "URBANIZACION SOL NACIENTE ",
    //     "URBANIZACION SOL",
    //     "URBANIZACION SUEÑO REAL ",
    //     "URBANIZACION TAVERAS",
    //     "URBANIZACION TERRANOVA",
    //     "URBANIZACION TONI LUCAS ",
    //     "URBANIZACION TONY YDAKA ",
    //     "URBANIZACION TORIBIO CAMILO ",
    //     "URBANIZACION TORIBIO PIANTINI ",
    //     "URBANIZACION TORRE ALTA ",
    //     "URBANIZACION TORRE ALTA II, III, IV Y V ",
    //     "URBANIZACION VALERA GUZMAN",
    //     "URBANIZACION VIDALIANA",
    //     "URBANIZACION VILLA AURA ",
    //     "URBANIZACION VILLA CAROLINA ",
    //     "URBANIZACION VILLA ELENA",
    //     "URBANIZACION VILLA NUEVA",
    //     "URBANIZACION VILLA PALMA",
    //     "URBANIZACION VILLA PANTOJA",
    //     "URBANIZACION VILLA PAZ",
    //     "URBANIZACION VILLA REAL ",
    //     "URBANIZACION VILLA REAL I Y II",
    //     "URBANIZACION VISTA FUNDACION",
    //     "URBANIZACION VISTA HERMOSA",
    //     "URBANIZACION WEBER",
    //     "URBANIZACION YAMILE ",
    //     "URBANIZACION YENNY MARIA I",
    //     "URBANIZACION YENNY MARIA II ",
    //     "URBANIZACION ZANTEL I ",
    //     "URBANIZACION ZANTEL II",
    //     "URBANIZACION ZANTEL III ",
    //     "URBANIZACIONDOMINGUEZ ",
    //     "URBANIZACIONDOVISA",
    //     "URBANIZACIONENGOMBE ",
    //     "URBANIZACIONESPERANZA ",
    //     "URBANIZACIONFERNANDEZ ",
    //     "URBANIZACIONGENESIS ",
    //     "URBANIZACIONGUSTAVO VARGAS",
    //     "URBANIZACIONPARAISO ",
    //     "URBANIZACIONPEREGRIN",
    //     "URBANIZACIONQUISQUEYA ",
    //     "URBANIZACIONSANCHEZ ",
    //     "URBANIZACIONTAVERAS ",
    //     "URBANIZACIONWEBER ",
    //     "UVERAL ",
    //     "UVERO ALTO ",
    //     "UVILLA (ZONA URBANA)",
    //     "UVILLA ABAJO",
    //     "UVILLA ARRIBA ",
    //     "UVILLITA ",
    //     "V CENTENARIO",
    //     "VACA GORDA ",
    //     "VACA VIEJA ",
    //     "VALDESIA ",
    //     "VALENCIO ",
    //     "VALENTIN ",
    //     "VALENTIN LAS YAYAS",
    //     "VALEONOR ",
    //     "VALLE DE LA ORQUESTA",
    //     "VALLE DE LOS ALGARROBOS ",
    //     "VALLE ENCANTADO ",
    //     "VALLE ENCANTADO 10",
    //     "VALLE GRANDE",
    //     "VALLE HERMOSO ",
    //     "VALLE JINA ",
    //     "VALLE NUEVO",
    //     "VALLE REAL ",
    //     "VALLE SIMON",
    //     "VALLE VERDE I ",
    //     "VALLE VERDE II",
    //     "VALLE VIEJO",
    //     "VALLECITO O VALLE NUEVO ",
    //     "VALLECITO",
    //     "VALLECITOS ",
    //     "VALLEJITO ABAJO ",
    //     "VALLEJO",
    //     "VALLEJUELO (ZONA URBANA)",
    //     "VANESSA",
    //     "VARA DE VACA",
    //     "VECINOS UNIDOS",
    //     "VEDADA ",
    //     "VELADERO ",
    //     "VELAZCASA",
    //     "VELAZQUITO ",
    //     "VENANCIO ",
    //     "VENECIA",
    //     "VENEZUELA (EL VALLE)",
    //     "VENEZUELA",
    //     "VENGAN A VER (ZONA URBANA)",
    //     "VENGAN A VER",
    //     "VENTURA",
    //     "VENTUROSO",
    //     "VENUS",
    //     "VERA DEL YAQUE",
    //     "VERAGUA ARRIBA",
    //     "VERAGUA",
    //     "VERDE",
    //     "VERDUM ",
    //     "VERDUM",
    //     "VEREDA AL MEDIO ",
    //     "VEREDA DE AMINA ",
    //     "VEREDA DE SINENCIO",
    //     "VEREDA DE YUNA",
    //     "VERON (ZONA URBANA) ",
    //     "VERON",
    //     "VERRACO ABAJO ",
    //     "VERRACO BLANCO",
    //     "VERRUGUETE ",
    //     "VIAJAMA",
    //     "VICENTE BRUGAL",
    //     "VICENTE NOBLE (ZONA URBANA) ",
    //     "VICENTE",
    //     "VICENTILLO ",
    //     "VICENTILLO (ZONA URBANA)",
    //     "VICTOR CHECHE ",
    //     "VICTORIANO ",
    //     "VICTORINA",
    //     "VIDAL GUILLEN ",
    //     "VIDAL PICHARDO",
    //     "VIEJO ALEJO",
    //     "VIEJO ARROYO HONDO",
    //     "VIEJO CARRIL",
    //     "VIEJO GOYO ",
    //     "VIEJO",
    //     "VIETNAM",
    //     "VIGIA",
    //     "VILLA ABAJO",
    //     "VILLA ABELARDO",
    //     "VILLA ALACRAN ",
    //     "VILLA ALBA ",
    //     "VILLA ALEGRE",
    //     "VILLA ALEJANDRINA II",
    //     "VILLA ALEXANDRA ",
    //     "VILLA ALTAGRACIA (EL HOYITO)",
    //     "VILLA ALTAGRACIA (ZONA URBANA)",
    //     "VILLA ALTAGRACIA U HOYO OSCURO",
    //     "VILLA AMANDA",
    //     "VILLA ANACAONA",
    //     "VILLA ANGEL",
    //     "VILLA ARMONIA ",
    //     "VILLA ARMONIA O NUEVO ",
    //     "VILLA ARRIBA",
    //     "VILLA AURA ",
    //     "VILLA AZUCARERA ",
    //     "VILLA BACHOLA ",
    //     "VILLA BAEZ ",
    //     "VILLA BALAGUER O PROYECTO YERBABUENA",
    //     "VILLA BANACK",
    //     "VILLA BAO ABAJO ",
    //     "VILLA BAO ARRIBA",
    //     "VILLA BARGABINA O EL TANQUE ",
    //     "VILLA BAYAGUANA (PROYECTO INVI) ",
    //     "VILLA BISONO (NAVARRETE).",
    //     "VILLA BLANCA I",
    //     "VILLA BLANCA II 10",
    //     "VILLA BOGAERT ",
    //     "VILLA BUENA VISTA ",
    //     "VILLA CAFETALERA",
    //     "VILLA CAIMITO ",
    //     "VILLA CAIMITO",
    //     "VILLA CAMPO",
    //     "VILLA CANAL",
    //     "VILLA CANTO",
    //     "VILLA CAOBA (LOS MULOS) ",
    //     "VILLA CAOBA",
    //     "VILLA CARIBEAN",
    //     "VILLA CARIDAD ",
    //     "VILLA CARMEN O LA GALLERA ",
    //     "VILLA CARMEN",
    //     "VILLA CARO ",
    //     "VILLA CAROLINA I",
    //     "VILLA CAROLINA II ",
    //     "VILLA CAROLINA III",
    //     "VILLA CAROLINA IV ",
    //     "VILLA CAROLINA IV",
    //     "VILLA CASTIN O LOS PEREZ",
    //     "VILLA CENTRAL ",
    //     "VILLA CENTRAL (ZONA URBANA) ",
    //     "VILLA CENTRO",
    //     "VILLA CERRO",
    //     "VILLA CLARA",
    //     "VILLA CLAUDIA ",
    //     "VILLA CODEPO",
    //     "VILLA COLINA",
    //     "VILLA COLORES ",
    //     "VILLA CONSUELO",
    //     "VILLA COPA ",
    //     "VILLA COSOBO",
    //     "VILLA CRISTAL ",
    //     "VILLA CRISTAL I ",
    //     "VILLA CRISTAL II",
    //     "VILLA DAVID",
    //     "VILLA DE BAIGUATE ",
    //     "VILLA DE RANCHO ARRIBA (ZONA URBANA)",
    //     "VILLA DE SONADOR (ZONA URBANA)",
    //     "VILLA DEL MAR ",
    //     "VILLA DEL NORTE O CAMPECHITO I",
    //     "VILLA DEL YAQUE ",
    //     "VILLA DELIA",
    //     "VILLA DEPORTIVA ",
    //     "VILLA DIANA",
    //     "VILLA DIEGO",
    //     "VILLA DORAL",
    //     "VILLA DUARTE ABAJO",
    //     "VILLA DUARTE ARRIBA ",
    //     "VILLA DUARTE VIEJO O LA FRANCIA ",
    //     "VILLA DUARTE",
    //     "VILLA DURA ",
    //     "VILLA EL DORADO ",
    //     "VILLA EL PALMAR ",
    //     "VILLA ELISA (ZONA URBANA) ",
    //     "VILLA ELISA",
    //     "VILLA ELOISA",
    //     "VILLA ELSA ",
    //     "VILLA ELSA II ",
    //     "VILLA ELSA III",
    //     "VILLA EMELY",
    //     "VILLA EMILIA",
    //     "VILLA ESFUERZO",
    //     "VILLA ESMERALDA ",
    //     "VILLA ESPAÑA",
    //     "VILLA ESPERANZA ",
    //     "VILLA ESPERANZA I ",
    //     "VILLA ESPERANZA II",
    //     "VILLA ESPERANZA O VILLA FATIMA",
    //     "VILLA ESPINAL ",
    //     "VILLA ESTANCIA NUEVA",
    //     "VILLA ESTELA",
    //     "VILLA EUROPA",
    //     "VILLA FARO ",
    //     "VILLA FATIMA",
    //     "VILLA FELICIA O LOS GRINGOS ",
    //     "VILLA FERIA (CENTRO DEL PUEBLO) ",
    //     "VILLA FILDA",
    //     "VILLA FLORES",
    //     "VILLA FONTANA ",
    //     "VILLA FRANCISCA ",
    //     "VILLA FRANCISCA I ",
    //     "VILLA FRANCISCA II",
    //     "VILLA FRANCISCA",
    //     "VILLA FRESCA O VILLA CAROLINA ",
    //     "VILLA FRESCA",
    //     "VILLA FUNDACION ",
    //     "VILLA FUNDACION (ZONA URBANA) ",
    //     "VILLA GARCIA",
    //     "VILLA GARZA",
    //     "VILLA GERMAN",
    //     "VILLA GLORIA",
    //     "VILLA GONZALEZ (ZONA URBANA)",
    //     "VILLA GRACIELA",
    //     "VILLA GUERRERO",
    //     "VILLA GÜERA",
    //     "VILLA HENEQUEN (PONTON) 04",
    //     "VILLA HERMOSA ",
    //     "VILLA HERMOSA (ZONA URBANA) ",
    //     "VILLA HOLGUIN ",
    //     "VILLA HOLLYWOOD ",
    //     "VILLA HORTENSIA ",
    //     "VILLA IRIS ",
    //     "VILLA ISABEL",
    //     "VILLA ISABELA ",
    //     "VILLA ISABELA (ZONA URBANA) ",
    //     "VILLA ISLABON ",
    //     "VILLA IVAN GUZMAN (EL SALADILLO)",
    //     "VILLA JAGUA",
    //     "VILLA JARAGUA ",
    //     "VILLA JARAGUA (ZONA URBANA) ",
    //     "VILLA JARAGUA",
    //     "VILLA JERUSALEN ",
    //     "VILLA JUANA O LOS PILOTOS ",
    //     "VILLA JUANA",
    //     "VILLA LA COLINA ",
    //     "VILLA LA FE",
    //     "VILLA LAURA",
    //     "VILLA LIBERACION O CAMPO DE AVIACION",
    //     "VILLA LIBERACION",
    //     "VILLA LINDA I ",
    //     "VILLA LINDA",
    //     "VILLA LISA ",
    //     "VILLA LOBOS ADENTRO ",
    //     "VILLA LOBOS AFUERA",
    //     "VILLA LODO ",
    //     "VILLA LORA ",
    //     "VILLA LORENZA ",
    //     "VILLA LOS ALMACIGOS (ZONA URBANA) ",
    //     "VILLA LOS HIDALGOS",
    //     "VILLA LOS PAJONES ",
    //     "VILLA MACO ",
    //     "VILLA MAGANTE (ZONA URBANA) ",
    //     "VILLA MAGDALENA ",
    //     "VILLA MAGISTERIAL 01",
    //     "VILLA MAJECA",
    //     "VILLA MARGARITA ",
    //     "VILLA MARIA MERCEDES",
    //     "VILLA MARIA",
    //     "VILLA MARINA",
    //     "VILLA MARTINA ",
    //     "VILLA MELLA",
    //     "VILLA MERCEDES",
    //     "VILLA MONTELLANO (ZONA URBANA)",
    //     "VILLA MORADA",
    //     "VILLA MUNICIPAL ",
    //     "VILLA MUÑOZ",
    //     "VILLA NACO ",
    //     "VILLA NAZARET ",
    //     "VILLA NAZARETH",
    //     "VILLA NENE ",
    //     "VILLA NIZAO",
    //     "VILLA NOA",
    //     "VILLA NUEVA",
    //     "VILLA OCOA ",
    //     "VILLA OCOA O LOS SUBURBIOS",
    //     "VILLA OCOA",
    //     "VILLA OLGA ",
    //     "VILLA OLIMPICA I",
    //     "VILLA OLIMPICA II ",
    //     "VILLA OLIMPICA",
    //     "VILLA ORILLA O PARAISO",
    //     "VILLA ORTEGA",
    //     "VILLA PAJA ",
    //     "VILLA PALMERA ",
    //     "VILLA PARANO",
    //     "VILLA PAREDES ",
    //     "VILLA PENCA",
    //     "VILLA PERAVIA ",
    //     "VILLA PINALES ",
    //     "VILLA PION ",
    //     "VILLA PLAYWOOD",
    //     "VILLA POLIN O TOMINES ABAJO ",
    //     "VILLA POMPA",
    //     "VILLA PORVENIR",
    //     "VILLA PROGRESO 10 ",
    //     "VILLA PROGRESO I",
    //     "VILLA PROGRESO II ",
    //     "VILLA PROGRESO II (PROYECTO VIRGILIO) ",
    //     "VILLA PROGRESO",
    //     "VILLA PROVIDENCIA ",
    //     "VILLA RAY",
    //     "VILLA RAZA ",
    //     "VILLA REAL ",
    //     "VILLA RIVA (ZONA URBANA)",
    //     "VILLA ROSA ",
    //     "VILLA SABINA",
    //     "VILLA SALMA",
    //     "VILLA SAN CARLOS",
    //     "VILLA SAN FELIPE",
    //     "VILLA SANTANA (BATEY SANTANA) ",
    //     "VILLA SHELL",
    //     "VILLA SINDA",
    //     "VILLA SOLIDARIDAD ",
    //     "VILLA SOMBRERO (ZONA URBANA)",
    //     "VILLA TABACALERA O URBANIZACION GARCIA",
    //     "VILLA TABACALERA",
    //     "VILLA TABARA ARRIBA (D.M.)",
    //     "VILLA TAPIA (ZONA URBANA) ",
    //     "VILLA TRINA",
    //     "VILLA TROPICALIA",
    //     "VILLA TUREY",
    //     "VILLA VASQUEZ (ZONA URBANA) ",
    //     "VILLA VELAZQUEZ ",
    //     "VILLA VERDE I ",
    //     "VILLA VERDE II",
    //     "VILLA VERDE",
    //     "VILLA VERDUM",
    //     "VILLA VISAN",
    //     "VILLA ZANGO",
    //     "VILLA ZORRILLA",
    //     "VILLARPANDO (ZONA URBANA) ",
    //     "VILLARPANDO",
    //     "VILLAS AGRICOLAS",
    //     "VILLAS CAROLINA ",
    //     "VILLAS COUNTRY CLUB ",
    //     "VILLAS DE SAN LUIS",
    //     "VILLAS TATI",
    //     "VILLEGAS ",
    //     "VILORIO",
    //     "VISION MUNDIAL",
    //     "VISTA AL MAR",
    //     "VISTA ALEGRE",
    //     "VISTA BELLA",
    //     "VISTA DEL PARQUE",
    //     "VISTA DEL VALLE ",
    //     "VISTA HERMOSA ",
    //     "VISTA HERMOSA O VILLA HERMOSA ",
    //     "VISTA LINDA",
    //     "VISTA SOCA ",
    //     "VISTA VERDE",
    //     "VIVE BIEN",
    //     "VIVIENDA O CENTRO DEL PUEBLO",
    //     "VIÑA ",
    //     "VUELTA DE LA PALOMA ",
    //     "VUELTA GRANDE ",
    //     "VUELTA LARGA",
    //     "WADY CRUZ",
    //     "WASHINGTON ",
    //     "WILLMORE ",
    //     "X",
    //     "YABACAO",
    //     "YABACOA (EL ATAJADIZO)",
    //     "YABACOA",
    //     "YABANA ",
    //     "YABANAL",
    //     "YABANO ",
    //     "YABIQUI",
    //     "YABON",
    //     "YABONICO ",
    //     "YACAHUEQUE ",
    //     "YACO ",
    //     "YAGRUMOS ",
    //     "YAGUAQUE ",
    //     "YAGUATE (ZONA URBANA) ",
    //     "YAGUATE ARRIBA O LA JABILLA ",
    //     "YAGÜEY ",
    //     "YAGÜITA DE PASTOR ",
    //     "YAIBA ABAJO",
    //     "YAIBA ARRIBA",
    //     "YAIBA O RINCON DE YAIBA ",
    //     "YAITA",
    //     "YAMASA (ZONA URBANA)",
    //     "YAMI ",
    //     "YANABO ABAJO",
    //     "YANABO ARRIBA ",
    //     "YANIGUA",
    //     "YAQUE (LOMA DEL YAQUE)",
    //     "YAQUE ARRIBA",
    //     "YAREYCITO",
    //     "YAROA ABAJO",
    //     "YASICA ABAJO",
    //     "YASICA ARRIBA ",
    //     "YASICA ARRIBA (ZONA URBANA) ",
    //     "YASIQUITA",
    //     "YASO ",
    //     "YASO ABAJO (ARROYO YASO)",
    //     "YASO ARRIBA",
    //     "YAURUMAL ",
    //     "YAYA CLARA ",
    //     "YAYA PICADA",
    //     "YAYAL",
    //     "YE ",
    //     "YERBA BUENA (ZONA URBANA) ",
    //     "YERBA BUENA O PICA PICA ",
    //     "YERBA BUENA",
    //     "YERBA DE CULEBRA",
    //     "YERBA DE GUINEA ",
    //     "YERBA LARGA",
    //     "YIYO GOMEZ ",
    //     "YOGO YOGO",
    //     "YONU ",
    //     "YONU ABAJO ",
    //     "YONU ARRIBA",
    //     "YUJO ",
    //     "YUJO ABAJO ",
    //     "YUNITA ",
    //     "YUVINA ",
    //     "YUVINITA ",
    //     "ZAFARRAYA",
    //     "ZALAYA ",
    //     "ZALZAMORA(ZARZAMORA)",
    //     "ZAMARRILLA ",
    //     "ZAMBA ARRIBA",
    //     "ZAMBA",
    //     "ZAMBRANA ABAJO (ZONA URBANA)",
    //     "ZAMBRANA ABAJO",
    //     "ZAMBRANA ARRIBA ",
    //     "ZANJUL ",
    //     "ZAPOTAL",
    //     "ZARABANDA",
    //     "ZARZUELA ",
    //     "ZAYAS (EL VEINTE) ",
    //     "ZEPITEN",
    //     "ZINC ",
    //     "ZONA CENTRICA CEVICOS ",
    //     "ZONA FRANCA DE HAINAMOSA",
    //     "ZONA FRANCA INDUSTRIAL DE VILLA MELLA ",
    //     "ZONA FRANCA INDUSTRIAL LOS ALCARRIZOS ",
    //     "ZONA INDUSTRIAL ",
    //     "ZONA INDUSTRIAL HERRERA ",
    //     "ZONA INDUSTRIAL LA ISABELA",
    //     "ZONA TURISTICA DE BAVARO",
    //     "ZONA TURISTICA",
    //     "ZONA URBANA",
    //     "ZONA VERDE ",
    //     "ZORRA BUENA",
    //     "ZUMBA",
    //     "ZUMBADOR ABAJO",
    //     "ZUMBADORA",
    //     "ZUMBADORCITO",
    //     "ZUMBI MANTECA ",
    // ]
    'tiposRelacionCorporativa': [
        "Cliente de Consolidacion",
        "Accionista principal (=10% Share capital)",
        "Asociado (≥10% Share capital)",
        "Socio (≥10% Share capital)",
        "Mixed",
        "Operativa financiera del negocio",
        "Operativo o financiero para los socios o accionistas",
        "Dueño principal",
        "Propietario efectivo",
        "Beneficiario",
        "Oficial Mayor",
        "Ministro de religion",
        "Fideicomisario",
        "fideicomitente",
        "Cedente",
        "Miembro de la Junta de Gobierno",
        "Oficial Principal/Representante",
        "Propiedad Accionaria (Persona Jurídica)",
        "Otros medios (Persona Jurídica)",
        "Alto funcionario directivo (Persona jurídica)",
        "Fideicomitente (Fideicomiso)",
        "Fideicomisario (fideicomiso)",
        "Protector (Fideicomiso)",
        "Beneficiario (Fideicomiso)",
        "Otro (Fideicomiso)",
        "Liquidadora - Equivalente (no fiduciaria)",
        "Fiduciaria - Equivalente (no fiduciaria)",
        "Protector - Equivalente (No Confiable)",
        "Beneficiaria - Equivalente (no fiduciaria)",
        "Otros - Equivalente (No fiduciarios)",
        "Contacto Primario",
        "Contacto Secundario",
        "Poder Legal",
        "Abogado",
        "Titular",
        "Titular Principal / Accionista Principal",
        "Suplidor Mayor",
        "Director",
        "Firmante Autorizado",
        "Oficial de Gestion",
        "Bankero Principal",
        "Banquero Secundario",
        "Companias Asociadas",
        "Compania Retenciones",
        "Subsidiarios",
    ],
}

export default dropdownOptions;